// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[0].use[1]!../../node_modules/ol/ol.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[0].use[1]!../../node_modules/ol-ext/control/Status.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[0].use[1]!../../node_modules/ol-ext/control/LayerSwitcher.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[0].use[1]!../../node_modules/ol-ext/control/Overview.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[0].use[1]!../../node_modules/ol-ext/overlay/Popup.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[0].use[1]!../../node_modules/ol-ext/control/Swipe.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[0].use[1]!../../node_modules/ol-contextmenu/dist/ol-contextmenu.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[0].use[1]!../../node_modules/tippy.js/dist/tippy.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Roboto-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Roboto-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/Roboto-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/Roboto-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/MaterialIcons-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/MaterialIconsOutlined-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28134, 182.5, 254%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27rgb%285.2, 44, 101.2%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28109.8, 168, 253.8%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("assets/img/auth_back.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("assets/img/vexcel_white_logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("assets/images/white-storm-border.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("assets/images/swipe.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("assets/images/swipe-white.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("assets/images/pin_btn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("assets/images/ic_visibility_off.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA1MTIgNTEyJyB3aWR0aD0nNTEyJyBoZWlnaHQ9JzUxMic+PHBhdGggZmlsbD0ncmdiKDI1NSwyNTUsMjU1KScgZD0nTTI1NiA4QzExOS4wNDMgOCA4IDExOS4wODMgOCAyNTZjMCAxMzYuOTk3IDExMS4wNDMgMjQ4IDI0OCAyNDhzMjQ4LTExMS4wMDMgMjQ4LTI0OEM1MDQgMTE5LjA4MyAzOTIuOTU3IDggMjU2IDh6bTAgMTEwYzIzLjE5NiAwIDQyIDE4LjgwNCA0MiA0MnMtMTguODA0IDQyLTQyIDQyLTQyLTE4LjgwNC00Mi00MiAxOC44MDQtNDIgNDItNDJ6bTU2IDI1NGMwIDYuNjI3LTUuMzczIDEyLTEyIDEyaC04OGMtNi42MjcgMC0xMi01LjM3My0xMi0xMnYtMjRjMC02LjYyNyA1LjM3My0xMiAxMi0xMmgxMnYtNjRoLTEyYy02LjYyNyAwLTEyLTUuMzczLTEyLTEydi0yNGMwLTYuNjI3IDUuMzczLTEyIDEyLTEyaDY0YzYuNjI3IDAgMTIgNS4zNzMgMTIgMTJ2MTAwaDEyYzYuNjI3IDAgMTIgNS4zNzMgMTIgMTJ2MjR6Jy8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA1MTIgNTEyJyB3aWR0aD0nNTEyJyBoZWlnaHQ9JzUxMic+PHBhdGggZmlsbD0ncmdiKDI1NSwyNTUsMjU1KScgZD0nTTI1NiA4QzExOSA4IDggMTE5IDggMjU2czExMSAyNDggMjQ4IDI0OCAyNDgtMTExIDI0OC0yNDhTMzkzIDggMjU2IDh6bTEyMS42IDMxMy4xYzQuNyA0LjcgNC43IDEyLjMgMCAxN0wzMzggMzc3LjZjLTQuNyA0LjctMTIuMyA0LjctMTcgMEwyNTYgMzEybC02NS4xIDY1LjZjLTQuNyA0LjctMTIuMyA0LjctMTcgMEwxMzQuNCAzMzhjLTQuNy00LjctNC43LTEyLjMgMC0xN2w2NS42LTY1LTY1LjYtNjUuMWMtNC43LTQuNy00LjctMTIuMyAwLTE3bDM5LjYtMzkuNmM0LjctNC43IDEyLjMtNC43IDE3IDBsNjUgNjUuNyA2NS4xLTY1LjZjNC43LTQuNyAxMi4zLTQuNyAxNyAwbDM5LjYgMzkuNmM0LjcgNC43IDQuNyAxMi4zIDAgMTdMMzEyIDI1Nmw2NS42IDY1LjF6Jy8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA1MTIgNTEyJyB3aWR0aD0nNTEyJyBoZWlnaHQ9JzUxMic+PHBhdGggZmlsbD0ncmdiKDI1NSwyNTUsMjU1KScgZD0nTTE3My44OTggNDM5LjQwNGwtMTY2LjQtMTY2LjRjLTkuOTk3LTkuOTk3LTkuOTk3LTI2LjIwNiAwLTM2LjIwNGwzNi4yMDMtMzYuMjA0YzkuOTk3LTkuOTk4IDI2LjIwNy05Ljk5OCAzNi4yMDQgMEwxOTIgMzEyLjY5IDQzMi4wOTUgNzIuNTk2YzkuOTk3LTkuOTk3IDI2LjIwNy05Ljk5NyAzNi4yMDQgMGwzNi4yMDMgMzYuMjA0YzkuOTk3IDkuOTk3IDkuOTk3IDI2LjIwNiAwIDM2LjIwNGwtMjk0LjQgMjk0LjQwMWMtOS45OTggOS45OTctMjYuMjA3IDkuOTk3LTM2LjIwNC0uMDAxeicvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA1NzYgNTEyJyB3aWR0aD0nNTc2JyBoZWlnaHQ9JzUxMic+PHBhdGggZmlsbD0ncmdiKDI1NSwyNTUsMjU1KScgZD0nTTU2OS41MTcgNDQwLjAxM0M1ODcuOTc1IDQ3Mi4wMDcgNTY0LjgwNiA1MTIgNTI3Ljk0IDUxMkg0OC4wNTRjLTM2LjkzNyAwLTU5Ljk5OS00MC4wNTUtNDEuNTc3LTcxLjk4N0wyNDYuNDIzIDIzLjk4NWMxOC40NjctMzIuMDA5IDY0LjcyLTMxLjk1MSA4My4xNTQgMGwyMzkuOTQgNDE2LjAyOHpNMjg4IDM1NGMtMjUuNDA1IDAtNDYgMjAuNTk1LTQ2IDQ2czIwLjU5NSA0NiA0NiA0NiA0Ni0yMC41OTUgNDYtNDYtMjAuNTk1LTQ2LTQ2LTQ2em0tNDMuNjczLTE2NS4zNDZsNy40MTggMTM2Yy4zNDcgNi4zNjQgNS42MDkgMTEuMzQ2IDExLjk4MiAxMS4zNDZoNDguNTQ2YzYuMzczIDAgMTEuNjM1LTQuOTgyIDExLjk4Mi0xMS4zNDZsNy40MTgtMTM2Yy4zNzUtNi44NzQtNS4wOTgtMTIuNjU0LTExLjk4Mi0xMi42NTRoLTYzLjM4M2MtNi44ODQgMC0xMi4zNTYgNS43OC0xMS45ODEgMTIuNjU0eicvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*External css imports for viewer components/core map*/
/* based on angular-toastr css https://github.com/Foxandxss/angular-toastr/blob/cb508fe6801d6b288d3afc525bb40fee1b101650/dist/angular-toastr.css */
/* position */
/* Roboto - Normal (400) */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
}
/* Roboto - Light (300) */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
}
/* Roboto - Medium (500) */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}
/* Roboto - Bold (700) */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
}
/* Material Icons */
@font-face {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2");
}
@font-face {
  font-family: "Material Icons Outlined";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2");
}
.material-icons {
  font-family: "Material Icons", sans-serif;
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
}

.material-icons-outlined {
  font-family: "Material Icons Outlined", sans-serif;
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
}

/* ==========  COLOR CUSTOMIZATION -- VDP ========== */
/**
 * Re-export variables and palette modules.
 *
 * This file forwards the 'styles/variables' and 'styles/palette' modules,
 * making their members available to any file that imports _globals.scss.
 * This centralizes configuration and ensures consistent theming across the library.
 */
/**
 * Global Styles for the Library
 *
 * The following styles are loaded globally to ensure that Material classes and
 * theme customizations have the highest priority in the CSS cascade.
 *
 * We use the Sass module system (@use) for our custom styles to encapsulate scope
 * and avoid namespace collisions, while @import is used for legacy or third-party
 * libraries that are not modularized.
 */
/* -------------------------------------------------------------------------
 * Global Material Customizations
 * -------------------------------------------------------------------------
 * Import custom Material styles that adjust the Material theme and component
 * appearances. These are loaded globally to ensure they take precedence.
 */
/* -------------------------------------------------------------------------
 * Angular Material Theme Customization - Multi-Theme Support
 * -------------------------------------------------------------------------
 * This file sets up Material 3 theming with runtime theme switching support.
 *
 * Architecture:
 * - Base structural styles applied once to html element
 * - Theme-specific color variants via classes: .theme-brand, .theme-generic-a, .theme-generic-b
 * - Dark mode variants via .dark-mode class
 * - Total of 6 theme variants: 3 themes × 2 modes (light/dark)
 */
/* -------------------------------------------------------------------------
 * Base Structural Styles
 * Applied once to all themes - includes typography, density, and structure
 * ------------------------------------------------------------------------- */
html {
  color-scheme: light;
  --mat-sys-body-large: 400 1rem / 1.5rem Roboto;
  --mat-sys-body-large-font: Roboto;
  --mat-sys-body-large-line-height: 1.5rem;
  --mat-sys-body-large-size: 1rem;
  --mat-sys-body-large-tracking: 0.031rem;
  --mat-sys-body-large-weight: 400;
  --mat-sys-body-medium: 400 0.875rem / 1.25rem Roboto;
  --mat-sys-body-medium-font: Roboto;
  --mat-sys-body-medium-line-height: 1.25rem;
  --mat-sys-body-medium-size: 0.875rem;
  --mat-sys-body-medium-tracking: 0.016rem;
  --mat-sys-body-medium-weight: 400;
  --mat-sys-body-small: 400 0.75rem / 1rem Roboto;
  --mat-sys-body-small-font: Roboto;
  --mat-sys-body-small-line-height: 1rem;
  --mat-sys-body-small-size: 0.75rem;
  --mat-sys-body-small-tracking: 0.025rem;
  --mat-sys-body-small-weight: 400;
  --mat-sys-display-large: 400 3.562rem / 4rem Roboto;
  --mat-sys-display-large-font: Roboto;
  --mat-sys-display-large-line-height: 4rem;
  --mat-sys-display-large-size: 3.562rem;
  --mat-sys-display-large-tracking: -0.016rem;
  --mat-sys-display-large-weight: 400;
  --mat-sys-display-medium: 400 2.812rem / 3.25rem Roboto;
  --mat-sys-display-medium-font: Roboto;
  --mat-sys-display-medium-line-height: 3.25rem;
  --mat-sys-display-medium-size: 2.812rem;
  --mat-sys-display-medium-tracking: 0;
  --mat-sys-display-medium-weight: 400;
  --mat-sys-display-small: 400 2.25rem / 2.75rem Roboto;
  --mat-sys-display-small-font: Roboto;
  --mat-sys-display-small-line-height: 2.75rem;
  --mat-sys-display-small-size: 2.25rem;
  --mat-sys-display-small-tracking: 0;
  --mat-sys-display-small-weight: 400;
  --mat-sys-headline-large: 400 2rem / 2.5rem Roboto;
  --mat-sys-headline-large-font: Roboto;
  --mat-sys-headline-large-line-height: 2.5rem;
  --mat-sys-headline-large-size: 2rem;
  --mat-sys-headline-large-tracking: 0;
  --mat-sys-headline-large-weight: 400;
  --mat-sys-headline-medium: 400 1.75rem / 2.25rem Roboto;
  --mat-sys-headline-medium-font: Roboto;
  --mat-sys-headline-medium-line-height: 2.25rem;
  --mat-sys-headline-medium-size: 1.75rem;
  --mat-sys-headline-medium-tracking: 0;
  --mat-sys-headline-medium-weight: 400;
  --mat-sys-headline-small: 400 1.5rem / 2rem Roboto;
  --mat-sys-headline-small-font: Roboto;
  --mat-sys-headline-small-line-height: 2rem;
  --mat-sys-headline-small-size: 1.5rem;
  --mat-sys-headline-small-tracking: 0;
  --mat-sys-headline-small-weight: 400;
  --mat-sys-label-large: 500 0.875rem / 1.25rem Roboto;
  --mat-sys-label-large-font: Roboto;
  --mat-sys-label-large-line-height: 1.25rem;
  --mat-sys-label-large-size: 0.875rem;
  --mat-sys-label-large-tracking: 0.006rem;
  --mat-sys-label-large-weight: 500;
  --mat-sys-label-large-weight-prominent: 700;
  --mat-sys-label-medium: 500 0.75rem / 1rem Roboto;
  --mat-sys-label-medium-font: Roboto;
  --mat-sys-label-medium-line-height: 1rem;
  --mat-sys-label-medium-size: 0.75rem;
  --mat-sys-label-medium-tracking: 0.031rem;
  --mat-sys-label-medium-weight: 500;
  --mat-sys-label-medium-weight-prominent: 700;
  --mat-sys-label-small: 500 0.688rem / 1rem Roboto;
  --mat-sys-label-small-font: Roboto;
  --mat-sys-label-small-line-height: 1rem;
  --mat-sys-label-small-size: 0.688rem;
  --mat-sys-label-small-tracking: 0.031rem;
  --mat-sys-label-small-weight: 500;
  --mat-sys-title-large: 400 1.375rem / 1.75rem Roboto;
  --mat-sys-title-large-font: Roboto;
  --mat-sys-title-large-line-height: 1.75rem;
  --mat-sys-title-large-size: 1.375rem;
  --mat-sys-title-large-tracking: 0;
  --mat-sys-title-large-weight: 400;
  --mat-sys-title-medium: 500 1rem / 1.5rem Roboto;
  --mat-sys-title-medium-font: Roboto;
  --mat-sys-title-medium-line-height: 1.5rem;
  --mat-sys-title-medium-size: 1rem;
  --mat-sys-title-medium-tracking: 0.009rem;
  --mat-sys-title-medium-weight: 500;
  --mat-sys-title-small: 500 0.875rem / 1.25rem Roboto;
  --mat-sys-title-small-font: Roboto;
  --mat-sys-title-small-line-height: 1.25rem;
  --mat-sys-title-small-size: 0.875rem;
  --mat-sys-title-small-tracking: 0.006rem;
  --mat-sys-title-small-weight: 500;
  --mat-sys-corner-extra-large: 28px;
  --mat-sys-corner-extra-large-top: 28px 28px 0 0;
  --mat-sys-corner-extra-small: 4px;
  --mat-sys-corner-extra-small-top: 4px 4px 0 0;
  --mat-sys-corner-full: 9999px;
  --mat-sys-corner-large: 16px;
  --mat-sys-corner-large-end: 0 16px 16px 0;
  --mat-sys-corner-large-start: 16px 0 0 16px;
  --mat-sys-corner-large-top: 16px 16px 0 0;
  --mat-sys-corner-medium: 12px;
  --mat-sys-corner-none: 0;
  --mat-sys-corner-small: 8px;
  --mat-sys-dragged-state-layer-opacity: 0.16;
  --mat-sys-focus-state-layer-opacity: 0.12;
  --mat-sys-hover-state-layer-opacity: 0.08;
  --mat-sys-pressed-state-layer-opacity: 0.12;
}
html .mat-bg-primary {
  background-color: var(--mat-sys-primary);
}
html .mat-bg-primary-container {
  background-color: var(--mat-sys-primary-container);
}
html .mat-bg-secondary {
  background-color: var(--mat-sys-secondary);
}
html .mat-bg-secondary-container {
  background-color: var(--mat-sys-secondary-container);
}
html .mat-bg-error {
  background-color: var(--mat-sys-error);
}
html .mat-bg-error-container {
  background-color: var(--mat-sys-error-container);
}
html .mat-bg-surface {
  background-color: var(--mat-sys-surface);
}
html .mat-bg-surface-variant {
  background-color: var(--mat-sys-surface-variant);
}
html .mat-bg-surface-container-highest {
  background-color: var(--mat-sys-surface-container-highest);
}
html .mat-bg-surface-container-high {
  background-color: var(--mat-sys-surface-container-high);
}
html .mat-bg-surface-container {
  background-color: var(--mat-sys-surface-container);
}
html .mat-bg-surface-container-low {
  background-color: var(--mat-sys-surface-container-low);
}
html .mat-bg-surface-container-lowest {
  background-color: var(--mat-sys-surface-container-lowest);
}
html .mat-bg-inverse-surface {
  background-color: var(--mat-sys-inverse-surface);
}
html .mat-bg-disabled {
  background-color: color-mix(in srgb, var(--mat-sys-on-surface) 12%, transparent);
}
html .mat-text-primary {
  color: var(--mat-sys-primary);
}
html .mat-text-secondary {
  color: var(--mat-sys-secondary);
}
html .mat-text-error {
  color: var(--mat-sys-error);
}
html .mat-text-disabled {
  color: color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent);
}
html .mat-text-on-surface-variant {
  color: var(--mat-sys-on-surface-variant);
}
html .mat-text-on-primary {
  color: var(--mat-sys-on-primary);
}
html .mat-text-on-primary-container {
  color: var(--mat-sys-on-primary-container);
}
html .mat-text-on-secondary {
  color: var(--mat-sys-on-secondary);
}
html .mat-text-on-secondary-container {
  color: var(--mat-sys-on-secondary-container);
}
html .mat-text-on-error {
  color: var(--mat-sys-on-error);
}
html .mat-text-on-error-container {
  color: var(--mat-sys-on-error-container);
}
html .mat-text-on-surface {
  color: var(--mat-sys-on-surface);
}
html .mat-text-inverse-on-surface {
  color: var(--mat-sys-inverse-on-surface);
}
html .mat-font-body-sm {
  font: var(--mat-sys-body-small);
  letter-spacing: var(--mat-sys-body-small-tracking);
}
html .mat-font-body-md {
  font: var(--mat-sys-body-medium);
  letter-spacing: var(--mat-sys-body-medium-tracking);
}
html .mat-font-body-lg {
  font: var(--mat-sys-body-large);
  letter-spacing: var(--mat-sys-body-large-tracking);
}
html .mat-font-display-sm {
  font: var(--mat-sys-display-small);
  letter-spacing: var(--mat-sys-display-small-tracking);
}
html .mat-font-display-md {
  font: var(--mat-sys-display-medium);
  letter-spacing: var(--mat-sys-display-medium-tracking);
}
html .mat-font-display-lg {
  font: var(--mat-sys-display-large);
  letter-spacing: var(--mat-sys-display-large-tracking);
}
html .mat-font-headline-sm {
  font: var(--mat-sys-headline-small);
  letter-spacing: var(--mat-sys-headline-small-tracking);
}
html .mat-font-headline-md {
  font: var(--mat-sys-headline-medium);
  letter-spacing: var(--mat-sys-headline-medium-tracking);
}
html .mat-font-headline-lg {
  font: var(--mat-sys-headline-large);
  letter-spacing: var(--mat-sys-headline-large-tracking);
}
html .mat-font-label-sm {
  font: var(--mat-sys-label-small);
  letter-spacing: var(--mat-sys-label-small-tracking);
}
html .mat-font-label-md {
  font: var(--mat-sys-label-medium);
  letter-spacing: var(--mat-sys-label-medium-tracking);
}
html .mat-font-label-lg {
  font: var(--mat-sys-label-large);
  letter-spacing: var(--mat-sys-label-large-tracking);
}
html .mat-font-title-sm {
  font: var(--mat-sys-title-small);
  letter-spacing: var(--mat-sys-title-small-tracking);
}
html .mat-font-title-md {
  font: var(--mat-sys-title-medium);
  letter-spacing: var(--mat-sys-title-medium-tracking);
}
html .mat-font-title-lg {
  font: var(--mat-sys-title-large);
  letter-spacing: var(--mat-sys-title-large-tracking);
}
html .mat-corner-xs {
  border-radius: var(--mat-sys-corner-extra-small);
}
html .mat-corner-sm {
  border-radius: var(--mat-sys-corner-small);
}
html .mat-corner-md {
  border-radius: var(--mat-sys-corner-medium);
}
html .mat-corner-lg {
  border-radius: var(--mat-sys-corner-large);
}
html .mat-corner-xl {
  border-radius: var(--mat-sys-corner-extra-large);
}
html .mat-corner-full {
  border-radius: var(--mat-sys-corner-full);
}
html .mat-border {
  border: 1px solid var(--mat-sys-outline);
}
html .mat-border-subtle {
  border: 1px solid var(--mat-sys-outline-variant);
}
html .mat-shadow-1 {
  box-shadow: var(--mat-sys-level1);
}
html .mat-shadow-2 {
  box-shadow: var(--mat-sys-level2);
}
html .mat-shadow-3 {
  box-shadow: var(--mat-sys-level3);
}
html .mat-shadow-4 {
  box-shadow: var(--mat-sys-level4);
}
html .mat-shadow-5 {
  box-shadow: var(--mat-sys-level5);
}

.dark-mode {
  color-scheme: dark;
}

/* Brand Theme - Light Mode (Default) */
.theme-default {
  --mat-sys-background: light-dark(#fff7fb, #19101b);
  --mat-sys-error: light-dark(#ba1a1a, #ffb4ab);
  --mat-sys-error-container: light-dark(#ffdad6, #93000a);
  --mat-sys-inverse-on-surface: light-dark(#fdecfc, #372d39);
  --mat-sys-inverse-primary: light-dark(#efb0ff, #9c00c9);
  --mat-sys-inverse-surface: light-dark(#372d39, #eedded);
  --mat-sys-on-background: light-dark(#221823, #eedded);
  --mat-sys-on-error: light-dark(#ffffff, #690005);
  --mat-sys-on-error-container: light-dark(#93000a, #ffdad6);
  --mat-sys-on-primary: light-dark(#ffffff, #54006e);
  --mat-sys-on-primary-container: light-dark(#77009a, #fad7ff);
  --mat-sys-on-primary-fixed: light-dark(#330044, #330044);
  --mat-sys-on-primary-fixed-variant: light-dark(#77009a, #77009a);
  --mat-sys-on-secondary: light-dark(#ffffff, #2f3131);
  --mat-sys-on-secondary-container: light-dark(#454747, #e2e2e2);
  --mat-sys-on-secondary-fixed: light-dark(#1a1c1c, #1a1c1c);
  --mat-sys-on-secondary-fixed-variant: light-dark(#454747, #454747);
  --mat-sys-on-surface: light-dark(#221823, #eedded);
  --mat-sys-on-surface-variant: light-dark(#514253, #f2dcf2);
  --mat-sys-on-tertiary: light-dark(#ffffff, #640036);
  --mat-sys-on-tertiary-container: light-dark(#8d004f, #ffd9e3);
  --mat-sys-on-tertiary-fixed: light-dark(#3e001f, #3e001f);
  --mat-sys-on-tertiary-fixed-variant: light-dark(#8d004f, #8d004f);
  --mat-sys-outline: light-dark(#837185, #9d8b9f);
  --mat-sys-outline-variant: light-dark(#d5c0d6, #514253);
  --mat-sys-primary: light-dark(#9c00c9, #efb0ff);
  --mat-sys-primary-container: light-dark(#fad7ff, #77009a);
  --mat-sys-primary-fixed: light-dark(#fad7ff, #fad7ff);
  --mat-sys-primary-fixed-dim: light-dark(#efb0ff, #efb0ff);
  --mat-sys-scrim: light-dark(#000000, #000000);
  --mat-sys-secondary: light-dark(#5d5f5f, #c6c6c7);
  --mat-sys-secondary-container: light-dark(#e2e2e2, #454747);
  --mat-sys-secondary-fixed: light-dark(#e2e2e2, #e2e2e2);
  --mat-sys-secondary-fixed-dim: light-dark(#c6c6c7, #c6c6c7);
  --mat-sys-shadow: light-dark(#000000, #000000);
  --mat-sys-surface: light-dark(#fff7fb, #19101b);
  --mat-sys-surface-bright: light-dark(#fff7fb, #403642);
  --mat-sys-surface-container: light-dark(#fae9f9, #261c27);
  --mat-sys-surface-container-high: light-dark(#f4e3f3, #312732);
  --mat-sys-surface-container-highest: light-dark(#eedded, #3c313d);
  --mat-sys-surface-container-low: light-dark(#ffeffd, #221823);
  --mat-sys-surface-container-lowest: light-dark(#ffffff, #140b16);
  --mat-sys-surface-dim: light-dark(#e6d5e5, #19101b);
  --mat-sys-surface-tint: light-dark(#9c00c9, #efb0ff);
  --mat-sys-surface-variant: light-dark(#f2dcf2, #514253);
  --mat-sys-tertiary: light-dark(#b80068, #ffb0cb);
  --mat-sys-tertiary-container: light-dark(#ffd9e3, #8d004f);
  --mat-sys-tertiary-fixed: light-dark(#ffd9e3, #ffd9e3);
  --mat-sys-tertiary-fixed-dim: light-dark(#ffb0cb, #ffb0cb);
  --mat-sys-neutral-variant20: #3a2c3c;
  --mat-sys-neutral10: #221823;
  --mat-sys-level0: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-sys-level1: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-sys-level2: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
  --mat-sys-level3: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-sys-level4: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-sys-level5: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-sys-corner-extra-large: 28px;
  --mat-sys-corner-extra-large-top: 28px 28px 0 0;
  --mat-sys-corner-extra-small: 4px;
  --mat-sys-corner-extra-small-top: 4px 4px 0 0;
  --mat-sys-corner-full: 9999px;
  --mat-sys-corner-large: 16px;
  --mat-sys-corner-large-end: 0 16px 16px 0;
  --mat-sys-corner-large-start: 16px 0 0 16px;
  --mat-sys-corner-large-top: 16px 16px 0 0;
  --mat-sys-corner-medium: 12px;
  --mat-sys-corner-none: 0;
  --mat-sys-corner-small: 8px;
  --mat-sys-dragged-state-layer-opacity: 0.16;
  --mat-sys-focus-state-layer-opacity: 0.12;
  --mat-sys-hover-state-layer-opacity: 0.08;
  --mat-sys-pressed-state-layer-opacity: 0.12;
}

/* Light Theme */
.theme-generic-a {
  --mat-sys-primary: #006c51;
  --mat-sys-on-primary: #ffffff;
  --mat-sys-primary-container: #92f6d0;
  --mat-sys-on-primary-container: #002117;
  --mat-sys-inverse-primary: #75d9b5;
  --mat-sys-primary-fixed: #92f6d0;
  --mat-sys-primary-fixed-dim: #75d9b5;
  --mat-sys-on-primary-fixed: #002117;
  --mat-sys-on-primary-fixed-variant: #00513d;
  --mat-sys-secondary: #426557;
  --mat-sys-on-secondary: #ffffff;
  --mat-sys-secondary-container: #c4ebd9;
  --mat-sys-on-secondary-container: #002117;
  --mat-sys-secondary-fixed: #c4ebd9;
  --mat-sys-secondary-fixed-dim: #a9cfbe;
  --mat-sys-on-secondary-fixed: #002117;
  --mat-sys-on-secondary-fixed-variant: #2b4d40;
  --mat-sys-tertiary: #2f666f;
  --mat-sys-on-tertiary: #ffffff;
  --mat-sys-tertiary-container: #b5ecf6;
  --mat-sys-on-tertiary-container: #001f24;
  --mat-sys-tertiary-fixed: #b5ecf6;
  --mat-sys-tertiary-fixed-dim: #99cfda;
  --mat-sys-on-tertiary-fixed: #001f24;
  --mat-sys-on-tertiary-fixed-variant: #104e57;
  --mat-sys-background: #fcf9f7;
  --mat-sys-on-background: #1c1b1b;
  --mat-sys-surface: #fcf9f7;
  --mat-sys-surface-dim: #dcd9d8;
  --mat-sys-surface-bright: #fcf9f7;
  --mat-sys-surface-container-lowest: #ffffff;
  --mat-sys-surface-container-low: #f6f3f2;
  --mat-sys-surface-container: #f0edec;
  --mat-sys-surface-container-high: #ebe7e6;
  --mat-sys-surface-container-highest: #e5e2e1;
  --mat-sys-on-surface: #1c1b1b;
  --mat-sys-shadow: #000000;
  --mat-sys-scrim: #000000;
  --mat-sys-surface-tint: #5a5f5d;
  --mat-sys-inverse-surface: #313030;
  --mat-sys-inverse-on-surface: #f3f0ef;
  --mat-sys-outline: #747875;
  --mat-sys-outline-variant: #c3c8c4;
  --mat-sys-error: #ba1a1a;
  --mat-sys-error-container: #ffdad6;
  --mat-sys-on-error: #ffffff;
  --mat-sys-on-error-container: #410002;
  --mat-sys-surface-variant: #dfe4df;
  --mat-sys-on-surface-variant: #434845;
}

/* Dark Theme */
.dark-mode .theme-generic-a {
  --mat-sys-primary: #75d9b5;
  --mat-sys-on-primary: #003829;
  --mat-sys-primary-container: #00513d;
  --mat-sys-on-primary-container: #92f6d0;
  --mat-sys-inverse-primary: #006c51;
  --mat-sys-primary-fixed: #92f6d0;
  --mat-sys-primary-fixed-dim: #75d9b5;
  --mat-sys-on-primary-fixed: #002117;
  --mat-sys-on-primary-fixed-variant: #00513d;
  --mat-sys-secondary: #a9cfbe;
  --mat-sys-on-secondary: #13362a;
  --mat-sys-secondary-container: #2b4d40;
  --mat-sys-on-secondary-container: #c4ebd9;
  --mat-sys-secondary-fixed: #c4ebd9;
  --mat-sys-secondary-fixed-dim: #a9cfbe;
  --mat-sys-on-secondary-fixed: #002117;
  --mat-sys-on-secondary-fixed-variant: #2b4d40;
  --mat-sys-tertiary: #99cfda;
  --mat-sys-on-tertiary: #00363d;
  --mat-sys-tertiary-container: #104e57;
  --mat-sys-on-tertiary-container: #b5ecf6;
  --mat-sys-tertiary-fixed: #b5ecf6;
  --mat-sys-tertiary-fixed-dim: #99cfda;
  --mat-sys-on-tertiary-fixed: #001f24;
  --mat-sys-on-tertiary-fixed-variant: #104e57;
  --mat-sys-background: #131313;
  --mat-sys-on-background: #e5e2e1;
  --mat-sys-surface: #131313;
  --mat-sys-surface-dim: #131313;
  --mat-sys-surface-bright: #3a3939;
  --mat-sys-surface-container-lowest: #0e0e0e;
  --mat-sys-surface-container-low: #1c1b1b;
  --mat-sys-surface-container: #201f1f;
  --mat-sys-surface-container-high: #2a2a29;
  --mat-sys-surface-container-highest: #353534;
  --mat-sys-on-surface: #e5e2e1;
  --mat-sys-shadow: #000000;
  --mat-sys-scrim: #000000;
  --mat-sys-surface-tint: #c3c8c4;
  --mat-sys-inverse-surface: #e5e2e1;
  --mat-sys-inverse-on-surface: #313030;
  --mat-sys-outline: #8d928f;
  --mat-sys-outline-variant: #434845;
  --mat-sys-error: #ffb4ab;
  --mat-sys-error-container: #93000a;
  --mat-sys-on-error: #690005;
  --mat-sys-on-error-container: #ffdad6;
  --mat-sys-surface-variant: #434845;
  --mat-sys-on-surface-variant: #c3c8c4;
}

/* -------------------------------------------------------------------------
 * Component-Specific Overrides
 * Applied to all themes
 * ------------------------------------------------------------------------- */
.mat-toolbar-header {
  --mat-toolbar-container-background-color: var(--mat-sys-primary-fixed-dim);
  --mat-toolbar-container-text-color: var(--mat-sys-on-primary);
}
.mat-toolbar-header .mat-mdc-icon-button {
  color: inherit;
}
.mat-toolbar-header .mat-mdc-icon-button mat-icon {
  color: inherit;
}

html {
  --mat-button-toggle-shape: 20px;
  --mat-button-toggle-selected-state-text-color: var(--mat-sys-primary);
  --mat-button-toggle-selected-state-background-color: transparent;
}

html {
  --mat-form-field-filled-container-color: transparent;
  --mat-form-field-filled-active-indicator-color: var(--mat-sys-outline);
  --mat-form-field-filled-focus-active-indicator-color: var(--mat-sys-primary);
}

html {
  --mat-fab-container-shape: 30px;
}

html {
  --mat-slide-toggle-selected-handle-size: 12px;
  --mat-slide-toggle-unselected-handle-size: 12px;
  --mat-slide-toggle-pressed-handle-size: 12px;
  --mat-slide-toggle-touch-target-size: 40px;
  --mat-slide-toggle-track-height: 22px;
  --mat-slide-toggle-track-width: 40px;
  --mat-slide-toggle-track-shape: 11px;
  --mat-slide-toggle-state-layer-size: 0px;
  --mat-slide-toggle-selected-handle-horizontal-margin: 0 22px;
  --mat-slide-toggle-unselected-handle-horizontal-margin: 0 6px;
  --mat-slide-toggle-selected-pressed-handle-horizontal-margin: 0 22px;
  --mat-slide-toggle-unselected-pressed-handle-horizontal-margin: 0 6px;
  --mat-slide-toggle-selected-handle-color: var(--mat-sys-secondary);
  --mat-slide-toggle-selected-hover-handle-color: var(--mat-sys-secondary);
  --mat-slide-toggle-selected-focus-handle-color: var(--mat-sys-secondary);
  --mat-slide-toggle-selected-pressed-handle-color: var(--mat-sys-secondary);
  --mat-slide-toggle-selected-track-color: var(--mat-sys-primary);
  --mat-slide-toggle-selected-hover-track-color: var(--mat-sys-primary);
  --mat-slide-toggle-selected-focus-track-color: var(--mat-sys-primary);
  --mat-slide-toggle-unselected-pressed-handle-color: var(--mat-sys-secondary);
  --mat-slide-toggle-unselected-handle-color: var(--mat-sys-secondary);
  --mat-slide-toggle-unselected-hover-handle-color: var(--mat-sys-secondary);
  --mat-slide-toggle-unselected-focus-handle-color: var(--mat-sys-secondary);
}

/* -------------------------------------------------------------------------
 * Override for surface variant cards overlays timeline etc
 * Applied to all themes
 * ------------------------------------------------------------------------- */
.inverse-surface {
  --mat-icon-button-icon-color: var(--mat-sys-inverse-on-surface);
  background-color: var(--mat-sys-inverse-surface);
  color: var(--mat-sys-inverse-on-surface);
  --mat-checkbox-label-text-color: var(--mat-sys-inverse-on-surface);
  --mat-checkbox-disabled-label-color: rgb(from var(--mat-sys-secondary-container) r g b/0.7);
  --mat-checkbox-disabled-selected-icon-color: rgb(from var(--mat-sys-secondary-container) r g b/0.7);
  --mat-checkbox-disabled-unselected-icon-color: rgb(from var(--mat-sys-secondary-container) r g b/0.7);
  --mat-checkbox-disabled-selected-checkmark-color: rgb(from var(--mat-sys-secondary-container) r g b/0.7);
  --mat-checkbox-unselected-icon-color: var(--mat-sys-inverse-on-surface);
  --mat-checkbox-unselected-hover-icon-color: var(--mat-sys-inverse-on-surface);
  --mat-checkbox-unselected-focus-icon-color: var(--mat-sys-inverse-on-surface);
  --mat-select-enabled-trigger-text-color: var(--mat-sys-inverse-on-surface);
  --mat-select-disabled-trigger-text-color: var(--mat-sys-inverse-on-surface);
  --mat-button-text-label-text-color: var(--mat-sys-inverse-on-surface);
  --mat-button-text-state-layer-color: var(--mat-sys-inverse-on-surface);
}
.inverse-surface.overlay {
  background-color: color-mix(in srgb, var(--mat-sys-inverse-surface), transparent 35%);
  border-radius: var(--mat-sys-corner-medium);
  padding: 0.5em;
  margin: 0.25em;
}
.inverse-surface {
  --mat-slide-toggle-selected-handle-color: var(--mat-sys-on-primary);
  --mat-slide-toggle-selected-hover-handle-color: var(--mat-sys-on-primary);
  --mat-slide-toggle-selected-focus-handle-color: var(--mat-sys-on-primary);
  --mat-slide-toggle-selected-pressed-handle-color: var(--mat-sys-on-primary);
  --mat-slide-toggle-selected-track-color: var(--mat-sys-primary);
  --mat-slide-toggle-selected-pressed-track-color: var(--mat-sys-primary);
  --mat-slide-toggle-selected-hover-track-color: var(--mat-sys-primary);
  --mat-slide-toggle-selected-focus-track-color: var(--mat-sys-primary);
  --mat-slide-toggle-unselected-pressed-handle-color: var(--mat-sys-on-primary);
  --mat-slide-toggle-unselected-handle-color: var(--mat-sys-on-primary);
  --mat-slide-toggle-unselected-hover-handle-color: var(--mat-sys-on-primary);
  --mat-slide-toggle-unselected-focus-handle-color: var(--mat-sys-on-primary);
  --mat-slide-toggle-unselected-track-color: var(--mat-sys-inverse-surface);
  --mat-slide-toggle-unselected-pressed-track-color: var(--mat-sys-inverse-surface);
  --mat-slide-toggle-unselected-hover-track-color: var(--mat-sys-inverse-surface);
  --mat-slide-toggle-unselected-focus-track-color: var(--mat-sys-inverse-surface);
  --mat-slide-toggle-label-text-color: var(--mat-sys-on-primary);
  --mat-slide-toggle-disabled-label-text-color: rgb(from var(--mat-sys-on-primary) r g b/0.7);
  --mat-slide-toggle-disabled-unselected-handle-color: var(--mat-sys-on-primary);
  --mat-slide-toggle-disabled-unselected-track-color: var(--mat-sys-on-primary);
}

.mat-checkbox-slim {
  --mat-checkbox-touch-target-display: none;
  --mat-checkbox-state-layer-size: 28px;
}
.mat-checkbox-slim .mdc-form-field {
  padding: 0;
}
.mat-checkbox-slim .mdc-label {
  padding: 0;
}

.mat-select-slim {
  font-size: 0.75rem;
  width: auto !important;
}
.mat-select-slim .mat-mdc-select-trigger {
  height: 1.5rem;
  min-height: 1.5rem;
  padding: 0 0.25rem;
}
.mat-select-slim .mat-mdc-select-arrow-wrapper {
  order: -1;
  margin-right: 0.25rem;
  margin-left: 0;
}
.mat-select-slim .mat-mdc-select-value {
  font-size: 0.75rem;
  line-height: 1.5rem;
}

.mat-select-slim-panel {
  font-size: 0.75rem !important;
  width: fit-content !important;
}
.mat-select-slim-panel .mat-mdc-option {
  min-height: 2rem !important;
  font-size: 0.75rem !important;
  padding: 0 0.5rem !important;
}

.mat-icon.mat-icon-xs {
  font-size: 14px;
  width: 14px;
  height: 14px;
  line-height: 14px;
}
.mat-icon.mat-icon-xs svg {
  width: 14px;
  height: 14px;
}
.mat-icon.mat-icon-sm {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}
.mat-icon.mat-icon-sm svg {
  width: 16px;
  height: 16px;
}
.mat-icon.mat-icon-md {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.mat-icon.mat-icon-md svg {
  width: 20px;
  height: 20px;
}
.mat-icon.mat-icon-xl {
  font-size: 48px;
  width: 48px;
  height: 48px;
  line-height: 48px;
}
.mat-icon.mat-icon-xl svg {
  width: 48px;
  height: 48px;
}

.mat-button-slim {
  --mat-button-filled-container-height: 24px;
  --mat-button-filled-touch-target-display: none;
  --mat-button-outlined-container-height: 24px;
  --mat-button-outlined-touch-target-display: none;
  --mat-button-protected-container-height: 24px;
  --mat-button-protected-touch-target-display: none;
  --mat-button-text-container-height: 24px;
  --mat-button-text-touch-target-display: none;
  --mat-button-tonal-container-height: 24px;
  --mat-button-tonal-touch-target-display: none;
  font-size: 0.6rem !important;
}

/* -------------------------------------------------------------------------
 * Chips - Compact, no border, theme colors
 * ------------------------------------------------------------------------- */
html {
  --mat-chip-outline-width: 0;
  --mat-chip-label-text-size: 0.75rem;
  --mat-chip-container-height: 1.5rem;
  --mat-chip-container-shape-radius: 1rem;
}

.mat-mdc-chip:not(.chip-empty) {
  --mat-chip-label-text-color: var(--mat-sys-primary-fixed-dim);
  --mat-chip-elevated-container-color: color-mix(in srgb, var(--mat-sys-primary) 40%, transparent);
}

.mat-mdc-chip.chip-empty {
  --mat-chip-label-text-color: var(--mat-sys-outline);
  --mat-chip-elevated-container-color: var(--mat-sys-surface-container-high);
}

/* -------------------------------------------------------------------------
 * Progress Bar - percentage variant (opt-in via .bar-percent class)
 * Does NOT affect loading bars or other mat-progress-bar usages.
 * Usage: add class="bar-percent" to any mat-progress-bar.
 * ------------------------------------------------------------------------- */
mat-progress-bar.bar-percent {
  width: 100%;
}
mat-progress-bar.bar-percent,
mat-progress-bar.bar-percent .mdc-linear-progress,
mat-progress-bar.bar-percent .mdc-linear-progress__buffer,
mat-progress-bar.bar-percent .mdc-linear-progress__bar {
  height: 1rem !important;
  border-radius: 0.4rem !important;
}
mat-progress-bar.bar-percent .mdc-linear-progress__bar-inner {
  border-radius: 0.4rem !important;
  border-top-width: 1rem !important;
  border-color: var(--bar-color, var(--mat-sys-primary)) !important;
}

.bar-row {
  display: flex;
  align-items: center;
  position: relative;
  width: 5rem;
}

.bar-percent-label {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  pointer-events: none;
  line-height: 1;
}

/* -------------------------------------------------------------------------
 * Expansion Panel - Compact layout, indicator on left
 * ------------------------------------------------------------------------- */
html {
  --mat-expansion-header-collapsed-state-height: 2.5rem;
  --mat-expansion-header-expanded-state-height: 2.5rem;
}

.mat-expansion-panel-header {
  padding: 0 0.75rem !important;
}
.mat-expansion-panel-header .mat-expansion-indicator {
  order: -1;
  margin-right: 0.5rem;
  transform: rotate(180deg);
}
.mat-expansion-panel-header mat-panel-title {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mat-expansion-panel-header mat-panel-description {
  flex: 0 0 auto;
  margin: 0;
  padding: 0;
  color: inherit;
}

.mat-expansion-panel-body {
  padding: 0 0.25rem 0.5rem !important;
  line-height: 1.3;
}

.mat-expansion-panel.mat-expanded > .mat-expansion-panel-header .mat-expansion-indicator {
  transform: rotate(0deg);
}

.mat-icon-button-small {
  --mat-icon-button-state-layer-size: 24px;
  --mat-icon-button-icon-size: 16px;
}
.mat-icon-button-small .mat-mdc-button-persistent-ripple,
.mat-icon-button-small .mat-mdc-button-ripple,
.mat-icon-button-small .mat-ripple {
  inset: 0;
  border-radius: 50%;
}
.mat-icon-button-small .mat-mdc-button-touch-target {
  width: 24px !important;
  height: 24px !important;
}
.mat-icon-button-small .mat-icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
  line-height: 16px;
}

.mat-icon-button-medium {
  --mat-icon-button-state-layer-size: 32px;
  --mat-icon-button-icon-size: 18px;
}
.mat-icon-button-medium .mat-mdc-button-persistent-ripple,
.mat-icon-button-medium .mat-mdc-button-ripple,
.mat-icon-button-medium .mat-ripple {
  inset: 0;
  border-radius: 50%;
}
.mat-icon-button-medium .mat-mdc-button-touch-target {
  width: 32px !important;
  height: 32px !important;
}
.mat-icon-button-medium .mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  line-height: 18px;
}

/* ── mat-stroked-button: compact global override ─────────────────────────── */
.mat-mdc-outlined-button {
  font-size: 0.8rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.mat-mdc-outlined-button.mat-mdc-button-base {
  --mdc-outlined-button-container-shape: 3px;
}
.mat-mdc-outlined-button.mat-mdc-button-base:not([disabled]) {
  border-color: var(--mat-sys-primary);
}

/* ── btn-loaded: filled primary state (data already loaded) ──────────────── */
.btn-loaded {
  background-color: var(--mat-sys-primary) !important;
  color: var(--mat-sys-inverse-on-surface) !important;
}

.hidden {
  display: none !important;
}

.panel-eyebrow {
  color: var(--mat-sys-primary);
  letter-spacing: var(--vx-tracking-wide);
}

.icon-primary {
  color: var(--mat-sys-primary);
}

.filters-panel {
  --mat-checkbox-state-layer-size: 26px;
}

app-full-screen-image {
  --mat-icon-button-icon-color: var(--mat-sys-on-primary);
}

.property-button-panel {
  --mat-fab-container-color: var(--mat-sys-surface-container-low);
  --mat-fab-foreground-color: var(--mat-sys-primary);
  --mat-fab-state-layer-color: var(--mat-sys-primary);
}

.scale-bar {
  --mat-menu-container-color: var(--mat-sys-inverse-surface);
  --mat-menu-item-label-text-color: var(--mat-sys-inverse-on-surface);
}

.mat-mdc-checkbox .mdc-checkbox .mat-mdc-checkbox-touch-target {
  width: 24px;
  height: 24px;
}

.image-dialog {
  background: white;
  border-radius: 8px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  cursor: default;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}
.image-dialog .dialog-content {
  padding: 16px;
  max-height: 90vh;
  overflow: auto;
}
.image-dialog .dialog-content .full-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

.fullscreen-image-panel {
  z-index: 1001 !important;
}
.fullscreen-image-panel app-full-screen-image {
  display: block;
  width: 100%;
  height: 100%;
}

.mat-icon-toggle-button {
  --mat-icon-button-icon-color: var(--mat-sys-on-surface);
}
.mat-icon-toggle-button.selected {
  color: var(--mat-sys-primary);
}

.map-toolbar {
  background-color: var(--mat-sys-inverse-surface);
  display: flex;
}
.map-toolbar .mat-icon-toggle-button {
  --mat-icon-button-icon-color: var(--mat-sys-inverse-on-surface);
}
.map-toolbar .mat-icon-toggle-button.selected {
  color: var(--mat-sys-primary);
  font-weight: 500;
}

.mat-mdc-mini-fab {
  --mat-fab-small-disabled-state-foreground-color: var(--mat-sys-on-surface);
  --mat-fab-small-disabled-state-container-color: var(--mat-sys-secondary-container);
}
.mat-mdc-mini-fab.selected {
  --mat-fab-small-foreground-color: var(--mat-sys-primary);
}

.search-panel-container {
  min-width: 320px;
  max-width: 600px;
  z-index: 11;
}

.search-form-field .mdc-text-field--filled {
  border-bottom-right-radius: var(--mat-form-field-filled-container-shape, var(--mat-sys-corner-extra-small));
  border-bottom-left-radius: var(--mat-form-field-filled-container-shape, var(--mat-sys-corner-extra-small));
}
.search-form-field .search-history-container {
  padding: 0;
}
.search-form-field .search-history-container .search-history-option {
  display: flex;
  background-color: var(--mat-sys-surface);
}
.search-form-field .search-history-container .mat-mdc-option .mdc-list-item__primary-text {
  display: flex;
  flex-grow: 1;
  align-items: center;
}
.search-form-field .search-history-container .mat-mdc-option .mdc-list-item__primary-text .search-text {
  flex-grow: 1;
}
.search-form-field .search-button {
  color: var(--mat-sys-primary);
}
.search-form-field {
  --mat-form-field-filled-container-color: var(--mat-sys-surface);
}

.form-small, .form-slim, .form-ultra-slim {
  --mat-form-field-container-height: 40px;
  --mat-form-field-filled-label-display: none;
  --mat-form-field-container-vertical-padding: 8px;
  --mat-form-field-filled-with-label-container-padding-top: 8px;
  --mat-form-field-filled-with-label-container-padding-bottom: 8px;
  --mat-form-field-filled-label-text-size: 12px;
  --mat-form-field-container-text-size: 14px;
}

.form-slim .mat-mdc-form-field-subscript-wrapper, .form-ultra-slim .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.form-ultra-slim {
  --mat-form-field-container-height: 36px;
  --mat-form-field-filled-label-display: none;
  --mat-form-field-container-vertical-padding: 6px;
  --mat-form-field-filled-with-label-container-padding-top: 6px;
  --mat-form-field-filled-with-label-container-padding-bottom: 6px;
  --mat-form-field-filled-label-text-size: 10px;
  --mat-form-field-container-text-size: 12px;
  --mat-select-trigger-text-size: 12px;
}

.panel-dialog, .medium-panel-dialog {
  --mat-dialog-container-min-width: 650px;
  --mat-dialog-container-max-width: 650px;
  --mat-dialog-container-small-max-width: 95vw;
}

.medium-panel-dialog {
  --mat-dialog-container-min-height: 700px;
  --mat-dialog-container-max-height: 700px;
}
.medium-panel-dialog mat-dialog-container {
  min-height: 700px !important;
}

.gallery-dialog {
  --mat-dialog-container-min-width: 80vw;
  --mat-dialog-container-small-max-width: 95vw;
  --mat-dialog-container-min-height: 75vh;
  --mat-dialog-container-max-height: 75vh;
}

.dialog-header-container {
  display: flex !important;
  align-items: center;
  gap: 16px;
  /* Remove this to allow to create sub component */
}
.dialog-header-container .header-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 12px;
  color: var(--mat-sys-on-surface);
}
.dialog-header-container button {
  flex-shrink: 0; /* Evita que los botones se deformen si el título es largo */
}
.dialog-header-container .close-button {
  align-self: start;
}

.search-form-field {
  flex: 1;
  --mat-form-field-state-layer-color: transparent;
  --mat-form-field-filled-active-indicator-color: transparent;
  --mat-form-field-filled-active-indicator-height: 0px;
  --mat-form-field-filled-hover-active-indicator-coloractive-indicator-color: transparent;
  --mat-form-field-filled-focus-active-indicator-color: transparent;
}

.mat-toolbar-filters {
  display: flex;
  flex-direction: row;
  gap: 0.3em;
}
.mat-toolbar-filters > div {
  width: 50%;
}
.mat-toolbar-filters > div mat-form-field {
  width: 100%;
}

.toolbar-viewer {
  --mat-fab-small-container-color: var(--mat-sys-inverse-surface);
  pointer-events: none;
}

.pac-container:after {
  background-image: none !important;
  height: 0 !important;
}

.pac-item {
  width: inherit !important;
  white-space: normal !important;
  line-height: 1.5 !important;
}

.pac-item-query {
  display: inline !important;
}

.panel-section-header {
  border-bottom: 1px solid var(--mat-sys-outline-variant);
  background: var(--mat-sys-surface-container-lowest);
}

/**
 * Vexcel Design System — Layout & Component Tokens
 *
 * CSS custom properties used across the chat UI and other components.
 *
 * RULE: Only define a --vx-* token when it is either:
 *   (a) a unique value with no --mat-sys-* equivalent, OR
 *   (b) a semantic concept (success, warning, link) that
 *       Material does not model and is used in ≥2 places.
 *
 * Use --mat-sys-* tokens directly everywhere else.
 */
:root {
  /* ── Layout dimensions ──────────────────────────────── */
  --vx-panel-w: 350px;
  --vx-bubble-w: 420px;
  --vx-bubble-h: 600px;
  --vx-panel-header-h: 48px;
  --vx-dialog-w: 650px;
  /* ── Semantic status colors ─────────────────────────── */
  /* No Material equivalent; used across type-chip, HITL cards, mock-panel */
  --vx-success: #22a55a;
  --vx-error: #d04825;
  --vx-on-error: #ffffff;
  --vx-error-container: #d048251a;
  --vx-on-error-container: #5c1800;
  --vx-warning: #f59e0b;
  --vx-on-warning: #ffffff;
  --vx-warning-container: color-mix(in srgb, var(--vx-warning) 15%, #fff);
  --vx-on-warning-container: #5b4500;
  --vx-tracking-wide: 0.08em; /* eyebrow / step-kicker letter-spacing */
  --vx-link: #2964aa;
}

/* ── Utility: spinning icon (used by sync icon during loading) ── */
.spin-icon {
  animation: vx-spin 1s linear infinite;
}

@keyframes vx-spin {
  to {
    transform: rotate(360deg);
  }
}
/* Import Bootstrap styles.
 * Note: @import is used here because Bootstrap is not yet fully modularized
 * and we need to preserve its original cascade order.
 */
/*!
 * Bootstrap  v5.3.8 (https://getbootstrap.com/)
 * Copyright 2011-2025 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: rgb(5.2, 44, 101.2);
  --bs-secondary-text-emphasis: rgb(43.2, 46.8, 50);
  --bs-success-text-emphasis: rgb(10, 54, 33.6);
  --bs-info-text-emphasis: rgb(5.2, 80.8, 96);
  --bs-warning-text-emphasis: rgb(102, 77.2, 2.8);
  --bs-danger-text-emphasis: rgb(88, 21.2, 27.6);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(206.6, 226, 254.6);
  --bs-secondary-bg-subtle: rgb(225.6, 227.4, 229);
  --bs-success-bg-subtle: rgb(209, 231, 220.8);
  --bs-info-bg-subtle: rgb(206.6, 244.4, 252);
  --bs-warning-bg-subtle: rgb(255, 242.6, 205.4);
  --bs-danger-bg-subtle: rgb(248, 214.6, 217.8);
  --bs-light-bg-subtle: rgb(251.5, 252, 252.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(158.2, 197, 254.2);
  --bs-secondary-border-subtle: rgb(196.2, 199.8, 203);
  --bs-success-border-subtle: rgb(163, 207, 186.6);
  --bs-info-border-subtle: rgb(158.2, 233.8, 249);
  --bs-warning-border-subtle: rgb(255, 230.2, 155.8);
  --bs-danger-border-subtle: rgb(241, 174.2, 180.6);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(10.4, 88, 202.4);
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: rgb(255, 242.6, 205.4);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(109.8, 168, 253.8);
  --bs-secondary-text-emphasis: rgb(166.8, 172.2, 177);
  --bs-success-text-emphasis: rgb(117, 183, 152.4);
  --bs-info-text-emphasis: rgb(109.8, 223.2, 246);
  --bs-warning-text-emphasis: rgb(255, 217.8, 106.2);
  --bs-danger-text-emphasis: rgb(234, 133.8, 143.4);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(2.6, 22, 50.6);
  --bs-secondary-bg-subtle: rgb(21.6, 23.4, 25);
  --bs-success-bg-subtle: rgb(5, 27, 16.8);
  --bs-info-bg-subtle: rgb(2.6, 40.4, 48);
  --bs-warning-bg-subtle: rgb(51, 38.6, 1.4);
  --bs-danger-bg-subtle: rgb(44, 10.6, 13.8);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(7.8, 66, 151.8);
  --bs-secondary-border-subtle: rgb(64.8, 70.2, 75);
  --bs-success-border-subtle: rgb(15, 81, 50.4);
  --bs-info-border-subtle: rgb(7.8, 121.2, 144);
  --bs-warning-border-subtle: rgb(153, 115.8, 4.2);
  --bs-danger-border-subtle: rgb(132, 31.8, 41.4);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(109.8, 168, 253.8);
  --bs-link-hover-color: rgb(138.84, 185.4, 254.04);
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: rgb(230.4, 132.6, 181.2);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(117, 183, 152.4);
  --bs-form-valid-border-color: rgb(117, 183, 152.4);
  --bs-form-invalid-color: rgb(234, 133.8, 143.4);
  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
[type=search]::-webkit-search-cancel-button {
  cursor: pointer;
  filter: grayscale(1);
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 226, 254.6);
  --bs-table-border-color: rgb(165.28, 180.8, 203.68);
  --bs-table-striped-bg: rgb(196.27, 214.7, 241.87);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 203.4, 229.14);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 209.05, 235.505);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(225.6, 227.4, 229);
  --bs-table-border-color: rgb(180.48, 181.92, 183.2);
  --bs-table-striped-bg: rgb(214.32, 216.03, 217.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(203.04, 204.66, 206.1);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(208.68, 210.345, 211.825);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(209, 231, 220.8);
  --bs-table-border-color: rgb(167.2, 184.8, 176.64);
  --bs-table-striped-bg: rgb(198.55, 219.45, 209.76);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(188.1, 207.9, 198.72);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(193.325, 213.675, 204.24);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 244.4, 252);
  --bs-table-border-color: rgb(165.28, 195.52, 201.6);
  --bs-table-striped-bg: rgb(196.27, 232.18, 239.4);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 219.96, 226.8);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 226.07, 233.1);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(255, 242.6, 205.4);
  --bs-table-border-color: rgb(204, 194.08, 164.32);
  --bs-table-striped-bg: rgb(242.25, 230.47, 195.13);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(229.5, 218.34, 184.86);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(235.875, 224.405, 189.995);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(248, 214.6, 217.8);
  --bs-table-border-color: rgb(198.4, 171.68, 174.24);
  --bs-table-striped-bg: rgb(235.6, 203.87, 206.91);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 193.14, 196.02);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 198.505, 201.465);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: rgb(198.4, 199.2, 200);
  --bs-table-striped-bg: rgb(235.6, 236.55, 237.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 224.1, 225);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 230.325, 231.25);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: rgb(77.4, 80.6, 83.8);
  --bs-table-striped-bg: rgb(44.1, 47.9, 51.7);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(55.2, 58.8, 62.4);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(49.65, 53.35, 57.05);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(182.4, 211.5, 254.4);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(182.4, 211.5, 254.4);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  color: rgba(var(--bs-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.75rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > textarea:focus ~ label::after,
.form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
.form-floating > textarea:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * var(--bs-border-width));
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(11.05, 93.5, 215.05);
  --bs-btn-hover-border-color: rgb(10.4, 88, 202.4);
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(10.4, 88, 202.4);
  --bs-btn-active-border-color: rgb(9.75, 82.5, 189.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(91.8, 99.45, 106.25);
  --bs-btn-hover-border-color: rgb(86.4, 93.6, 100);
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(86.4, 93.6, 100);
  --bs-btn-active-border-color: rgb(81, 87.75, 93.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(21.25, 114.75, 71.4);
  --bs-btn-hover-border-color: rgb(20, 108, 67.2);
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(20, 108, 67.2);
  --bs-btn-active-border-color: rgb(18.75, 101.25, 63);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(49.3, 209.95, 242.25);
  --bs-btn-hover-border-color: rgb(37.2, 207.3, 241.5);
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(61.4, 212.6, 243);
  --bs-btn-active-border-color: rgb(37.2, 207.3, 241.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(255, 202.3, 44.2);
  --bs-btn-hover-border-color: rgb(255, 199.2, 31.8);
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(255, 205.4, 56.6);
  --bs-btn-active-border-color: rgb(255, 199.2, 31.8);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(187, 45.05, 58.65);
  --bs-btn-hover-border-color: rgb(176, 42.4, 55.2);
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(176, 42.4, 55.2);
  --bs-btn-active-border-color: rgb(165, 39.75, 51.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(210.8, 211.65, 212.5);
  --bs-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(198.4, 199.2, 200);
  --bs-btn-active-border-color: rgb(186, 186.75, 187.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(66.3, 69.7, 73.1);
  --bs-btn-hover-border-color: rgb(55.2, 58.8, 62.4);
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(77.4, 80.6, 83.8);
  --bs-btn-active-border-color: rgb(55.2, 58.8, 62.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(-1 * var(--bs-border-width));
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(-1 * var(--bs-border-width));
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:nth-child(n+3),
.btn-group-vertical > :not(.btn-check) + .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-top,
  .card-group > .card:not(:last-child) > .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-bottom,
  .card-group > .card:not(:last-child) > .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-top,
  .card-group > .card:not(:first-child) > .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-bottom,
  .card-group > .card:not(:first-child) > .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse,
.accordion-flush > .accordion-item > .accordion-header .accordion-button,
.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(-1 * var(--bs-border-width));
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height);
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:not(.active):active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

:root,
[data-bs-theme=light] {
  --bs-btn-close-filter: ;
}

[data-bs-theme=dark] {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-right: calc(-0.5 * var(--bs-modal-header-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-left: auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--bs-carousel-indicator-active-bg);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--bs-carousel-caption-color);
  text-align: center;
}

.carousel-dark {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

:root,
[data-bs-theme=light] {
  --bs-carousel-indicator-active-bg: #fff;
  --bs-carousel-caption-color: #fff;
  --bs-carousel-control-icon-filter: ;
}

[data-bs-theme=dark] {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  flex-shrink: 0;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-left: auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  user-select: all !important;
}

.user-select-auto {
  user-select: auto !important;
}

.user-select-none {
  user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
:root {
  --mat-form-field-hover-state-layer-opacity: 0;
  --mat-form-field-filled-label-text-color: var(--mat-sys-secondary);
  --mat-form-field-filled-label-text-size: 20px;
  --mat-form-field-filled-hover-label-text-color: var(--mat-sys-secondary);
  --mat-form-field-filled-focus-label-text-color: var(--mat-sys-secondary);
  --mat-form-field-filled-error-label-text-color: var(--mat-sys-secondary);
  --mat-form-field-filled-error-hover-label-text-color: var(--mat-sys-secondary);
  --mat-form-field-filled-error-focus-label-text-color: var(--mat-sys-secondary);
  --mat-select-panel-background-color: var(--mat-sys-background);
  --mat-checkbox-label-text-color: var(--mat-sys-secondary);
  --mat-menu-container-color: var(--mat-sys-background);
  --mat-menu-divider-color: rgba(var(--mat-sys-inverse-surface), 0.7);
}

mat-button-toggle-group {
  background-color: #e0e0e0 !important;
}

mat-button-toggle {
  border: none !important;
  height: 100% !important;
}
mat-button-toggle .mat-button-toggle-button {
  border: none !important;
}
mat-button-toggle .mat-button-toggle-label-content {
  line-height: 32px !important;
  padding: 0 16px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: var(--mat-sys-inverse-surface) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
mat-button-toggle.mat-button-toggle-checked {
  background-color: var(--mat-sys-primary) !important;
}
mat-button-toggle.mat-button-toggle-checked .mat-button-toggle-label-content {
  color: white !important;
}
mat-button-toggle .mat-pseudo-checkbox-minimal.mat-pseudo-checkbox-checked::after {
  color: white;
}
mat-button-toggle mat-button-toggle-group.neutral {
  background-color: var(--mat-sys-inverse-surface) !important;
}
mat-button-toggle mat-button-toggle-group.neutral mat-button-toggle.mat-button-toggle-checked {
  background-color: transparent !important;
}
mat-button-toggle mat-button-toggle-group.neutral mat-button-toggle.mat-button-toggle-checked .mat-button-toggle-label-content {
  color: var(--mat-sys-inverse-surface) !important;
}

.mat-mdc-slider {
  --mat-mdc-slider-hover-ripple-color: unset;
  --mat-mdc-slider-focus-ripple-color: unset;
}

.mat-mdc-option-active {
  background-color: var(--mat-sys-background) !important;
  color: var(--mat-sys-primary) !important;
}

.mat-error .error-title {
  font-weight: bold;
  white-space: normal;
  word-wrap: break-word;
}

.mat-mdc-form-field-error-wrapper {
  z-index: 99 !important;
  padding: 0 !important;
}

.mdc-text-field {
  padding: 0 !important;
}

.mat-error {
  margin: 0.25rem 0 0 0;
  border-color: red;
  border-style: solid;
  border-width: 1px;
  min-width: 100%;
  background-color: #FFE8E8;
  color: red;
  font-size: var(--mat-sys-label-small-size) !important;
}

.mat-error p {
  margin: 0 0.25rem 0 1.5rem !important;
}

.mat-error .error-title {
  font-weight: bold;
  white-space: normal;
  word-wrap: break-word;
  margin-top: -12px !important;
}

.mat-error .mat-icon {
  font-size: 15px !important;
  padding: 0.25rem;
  position: absolute;
  height: 24px !important;
  width: 24px !important;
}

.auth-wrapper {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center;
  align-items: center;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  justify-content: center;
  align-content: center;
}
.auth-wrapper .auth-form {
  width: 100%;
  padding: 8px;
  --mat-form-field-filled-label-text-weight: var(--mat-sys-title-medium-weight);
  --mat-form-field-filled-label-text-color: var(--mat-sys-secondary);
}
.auth-wrapper .auth-form .mat-mdc-form-field {
  width: 100%;
}
.auth-wrapper .auth-form .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  padding: 0;
}
.auth-wrapper .auth-box {
  position: relative;
  top: 0;
  opacity: 1;
  float: left;
  width: 100%;
  background: #fff;
  border-radius: 2px;
  transform: scale(1);
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  z-index: 5;
  max-width: 330px;
  padding: 0;
}
.auth-wrapper .auth-container {
  margin-top: 0.5rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.auth-wrapper .auth-container h6 {
  margin-top: 1rem;
}
@media (max-width: 767.98px) {
  .auth-wrapper .auth-container {
    width: 300px !important;
  }
  .auth-wrapper .auth-box {
    max-width: 300px !important;
  }
}
.auth-wrapper .auth-icon {
  position: absolute;
  right: 2%;
  bottom: 1%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-size: contain;
  background-repeat: no-repeat;
  width: 100px;
  height: 130px;
  color: white;
}
.auth-wrapper .auth-title {
  font-size: 20px;
  font-weight: 500;
}
.auth-wrapper .auth-container-actions {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 20px 0;
}
.auth-wrapper .auth-loading-container {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center;
  align-items: center;
  background-color: rgba(131, 131, 131, 0.21);
  position: absolute;
  min-width: 100%;
  min-height: 100%;
  z-index: 99;
  justify-content: center;
  align-content: center;
}
.auth-wrapper .auth-forgot-password {
  display: block;
  text-align: right;
  margin-bottom: 15px;
}
.auth-wrapper .auth-container-resume {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.auth-wrapper .auth-accept-button {
  font-size: 16px !important;
  padding: 1.5rem 1rem !important;
}
.auth-wrapper .auth-accept-button.mat-button-disabled {
  background-color: rgba(0, 0, 0, 0.12) !important;
  color: rgba(0, 0, 0, 0.26) !important;
}
.auth-wrapper .auth-error-response-container {
  margin-top: 0.7em;
  position: relative;
}

/* -------------------------------------------------------------------------
 * Optional Viewer Components Styles
 * -------------------------------------------------------------------------
 * These styles are not mandatory to be loaded globally.
 * They are separated so they can be loaded lazily if needed,
 * avoiding unnecessary bloat in the main bundle.
 */
/**
 * Re-export variables and palette modules.
 *
 * This file forwards the 'styles/variables' and 'styles/palette' modules,
 * making their members available to any file that imports _globals.scss.
 * This centralizes configuration and ensures consistent theming across the library.
 */
confirm-download-dialog .download-button {
  background-color: var(--mat-sys-primary);
  color: white;
}

.dialogActions .buttonDialog {
  color: white;
  background-color: var(--mat-sys-primary) !important;
}
.dialogActions .buttonDialog:disabled {
  color: #53575a !important;
}
.dialogActions .cancelButton:disabled {
  color: #53575a !important;
}

.urlStyle {
  width: 70%;
}

.disabled {
  color: rgba(0, 0, 0, 0.38);
}

.upload-div {
  width: 100%;
  display: inline-flex;
  align-items: center;
  margin-bottom: 4%;
}

/* TODO(mdc-migration): The following rule targets internal classes of radio that may no longer apply for the MDC version. */
.divButtonFoot {
  justify-content: flex-end;
  width: 100%;
  display: inline-flex;
}

.spacer {
  flex: 1 1 auto;
}

.horizontal-container {
  padding: 10px;
  width: 100%;
  display: inline-flex;
  align-items: center;
}
.layersContainer {
  max-height: 200px;
  max-width: 540px;
  overflow-y: scroll;
}
.layersContainer > div {
  border: 1px solid #C3C1C1;
  margin-bottom: 15px;
}
.layersContainer > div .layer-info {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}
.layersContainer .horizontal-container mat-checkbox {
  /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
  /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
}
.layersContainer .horizontal-container mat-checkbox .mat-checkbox-layout {
  /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
}
.type-radio-group {
  width: 30%;
  display: flex;
}
.type-radio-group .spacer {
  flex: 0.47 0.5 auto;
}
.type-radio-group .spacer.auth-option-spacer {
  min-width: 27%;
}

.bottom-wrapper {
  display: flex;
}
.bottom-wrapper button {
  width: 30%;
  max-width: 165px;
}

.loading {
  display: flex;
  align-items: center;
  width: 30%;
}
.loading span {
  color: rgba(0, 0, 0, 0.7);
}

/**
 * Re-export variables and palette modules.
 *
 * This file forwards the 'styles/variables' and 'styles/palette' modules,
 * making their members available to any file that imports _globals.scss.
 * This centralizes configuration and ensures consistent theming across the library.
 */
.overlay-widget .layer-row {
  font-size: 12px;
  height: 24px;
  box-shadow: unset;
  padding: 0 !important;
  display: contents !important;
  background-color: rgba(76, 81, 85, 0.65);
  color: white;
}
.overlay-widget .layer-name {
  color: white;
}

.layer-manager-sync {
  position: absolute;
  width: 350px;
  top: 0;
  right: 50px;
  bottom: 50px;
  left: 0;
  overflow: inherit;
}

app-layer-manager-widget .child-layers {
  padding-left: 1em !important;
  overflow: unset !important;
}
app-layer-manager-widget .main-layer {
  padding-left: 0;
  padding-right: 0;
}
app-layer-manager-widget .layer-name {
  color: white !important;
}
app-layer-manager-widget .icon-container.arrow-icon-spacing {
  margin-left: -2px !important;
  width: 14px !important;
}

app-layer-item {
  width: 100% !important;
}

.layer-content {
  flex-grow: 1;
}

.layer-name {
  color: #797E82;
  font-weight: normal !important;
}

.layer-name.disabled {
  color: rgb(157, 161, 163) !important;
}

.layer-manager-container .overlay-container {
  display: block;
}

.layer-selector {
  width: 100%;
  margin-bottom: 20px;
  padding: 0;
}

.icon-container {
  padding-top: 5px;
  width: 20px !important;
  display: flex;
  align-items: center;
  vertical-align: center;
}

.icon-container.arrow-icon-spacing {
  margin-left: -10px;
}

.layer-row .mat-icon {
  user-select: none;
}

.left-mat-icon {
  width: 20px !important;
  cursor: pointer;
}

#security-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.material-icons.folder-icon {
  color: #1877af;
}

.layer-row .tools-container .location-button {
  opacity: 0.7;
}

.layer-row .tools-container .location-button:disabled {
  color: rgb(157, 161, 163);
}

.layer-row {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 6px 0;
  padding: 6px 2px;
  border-radius: 4px;
}

.layer-row .tools-container .location-button:disabled {
  color: rgb(157, 161, 163);
}

.layer-row .tools-container .mat-divider {
  border-right: 2px rgb(157, 161, 163) solid !important;
}

.layer-name {
  padding: 0 6px;
  font-size: 13px;
}

/**
Draggable layer panel
 */
.layer-selector .cdk-drag-preview {
  box-sizing: border-box;
}

.layer-selector .cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.layer-selector .layer-row:last-child {
  border: none;
}

.layer-selector .base-layer-group.cdk-drop-list-dragging .layer-row:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.child-layers {
  padding-left: 3rem;
  margin-left: 0.5rem !important;
  width: 100%;
}

.child-features {
  display: flex;
}

.feature-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 4px 2px;
  margin-left: 15px;
  line-height: 20px;
}

.feature-content span {
  max-width: 190px;
  display: inline-block;
}

.feature-icon {
  padding: 5px;
}

.left-mat-icon {
  width: 20px !important;
  height: 20px !important;
  cursor: pointer;
}

.no-pointer {
  cursor: default !important;
}

.mat-divider {
  border-top-color: rgba(0, 0, 0, 0.15);
}

.primary-field {
  font-size: 0.8rem;
}

.secondary-field {
  font-size: 0.7rem;
}

.highlight {
  font-weight: bold !important;
  background: rgba(73, 150, 233, 0.2) 0 0 no-repeat padding-box;
  border-radius: 4px;
}

.svg_left-icons {
  width: 70%;
  height: 70%;
}

.icon-field {
  padding: 8px !important;
  margin: 0 !important;
}

.zoom-to-feature mat-icon {
  transform: scale(1) !important;
}

.switch-button {
  font-size: 34px;
  width: 34px;
  height: 34px;
  color: #9c9c9c;
}

.switch-button.on {
  color: #1877af;
}

/**
 * Re-export variables and palette modules.
 *
 * This file forwards the 'styles/variables' and 'styles/palette' modules,
 * making their members available to any file that imports _globals.scss.
 * This centralizes configuration and ensures consistent theming across the library.
 */
.link-btn {
  color: var(--mat-sys-primary);
  cursor: pointer;
  pointer-events: all;
}

.toolbar-toggle-container {
  position: relative;
}

.toolbar-panel-container {
  position: absolute;
  padding: 15px;
  left: 50px;
  top: 0;
  width: 350px;
  height: 100%;
  max-height: 100%;
  background-color: var(--mat-sys-surface);
  z-index: 5;
  flex: 1;
  overflow-x: auto;
}

.scale-line {
  margin-top: 8px !important;
}

.scale-line-selector {
  z-index: 4;
}

#unit-selector-panel {
  position: absolute;
  bottom: 7em;
}

.button-area {
  display: flex !important;
}

.restore-button {
  background-color: var(--mat-sys-on-primary) !important;
  color: var(--mat-sys-primary) !important;
  padding: 0 8px !important;
}

.save-button {
  background-color: var(--mat-sys-primary) !important;
  color: var(--mat-sys-on-primary) !important;
}

.non-truncated-property-tooltip {
  word-break: keep-all !important;
  white-space: normal !important;
  max-width: 215px !important;
}

.non-truncated-property-tooltip-disabled {
  word-break: keep-all !important;
  white-space: normal !important;
  max-width: 240px !important;
}

.non-truncated-damage-tooltip {
  word-break: keep-all !important;
  white-space: normal !important;
  max-width: 251px !important;
}

.non-truncated-damage-tooltip-disabled {
  word-break: keep-all !important;
  white-space: normal !important;
  max-width: 267px !important;
}

.non-truncated-pdf-tooltip {
  word-break: keep-all !important;
  white-space: normal !important;
  max-width: 230px !important;
}

.non-truncated-pdf-tooltip-disabled {
  word-break: keep-all !important;
  white-space: normal !important;
  max-width: 280px !important;
}

/**
 * Re-export variables and palette modules.
 *
 * This file forwards the 'styles/variables' and 'styles/palette' modules,
 * making their members available to any file that imports _globals.scss.
 * This centralizes configuration and ensures consistent theming across the library.
 */
app-infrared-selector .switch-button.on {
  color: var(--mat-sys-primary) !important;
}
app-infrared-selector button.on {
  color: var(--mat-sys-primary) !important;
}

app-collection-controller .path-orientation.selected {
  fill: var(--mat-sys-primary);
}
app-collection-controller .nadir-button.selected {
  color: var(--mat-sys-primary);
}
app-collection-controller .infrared-button.selected {
  color: var(--mat-sys-primary);
}
app-collection-controller .path-mode.selected {
  fill: var(--mat-sys-primary);
}

.mode-badge {
  width: 20px !important;
  height: 20px !important;
  border-radius: 10px;
  font-size: 10px;
  font-weight: bold;
  color: #fff;
  line-height: 20px;
  text-align: center;
  background-color: #008DFF;
}

.mode-badge.gray {
  background-color: #BFBFBF;
}

.mode-badge.second-mode-badge {
  margin-left: 4px;
}

.collection-preview-card {
  min-width: 600px;
  position: relative !important;
  pointer-events: auto;
  padding: 0 35px !important;
}
.collection-preview-card .mat-mdc-card-content {
  padding: 0 !important;
  position: relative !important;
  margin-top: 20px !important;
  height: 80px;
}
.collection-preview-card.mini .mat-mdc-card-content {
  margin-top: 30px !important;
}

.mini-slider {
  min-width: 105px !important;
}
.mini-slider .filters-panel {
  left: 60px !important;
  margin: 15px 0 !important;
}

.collection-preview-card .ngx-slider-limit {
  color: black;
  font-size: 14px;
}

.collection-preview-card .ngx-slider .ngx-slider-bar {
  background: #E3E3E3;
  height: 2px;
}

/* START Pointer stop timeline style */
.collection-preview-card .ngx-slider .ngx-slider-pointer {
  outline-width: 0 !important;
  margin-left: -2px;
  top: 22px;
  background-color: transparent !important;
  z-index: 3;
  border-radius: 0;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 15px solid #f1f1f2;
}

.mini-slider .ngx-slider .ngx-slider-pointer {
  left: 16px !important;
}

.collection-preview-card .ngx-slider .ngx-slider-pointer::after {
  border-radius: 4px;
  width: 6px !important;
  height: 6px !important;
  background-color: white !important;
  top: 7px !important;
  left: -3px !important;
}

/* END Pointer stop timeline style */
/* START Stops timeline style */
.collection-preview-card .ngx-slider .ngx-slider-tick {
  font-family: Roboto-Light, Roboto, sans-serif;
  font-size: 12px !important;
  position: absolute;
  font-weight: bold !important;
  color: #fff !important;
  margin: 0 0 0 -2px !important;
  border-radius: 10px;
}

.mini-slider .ngx-slider .ngx-slider-tick.gray {
  left: 16px !important;
}

.mini-slider .ngx-slider .ngx-slider-tick {
  left: 16px !important;
}

.collection-preview-card .ngx-slider .ngx-slider-tick::after {
  position: absolute;
  width: 20px !important;
  height: 20px !important;
  font-weight: bold !important;
  color: #fff !important;
  top: -5px !important;
  left: -5px !important;
  line-height: 20px;
  border-radius: 10px;
  background-color: #008DFF !important;
}

.collection-preview-card .ngx-slider .ngx-slider-tick.wide::after {
  position: absolute;
  width: 20px !important;
  height: 20px !important;
  font-weight: bold !important;
  color: #fff !important;
  top: -5px !important;
  left: -5px !important;
  line-height: 20px;
  border-radius: 10px;
  background-color: #8ECCFF !important;
}

.collection-preview-card .ngx-slider .ngx-slider-tick.gray::after {
  position: absolute;
  width: 30px !important;
  height: 30px !important;
  font-weight: bold !important;
  top: -8px !important;
  left: -8px !important;
  line-height: 24px;
  margin: 0 0 0 -2px !important;
  background-color: #BFBFBF !important;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) no-repeat no-repeat;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) no-repeat no-repeat;
  -webkit-mask-size: 30px;
}

.collection-preview-card .ngx-slider .ngx-slider-tick.threeD::after {
  content: "3D" !important;
}

.collection-preview-card .ngx-slider .ngx-slider-tick.twoD::after {
  content: "2D" !important;
}

.collection-preview-card .ngx-slider-tick-value {
  color: #e2e2e2;
  font-size: 12px !important;
  white-space: nowrap !important;
  top: -22px !important;
}

.collection-preview-card .ngx-slider .ngx-slider-tick.gray .ngx-slider-tick-value {
  top: -18px !important;
}

.collection-preview-card .ngx-slider-tick.collection-hide {
  opacity: 0.35;
}

/* END Stops timeline style */
/* START Legend timeline style */
.collection-preview-card .ngx-slider-tick-legend {
  top: 2px !important;
  font-size: 10px;
  color: #F4F5F7;
  text-shadow: 0 3px 6px #000000;
  margin-top: 10px;
  white-space: nowrap !important;
}

.collection-preview-card .ngx-slider-span {
  height: 0;
}

.collection-preview-card .ngx-slider .ngx-slider-tick-legend .legend-limits {
  text-align: center !important;
}

.legend-limits {
  position: absolute;
  bottom: 37px;
  margin: 0 0 -15px -18px !important;
  width: 37px;
  height: 30px;
  overflow: hidden;
  white-space: pre-wrap;
}

.legend-year {
  position: absolute;
  font-size: 12px;
  top: -35px !important;
  margin-left: -10px;
}

/* END Legend timeline style */
/* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
/* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
.right-padding {
  padding-right: 50px !important;
}

.slider-padding {
  display: flex !important;
}

.disabled {
  pointer-events: none;
}

.float-right {
  float: right;
}

.collection-hide {
  opacity: 0.25;
}

.hide {
  display: none !important;
}

.center {
  position: relative;
}

.block {
  display: block;
}

.container-line {
  width: 80px;
  height: 1px;
  background-color: black;
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.circle {
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 10px;
  background-color: white;
  border: solid 1px black;
  border-radius: 50%;
  position: absolute;
  top: -4px;
  left: calc(50% - 5px);
}

.white {
  background: white;
}

.white .circle {
  background: white;
  border-color: white;
}

.badge-display {
  margin-top: -17px;
  position: absolute;
}

.date-label {
  text-align: center;
  color: white;
  padding-top: 23px;
  position: relative;
}

.date-mini-slider {
  text-align: center;
  font-size: 10px;
  text-shadow: 3px 3px #43464b;
  position: relative;
}

.text-white {
  color: white;
}

/**
 * Re-export variables and palette modules.
 *
 * This file forwards the 'styles/variables' and 'styles/palette' modules,
 * making their members available to any file that imports _globals.scss.
 * This centralizes configuration and ensures consistent theming across the library.
 */
.sidebar-component {
  box-sizing: content-box;
  padding: 0 24px 16px;
  display: block;
  margin: 0;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  overflow: visible;
  background-color: white;
}

.sidebar-component .header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 10px;
}

.sidebar-component .container-title {
  font-weight: bold;
  padding-left: 10px;
  display: block;
  font-size: 14px;
  margin-left: -20px;
  color: black;
}

.sidebar-component .sub-title {
  text-align: left;
  color: black;
  padding: 4px;
  margin: 10px 0;
}

.sidebar-component .header-container {
  flex: 1 1 auto;
}

.sidebar-component .container-title {
  color: #84bd00;
  font-weight: bold;
  padding-left: 10px;
  display: block;
  font-size: 12px;
  padding-top: 4px;
}

.sidebar-component .sub-title {
  color: #84bd00;
  font-weight: bold;
  padding-left: 20px;
  text-align: center;
  font-size: 10px;
}

.sidebar-component .info-title {
  color: rgb(157, 161, 163);
  font-weight: bold;
  padding-left: 10px;
  text-align: center;
  font-size: 12px;
}

.sidebar-component .top-divider {
  border-top: 2px rgba(157, 161, 163, 0.8);
}

.sidebar-component .container-subtitle {
  padding-left: 10px;
  color: rgb(157, 161, 163);
  font-size: 10px;
  display: block;
}

.sidebar-icon-indicator {
  height: 28px;
  width: 28px;
  font-size: 28px;
}

.sidebar-radio-button {
  padding: 0 6px 0 0;
}

/**
 * Re-export variables and palette modules.
 *
 * This file forwards the 'styles/variables' and 'styles/palette' modules,
 * making their members available to any file that imports _globals.scss.
 * This centralizes configuration and ensures consistent theming across the library.
 */
/*  FullScreen mode */
.fullscreen {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #262626;
  color: white;
}
.fullscreen .top-info-panel {
  display: flex;
  width: 100%;
  align-items: center;
  height: 7%;
  position: absolute;
  top: 0;
  justify-content: space-between;
  padding: 0 3%;
  z-index: 16;
  background-color: #262626;
}
.fullscreen .top-info-panel .info-back-wrapper {
  width: 19%;
  display: flex;
  min-width: 360px;
  align-items: center;
  padding-top: 1%;
}
.fullscreen .top-info-panel .info-back-wrapper mat-icon {
  cursor: pointer;
}
.fullscreen .top-info-panel .info-back-wrapper .address {
  text-align: left;
  font-size: 16px;
  padding-left: 1%;
  width: 100%;
}
.fullscreen .top-info-panel .view-on-map-button {
  border: none;
  font-size: 16px;
  font-weight: bold;
  background: transparent;
  color: var(--mat-sys-primary);
}
.fullscreen .top-info-panel .view-on-map-button:focus {
  outline: none;
}
.fullscreen .top-info-panel .view-on-map-button mat-icon {
  position: relative;
  top: 7px;
}
.fullscreen .side-column {
  width: 10%;
  display: flex;
  flex-direction: column;
  min-height: 10%;
  justify-content: center;
}
.fullscreen .side-column .arrow-label {
  position: relative;
  top: 20px;
}
.fullscreen .side-column.align-right {
  align-items: flex-end;
  padding-right: 1%;
}
.fullscreen .side-column.align-left {
  align-items: flex-start;
  padding-left: 1%;
}
.fullscreen .side-column mat-icon {
  cursor: pointer;
  position: absolute;
}
.fullscreen .fullscreen-image {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.fullscreen .fullscreen-image .img-wrapper {
  width: 80%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  overflow: hidden;
}
.fullscreen .fullscreen-image .img-wrapper::-webkit-scrollbar {
  display: none;
}
.fullscreen .fullscreen-image .img-wrapper .image {
  position: relative;
  display: flex;
  min-width: 80%;
  align-items: center;
  justify-content: center;
}
.fullscreen .fullscreen-image .img-wrapper .image .image-mask {
  position: absolute;
  background-color: #F9FAFB;
  border: 1px solid #707070;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 15;
}
.fullscreen .fullscreen-image .img-wrapper .image .image-mask .loading-animation {
  width: 80px;
  height: 80px;
}
.fullscreen .fullscreen-image .img-wrapper .image .image-mask .loading-animation div {
  transform-origin: 11px 40px;
  margin-left: 35%;
}
.fullscreen .fullscreen-image .img-wrapper .image .image-mask .loading-animation div::after {
  width: 4px;
  height: 19px;
}
.fullscreen .bottom-info-panel {
  width: 100%;
  height: 13%;
  position: absolute;
  bottom: 0%;
  padding: 0 3%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 16;
  background-color: #262626;
}
.fullscreen .bottom-info-panel .image-info-wrapper {
  display: flex;
  height: 100%;
  width: 26%;
  justify-content: space-between;
  align-items: center;
  min-width: 370px;
  word-wrap: break-word;
}
.fullscreen .bottom-info-panel .image-info-wrapper .image-gsd-type {
  text-transform: capitalize;
}
.fullscreen .bottom-info-panel .bottom-actions-panel {
  display: flex;
  justify-content: space-between;
}
.fullscreen .bottom-info-panel .bottom-actions-panel .mat-button-toggle {
  background: transparent;
}
.fullscreen .bottom-info-panel .bottom-actions-panel .fullscreen-action.active {
  background-color: rgba(255, 255, 255, 0.33);
}
.fullscreen .bottom-info-panel .bottom-actions-panel .fullscreen-control-panel {
  background-color: #53575a;
}
.fullscreen .bottom-info-panel .bottom-actions-panel .count {
  display: flex;
  align-items: center;
  width: 43px;
  justify-content: center;
}
.fullscreen .disabled, .fullscreen .disabled mat-icon {
  color: rgba(157, 161, 163, 0.8);
  cursor: default;
}

.toolTipButton {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.toolTipButton .tooltiptext {
  visibility: hidden;
  font-weight: 500;
  font-size: 10px;
  background-color: #616161;
  margin: 30px 14px 14px 14px;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 6px 8px;
  position: absolute;
  z-index: 1;
}

.toolTipButton:hover .tooltiptext {
  visibility: visible;
}

.fullscreen-info-panel {
  background: white;
  color: #3C4043;
}
.fullscreen-info-panel .info-details div.value-list {
  color: rgba(0, 0, 0, 0.54);
}

.toolbar-header-wrapper .toolbar-gallery-header .open-gallery-button {
  color: var(--mat-sys-primary);
}
.toolbar-header-wrapper .toolbar-gallery-header .collapse-button mat-icon {
  background: #F7F9FC;
  color: var(--mat-sys-primary);
}
.toolbar-header-wrapper .toolbar-gallery-header .collapse-button mat-icon:hover {
  color: #F7F9FC;
  background: var(--mat-sys-primary);
}

.toolbar-gallery-info-panel .scroll-arrow {
  background: whitesmoke;
}
.toolbar-gallery-info-panel .scroll-arrow#left-arrow {
  background: linear-gradient(270deg, transparent 0, rgb(245, 245, 245) 30%);
}
.toolbar-gallery-info-panel .scroll-arrow#right-arrow {
  background: linear-gradient(90deg, transparent 0, rgb(245, 245, 245) 30%);
}
.toolbar-gallery-info-panel .image-filters .filter {
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.2470588235);
  box-shadow: 0px 3px 6px rgba(157, 161, 163, 0.3490196078);
}
.toolbar-gallery-info-panel .image-filters .filter.selected {
  border-color: var(--mat-sys-primary);
}

.image-wrapper.is-selected {
  border-color: var(--mat-sys-primary) !important;
}

.collections-wrapper::-webkit-scrollbar, .toolbar-gallery-container::-webkit-scrollbar {
  background-color: #f5f5f5;
}
.collections-wrapper::-webkit-scrollbar-thumb, .toolbar-gallery-container::-webkit-scrollbar-thumb {
  background: #BEBEC4 0% 0% no-repeat padding-box;
}
.collections-wrapper .collection-cover .cover-year-label, .toolbar-gallery-container .collection-cover .cover-year-label {
  color: white;
}
.collections-wrapper .collection-cover .cover-year-label:after, .toolbar-gallery-container .collection-cover .cover-year-label:after {
  background: transparent linear-gradient(180deg, rgba(247, 247, 255, 0.0509803922) 0%, rgba(150, 150, 150, 0.8274509804) 33%, #5F5F62 100%) 0% 0% no-repeat padding-box;
}

/*  Image Gallery colors */
.selected-image {
  box-shadow: inset 0px 0px 1px 5px var(--mat-sys-primary);
}

/*Filter styles*/
/*Placeholder*/
@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
/**
 * Re-export variables and palette modules.
 *
 * This file forwards the 'styles/variables' and 'styles/palette' modules,
 * making their members available to any file that imports _globals.scss.
 * This centralizes configuration and ensures consistent theming across the library.
 */
.dialog-bottom-actions-spacing {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
}

.upload-layer-container {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.upload-layer-container .info-row {
  display: inline-flex;
  justify-content: space-between;
  text-align: center;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #53575a;
  margin: 1em 0;
  padding: 0;
  width: 99%;
}

.url-form {
  padding-bottom: 30px;
}

.layer-name-label {
  max-width: 300px !important;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
}

.buttonDialog {
  width: 20%;
  margin: 10px;
  display: flex;
  justify-content: center;
}

.cancelButton {
  width: 20%;
  margin: 10px;
  display: flex;
  justify-content: center;
  background-color: white !important;
  color: black !important;
}

.dialogActions {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.name-end-icon {
  padding-left: 15px;
}

.row-field-name {
  width: 60% !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.row-field {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.name {
  display: flex;
  align-items: center;
}

.edit-icon {
  padding-left: 20px !important;
  color: #53575a;
  padding-right: 20px !important;
}

.add-data-title {
  padding-left: 10px;
}

.layer-name-dialog {
  width: 100%;
}

.name-field-color {
  color: #53575a !important;
}

.type-radio-group {
  width: 30%;
  display: flex;
}
.type-radio-group .spacer {
  flex: 0.47 0.5 auto;
}

.bottom-wrapper {
  display: flex;
}
.bottom-wrapper button {
  width: 30%;
  max-width: 165px;
  color: var(--mat-sys-primary);
}

.upload-layer-content {
  display: flex;
  max-height: 40vh !important;
  justify-content: space-between;
  flex-direction: column;
  overflow-y: scroll;
}

.spacer {
  flex: 1 1 auto;
}

.auth-div {
  padding-bottom: 20px;
}

.checkbox-padding {
  padding-right: 20px !important;
}

.auth-field {
  width: 100%;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
}

.horizontal-container {
  padding: 10px;
  width: 100%;
  justify-content: space-between;
  display: inline-flex;
  align-items: center;
}
.horizontal-container.rename-form {
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.url-div {
  display: inline-block;
}

.loading {
  padding-top: 30px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100% !important;
  max-height: 150px !important;
}

.error {
  color: red;
}

.loading-data-label {
  padding-top: 50px;
}

.mat-mdc-option.mat-active {
  background: white !important;
}

.mat-mdc-option.mat-mdc-selected {
  background: white !important;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

/* TODO(mdc-migration): The following rule targets internal classes of slider that may no longer apply for the MDC version.*/
.mat-mdc-slider.mat-accent .mat-slider-thumb-label-text {
  color: white !important;
}

.slider-wrapper .slider-label {
  color: rgba(0, 0, 0, 0.42);
  font-size: 11px;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.dropzone {
  background-color: rgba(243, 242, 241, 0.5647058824);
  border: 1px dashed var(--mat-sys-primary);
}
.dropzone .dropzone-label {
  color: rgb(157, 161, 163);
  font-weight: 500;
}

/*  Loader styles */
.loading-animation {
  width: 40px;
  height: 40px;
}
.loading-animation div {
  transform-origin: 11px 18px;
  animation: lds-spinner 1.2s linear infinite;
}
.loading-animation div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 5px;
  left: 10px;
  width: 2px;
  height: 8px;
  background: black;
}
.loading-animation div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.loading-animation div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.loading-animation div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.loading-animation div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.loading-animation div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.loading-animation div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.loading-animation div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.loading-animation div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.loading-animation div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.loading-animation div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.loading-animation div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.loading-animation div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}

/**
 * Re-export variables and palette modules.
 *
 * This file forwards the 'styles/variables' and 'styles/palette' modules,
 * making their members available to any file that imports _globals.scss.
 * This centralizes configuration and ensures consistent theming across the library.
 */
phoenix-property-info .copy-table, phoenix-property-damage-info .copy-table {
  color: var(--mat-sys-primary);
}
phoenix-property-info .copy-table mat-icon, phoenix-property-damage-info .copy-table mat-icon {
  color: var(--mat-sys-primary);
}

.ortho-status {
  background-color: var(--mat-sys-primary);
}

.ortho-status-blue {
  background-color: #FFFFFF !important;
  color: #414344 !important;
}
.ortho-status-blue .white-icon {
  color: #414344 !important;
}

.colored-icon-preview {
  color: #414344;
}

app-location-info .copy-clipboard-button mat-icon {
  color: #8A8A8A;
}
app-location-info .copy-clipboard-button button {
  width: 25px;
  height: 25px;
  margin-top: 7px;
}

.location-info-container {
  position: absolute;
  bottom: 2px;
  right: 18px;
  z-index: 5;
  pointer-events: none;
}

.location-info-container-phoenix {
  margin-bottom: 0;
  margin-right: 0;
  margin-top: 2px;
  opacity: 0.9;
}

/**
 * Re-export variables and palette modules.
 *
 * This file forwards the 'styles/variables' and 'styles/palette' modules,
 * making their members available to any file that imports _globals.scss.
 * This centralizes configuration and ensures consistent theming across the library.
 */
.form-container {
  display: flex;
  flex-direction: column;
}

.form-container > * {
  width: 100%;
}

.map-sidenav-container {
  padding: 0 4px;
  border-radius: 4px;
  overflow: visible;
}

.viewer-container {
  display: flex;
  position: relative;
  height: calc(100vh - 64px);
}

.viewer-container .map-container {
  flex: 1;
  position: relative;
  overflow: hidden;
  width: auto;
}

.viewer-container .panel-container {
  position: absolute;
  z-index: 2;
  display: flex;
  max-height: 100%;
  height: 100%;
  transition: height 0.5s ease-in;
}

/* dual-view container*/
.dual-container {
  display: flex;
}

.dual-child-container {
  flex: 1 0 50%;
  max-width: 50%;
}

.dual-child-container + .dual-child-container {
  border-left: solid var(--mat-sys-secondary) 3px;
}

.dual-child-container .viewer-container .panel-container {
  transition: max-height 0.5s ease-in;
  max-height: 50% !important;
}

.left-toolbar-container {
  z-index: 10;
  width: 50px;
  min-height: 100%;
  padding: 15px 0;
  pointer-events: none;
}
.left-toolbar-container > * {
  pointer-events: auto;
}

.left-toolbar-container-arrow {
  z-index: 10;
  height: 50px;
  width: 20px;
  background-color: #414344;
  overflow: hidden;
  bottom: auto !important;
  top: 0 !important;
  right: auto !important;
  box-shadow: none;
  border: 2px;
  opacity: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.arrow-icon {
  color: white;
  font-size: 20px;
  opacity: 100% !important;
  display: contents !important;
}

.right-toolbar-container {
  z-index: 10;
  position: absolute;
  right: 0;
  display: flex;
  justify-content: center;
  pointer-events: none;
  min-height: 100%;
  padding-top: 0;
}

.top-toolbar-container {
  position: absolute;
  width: 100%;
  display: flex;
  pointer-events: none;
  padding-top: 10px;
  z-index: 20;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
}

.expand-dual-view-container {
  position: absolute;
  display: flex;
  align-items: flex-start;
  top: 0 !important;
  z-index: 20;
  justify-content: left;
}

.top-toolbar-container .measurement-tools {
  position: absolute;
  right: 0;
  top: 0;
}

.toolbar-container {
  position: absolute;
  bottom: 20px;
  right: 35px;
  z-index: 5;
  pointer-events: none;
}

.toolbar-zoom-container {
  position: absolute;
  bottom: 70px;
  right: 35px;
  z-index: 5;
}

.toolbar-container-2 {
  bottom: 150px;
}

.toolbar-container .toolbar-item {
  height: 100%;
}

.search-manager-card {
  margin-bottom: 5px;
}

.footer-tools-container {
  position: absolute;
  bottom: 0;
  right: 35px;
}

.measurement-tools {
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 2;
}

.measurement-container .measure-select-field select {
  text-align: right;
}

.tooltip-for-measure {
  position: relative;
  text-shadow: 0 3px 2px #000000;
  border-radius: 0;
  color: white;
  padding: 4px 8px;
  white-space: nowrap;
  font-family: Roboto, CenturyGothic, AppleGothic, sans-serif;
  font-weight: bold;
  font-size: 14px;
}

.map-legend-container {
  position: absolute;
  right: auto !important;
  bottom: 30px;
  z-index: 5;
}

.dual-view-bottom-left {
  position: absolute;
  right: auto !important;
  bottom: 75px;
  z-index: 5;
}

.historic-container {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 5;
}

.toast-bottom-container {
  display: flex;
  justify-content: center;
  z-index: 11 !important;
}

.toolbar-toast-container {
  position: absolute;
  bottom: 70px !important;
  z-index: 11 !important;
}

.toolbar-info-controller {
  z-index: 10;
}

.info-container {
  position: absolute;
  padding-left: 50px;
  width: -webkit-fill-available;
  z-index: 4;
}

.info-container-short {
  margin-left: 350px;
  width: -webkit-fill-available;
}

@media screen and (max-width: 1400px) {
  .top-toolbar-container .measurement-tools {
    position: initial;
  }
}
@media screen and (max-width: 2800px) {
  .top-toolbar-container .measurement-tools.dual-view-tools {
    position: initial;
  }
}
/**
 * Re-export variables and palette modules.
 *
 * This file forwards the 'styles/variables' and 'styles/palette' modules,
 * making their members available to any file that imports _globals.scss.
 * This centralizes configuration and ensures consistent theming across the library.
 */
.search-display-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 64px) !important;
  background-color: var(--mat-sys-surface);
}

.display-toolbar {
  flex-shrink: 0;
  background: var(--mat-sys-surface);
  color: rgba(0, 0, 0, 0.87);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.toolbar-content {
  display: flex;
  align-items: center;
}

.toolbar-icon {
  margin-right: 12px;
}

.toolbar-icon--primary {
  color: #2196F3;
}

.toolbar-icon--success {
  color: #4CAF50;
}

.toolbar-icon--warning {
  color: #FF9800;
}

.toolbar-text {
  display: flex;
  flex-direction: column;
}

.toolbar-title {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.2;
}

.toolbar-subtitle {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.2;
}

.toolbar-subtitle--inline {
  margin-left: 16px;
  font-size: 14px;
}

.toolbar-spacer {
  flex: 1;
}

.display-content {
  padding: 16px;
}

.display-content--centered {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.display-content--no-padding {
  padding: 0;
}

.landing-section {
  max-width: 900px;
  width: 100%;
  padding: 64px 32px;
  text-align: center;
}

.landing-header {
  margin-bottom: 48px;
}

.landing-icon {
  font-size: 80px;
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
}

.landing-icon--primary {
  color: #2196F3;
}

.landing-icon--success {
  color: #4CAF50;
}

.landing-icon--error {
  color: #f44336;
}

.landing-icon--warning {
  color: #FF9800;
}

.landing-title {
  margin: 0 0 16px 0;
  font-size: 32px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.87);
}

.landing-description {
  font-size: 18px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.6;
  margin: 0;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.state-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 32px;
  text-align: center;
}

.state-container--compact {
  padding: 32px 16px;
}

.state-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  color: rgba(0, 0, 0, 0.38);
}

.state-icon--error {
  color: #f44336;
}

.state-icon--primary {
  color: #2196F3;
}

.state-title {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.87);
}

.state-title--medium {
  font-size: 20px;
}

.state-description {
  margin: 0 0 24px 0;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.6);
  max-width: 400px;
  line-height: 1.5;
}

.results-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  width: 100%;
}

.results-grid--compact {
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 12px;
}

.feature-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  margin-bottom: 64px;
}

.feature-card {
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.feature-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
}

.feature-card-content {
  padding: 32px 24px;
  text-align: center;
}

.feature-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
  color: var(--mat-sys-primary);
}

.feature-title {
  margin: 0 0 12px 0;
  font-size: 18px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.feature-description {
  margin: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.5;
}

.chips-section {
  text-align: center;
  margin-bottom: 32px;
}

.chips-section-title {
  margin: 0 0 24px 0;
  font-size: 20px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.87);
}

.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.suggestion-chip {
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  height: auto !important;
  max-width: 100%;
}
.suggestion-chip .mdc-evolution-chip__text-label,
.suggestion-chip .mat-mdc-chip-action-label {
  white-space: normal;
  line-height: 1.4;
}
.suggestion-chip.mdc-evolution-chip {
  --mat-chip-container-color: #e0e0e0;
  --mat-chip-label-text-color: rgba(0, 0, 0, 0.87);
}
.suggestion-chip.mdc-evolution-chip:hover {
  --mat-chip-container-color: rgba(76, 175, 80, 0.12);
  --mat-chip-elevated-container-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.suggestion-chip:not(.mdc-evolution-chip) {
  background-color: #e0e0e0 !important;
}
.suggestion-chip:not(.mdc-evolution-chip):hover {
  background-color: rgba(76, 175, 80, 0.12) !important;
}

.suggestion-chip--primary.mdc-evolution-chip {
  --mat-chip-container-color: #e3f2fd;
}
.suggestion-chip--primary.mdc-evolution-chip:hover {
  --mat-chip-container-color: rgba(33, 150, 243, 0.12);
}
.suggestion-chip--primary:not(.mdc-evolution-chip) {
  background-color: #e3f2fd !important;
}
.suggestion-chip--primary:not(.mdc-evolution-chip):hover {
  background-color: rgba(33, 150, 243, 0.12) !important;
}

/* TODO(mdc-migration): The following rule targets internal classes of chips that may no longer apply for the MDC version.*/
mat-chip-set .mdc-evolution-chip-set__chips {
  gap: 8px;
}

.load-more-section {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  padding: 16px;
}

.load-more-button {
  min-width: 160px;
}

.chat-input-container {
  display: flex;
  padding: 16px;
  background: var(--mat-sys-surface);
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  gap: 12px;
  align-items: flex-end;
  flex-shrink: 0;
}

.chat-input-field {
  flex: 1;
  margin: 0;
}
.chat-input-field textarea {
  resize: none;
  min-height: 24px;
  line-height: 1.5;
}

.send-button {
  height: 56px;
  min-width: 100px;
}

@media (max-width: 768px) {
  .display-content {
    padding: 12px;
  }
  .landing-section {
    padding: 32px 16px;
  }
  .landing-header {
    margin-bottom: 32px;
  }
  .landing-icon {
    font-size: 64px;
    width: 64px;
    height: 64px;
  }
  .landing-title {
    font-size: 28px;
  }
  .landing-description {
    font-size: 16px;
  }
  .feature-cards-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 48px;
  }
  .feature-card-content {
    padding: 24px 16px;
  }
  .feature-icon {
    font-size: 40px;
    width: 40px;
    height: 40px;
  }
  .results-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .chips-container {
    flex-direction: column;
    gap: 8px;
    align-items: center;
  }
  .state-container {
    padding: 32px 16px;
  }
  .state-icon {
    font-size: 48px;
    width: 48px;
    height: 48px;
  }
  .state-title {
    font-size: 20px;
  }
  .state-description {
    font-size: 14px;
  }
  .toolbar-subtitle--inline {
    display: none;
  }
  .chat-input-container {
    padding: 12px;
  }
  .send-button {
    min-width: 80px;
  }
}
/* -------------------------------------------------------------------------
 * Dialog Styles - Unified Search Dialog Components
 * -------------------------------------------------------------------------
 * Unified styles for SearchImageDialog and SearchGeofencingDialog components.
 * Uses Material Design Components (MDC) with responsive design.
 * Provides consistent layout, animations, and user experience.
 */
.vision-dialog-container {
  max-width: min(90vw, 1000px) !important;
  max-height: 90vh;
  width: 100%;
  height: 100%;
}
@media (min-width: 768px) {
  .vision-dialog-container {
    max-width: 900px;
    max-height: 85vh;
  }
}
@media (min-width: 1024px) {
  .vision-dialog-container {
    max-width: min(60vw, 1000px);
    max-height: 80vh;
  }
}

/* -------------------------------------------------------------------------
 * Dialog Structure - Common Layout
 * -------------------------------------------------------------------------
 */
.vision-dialog-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 500px;
}
.vision-dialog-content .dialog-header {
  padding: 24px 24px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
}
.vision-dialog-content .dialog-header h2 {
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}
.vision-dialog-content .dialog-header .dialog-description {
  margin: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.5;
}
.vision-dialog-content .dialog-body {
  flex: 1 1 auto;
  padding: 0 24px;
  overflow-y: auto;
  min-height: 0;
}
.vision-dialog-content .dialog-body .search-dialog-tabs {
  flex: 1;
  min-height: 0;
}
.vision-dialog-content .dialog-body .search-dialog-tabs .tab-content {
  padding: 24px 0;
  min-height: 300px;
}
.vision-dialog-content .dialog-body .search-dialog-tabs .tab-content .method-description {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  font-size: 14px;
  color: #666;
}
.vision-dialog-content .dialog-body .search-dialog-tabs .tab-content .method-description mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.vision-dialog-content .dialog-body .search-dialog-tabs .tab-content .form-section {
  margin-bottom: 16px;
}
.vision-dialog-content .dialog-body .search-dialog-tabs .tab-content .full-width {
  width: 100%;
}
.vision-dialog-content .dialog-footer {
  flex-shrink: 0;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.vision-dialog-content .dialog-footer button.loading {
  position: relative;
  color: transparent !important;
}
.vision-dialog-content .dialog-footer button.loading .loading-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: spin 1s linear infinite;
}
.vision-dialog-content .dialog-footer button.loading mat-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* -------------------------------------------------------------------------
 * Tab Validation Status - Only show when there's content
 * -------------------------------------------------------------------------
 */
.tab-validation-status {
  margin-top: 16px;
  padding: 12px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9em;
}
.tab-validation-status mat-icon {
  flex-shrink: 0;
}
.tab-validation-status.valid {
  background-color: rgba(76, 175, 80, 0.05);
  color: rgb(27, 94, 32);
  border: 1px solid rgba(76, 175, 80, 0.2);
}
.tab-validation-status.valid mat-icon {
  color: rgb(56, 142, 60);
}
.tab-validation-status.invalid {
  background-color: rgba(244, 67, 54, 0.05);
  color: rgb(183, 28, 28);
  border: 1px solid rgba(244, 67, 54, 0.2);
}
.tab-validation-status.invalid mat-icon {
  color: rgb(211, 47, 47);
}
.tab-validation-status.loading {
  background-color: rgba(33, 150, 243, 0.05);
  color: rgb(13, 71, 161);
  border: 1px solid rgba(33, 150, 243, 0.2);
}
.tab-validation-status.loading mat-icon {
  color: rgb(25, 118, 210);
  animation: spin 1s linear infinite;
}

/* -------------------------------------------------------------------------
 * Preview Section - Fixed at bottom (40% height for image dialog)
 * -------------------------------------------------------------------------
 */
.preview-section {
  flex-shrink: 0;
  height: 40%;
  min-height: 200px;
  margin-top: 16px;
  border-top: 2px solid #e0e0e0;
  padding: 16px 0 0 0;
  background-color: #fafafa;
}
.preview-section .preview-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-weight: 500;
  color: #333;
}
.preview-section .preview-header mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #1976d2;
}
.preview-section .preview-content {
  height: calc(100% - 50px);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.preview-section .preview-content .image-preview {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.preview-section .preview-content .preview-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #666;
}
.preview-section .preview-content .preview-info mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #ccc;
}
.preview-section .preview-content .preview-info .preview-details {
  text-align: center;
  font-size: 14px;
}
.preview-section .preview-content .preview-info .preview-details .file-name {
  font-weight: 500;
  color: #333;
}
.preview-section .preview-content .preview-info .preview-details .file-size {
  color: #666;
  font-size: 12px;
}
.preview-section .preview-placeholder {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #999;
}
.preview-section .preview-placeholder mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
}

/* -------------------------------------------------------------------------
 * Map/Geometry specific styling
 * -------------------------------------------------------------------------
 */
.radius-section {
  margin-top: 24px;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #f9f9f9;
}
.map-radius-info {
  margin-top: 16px;
  padding: 12px;
  background-color: #e3f2fd;
  border: 1px solid #2196f3;
  border-radius: 4px;
}
.map-radius-info .radius-display {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1565c0;
  font-weight: 500;
}
.map-radius-info .radius-display mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

/* -------------------------------------------------------------------------
 * Section Headers - Common styling for all sections
 * -------------------------------------------------------------------------
 */
.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-weight: 500;
  color: #424242;
}
.section-header.warning mat-icon {
  color: #b28704;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.section-header mat-icon {
  color: #1976d2;
  font-size: 20px;
  width: 20px;
  height: 20px;
}

/* -------------------------------------------------------------------------
 * Content Sections - Common padding and structure
 * -------------------------------------------------------------------------
 */
.content-section, .progress-section, .format-selection-section, .export-config-section, .search-query-section {
  padding: 16px 0;
}
.content-section:not(:last-child), .progress-section:not(:last-child), .format-selection-section:not(:last-child), .export-config-section:not(:last-child), .search-query-section:not(:last-child) {
  border-bottom: 1px solid #e0e0e0;
}

/* -------------------------------------------------------------------------
 * Card layouts - Selection cards for various dialogs
 * -------------------------------------------------------------------------
 */
.selection-cards, .format-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.format-cards {
  flex-direction: row !important;
}

.selection-card, .format-card {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border: 2px solid transparent;
  border-radius: 8px;
}
.selection-card:hover, .format-card:hover {
  border-color: rgba(25, 118, 210, 0.3);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.selection-card.selected, .selected.format-card {
  border-color: #075eba;
  background-color: rgba(25, 118, 210, 0.05);
}
.selection-card .card-header, .format-card .card-header, .format-card .format-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}
.selection-card .card-header .card-icon, .selection-card .card-header .format-card .format-icon, .format-card .card-header .card-icon, .format-card .card-header .format-icon, .format-card .format-header .card-icon, .format-card .format-header .format-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: #1976d2;
}
.selection-card .card-header .card-info, .selection-card .card-header .format-card .format-info, .format-card .card-header .card-info, .format-card .card-header .format-info, .format-card .format-header .card-info, .format-card .format-header .format-info {
  flex: 1;
}
.selection-card .card-header .card-info .card-title, .selection-card .card-header .card-info .format-card .format-title, .selection-card .card-header .format-card .format-info .card-title, .selection-card .card-header .format-card .format-info .format-title, .format-card .card-header .card-info .card-title, .format-card .card-header .card-info .format-title, .format-card .card-header .format-info .card-title, .format-card .card-header .format-info .format-title, .format-card .format-header .card-info .card-title, .format-card .format-header .card-info .format-title, .format-card .format-header .format-info .card-title, .format-card .format-header .format-info .format-title {
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
}
.selection-card .card-header .card-info .card-title .recommended-badge, .selection-card .card-header .card-info .format-card .format-title .recommended-badge, .selection-card .card-header .format-card .format-info .card-title .recommended-badge, .selection-card .card-header .format-card .format-info .format-title .recommended-badge, .format-card .card-header .card-info .card-title .recommended-badge, .format-card .card-header .card-info .format-title .recommended-badge, .format-card .card-header .format-info .card-title .recommended-badge, .format-card .card-header .format-info .format-title .recommended-badge, .format-card .format-header .card-info .card-title .recommended-badge, .format-card .format-header .card-info .format-title .recommended-badge, .format-card .format-header .format-info .card-title .recommended-badge, .format-card .format-header .format-info .format-title .recommended-badge {
  background-color: #4caf50;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
}
.selection-card .card-header .card-info .card-extension, .selection-card .card-header .card-info .format-card .format-extension, .selection-card .card-header .format-card .format-info .card-extension, .selection-card .card-header .format-card .format-info .format-extension, .format-card .card-header .card-info .card-extension, .format-card .card-header .card-info .format-extension, .format-card .card-header .format-info .card-extension, .format-card .card-header .format-info .format-extension, .format-card .format-header .card-info .card-extension, .format-card .format-header .card-info .format-extension, .format-card .format-header .format-info .card-extension, .format-card .format-header .format-info .format-extension {
  font-size: 12px;
  color: #666;
  font-family: monospace;
}
.selection-card .card-description, .format-card .card-description, .format-card .format-description {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

/* -------------------------------------------------------------------------
 * Query Display - For export dialog
 * -------------------------------------------------------------------------
 */
.search-query-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background-color: #f9f9f9;
}
.search-query-card .query-info .query-type {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.search-query-card .query-info .query-type mat-icon {
  color: #1976d2;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.search-query-card .query-info .query-type .query-title {
  font-weight: 500;
  color: #333;
}
.search-query-card .query-info .query-description {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
}
.search-query-card .query-info .query-preview .preview-image {
  max-width: 200px;
  max-height: 120px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  object-fit: cover;
}
.search-query-card .query-info .query-preview .text-preview {
  font-family: "Courier New", monospace;
  font-size: 12px;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px;
  color: #555;
  max-height: 80px;
  overflow-y: auto;
  word-break: break-all;
  white-space: pre-wrap;
}

/* -------------------------------------------------------------------------
 * Progress and Status - For export dialog
 * -------------------------------------------------------------------------
 */
.progress-container {
  margin-bottom: 16px;
}
.progress-container .progress-text {
  text-align: center;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #1976d2;
}

.status-message {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
}
.status-message.success {
  background-color: rgba(76, 175, 80, 0.1);
  color: #2e7d32;
  border: 1px solid rgba(76, 175, 80, 0.3);
}
.status-message.success mat-icon {
  color: #4caf50;
}
.status-message.error {
  background-color: rgba(244, 67, 54, 0.1);
  color: #c62828;
  border: 1px solid rgba(244, 67, 54, 0.3);
}
.status-message.error mat-icon {
  color: #f44336;
}
.status-message:not(.success):not(.error) {
  background-color: rgba(33, 150, 243, 0.1);
  color: #1565c0;
  border: 1px solid rgba(33, 150, 243, 0.3);
}
.status-message:not(.success):not(.error) mat-icon {
  color: #2196f3;
}

.error-actions {
  text-align: center;
}

/* -------------------------------------------------------------------------
 * Animations
 * -------------------------------------------------------------------------
 */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* -------------------------------------------------------------------------
 * Tab Groups (Both Dialogs)
 * -------------------------------------------------------------------------
 */
.search-dialog-tabs .mat-mdc-tab-group .mat-mdc-tab-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.tab-content {
  padding: 24px 0;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.method-description {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
  margin-bottom: 8px;
}
.method-description mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

/* -------------------------------------------------------------------------
 * File Upload Section with Drag & Drop (Both Dialogs)
 * -------------------------------------------------------------------------
 */
.upload-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.file-input-hidden {
  display: none;
}

.dropzone {
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #fafafa;
  position: relative;
  height: 180px;
  overflow: hidden;
}
.dropzone:hover {
  border-color: #999;
  background-color: #f5f5f5;
}
.dropzone.drag-over {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.04);
}
.dropzone.drag-over .dropzone-content {
  opacity: 0;
}
.dropzone.has-file {
  border-color: #4caf50;
  background-color: rgba(76, 175, 80, 0.04);
  border-style: solid;
  text-align: left !important;
  height: 120px;
}
.dropzone.has-image {
  text-align: left !important;
  height: 120px;
}
.dropzone.dropzone-error {
  border-color: #f44336;
  background-color: rgba(244, 67, 54, 0.04);
}
.dropzone .dropzone-content {
  transition: opacity 0.3s ease;
}
.dropzone .dropzone-content .upload-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #999;
  margin-bottom: 16px;
}
.dropzone .dropzone-content .primary-text {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  margin: 0 0 8px;
}
.dropzone .dropzone-content .secondary-text {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  margin: 0 0 16px;
}
.dropzone .dropzone-content .secondary-text .link-text {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
}
.dropzone .dropzone-content .file-restrictions small {
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
}
.dropzone .dropzone-drag-over .drag-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #1976d2;
  margin-bottom: 16px;
  animation: bounce 1s infinite;
}
.dropzone .dropzone-drag-over p {
  font-size: 18px;
  font-weight: 500;
  color: #1976d2;
  margin: 0;
}
.dropzone .uploaded-image-preview {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  text-align: left;
  padding: 16px;
}
.dropzone .uploaded-image-preview .image-preview {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  object-fit: cover;
  border: 1px solid rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
}
.dropzone .uploaded-image-preview .image-preview-error {
  width: 80px;
  height: 80px;
  font-size: 80px;
  color: var(--mat-sys-error);
  flex-shrink: 0;
}
.dropzone .uploaded-image-preview .file-info {
  flex: 1;
  min-width: 0;
  position: relative;
}
.dropzone .uploaded-image-preview .file-info .file-name {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 4px;
  word-break: break-all;
}
.dropzone .uploaded-image-preview .file-info .file-details {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}
.dropzone .uploaded-file-info {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  position: relative;
}
.dropzone .uploaded-file-info .file-icon {
  flex-shrink: 0;
}
.dropzone .uploaded-file-info .file-icon mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #666;
}
.dropzone .uploaded-file-info .file-details {
  flex: 1;
  min-width: 0;
}
.dropzone .uploaded-file-info .file-details .file-name {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 4px;
  word-break: break-all;
  font-size: 16px;
}
.dropzone .uploaded-file-info .file-details .file-size {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 8px;
}
.dropzone .uploaded-file-info .file-details .file-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.dropzone .uploaded-file-info .file-details .file-status.processing {
  color: #1976d2;
}
.dropzone .uploaded-file-info .file-details .file-status.success {
  color: #4caf50;
}
.dropzone .uploaded-file-info .file-details .file-status.error {
  color: #f44336;
}
.dropzone .uploaded-file-info .file-details .file-status mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

/* -------------------------------------------------------------------------
 * Form Sections (Both Dialogs)
 * -------------------------------------------------------------------------
 */
.form-section .full-width {
  width: 100%;
}
.validate-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.validate-section button {
  align-self: flex-start;
}
.validate-section .validation-result .validation-success {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #4caf50;
  font-size: 14px;
  padding: 8px 12px;
  background-color: rgba(76, 175, 80, 0.04);
  border-radius: 4px;
  border: 1px solid rgba(76, 175, 80, 0.2);
}
.validate-section .validation-result .validation-success mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.validate-section .validation-result .validation-error {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #f44336;
  font-size: 14px;
  padding: 8px 12px;
  background-color: rgba(244, 67, 54, 0.04);
  border-radius: 4px;
  border: 1px solid rgba(244, 67, 54, 0.2);
}
.validate-section .validation-result .validation-error mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

/* -------------------------------------------------------------------------
 * Map Selection Tools (Both Dialogs)
 * -------------------------------------------------------------------------
 */
.map-selection-section .selection-tools h4 {
  margin: 0 0 16px;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
}
.map-selection-section .selection-tools .tool-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}
.map-selection-section .selection-tools .tool-cards .tool-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
.map-selection-section .selection-tools .tool-cards .tool-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  border-color: rgba(25, 118, 210, 0.2);
}
.map-selection-section .selection-tools .tool-cards .tool-card.selected {
  border-color: #1976d2;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}
.map-selection-section .selection-tools .tool-cards .tool-card {
  /* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version.
  */
}
.map-selection-section .selection-tools .tool-cards .tool-card mat-card-content {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px !important;
}
.map-selection-section .selection-tools .tool-cards .tool-card mat-card-content .tool-info {
  flex: 1;
}
.map-selection-section .selection-tools .tool-cards .tool-card mat-card-content .tool-info .tool-title {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 4px;
}
.map-selection-section .selection-tools .tool-cards .tool-card mat-card-content .tool-info .tool-description {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.3;
}
.map-selection-section .selection-tools .tool-cards .tool-card.selected .tool-title {
  color: #1976d2;
}

/* -------------------------------------------------------------------------
 * Configuration Sections (Both Dialogs)
 * -------------------------------------------------------------------------
 */
.config-section {
  margin-top: 24px;
  padding-top: 24px;
}
.config-section .config-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
}
.config-section .config-header mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.config-section .config-description {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  line-height: 1.5;
  margin: 0 0 16px;
}
.config-section .config-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #4caf50;
  font-size: 14px;
  padding: 12px;
  background-color: rgba(76, 175, 80, 0.04);
  border-radius: 4px;
  border: 1px solid rgba(76, 175, 80, 0.2);
}
.config-section .config-info .success-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.config-section .details-section {
  margin-top: 16px;
}
.config-section .details-section summary {
  cursor: pointer;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
  padding: 8px 0;
  outline: none;
}
.config-section .details-section summary:hover {
  color: rgba(0, 0, 0, 0.87);
}
.config-section .details-section .details-content {
  margin-top: 8px;
}
.config-section .details-section .details-content label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  display: block;
  margin-bottom: 4px;
}
.config-section .details-section .details-content pre {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  font-size: 11px;
  line-height: 1.4;
  overflow-x: auto;
  margin: 0;
  border: 1px solid #e0e0e0;
}

/* -------------------------------------------------------------------------
 * Preview Sections
 * -------------------------------------------------------------------------
 */
.preview-section {
  margin-top: 24px;
}
.preview-section .preview-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 16px 0;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
}
.preview-section .preview-header mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.preview-section .preview-container {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background-color: #fafafa;
}
.preview-section .preview-container .preview-image {
  width: 100%;
  max-height: 200px;
  object-fit: contain;
  display: block;
}
.preview-section .preview-container .preview-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  color: rgba(0, 0, 0, 0.5);
  font-style: italic;
}
.preview-section .preview-container .preview-placeholder mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
}

/* -------------------------------------------------------------------------
 * Error Display (Both Dialogs)
 * -------------------------------------------------------------------------
 */
.error-message, .global-error {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #f44336;
  font-size: 14px;
  padding: 12px 16px;
  background-color: rgba(244, 67, 54, 0.04);
  border-radius: 4px;
  border: 1px solid rgba(244, 67, 54, 0.2);
  margin-top: 16px;
}
.error-message mat-icon, .global-error mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

/* -------------------------------------------------------------------------
 * Animations
 * -------------------------------------------------------------------------
 */
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}
@keyframes pulse-dot {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
/* -------------------------------------------------------------------------
 * Responsive Design
 * -------------------------------------------------------------------------
 */
@media (max-width: 767px) {
  .dialog-header {
    padding: 16px 16px 12px;
  }
  .dialog-header h2 {
    font-size: 20px;
  }
  .dialog-body {
    padding: 0 16px;
  }
  .dialog-footer {
    padding: 12px 16px 16px;
    flex-direction: column;
  }
  .tab-content {
    padding: 16px 0;
    min-height: 250px;
  }
  .dropzone {
    padding: 20px 16px;
    height: 160px;
  }
  .dropzone .dropzone-content .upload-icon {
    font-size: 36px;
    width: 36px;
    height: 36px;
    margin-bottom: 12px;
  }
  .dropzone .dropzone-content .primary-text {
    font-size: 14px;
  }
  .dropzone .dropzone-content .secondary-text {
    font-size: 12px;
  }
  .dropzone .uploaded-image-preview {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }
  .dropzone .uploaded-image-preview .image-preview {
    width: 60px;
    height: 60px;
  }
  .dropzone .uploaded-file-info {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }
  .dropzone .uploaded-file-info .file-icon mat-icon {
    font-size: 36px;
    width: 36px;
    height: 36px;
  }
  .map-selection-section .selection-tools .tool-cards {
    grid-template-columns: 1fr;
  }
  .preview-section .preview-container .preview-placeholder {
    padding: 32px 16px;
  }
  .preview-section .preview-container .preview-placeholder mat-icon {
    font-size: 36px;
    width: 36px;
    height: 36px;
  }
}
/* -------------------------------------------------------------------------
 * Focus and Accessibility
 * -------------------------------------------------------------------------
 */
.dropzone:focus-visible,
.tool-card:focus-visible {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.mat-mdc-button:focus-visible,
.mat-mdc-icon-button:focus-visible {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

/**
 * Agent UI Component Styles
 *
 * BEM-style SCSS classes for all agent-ui components.
 * All classes are prefixed with "achat-" (agent-chat) to avoid collisions.
 * Components use ViewEncapsulation.None so these styles are globally scoped.
 *
 * Colors and spacing reference the CSS custom properties defined in
 * agent-ui/styles/globals.scss under the [data-agent-ui] scope.
 */
.achat-view {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.achat-scroll-loading {
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}

.achat-scroll-wrapper {
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  position: relative;
}

.achat-scroll-viewport {
  flex: 1;
  min-height: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}

.achat-scroll-content {
  padding-left: 1rem;
  padding-right: 1rem;
}
@media (min-width: 640px) {
  .achat-scroll-content {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

.achat-scroll-messages {
  max-width: 48rem;
  margin-left: auto;
  margin-right: auto;
  padding: 0.5rem 0; /* Add vertical padding for better spacing */
}

.achat-scroll-to-bottom-wrap {
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 30;
}

.achat-scroll-to-bottom {
  border-radius: 9999px;
  width: 40px;
  height: 40px;
  padding: 0;
  background-color: #ffffff;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.achat-scroll-to-bottom:hover {
  background-color: #f9fafb;
}
.achat-scroll-to-bottom:focus {
  outline: none;
}
.achat-scroll-to-bottom:focus-visible {
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.4), 0 0 0 4px rgba(255, 255, 255, 0.8);
}
.achat-scroll-to-bottom lucide-angular {
  width: 16px;
  height: 16px;
  color: #4b5563;
}
.dark .achat-scroll-to-bottom {
  background-color: #111827;
  border-color: #374151;
}
.dark .achat-scroll-to-bottom:hover {
  background-color: #1f2937;
}
.dark .achat-scroll-to-bottom lucide-angular {
  color: #ffffff;
}

.achat-feather {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4rem;
  pointer-events: none;
  z-index: 10;
  background: linear-gradient(to top, var(--achat-bg, transparent), transparent);
}

.achat-bottom-panel {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
}

.achat-run-error {
  border-top: 1px solid var(--mat-divider-color, rgba(0, 0, 0, 0.12));
  background-color: var(--mat-sys-error-container, #fce8e6);
}
.achat-run-error__icon {
  color: var(--mat-sys-error, #b3261e);
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.achat-run-error__text {
  color: var(--mat-sys-on-error-container, #410e0b);
}

.achat-input-container {
  position: relative;
}

.achat-input-container__inner {
  max-width: 48rem;
  margin-left: auto;
  margin-right: auto;
  padding: 0 0.75rem 0.75rem;
}
@media (min-width: 640px) {
  .achat-input-container__inner {
    padding: 0 0.5rem 0.75rem;
  }
}

.achat-disclaimer {
  text-align: center;
  font-size: 0.75rem;
  color: var(--muted-foreground);
  padding: 0.75rem 1rem;
  max-width: 48rem;
  margin-left: auto;
  margin-right: auto;
}

.achat-input {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 4px;
  padding: 6px;
  cursor: text;
  overflow: visible;
  background-clip: padding-box;
  background-color: #ffffff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.0392156863), 0 0 1px 0 rgba(0, 0, 0, 0.6196078431);
  border-radius: 28px;
}
.dark .achat-input {
  background-color: #303030;
}

.achat-toolbar {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.achat-toolbar__group {
  display: flex;
  align-items: center;
}

.achat-toolbar__send-wrap {
  margin-right: 10px;
}

.achat-textarea {
  flex: 1;
  padding: 8px 6px;
  outline: none;
  resize: none;
  background-color: transparent;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
  line-height: 1.625;
  font-size: 16px;
  font-family: inherit;
  min-height: 36px !important;
  height: auto !important;
  box-sizing: border-box;
  border: none;
  overflow-y: auto;
  overflow-x: hidden;
}
.achat-textarea::placeholder {
  color: rgba(0, 0, 0, 0.47);
}
.dark .achat-textarea::placeholder {
  color: rgba(255, 255, 255, 0.8);
}
.achat-textarea:focus {
  outline: none;
  border: none;
}

.achat-audio-recorder {
  display: block;
  width: 100%;
}

.achat-audio-recorder__canvas {
  height: 44px;
  width: 100%;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.achat-tools-btn, .achat-msg-btn, .achat-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.15s ease;
  flex-shrink: 0;
  outline: none;
  cursor: pointer;
  border: none;
}
.achat-tools-btn:disabled, .achat-msg-btn:disabled, .achat-btn:disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}
.achat-tools-btn:focus-visible, .achat-msg-btn:focus-visible, .achat-btn:focus-visible {
  border: 1px solid var(--ring);
  box-shadow: 0 0 0 3px rgba(var(--ring), 0.5);
}
.achat-tools-btn svg, .achat-msg-btn svg, .achat-btn svg,
.achat-tools-btn lucide-angular,
.achat-msg-btn lucide-angular,
.achat-btn lucide-angular {
  pointer-events: none;
  flex-shrink: 0;
}

.achat-btn {
  border-radius: 9999px;
  height: 36px;
  width: 36px;
}

.achat-btn--primary {
  background-color: #000000;
  color: #ffffff;
}
.achat-btn--primary:hover:not(:disabled) {
  opacity: 0.7;
}
.achat-btn--primary:disabled {
  background-color: rgba(0, 0, 0, 0.08);
  color: rgb(13, 13, 13);
  opacity: 1;
}
.dark .achat-btn--primary {
  background-color: #ffffff;
  color: #000000;
}
.dark .achat-btn--primary:disabled {
  background-color: #454545;
  color: #ffffff;
}

.achat-btn--secondary {
  background-color: transparent;
  color: #444444;
}
.achat-btn--secondary:hover:not(:disabled) {
  background-color: #f8f8f8;
  color: #333333;
}
.achat-btn--secondary:disabled {
  background-color: transparent;
  color: #444444;
}
.dark .achat-btn--secondary {
  color: #ffffff;
  border-color: #404040;
}
.dark .achat-btn--secondary:hover:not(:disabled) {
  background-color: #404040;
  color: #ffffff;
}
.dark .achat-btn--secondary:disabled {
  background-color: transparent;
  color: #cccccc;
}

.achat-btn--mr {
  margin-right: 0.5rem;
}

.achat-btn--ml {
  margin-left: 0.5rem;
}

.achat-btn--mr-custom {
  margin-right: 10px;
}

.achat-msg-btn {
  padding: 0;
  color: rgb(93, 93, 93);
  background-color: transparent;
  height: 32px;
  width: 32px;
  border-radius: 6px;
}
.achat-msg-btn:hover:not(:disabled) {
  background-color: #e8e8e8;
  color: rgb(93, 93, 93);
}
.dark .achat-msg-btn {
  color: rgb(243, 243, 243);
}
.dark .achat-msg-btn:hover:not(:disabled) {
  background-color: #303030;
  color: rgb(243, 243, 243);
}

.achat-msg-btn--sm {
  height: 24px;
  width: 24px;
}

.achat-tools-btn {
  border-radius: 9999px;
  height: 36px;
  padding: 0 0.75rem;
  gap: 0.5rem;
  background-color: transparent;
  color: #444444;
  font-weight: 400;
}
.achat-tools-btn:hover:not(:disabled) {
  background-color: #f8f8f8;
  color: #333333;
}
.achat-tools-btn:disabled {
  background-color: transparent;
  color: #444444;
  cursor: not-allowed;
}
.dark .achat-tools-btn {
  color: #ffffff;
  border-color: #404040;
}
.dark .achat-tools-btn:hover:not(:disabled) {
  background-color: #404040;
  color: #ffffff;
}
.dark .achat-tools-btn:disabled {
  background-color: transparent;
  color: #cccccc;
}

.achat-tools-btn__label {
  font-size: 0.875rem;
  font-weight: 400;
}

.achat-menu {
  min-width: 200px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  padding: 0.25rem;
}
.dark .achat-menu {
  background-color: #1f1f1f;
  border-color: #374151;
}

.achat-menu__separator {
  height: 1px;
  background-color: #e5e7eb;
  margin: 0.25rem 0;
}
.dark .achat-menu__separator {
  background-color: #374151;
}

.achat-menu__item {
  width: 100%;
  padding: 0.5rem 0.75rem;
  text-align: left;
  background-color: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: inherit;
}
.achat-menu__item:hover {
  background-color: #f3f4f6;
}
.dark .achat-menu__item:hover {
  background-color: #1f2937;
}

.achat-menu__item-chevron {
  margin-left: auto;
}

.achat-message-view {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.achat-cursor {
  width: 11px;
  height: 11px;
  border-radius: 9999px;
  background-color: var(--foreground);
  animation: pulse-cursor 0.9s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  margin-left: 0.25rem;
}

.achat-assistant-msg {
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
  -webkit-font-smoothing: antialiased;
}
.dark .achat-assistant-msg {
  color: var(--foreground);
}

.achat-msg__actions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.achat-reasoning-step {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  color: var(--muted-foreground);
}

.achat-reasoning-spinner {
  display: inline-block;
  width: 0.75rem;
  height: 0.75rem;
  margin-top: 0.125rem;
  flex-shrink: 0;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: achat-reasoning-spin 0.75s linear infinite;
}

@keyframes achat-reasoning-spin {
  to {
    transform: rotate(360deg);
  }
}
.achat-reasoning-label {
  font-size: 0.75rem;
  font-style: italic;
  line-height: 1.25rem;
}

.achat-reasoning-desc {
  opacity: 0.7;
}

.achat-reasoning-step--done {
  opacity: 0.55;
}
.achat-reasoning-step--done .achat-reasoning-label {
  font-style: normal;
}

.achat-reasoning-check {
  display: inline-block;
  width: 0.75rem;
  height: 0.75rem;
  margin-top: 0.125rem;
  flex-shrink: 0;
  font-size: 0.7rem;
  line-height: 0.75rem;
  color: var(--success, #16a34a);
}

.achat-assistant-toolbar {
  width: 100%;
  background-color: transparent;
  display: flex;
  align-items: center;
  margin-left: -5px;
}

.achat-user-msg {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-top: 2.5rem;
}
.achat-user-msg:hover .achat-user-toolbar {
  visibility: visible;
}

.achat-user-msg__content {
  background-color: var(--muted);
  position: relative;
  max-width: 80%;
  border-radius: 18px;
  padding: 6px 1rem;
  display: inline-block;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
}
.achat-user-msg__content[data-multiline=true] {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.achat-user-toolbar {
  width: 100%;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 4px;
  visibility: hidden;
}

.achat-branch-nav {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.achat-branch-nav__label {
  font-size: 0.875rem;
  color: var(--muted-foreground);
  font-weight: 500;
  padding-left: 0;
  padding-right: 0;
}

.ai-card {
  border-radius: var(--mat-sys-corner-large) !important;
  overflow: hidden;
}

.ai-card__footer {
  border-top: 1px solid var(--mat-sys-outline-variant);
  background: var(--mat-sys-surface-container-low);
  min-height: 44px;
}

.ai-card__header {
  border-bottom: 1px solid var(--mat-sys-outline-variant);
}

.ai-card__cost-box {
  background: color-mix(in srgb, var(--vx-warning) 8%, transparent);
  border: 1px solid color-mix(in srgb, var(--vx-warning) 40%, transparent);
  border-radius: var(--mat-sys-corner-medium);
}

.ai-card__missing-params {
  background: var(--mat-sys-error-container);
  color: var(--mat-sys-on-error-container);
  border-radius: var(--mat-sys-corner-medium);
}

.ai-card__warning-icon {
  color: var(--vx-warning);
}

.ai-card__warning-text {
  color: var(--vx-warning);
}

.notification-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: var(--mat-sys-corner-full);
  padding: 2px 10px;
}
.notification-badge mat-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
}
.notification-badge--success {
  background: color-mix(in srgb, var(--vx-success) 12%, transparent);
  color: var(--vx-success);
  border: 1px solid color-mix(in srgb, var(--vx-success) 30%, transparent);
}
.notification-badge--error {
  background: var(--mat-sys-error-container);
  color: var(--mat-sys-error);
  border: 1px solid color-mix(in srgb, var(--mat-sys-error) 30%, transparent);
}
.notification-badge--pending {
  background: color-mix(in srgb, var(--mat-sys-secondary) 10%, transparent);
  color: var(--mat-sys-on-surface-variant);
  border: 1px solid var(--mat-sys-outline-variant);
}
.notification-badge--running {
  background: color-mix(in srgb, var(--mat-sys-secondary) 10%, transparent);
  color: var(--mat-sys-on-surface-variant);
  border: 1px solid var(--mat-sys-outline-variant);
}
.notification-badge--warning {
  background: color-mix(in srgb, var(--vx-warning) 12%, transparent);
  color: var(--vx-warning);
  border: 1px solid color-mix(in srgb, var(--vx-warning) 40%, transparent);
}

.toolbar-header-overlay {
  position: absolute;
  top: 64px;
  left: 0;
  right: 0;
  z-index: 999;
}

.custom-tooltip {
  max-width: 350px !important;
}

.status-tooltip {
  max-width: 400px !important;
}

/* status control styles */
canvas {
  opacity: 1 !important;
  background: transparent !important;
}

.ol-map {
  height: calc(100vh - 64px) !important;
  overflow: hidden;
  width: 100%;
}

.discrete-view {
  background: linear-gradient(180deg, #5c635d, rgba(92, 99, 93, 0.8)) !important;
  background-size: 400% 400%;
  animation: gradient 6s ease infinite !important;
}

@keyframes gradient {
  0% {
    background-position: 50% 0;
  }
  50% {
    background-position: 50% 100%;
  }
  100% {
    background-position: 50% 0;
  }
}
.map {
  overflow: hidden;
  height: 800px;
}

/*  swipe control */
.ol-swipe.ol-control {
  background-color: white;
  border-radius: 0 !important;
  padding: 0 !important;
  cursor: ew-resize;
}
.ol-swipe.ol-control::after {
  top: -5000px !important;
  bottom: -5000px !important;
  position: absolute;
  left: 28%;
  width: 14px;
  background: transparent !important;
}
.ol-swipe.ol-control button {
  width: 24px;
  height: 24px;
  transform: rotate(90deg);
  background: white url(${___CSS_LOADER_URL_REPLACEMENT_28___}) no-repeat fixed center/cover !important;
  border-radius: 0 !important;
  cursor: ew-resize;
}
.ol-swipe.ol-control button::before {
  background: transparent;
}
.ol-swipe.ol-control button::after {
  background: transparent;
}

.ol-swipe:hover.ol-control {
  background-color: var(--mat-sys-primary);
}
.ol-swipe:hover.ol-control::before {
  background: var(--mat-sys-primary) !important;
}
.ol-swipe:hover.ol-control button {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) no-repeat fixed center/cover !important;
}

.ol-control.ol-status {
  font-family: "Lucida Grande", Verdana, Geneva, Lucida, Arial, Helvetica, sans-serif;
  font-size: 16px;
}

.ol-attribution.ol-uncollapsible {
  position: relative;
  background-color: unset;
  max-width: unset;
  padding: 0 !important;
}

.ol-attribution ul, .ol-attribution a {
  font-size: 13px !important;
  color: white !important;
  margin-top: 2px;
  text-shadow: unset !important;
  padding: unset !important;
}

.ol-scale-line {
  position: initial;
  background-color: var(--mat-sys-inverse-surface);
  z-index: 1 !important;
}

.ol-scale-line-inner {
  border: 1px solid white !important;
  border-top: none !important;
  border-color: rgba(255, 255, 255, 0.75) !important;
  color: rgba(255, 255, 255, 0.75) !important;
}

/* end status control styles */
/* mode switching animation styles */
.ol-viewport.down-2d {
  perspective: 400px;
  animation: lay-down 2s normal 1;
}

.ol-viewport.layed-down {
  transform: perspective(300px) rotateX(16deg) scale(0.7, 0.7);
}

/*dont used*/
.ol-popup.default.hasclosebox.ol-popup-bottom.ol-popup-left.visible {
  left: -9999em;
}
.ol-popup.default.hasclosebox.ol-popup-bottom.ol-popup-left.visible > div {
  left: 9999em !important;
  position: relative;
}

.ol-popup.default.hasclosebox.ol-popup-bottom.ol-popup-right.visible {
  left: -9999em;
}
.ol-popup.default.hasclosebox.ol-popup-bottom.ol-popup-right.visible > div {
  left: 9999em !important;
  position: relative;
}

.ol-popup.default.hasclosebox.ol-popup-top.ol-popup-left.visible {
  left: -9999em;
}
.ol-popup.default.hasclosebox.ol-popup-top.ol-popup-left.visible > div {
  left: 9999em !important;
  position: relative;
}

ol-popup.default.hasclosebox.ol-popup-top.ol-popup-right.visible {
  left: -9999em;
}
ol-popup.default.hasclosebox.ol-popup-top.ol-popup-right.visible > div {
  left: 9999em !important;
  position: relative;
}

.ol-popup-content #open-gallery-button {
  color: var(--mat-sys-primary);
}

.ol-popup-content #open-gallery-button.disabled {
  color: rgba(0, 0, 0, 0.5411764706);
}

.ol-viewport.up-3d {
  perspective: 400px;
  animation: zoom-in 1s normal 1;
}

.ol-viewport.down-3d {
  perspective: 400px;
  animation: zoom-out 2s normal 1;
}

.ol-viewport.layed-down-3d {
  transform: perspective(500px) rotateX(40deg) scale(1, 1);
}

.ol-viewport.up-2d {
  perspective: 400px;
  animation: lay-down-3d 1s normal 1;
}

.ol-viewport.additional {
  perspective: 400px;
  animation: lay-down 1s reverse 1;
}

.grid-container {
  z-index: 0;
  width: 100%;
  height: 100%;
  perspective: 400px;
  display: flex;
  overflow: hidden;
  position: sticky;
  bottom: 0;
}

.background-grid {
  width: 100%;
  height: 100%;
  transform: rotateX(40deg);
  background: linear-gradient(0deg, transparent 24%, #4D5154 25%, #4D5154 26%, transparent 27%, transparent 74%, #4D5154 75%, #4D5154 76%, transparent 77%, transparent), linear-gradient(90deg, transparent 24%, #4D5154 25%, #4D5154 26%, transparent 27%, transparent 74%, #4D5154 75%, #4D5154 76%, transparent 77%, transparent);
  background-color: #707070;
  border: 2px solid #4D5154;
  background-size: 7rem 7rem;
}

/* end mode switching animation styles */
/* layerSwitcher control styles */
.ol-layerswitcher .panel li.ol-layer-hidden {
  opacity: 0.6;
  display: none !important;
}

.ol-control.ol-layerswitcher {
  right: 20px;
  left: auto;
  max-height: 70% !important;
  background: white !important;
}
.ol-control.ol-layerswitcher .panel-container {
  position: static;
}

.ol-layerswitcher > button {
  float: none;
}

.tooltip {
  color: white;
  font-family: "Century Gothic", CenturyGothic, AppleGothic, sans-serif;
}

/* end layerSwitcher control styles */
/* Context menu styles */
.ol-ctx-menu-container {
  position: absolute;
  padding: 0;
  background: #fff;
  color: #222;
  font-size: 15px;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.2) 3px 3px 5px;
  box-sizing: border-box;
  z-index: 1;
}

.ol-ctx-menu-container li {
  position: relative;
  padding: 5px;
  line-height: 30px;
  text-indent: 30px;
}

/* infobox */
.ol-popup .closeBox {
  color: #8A8A8A;
  font-weight: 200;
  font-size: 16px !important;
  background-color: white;
}

.ol-popup-content #open-gallery-button {
  border: none;
  background-color: transparent;
  font-weight: bolder;
  padding: 0;
  position: relative;
}

.ol-popup-content #open-gallery-button #gallery-tooltip {
  visibility: hidden;
  width: 180px;
  background-color: rgba(85, 85, 85, 0.4784313725);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 6px 0;
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 3%;
  font-size: 11px;
}

.ol-popup-content #open-gallery-button.disabled:hover #gallery-tooltip {
  visibility: visible;
}

.ol-popup-content #open-gallery-button:focus {
  outline: none;
}

.ol-popup-content #open-gallery-button.disabled {
  cursor: default;
}

.ol-popup .closeBox:hover {
  background-color: white;
  color: #666666;
}

.ol-popup .closeBox:after {
  top: 30%;
}

.ol-popup .ol-popup-content {
  flex-direction: column;
  align-items: flex-start;
  padding: 1.5vh 0 1.5vh 1.5vw;
}

.ol-popup-content .address {
  font-size: 14px;
  -webkit-user-select: text;
  -moz-user-select: text;
  user-select: text;
  font-weight: bold;
}

.ol-popup-content .location,
.ol-popup-content .capture-date {
  color: rgba(0, 0, 0, 0.5411764706);
  font-size: 12px;
  -webkit-user-select: text;
  -moz-user-select: text;
  user-select: text;
}

.ol-popup-content .capture-date span {
  font-weight: 500;
}

.ol-popup-content .infobox-control {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ol-popup-content .infobox-control span:first-child {
  margin-right: 5px;
}

.ol-popup-content .infobox-control #pin-btn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  height: 18px;
  width: 11px;
}

.ol-popup-content .infobox-control #visibility-btn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  background-repeat: no-repeat;
  height: 12px;
  width: 14px;
  top: 3px;
  position: relative;
}

.ol-popup-content .infobox-control #visibility-btn:hover::after {
  content: "";
  height: 1px;
  width: 1px;
  box-shadow: 6px 8px 10px 4px rgba(0, 0, 0, 0.3);
}

.ol-popup.default {
  width: auto;
  border: none;
  border-radius: 2px;
  transform: none;
}

.ol-popup.default.feature {
  width: auto;
  border: none;
  border-radius: 2px;
  transform: none;
  overflow: auto;
  user-select: text !important;
}

.ol-popup.default > div {
  border: none;
  border-radius: 2px;
}

.ol-popup.default.ol-popup-bottom {
  margin-bottom: 28px;
}

.ol-popup-top.ol-popup-left.default,
.ol-popup-top.ol-popup-right.default,
.ol-popup-right.default,
.ol-popup-left.default {
  margin-top: 15px;
  transform: none;
}

.ol-popup-right.default {
  margin: 5px 0 25px 0 !important;
}

.ol-popup-left.default {
  margin: 5px 0 25px 0 !important;
}

.ol-popup-top.ol-popup-left.default,
.ol-popup-left.default > div {
  transform: translateX(-50%);
  margin-bottom: 30px;
}

.ol-popup-left.default > div,
.ol-popup-right.default > div {
  border: 1px grey solid;
}

.ol-popup-top.ol-popup-right.default,
.ol-popup-right.default > div {
  transform: translateX(50%);
  margin-bottom: 30px;
}

.ol-popup-left .anchor {
  left: 50%;
}

.ol-popup-right .anchor {
  right: 50%;
}

.ol-popup.default .anchor {
  margin: 0;
  margin-bottom: -12px;
}

.ol-popup.default .anchor:before {
  border-color: transparent;
}

.ol-popup-top .anchor {
  top: -12px;
}

.overlay-tooltip {
  background-color: rgba(0, 0, 0, 0.4);
  margin: -10px 6px;
}

.overlay-tooltip .ol-popup-content {
  padding: 5px !important;
  color: white !important;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

#loading-message-container {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
}

#loading-message-container span {
  color: white;
  font-size: 14px;
  font-weight: bold;
}

.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
/* End context menu styles */
/* animation keyframes */
@keyframes lay-down {
  0% {
    transform: perspective(500px) rotateX(0deg) scale(0.7, 0.7);
  }
  100% {
    transform: perspective(300px) rotateX(16deg) scale(0.7, 0.7);
  }
}
@keyframes zoom-in {
  0% {
    transform: perspective(300px) rotateX(0deg) scale(0.7, 0.7);
  }
  100% {
    transform: perspective(500px) rotateX(0deg) scale(1, 1);
  }
}
@keyframes lay-down-3d {
  0% {
    transform: perspective(500px) rotateX(40deg) scale(1, 1);
  }
  100% {
    transform: none;
  }
}
@keyframes zoom-out {
  0% {
    transform: perspective(500px) rotateX(40deg) scale(1.5, 1.5);
  }
  100% {
    transform: perspective(500px) rotateX(40deg) scale(1, 1);
  }
}
@keyframes zoom-out-in {
  0% {
    transform: perspective(500px) rotateX(40deg) scale(1.5, 1.5);
  }
  33.33%, 50% {
    transform: perspective(500px) rotateX(40deg) scale(1, 1);
  }
  100% {
    transform: perspective(500px) rotateX(40deg) scale(1.5, 1.5);
  }
}
/* End animation keyframes */
.toast-center-center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.toast-top-center {
  top: 0;
  right: 0;
  width: 100%;
}

.toast-bottom-center {
  bottom: 0;
  right: 0;
  width: 100%;
}

.toast-top-full-width {
  top: 0;
  right: 0;
  width: 100%;
}

.toast-bottom-full-width {
  bottom: 0;
  right: 0;
  width: 100%;
}

.toast-top-left {
  top: 12px;
  left: 12px;
}

.toast-top-right {
  top: 12px;
  right: 12px;
}

.toast-bottom-right {
  right: 12px;
  bottom: 12px;
}

.toast-bottom-left {
  bottom: 12px;
  left: 12px;
}

/* toast styles */
.toast-title {
  font-weight: bold;
}

.toast-message {
  word-wrap: break-word;
}

.toast-message a,
.toast-message label {
  color: #FFFFFF;
}

.toast-message a:hover {
  color: #CCCCCC;
  text-decoration: none;
}

.toast-close-button {
  position: relative;
  right: -0.3em;
  top: -0.3em;
  float: right;
  font-size: 20px;
  font-weight: bold;
  color: #FFFFFF;
  text-shadow: 0 1px 0 #ffffff;
  /* opacity: 0.8; */
}

.toast-close-button:hover,
.toast-close-button:focus {
  color: #000000;
  text-decoration: none;
  cursor: pointer;
  opacity: 0.4;
}

/*Additional properties for button version
 iOS requires the button element instead of an anchor tag.
 If you want the anchor version, it requires \`href="#"\`.*/
button.toast-close-button {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
}

.toast-container {
  pointer-events: none;
  position: fixed;
  z-index: 999999;
}

.toast-container * {
  box-sizing: border-box;
}

.toast-container .ngx-toastr {
  position: relative;
  overflow: hidden;
  margin: 0 0 6px;
  padding: 15px 15px 15px 50px;
  width: 300px;
  border-radius: 3px 3px 3px 3px;
  background-position: 15px center;
  background-repeat: no-repeat;
  background-size: 24px;
  box-shadow: 0 0 12px #999999;
  color: #FFFFFF;
}

.toast-container .ngx-toastr:hover {
  box-shadow: 0 0 12px #000000;
  opacity: 1;
  cursor: pointer;
}

/* https://github.com/FortAwesome/Font-Awesome-Pro/blob/master/advanced-options/raw-svg/regular/info-circle.svg */
.toast-info {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}

/* https://github.com/FortAwesome/Font-Awesome-Pro/blob/master/advanced-options/raw-svg/regular/times-circle.svg */
.toast-error {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}

/* https://github.com/FortAwesome/Font-Awesome-Pro/blob/master/advanced-options/raw-svg/regular/check.svg */
.toast-success {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}

/* https://github.com/FortAwesome/Font-Awesome-Pro/blob/master/advanced-options/raw-svg/regular/exclamation-triangle.svg */
.toast-warning {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}

.toast-container.toast-top-center .ngx-toastr,
.toast-container.toast-bottom-center .ngx-toastr {
  width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.toast-container.toast-top-full-width .ngx-toastr,
.toast-container.toast-bottom-full-width .ngx-toastr {
  width: 96%;
  margin-left: auto;
  margin-right: auto;
}

.ngx-toastr {
  background-color: #030303;
  pointer-events: auto;
}

.toast-success {
  background-color: #51A351;
}

.toast-error {
  background-color: #BD362F;
}

.toast-info {
  background-color: #2F96B4;
}

.toast-warning {
  background-color: #F89406;
}

.toast-progress {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 4px;
  background-color: #000000;
  opacity: 0.4;
}

/* Responsive Design */
@media all and (max-width: 240px) {
  .toast-container .ngx-toastr.div {
    padding: 8px 8px 8px 50px;
    width: 11em;
  }
  .toast-container .toast-close-button {
    right: -0.2em;
    top: -0.2em;
  }
}
@media all and (min-width: 241px) and (max-width: 480px) {
  .toast-container .ngx-toastr.div {
    padding: 8px 8px 8px 50px;
    width: 18em;
  }
  .toast-container .toast-close-button {
    right: -0.2em;
    top: -0.2em;
  }
}
@media all and (min-width: 481px) and (max-width: 768px) {
  .toast-container .ngx-toastr.div {
    padding: 15px 15px 15px 50px;
    width: 25em;
  }
}
.tippy-box {
  background-color: #555;
}

/*Override toast default styles*/
.toast-progress {
  background-color: #FFFFFF !important;
  opacity: 1 !important;
}

.toast-container {
  /*  height: 70px; */
  padding-top: 40px;
}

/* Compact top-right warning card. The toast id doubles as its CSS class
   (see VisionToastComponent.createToast), so every id using this look is listed here. */
.toast-warning-expire,
.toast-warning-geofencing {
  width: 250px;
  font-size: 12px;
  margin-top: 30px;
  color: white;
  border-radius: 4px;
  padding: 5px;
}

.toast-warning-expire .toast-container,
.toast-warning-geofencing .toast-container {
  height: 70px;
}

.toast-warning {
  background-size: 16px !important;
  background-repeat: no-repeat;
  background-origin: content-box;
  background-position-y: 5px;
}

.download-imagery-warning {
  width: 300px;
  color: white;
  border-radius: 4px;
  pointer-events: none !important;
  display: flex;
  justify-content: center !important;
}

.download-imagery-warning .toast-container {
  height: 70px;
}

.download-image-toast, .screenshot-download-toast {
  width: 300px;
  color: white;
  border-radius: 4px;
  pointer-events: none !important;
  display: flex;
  justify-content: center !important;
}

.damage-assessment-toast, .screenshot-download-toast {
  width: 300px;
  color: white;
  border-radius: 4px;
  pointer-events: none !important;
  display: flex;
  justify-content: center !important;
}

.toast-container .ngx-toastr {
  box-shadow: none !important;
}

.toast-bottom-center {
  height: 145px;
  padding-bottom: 40px;
  display: flex;
  justify-content: center !important;
}

.download-toast .toast-container .ngx-toastr {
  pointer-events: none !important;
  display: flex;
  justify-content: center !important;
  text-align: center;
}

.toast-warning .toast-text {
  padding-left: 20px;
}

.toast-text {
  display: flex;
  justify-content: flex-start !important;
  align-self: center;
}

button.toast-close-button {
  position: relative;
  top: -20px;
  left: 7px;
}

.mat-toolbar-header {
  --mat-icon-button-hover-state-layer-opacity: 0.25;
}
.mat-toolbar-header .mat-mdc-icon-button:hover mat-icon {
  opacity: 0.45;
}

app-search-bar {
  --mat-icon-button-hover-state-layer-opacity: 0;
}
app-search-bar .mat-mdc-icon-button:hover mat-icon {
  opacity: 0.65 !important;
}

/* Brand Theme - Light Mode (Default) */
.theme-brand {
  --mat-sys-background: light-dark(#fbf9f9, #121314);
  --mat-sys-error: light-dark(#b62327, #ffb3ad);
  --mat-sys-error-container: light-dark(#ffdad7, #930012);
  --mat-sys-inverse-on-surface: light-dark(#f2f0f0, #303031);
  --mat-sys-inverse-primary: light-dark(#83d2e3, #006877);
  --mat-sys-inverse-surface: light-dark(#303031, #e4e2e2);
  --mat-sys-on-background: light-dark(#1b1c1c, #e4e2e2);
  --mat-sys-on-error: light-dark(#ffffff, #68000a);
  --mat-sys-on-error-container: light-dark(#930012, #ffdad7);
  --mat-sys-on-primary: light-dark(#ffffff, #00363e);
  --mat-sys-on-primary-container: light-dark(#004e5a, #a2eeff);
  --mat-sys-on-primary-fixed: light-dark(#001f25, #001f25);
  --mat-sys-on-primary-fixed-variant: light-dark(#004e5a, #004e5a);
  --mat-sys-on-secondary: light-dark(#ffffff, #303030);
  --mat-sys-on-secondary-container: light-dark(#474747, #e4e2e1);
  --mat-sys-on-secondary-fixed: light-dark(#1b1c1c, #1b1c1c);
  --mat-sys-on-secondary-fixed-variant: light-dark(#474747, #474747);
  --mat-sys-on-surface: light-dark(#1b1c1c, #e4e2e2);
  --mat-sys-on-surface-variant: light-dark(#474747, #e4e2e1);
  --mat-sys-on-tertiary: light-dark(#ffffff, #00344a);
  --mat-sys-on-tertiary-container: light-dark(#004c6a, #c4e7ff);
  --mat-sys-on-tertiary-fixed: light-dark(#001e2d, #001e2d);
  --mat-sys-on-tertiary-fixed-variant: light-dark(#004c6a, #004c6a);
  --mat-sys-outline: light-dark(#777777, #919090);
  --mat-sys-outline-variant: light-dark(#c8c6c6, #474747);
  --mat-sys-primary: light-dark(#006877, #83d2e3);
  --mat-sys-primary-container: light-dark(#a2eeff, #004e5a);
  --mat-sys-primary-fixed: light-dark(#a2eeff, #a2eeff);
  --mat-sys-primary-fixed-dim: light-dark(#83d2e3, #83d2e3);
  --mat-sys-scrim: light-dark(#000000, #000000);
  --mat-sys-secondary: light-dark(#5f5e5e, #c8c6c6);
  --mat-sys-secondary-container: light-dark(#e4e2e1, #474747);
  --mat-sys-secondary-fixed: light-dark(#e4e2e1, #e4e2e1);
  --mat-sys-secondary-fixed-dim: light-dark(#c8c6c6, #c8c6c6);
  --mat-sys-shadow: light-dark(#000000, #000000);
  --mat-sys-surface: light-dark(#fbf9f9, #121314);
  --mat-sys-surface-bright: light-dark(#fbf9f9, #393939);
  --mat-sys-surface-container: light-dark(#efeded, #1f2020);
  --mat-sys-surface-container-high: light-dark(#e9e8e7, #292a2a);
  --mat-sys-surface-container-highest: light-dark(#e4e2e2, #343535);
  --mat-sys-surface-container-low: light-dark(#f5f3f3, #1b1c1c);
  --mat-sys-surface-container-lowest: light-dark(#ffffff, #0d0e0f);
  --mat-sys-surface-dim: light-dark(#dbdad9, #121314);
  --mat-sys-surface-tint: light-dark(#006877, #83d2e3);
  --mat-sys-surface-variant: light-dark(#e4e2e1, #474747);
  --mat-sys-tertiary: light-dark(#00658b, #7dd0ff);
  --mat-sys-tertiary-container: light-dark(#c4e7ff, #004c6a);
  --mat-sys-tertiary-fixed: light-dark(#c4e7ff, #c4e7ff);
  --mat-sys-tertiary-fixed-dim: light-dark(#7dd0ff, #7dd0ff);
  --mat-sys-neutral-variant20: #303030;
  --mat-sys-neutral10: #1b1c1c;
  --mat-sys-level0: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-sys-level1: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-sys-level2: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
  --mat-sys-level3: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-sys-level4: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-sys-level5: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-sys-corner-extra-large: 28px;
  --mat-sys-corner-extra-large-top: 28px 28px 0 0;
  --mat-sys-corner-extra-small: 4px;
  --mat-sys-corner-extra-small-top: 4px 4px 0 0;
  --mat-sys-corner-full: 9999px;
  --mat-sys-corner-large: 16px;
  --mat-sys-corner-large-end: 0 16px 16px 0;
  --mat-sys-corner-large-start: 16px 0 0 16px;
  --mat-sys-corner-large-top: 16px 16px 0 0;
  --mat-sys-corner-medium: 12px;
  --mat-sys-corner-none: 0;
  --mat-sys-corner-small: 8px;
  --mat-sys-dragged-state-layer-opacity: 0.16;
  --mat-sys-focus-state-layer-opacity: 0.12;
  --mat-sys-hover-state-layer-opacity: 0.08;
  --mat-sys-pressed-state-layer-opacity: 0.12;
  --mat-sys-primary: #56A7B7;
  --mat-sys-on-primary: #ffffff;
  --mat-sys-primary-container: #56A7B7;
  --mat-sys-on-primary-container: #ffffff;
  --mat-sys-on-secondary-container: #dee2e6;
  --mat-sys-primary-fixed-dim: #3B737E;
  --mat-sys-inverse-surface: #414344;
  --mat-sys-inverse-on-surface: #ffffff;
  --mat-sys-error: red;
  --mat-sys-corner-medium: 8px;
  --mat-sys-corner-full: 8px;
  --mat-sys-corner-extra-large: 8px;
}

.dark-mode.theme-brand {
  --mat-sys-primary: #83d2e3;
  --mat-sys-on-primary: #00363e;
  --mat-sys-primary-container: #004e5a;
  --mat-sys-on-primary-container: #a2eeff;
  --mat-sys-on-secondary-container: #57818a;
  --mat-sys-primary-fixed-dim: #83d2e3;
  --mat-sys-inverse-surface: #e5e2e1;
  --mat-sys-inverse-on-surface: #313030;
  --mat-sys-error: red;
  --mat-sys-corner-medium: 8px;
  --mat-sys-corner-full: 8px;
  --mat-sys-corner-extra-large: 8px;
}

.auth-box:has(.register-container) {
  max-width: 500px !important;
  min-width: 500px !important;
}

:root {
  --required-color: red ;
}

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  min-height: 100vh;
  font-family: Roboto, sans-serif;
}

.unsupportedMessage {
  visibility: hidden;
}

.lds-spinner {
  color: gray;
  display: inline-block;
  position: absolute;
  width: 80px;
  height: 80px;
  top: 50%;
}

.mat-mdc-dialog-container .lds-spinner {
  position: relative;
  left: 0;
  top: 0;
}

.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}

.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 6px;
  height: 18px;
  border-radius: 20%;
  background: black;
}

.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}

.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}

.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}

.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}

.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}

.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}

.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}

.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}

.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}

.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}

.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}

.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}

@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.loaded {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/styles.scss","webpack://./node_modules/@vision/viewer-components/styles/external.scss","webpack://./node_modules/ngx-toastr/toastr.css","webpack://./src/styles/fonts.scss","webpack://./src/styles/theme.scss","webpack://./node_modules/@vision/viewer-components/styles/_globals.scss","webpack://./node_modules/@vision/viewer-components/styles/viewer-global-styles.scss","webpack://./node_modules/@vision/viewer-components/styles/custom-material.scss","webpack://./node_modules/@angular/material/core/tokens/_system.scss","webpack://./node_modules/@angular/material/core/tokens/_classes.scss","webpack://./node_modules/@angular/material/core/tokens/_token-utils.scss","webpack://./node_modules/@angular/material/core/style/_sass-utils.scss","webpack://./node_modules/@vision/viewer-components/styles/viewer-md-global.scss","webpack://./node_modules/@vision/viewer-components/styles/_vx-tokens.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/styles/material-custom-styles.scss","webpack://./src/styles/auth-styles.scss","webpack://./node_modules/@vision/viewer-components/styles/viewer-styles.scss","webpack://./node_modules/@vision/viewer-components/styles/components/popup.scss","webpack://./node_modules/@vision/viewer-components/styles/components/layers.scss","webpack://./node_modules/@vision/viewer-components/styles/_variables.scss","webpack://./node_modules/@vision/viewer-components/styles/components/tools.scss","webpack://./node_modules/@vision/viewer-components/styles/components/collection-timeline.scss","webpack://./node_modules/@vision/viewer-components/styles/components/sidebar.scss","webpack://./node_modules/@vision/viewer-components/styles/components/gallery.scss","webpack://./node_modules/@vision/viewer-components/styles/components/user-data.scss","webpack://./node_modules/@vision/viewer-components/styles/components/properties.scss","webpack://./node_modules/@vision/viewer-components/styles/components/map-container.scss","webpack://./node_modules/@vision/viewer-components/styles/components/compound-display.scss","webpack://./node_modules/@vision/viewer-components/styles/components/dialog.scss","webpack://./node_modules/@vision/viewer-components/styles/components/agent-ui.scss","webpack://./node_modules/@vision/viewer-components/styles/components/ai-chat-cards.scss","webpack://./node_modules/@vision/viewer-components/styles/components.scss","webpack://./node_modules/@vision/viewer-components/styles/core-map-styles.scss","webpack://./src/styles/home-styles.scss","webpack://./src/styles/custom-styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,sDAAA;ACAA,kJAAA;AAEA,aAAA;ACFA,0BAAA;AACA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4DAAA;AHaF;AGVA,yBAAA;AACA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4DAAA;AHYF;AGTA,0BAAA;AACA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4DAAA;AHWF;AGRA,wBAAA;AACA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4DAAA;AHUF;AGPA,mBAAA;AACA;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4DAAA;AHSF;AGNA;EACE,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4DAAA;AHQF;AGLA;EACE,yCAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,qCAAA;EACA,mCAAA;AHOF;;AGJA;EACE,kDAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,qCAAA;EACA,mCAAA;AHOF;;AIzFA,sDAAA;ACAA;;;;;;EAAA;ACAA;;;;;;;;;EAAA;AAWA;;;;;EAAA;ACXA;;;;;;;;;;EAAA;AAgBA;;;8EAAA;AAIA;EACE,mBAAA;ECyPI,8CAAA;EAAA,iCAAA;EAAA,wCAAA;EAAA,+BAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,oDAAA;EAAA,kCAAA;EAAA,0CAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,mDAAA;EAAA,oCAAA;EAAA,yCAAA;EAAA,sCAAA;EAAA,2CAAA;EAAA,mCAAA;EAAA,uDAAA;EAAA,qCAAA;EAAA,6CAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,qDAAA;EAAA,oCAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,kDAAA;EAAA,qCAAA;EAAA,4CAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,uDAAA;EAAA,sCAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,kDAAA;EAAA,qCAAA;EAAA,0CAAA;EAAA,qCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,oDAAA;EAAA,kCAAA;EAAA,0CAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,2CAAA;EAAA,iDAAA;EAAA,mCAAA;EAAA,wCAAA;EAAA,oCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,kCAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,oDAAA;EAAA,kCAAA;EAAA,0CAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,gDAAA;EAAA,mCAAA;EAAA,0CAAA;EAAA,iCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,oDAAA;EAAA,kCAAA;EAAA,0CAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,iCAAA;EAqBA,kCAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,6CAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,yCAAA;EAAA,6BAAA;EAAA,wBAAA;EAAA,2BAAA;EAQA,2CAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,2CAAA;AR3DN;ASpOE;EACE,wCAAA;ATsOJ;AShOE;EACE,kDAAA;ATkOJ;AS7NE;EACE,0CAAA;AT+NJ;ASzNE;EACE,oDAAA;AT2NJ;ASrNE;EACE,sCAAA;ATuNJ;ASlNE;EACE,gDAAA;AToNJ;AS9ME;EACE,wCAAA;ATgNJ;AS1ME;EACE,gDAAA;AT4MJ;AStME;EACE,0DAAA;ATwMJ;ASlME;EACE,uDAAA;AToMJ;AS9LE;EACE,kDAAA;ATgMJ;AS1LE;EACE,sDAAA;AT4LJ;ASvLE;EACE,yDAAA;ATyLJ;ASnLE;EACE,gDAAA;ATqLJ;AS/KE;EACE,gFAAA;ATiLJ;ASvKE;EACE,6BAAA;ATyKJ;ASrKE;EACE,+BAAA;ATuKJ;ASlKE;EACE,2BAAA;AToKJ;AShKE;EACE,qEAAA;ATkKJ;AS5JE;EACE,wCAAA;AT8JJ;AS1JE;EACE,gCAAA;AT4JJ;ASvJE;EACE,0CAAA;ATyJJ;ASrJE;EACE,kCAAA;ATuJJ;ASlJE;EACE,4CAAA;AToJJ;AShJE;EACE,8BAAA;ATkJJ;AS7IE;EACE,wCAAA;AT+IJ;AS3IE;EACE,gCAAA;AT6IJ;ASxIE;EACE,wCAAA;AT0IJ;AShIE;EACE,+BAAA;EACA,kDAAA;ATkIJ;AS5HE;EACE,gCAAA;EACA,mDAAA;AT8HJ;ASxHE;EACE,+BAAA;EACA,kDAAA;AT0HJ;AStHE;EACE,kCAAA;EACA,qDAAA;ATwHJ;ASnHE;EACE,mCAAA;EACA,sDAAA;ATqHJ;ASjHE;EACE,kCAAA;EACA,qDAAA;ATmHJ;AS9GE;EACE,mCAAA;EACA,sDAAA;ATgHJ;AS3GE;EACE,oCAAA;EACA,uDAAA;AT6GJ;ASxGE;EACE,mCAAA;EACA,sDAAA;AT0GJ;AStGE;EACE,gCAAA;EACA,mDAAA;ATwGJ;ASnGE;EACE,iCAAA;EACA,oDAAA;ATqGJ;AShGE;EACE,gCAAA;EACA,mDAAA;ATkGJ;AS7FE;EACE,gCAAA;EACA,mDAAA;AT+FJ;ASzFE;EACE,iCAAA;EACA,oDAAA;AT2FJ;ASrFE;EACE,gCAAA;EACA,mDAAA;ATuFJ;AS5EE;EACE,gDAAA;AT8EJ;ASzEE;EACE,0CAAA;AT2EJ;AStEE;EACE,2CAAA;ATwEJ;ASlEE;EACE,0CAAA;AToEJ;AS9DE;EACE,gDAAA;ATgEJ;AS3DE;EACE,yCAAA;AT6DJ;ASnDE;EACE,wCAAA;ATqDJ;AS/CE;EACE,gDAAA;ATiDJ;ASvCE;EACE,iCAAA;ATyCJ;ASpCE;EACE,iCAAA;ATsCJ;ASjCE;EACE,iCAAA;ATmCJ;AS7BE;EACE,iCAAA;AT+BJ;AS1BE;EACE,iCAAA;AT4BJ;;AOpYA;EACE,kBAAA;APuYF;;AOpYA,uCAAA;AACA;EC+LM,kDAAA;EAAA,6CAAA;EAAA,uDAAA;EAAA,0DAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,qDAAA;EAAA,gDAAA;EAAA,0DAAA;EAAA,kDAAA;EAAA,4DAAA;EAAA,wDAAA;EAAA,gEAAA;EAAA,oDAAA;EAAA,8DAAA;EAAA,0DAAA;EAAA,kEAAA;EAAA,kDAAA;EAAA,0DAAA;EAAA,mDAAA;EAAA,6DAAA;EAAA,yDAAA;EAAA,iEAAA;EAAA,+CAAA;EAAA,uDAAA;EAAA,+CAAA;EAAA,yDAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA,6CAAA;EAAA,iDAAA;EAAA,2DAAA;EAAA,uDAAA;EAAA,2DAAA;EAAA,8CAAA;EAAA,+CAAA;EAAA,sDAAA;EAAA,yDAAA;EAAA,8DAAA;EAAA,iEAAA;EAAA,6DAAA;EAAA,gEAAA;EAAA,mDAAA;EAAA,oDAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,0DAAA;EAAA,sDAAA;EAAA,0DAAA;EAAA,oCAAA;EAAA,4BAAA;EAoDA,8HAAA;EAAA,+HAAA;EAAA,+HAAA;EAAA,iIAAA;EAAA,iIAAA;EAAA,kIAAA;EAQA,kCAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,6CAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,yCAAA;EAAA,6BAAA;EAAA,wBAAA;EAAA,2BAAA;EAQA,2CAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,2CAAA;AR6MN;;AOrcA,gBAAA;AACA;EC0JQ,0BAAA;EAAA,6BAAA;EAAA,oCAAA;EAAA,uCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,oCAAA;EAAA,mCAAA;EAAA,2CAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,sCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,6CAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,oCAAA;EAAA,4CAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,0BAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,oCAAA;EAAA,yCAAA;EAAA,4CAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,wBAAA;EAAA,+BAAA;EAAA,kCAAA;EAAA,qCAAA;EAAA,0BAAA;EAAA,kCAAA;EAAA,wBAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,qCAAA;AR+VR;;AO3bA,eAAA;AACA;EC2FQ,0BAAA;EAAA,6BAAA;EAAA,oCAAA;EAAA,uCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,oCAAA;EAAA,mCAAA;EAAA,2CAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,sCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,6CAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,oCAAA;EAAA,4CAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,0BAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,oCAAA;EAAA,yCAAA;EAAA,4CAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,wBAAA;EAAA,+BAAA;EAAA,kCAAA;EAAA,qCAAA;EAAA,0BAAA;EAAA,kCAAA;EAAA,wBAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,qCAAA;ARoZR;;AOjbA;;;8EAAA;AAIA;EGzGQ,0EAAA;EAAA,6DAAA;AV+hBR;AO9aE;EACE,cAAA;APgbJ;AO9aI;EACE,cAAA;APgbN;;AW3lBI;EDsDI,+BAAA;EAAA,qEAAA;EAAA,gEAAA;AV2iBR;;AWjmBI;EDsDI,oDAAA;EAAA,sEAAA;EAAA,4EAAA;AVijBR;;AWvmBI;EDsDI,+BAAA;AVqjBR;;AW3mBI;EDsDI,6CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,0CAAA;EAAA,qCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,4DAAA;EAAA,6DAAA;EAAA,oEAAA;EAAA,qEAAA;EAAA,kEAAA;EAAA,wEAAA;EAAA,wEAAA;EAAA,0EAAA;EAAA,+DAAA;EAAA,qEAAA;EAAA,qEAAA;EAAA,4EAAA;EAAA,oEAAA;EAAA,0EAAA;EAAA,0EAAA;AV+kBR;;AOvaA;;;8EAAA;AAKA;EAEE,+DAAA;EAEA,gDAAA;EACA,wCAAA;EGlLM,kEAAA;EAAA,2FAAA;EAAA,mGAAA;EAAA,qGAAA;EAAA,wGAAA;EAAA,uEAAA;EAAA,6EAAA;EAAA,6EAAA;EAAA,0EAAA;EAAA,2EAAA;EAAA,qEAAA;EAAA,sEAAA;AVqmBR;AOzZE;EACE,qFAAA;EACA,2CAAA;EACA,cAAA;EACA,cAAA;AP2ZJ;AO9bA;EG7KQ,mEAAA;EAAA,yEAAA;EAAA,yEAAA;EAAA,2EAAA;EAAA,+DAAA;EAAA,uEAAA;EAAA,qEAAA;EAAA,qEAAA;EAAA,6EAAA;EAAA,qEAAA;EAAA,2EAAA;EAAA,2EAAA;EAAA,yEAAA;EAAA,iFAAA;EAAA,+EAAA;EAAA,+EAAA;EAAA,8DAAA;EAAA,2FAAA;EAAA,8EAAA;EAAA,6EAAA;AVioBR;;AOrZA;EG5OQ,yCAAA;EAAA,qCAAA;AVsoBR;AOvZE;EACE,UAAA;APyZJ;AOtZE;EACE,UAAA;APwZJ;;AOnZA;EACE,kBAAA;EACA,sBAAA;APsZF;AOrZE;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;APuZJ;AOnZE;EACE,SAAA;EACA,qBAAA;EACA,cAAA;APqZJ;AOlZE;EACE,kBAAA;EACA,mBAAA;APoZJ;;AO/YA;EACE,6BAAA;EACA,6BAAA;APkZF;AOhZE;EACE,2BAAA;EACA,6BAAA;EACA,4BAAA;APkZJ;;AOtWE;EAVA,eAUuC;EATvC,WASuC;EARvC,YAQuC;EAPvC,iBAOuC;AP6WzC;AOnXE;EACE,WAKqC;EAJrC,YAIqC;APiXzC;AOhXE;EAXA,eAWuC;EAVvC,WAUuC;EATvC,YASuC;EARvC,iBAQuC;APsXzC;AO7XE;EACE,WAMqC;EALrC,YAKqC;AP0XzC;AOzXE;EAZA,eAYuC;EAXvC,WAWuC;EAVvC,YAUuC;EATvC,iBASuC;AP+XzC;AOvYE;EACE,WAOqC;EANrC,YAMqC;APmYzC;AOlYE;EAbA,eAauC;EAZvC,WAYuC;EAXvC,YAWuC;EAVvC,iBAUuC;APwYzC;AOjZE;EACE,WAQqC;EAPrC,YAOqC;AP4YzC;;AOtXA;EG5VQ,0CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,iDAAA;EAAA,wCAAA;EAAA,4CAAA;EAAA,yCAAA;EAAA,6CAAA;EH8VN,4BAAA;APkYF;;AO/XA;;8EAAA;AIvZI;EDsDI,2BAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,uCAAA;AV0uBR;;AO/XA;EG3WQ,6DAAA;EAAA,gGAAA;AV+uBR;;AO7XA;EGlXQ,mDAAA;EAAA,0EAAA;AVovBR;;AO3XA;;;;8EAAA;AAKA;EACE,WAAA;AP8XF;AO5XE;;;;EAIE,uBAAA;EACA,gCAAA;AP8XJ;AO3XE;EACE,gCAAA;EACA,iCAAA;EACA,iEAAA;AP6XJ;;AOzXA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AP4XF;;AOzXA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;AP4XF;;AOzXA;;8EAAA;AIxdI;EDsDI,qDAAA;EAAA,oDAAA;AVmyBR;;AOzXA;EACE,6BAAA;AP4XF;AO1XE;EACE,SAAA;EACA,oBAAA;EACA,yBAAA;AP4XJ;AOzXE;EACE,OAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AP2XJ;AOxXE;EACE,cAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;AP0XJ;;AOtXA;EACE,oCAAA;EACA,gBAAA;APyXF;;AOtXA;EACE,uBAAA;APyXF;;AOtXA;EA3KE,wCAAA;EACA,iCAAA;APqiBF;AOniBE;;;EAGE,QAAA;EACA,kBAAA;APqiBJ;AOliBE;EACE,sBAAA;EACA,uBAAA;APoiBJ;AOjiBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;APmiBJ;;AOvYA;EA/KE,wCAAA;EACA,iCAAA;AP0jBF;AOxjBE;;;EAGE,QAAA;EACA,kBAAA;AP0jBJ;AOvjBE;EACE,sBAAA;EACA,uBAAA;APyjBJ;AOtjBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;APwjBJ;;AOxZA,+EAAA;AACA;EACE,iBAAA;EACA,wCAAA;AP2ZF;AOzZE;EACE,0CAAA;AP2ZJ;AOxZE;EACE,oCAAA;AP0ZJ;;AOtZA,+EAAA;AACA;EACE,mDAAA;EACA,mDAAA;APyZF;;AOtZA;EACE,wBAAA;APyZF;;AOrZA;EACE,6BAAA;EACA,uCAAA;APwZF;;AOpZA;EACE,6BAAA;APuZF;;AO5YA;EG/fQ,qCAAA;AV+4BR;;AO1YA;EGrgBQ,uDAAA;AVm5BR;;AOxYA;EG3gBQ,+DAAA;EAAA,kDAAA;EAAA,mDAAA;AVy5BR;;AOtYA;EGnhBQ,0DAAA;EAAA,mEAAA;AV85BR;;AYt+BA;EACE,WAAA;EACA,YAAA;AZy+BF;;AYr+BA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;AZw+BF;AYt+BE;EACE,aAAA;EACA,gBAAA;EACA,cAAA;AZw+BJ;AYt+BI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AZw+BN;;AYl+BA;EACE,wBAAA;AZq+BF;AYn+BE;EACE,cAAA;EACA,WAAA;EACA,YAAA;AZq+BJ;;AYj+BA;EF+BQ,uDAAA;AVs8BR;AYj+BE;EACE,6BAAA;AZm+BJ;;AYh+BA;EACE,gDAAA;EACA,aAAA;AZm+BF;AYl+BE;EFoBM,+DAAA;AVi9BR;AYj+BI;EACE,6BAAA;EACA,gBAAA;AZm+BN;;AY99BA;EFSQ,0EAAA;EAAA,kFAAA;AV09BR;AY99BE;EFIM,wDAAA;AV69BR;;AYt9BA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;AZy9BF;;AYt9BE;EACE,2GAAA;EACA,0GAAA;AZy9BJ;AYt9BE;EACE,UAAA;AZw9BJ;AYv9BI;EACE,aAAA;EACA,wCAAA;AZy9BN;AYv9BI;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AZy9BN;AYx9BM;EACE,YAAA;AZ09BR;AYt9BE;EACE,6BAAA;AZw9BJ;AY9+BA;EFZQ,+DAAA;AV6/BR;;AYn9BA;EF1CQ,uCAAA;EAAA,2CAAA;EAAA,gDAAA;EAAA,6DAAA;EAAA,gEAAA;EAAA,6CAAA;EAAA,0CAAA;AVugCR;;AYl9BE;EACE,aAAA;AZq9BJ;;AYl9BA;EFzDQ,uCAAA;EAAA,2CAAA;EAAA,gDAAA;EAAA,6DAAA;EAAA,gEAAA;EAAA,6CAAA;EAAA,0CAAA;EAAA,oCAAA;AVshCR;;AY78BA;EACE,uCAAA;EACA,uCAAA;EACA,4CAAA;AZg9BF;;AY98BA;EAEE,wCAAA;EACA,wCAAA;AZg9BF;AY/8BE;EACE,4BAAA;AZi9BJ;;AY98BA;EACE,sCAAA;EACA,4CAAA;EAEA,uCAAA;EACA,uCAAA;AZg9BF;;AY78BA;EACE,wBAAA;EACA,mBAAA;EACA,SAAA;EACA,iDAAA;AZg9BF;AY58BE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gCAAA;AZ88BJ;AY58BE;EACE,cAAA,EAAA,4DAAA;AZ88BJ;AY58BE;EACE,iBAAA;AZ88BJ;;AY18BA;EACE,OAAA;EACA,+CAAA;EACA,2DAAA;EACA,oDAAA;EACA,uFAAA;EACA,iEAAA;AZ68BF;;AYz8BA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;AZ48BF;AY18BE;EACE,UAAA;AZ48BJ;AY18BI;EACE,WAAA;AZ48BN;;AYx8BA;EF7IQ,+DAAA;EEqJN,oBAAA;AZq8BF;;AY/7BA;EACE,iCAAA;EACA,oBAAA;AZk8BF;;AY/7BA;EACE,yBAAA;EACA,8BAAA;EACA,2BAAA;AZk8BF;;AY/7BA;EACE,0BAAA;AZk8BF;;AY97BA;EACE,uDAAA;EACA,mDAAA;AZi8BF;;Aa1rCA;;;;;;;;;;;EAAA;AAaA;EACE,0DAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,yBAAA;EACA,oBAAA;EAEA,0DAAA;EACA,0EAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,+BAAA;EACA,gCAAA;EACA,qBAAA;EACA,wBAAA;EACA,uEAAA;EACA,kCAAA;EACA,0BAAA,EAAA,yCAAA;EACA,kBAAA;Ab2rCF;;AaxrCA,oEAAA;AACA;EACE,qCAAA;Ab2rCF;;AaxrCA;EACE;IAAK,yBAAA;Eb4rCL;AACF;AM9sCA;;;EAAA;AQxBE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,8CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,4BAAA;EAIA,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,2CAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,yCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AfyuCF;;AiBz1CI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,uCAAA;EACA,gCAAA;EAGE,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,0CAAA;EAAA,6CAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,uCAAA;EACA,iDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,2CAAA;EACA,kDAAA;EACA,+CAAA;EACA,sDAAA;AfyuCJ;;AkBj5CA;;;EAGE,sBAAA;AlBo5CF;;AkBr4CI;EANJ;IAOM,uBAAA;ElBy4CJ;AACF;;AkB53CA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AlB+3CF;;AkBt3CA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;AnBgwB9B;;AkB/2CA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;AlBg3CF;;AkB72CA;EFuMQ,iCAAA;AhB0qCR;AgBt0CI;EE3CJ;IF8MQ,iBAAA;EhBuqCN;AACF;;AkBj3CA;EFkMQ,iCAAA;AhBmrCR;AgB/0CI;EEtCJ;IFyMQ,eAAA;EhBgrCN;AACF;;AkBr3CA;EF6LQ,+BAAA;AhB4rCR;AgBx1CI;EEjCJ;IFoMQ,kBAAA;EhByrCN;AACF;;AkBz3CA;EFwLQ,iCAAA;AhBqsCR;AgBj2CI;EE5BJ;IF+LQ,iBAAA;EhBksCN;AACF;;AkB73CA;EF+KM,kBALI;AhButCV;;AkB53CA;EF0KM,eALI;AhB2tCV;;AkBr3CA;EACE,aAAA;EACA,mBCwV0B;AnBgiC5B;;AkB92CA;EACE,iCAAA;EACA,YAAA;EACA,8BAAA;AlBi3CF;;AkB32CA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AlB82CF;;AkBx2CA;;EAEE,kBAAA;AlB22CF;;AkBx2CA;;;EAGE,aAAA;EACA,mBAAA;AlB22CF;;AkBx2CA;;;;EAIE,gBAAA;AlB22CF;;AkBx2CA;EACE,gBC6b4B;AnB86B9B;;AkBt2CA;EACE,qBAAA;EACA,cAAA;AlBy2CF;;AkBn2CA;EACE,gBAAA;AlBs2CF;;AkB91CA;;EAEE,mBCsa4B;AnB27B9B;;AkBz1CA;EF6EM,kBALI;AhBqxCV;;AkBt1CA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;AlBy1CF;;AkBh1CA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;AlBm1CF;;AkBh1CA;EAAM,eAAA;AlBo1CN;;AkBn1CA;EAAM,WAAA;AlBu1CN;;AkBl1CA;EACE,gEAAA;EACA,0BCgNwC;AnBqoC1C;AkBn1CE;EACE,mDAAA;AlBq1CJ;;AkB10CE;EAEE,cAAA;EACA,qBAAA;AlB40CJ;;AkBr0CA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AhBg0CV;;AkBj0CA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AhBw0CV;AkBh0CE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;AlBk0CJ;;AkB9zCA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;AlBi0CF;AkB9zCE;EACE,cAAA;AlBg0CJ;;AkB5zCA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBC25CkC;ED15ClC,sCC25CkC;EChsDhC,sBAAA;ApBqmDJ;AkB7zCE;EACE,UAAA;EF7BE,cALI;AhBk2CV;;AkBrzCA;EACE,gBAAA;AlBwzCF;;AkBlzCA;;EAEE,sBAAA;AlBqzCF;;AkB7yCA;EACE,oBAAA;EACA,yBAAA;AlBgzCF;;AkB7yCA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;AlBgzCF;;AkBzyCA;EAEE,mBAAA;EACA,gCAAA;AlB2yCF;;AkBxyCA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AlB2yCF;;AkBnyCA;EACE,qBAAA;AlBsyCF;;AkBhyCA;EAEE,gBAAA;AlBkyCF;;AkB1xCA;EACE,UAAA;AlB6xCF;;AkBxxCA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AlB2xCF;;AkBvxCA;;EAEE,oBAAA;AlB0xCF;;AkBrxCA;EACE,eAAA;AlBwxCF;;AkBrxCA;EAGE,iBAAA;AlBsxCF;AkBnxCE;EACE,UAAA;AlBqxCJ;;AkB9wCA;EACE,wBAAA;AlBixCF;;AkBzwCA;;;;EAIE,0BAAA;AlB4wCF;AkBzwCI;;;;EACE,eAAA;AlB8wCN;;AkBvwCA;EACE,UAAA;EACA,kBAAA;AlB0wCF;;AkBrwCA;EACE,gBAAA;AlBwwCF;;AkB9vCA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AlBiwCF;;AkBzvCA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EDjN5B,oBAAA;EFnNM,iCAAA;AhB+8CR;AgB3mDI;EEyWJ;IFtMQ,iBAAA;EhB48CN;AACF;AkB9vCE;EACE,WAAA;AlBgwCJ;;AkBzvCA;;;;;;;EAOE,UAAA;AlB4vCF;;AkBzvCA;EACE,YAAA;AlB4vCF;;AkBnvCA;EACE,6BAAA;EACA,oBAAA;AlBsvCF;AkBnvCE;EACE,eAAA;EACA,oBAAA;AlBqvCJ;;AkB5uCA;;;;;;;CAAA;AAWA;EACE,wBAAA;AlB4uCF;;AkBvuCA;EACE,UAAA;AlB0uCF;;AkBnuCA;EACE,aAAA;EACA,0BAAA;AlBsuCF;;AkBjuCA;EACE,qBAAA;AlBouCF;;AkB/tCA;EACE,SAAA;AlBkuCF;;AkB3tCA;EACE,kBAAA;EACA,eAAA;AlB8tCF;;AkBttCA;EACE,wBAAA;AlBytCF;;AkBjtCA;EACE,wBAAA;AlBotCF;;AqB/xDA;ELmQM,kBALI;EK5PR,gBFwoB4B;AnB0pC9B;;AqB7xDE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AhBmiDR;AgB/rDI;EKpGF;ILuQM,eAAA;EhBgiDN;AACF;;AqBxyDE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AhB8iDR;AgB1sDI;EKpGF;ILuQM,iBAAA;EhB2iDN;AACF;;AqBnzDE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AhByjDR;AgBrtDI;EKpGF;ILuQM,eAAA;EhBsjDN;AACF;;AqB9zDE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AhBokDR;AgBhuDI;EKpGF;ILuQM,iBAAA;EhBikDN;AACF;;AqBz0DE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AhB+kDR;AgB3uDI;EKpGF;ILuQM,eAAA;EhB4kDN;AACF;;AqBp1DE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AhB0lDR;AgBtvDI;EKpGF;ILuQM,iBAAA;EhBulDN;AACF;;AqBv0DA;ECvDE,eAAA;EACA,gBAAA;AtBk4DF;;AqBv0DA;EC5DE,eAAA;EACA,gBAAA;AtBu4DF;;AqBz0DA;EACE,qBAAA;ArB40DF;AqB10DE;EACE,oBFsoB0B;AnBssC9B;;AqBl0DA;EL8MM,kBALI;EKvMR,yBAAA;ArBq0DF;;AqBj0DA;EACE,mBFiUO;EH1HH,kBALI;AhBmoDV;AqBl0DE;EACE,gBAAA;ArBo0DJ;;AqBh0DA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cFtFS;AnBy5DX;AqBj0DE;EACE,aAAA;ArBm0DJ;;AuBn6DA;ECIE,eAAA;EAGA,YAAA;AxBi6DF;;AuBl6DA;EACE,gBJ+jDkC;EI9jDlC,mCJ+jDkC;EI9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AxB06DF;;AuB55DA;EAEE,qBAAA;AvB85DF;;AuB35DA;EACE,qBAAA;EACA,cAAA;AvB85DF;;AuB35DA;EPyPM,kBALI;EOlPR,gCJkjDkC;AnB4WpC;;AyBh8DE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;A1B68DF;;A2Bv5DI;EF5CE;IACE,gBNkee;EnBq+CrB;AACF;A2B75DI;EF5CE;IACE,gBNkee;EnB0+CrB;AACF;A2Bl6DI;EF5CE;IACE,gBNkee;EnB++CrB;AACF;A2Bv6DI;EF5CE;IACE,iBNkee;EnBo/CrB;AACF;A2B56DI;EF5CE;IACE,iBNkee;EnBy/CrB;AACF;A4B5+DA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;A5Bk/DJ;;A4B7+DE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;A7Bs/DF;A4Bp/DI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;A7Bg/DF;;A6Bj8DM;EACE,WAAA;A7Bo8DR;;A6Bj8DM;EApCJ,cAAA;EACA,WAAA;A7By+DF;;A6B39DE;EACE,cAAA;EACA,WAAA;A7B89DJ;;A6Bh+DE;EACE,cAAA;EACA,UAAA;A7Bm+DJ;;A6Br+DE;EACE,cAAA;EACA,mBAAA;A7Bw+DJ;;A6B1+DE;EACE,cAAA;EACA,UAAA;A7B6+DJ;;A6B/+DE;EACE,cAAA;EACA,UAAA;A7Bk/DJ;;A6Bp/DE;EACE,cAAA;EACA,mBAAA;A7Bu/DJ;;A6Bx9DM;EAhDJ,cAAA;EACA,WAAA;A7B4gEF;;A6Bv9DU;EAhEN,cAAA;EACA,kBAAA;A7B2hEJ;;A6B59DU;EAhEN,cAAA;EACA,mBAAA;A7BgiEJ;;A6Bj+DU;EAhEN,cAAA;EACA,UAAA;A7BqiEJ;;A6Bt+DU;EAhEN,cAAA;EACA,mBAAA;A7B0iEJ;;A6B3+DU;EAhEN,cAAA;EACA,mBAAA;A7B+iEJ;;A6Bh/DU;EAhEN,cAAA;EACA,UAAA;A7BojEJ;;A6Br/DU;EAhEN,cAAA;EACA,mBAAA;A7ByjEJ;;A6B1/DU;EAhEN,cAAA;EACA,mBAAA;A7B8jEJ;;A6B//DU;EAhEN,cAAA;EACA,UAAA;A7BmkEJ;;A6BpgEU;EAhEN,cAAA;EACA,mBAAA;A7BwkEJ;;A6BzgEU;EAhEN,cAAA;EACA,mBAAA;A7B6kEJ;;A6B9gEU;EAhEN,cAAA;EACA,WAAA;A7BklEJ;;A6B3gEY;EAxDV,wBAAA;A7BukEF;;A6B/gEY;EAxDV,yBAAA;A7B2kEF;;A6BnhEY;EAxDV,gBAAA;A7B+kEF;;A6BvhEY;EAxDV,yBAAA;A7BmlEF;;A6B3hEY;EAxDV,yBAAA;A7BulEF;;A6B/hEY;EAxDV,gBAAA;A7B2lEF;;A6BniEY;EAxDV,yBAAA;A7B+lEF;;A6BviEY;EAxDV,yBAAA;A7BmmEF;;A6B3iEY;EAxDV,gBAAA;A7BumEF;;A6B/iEY;EAxDV,yBAAA;A7B2mEF;;A6BnjEY;EAxDV,yBAAA;A7B+mEF;;A6B5iEQ;;EAEE,gBAAA;A7B+iEV;;A6B5iEQ;;EAEE,gBAAA;A7B+iEV;;A6BtjEQ;;EAEE,sBAAA;A7ByjEV;;A6BtjEQ;;EAEE,sBAAA;A7ByjEV;;A6BhkEQ;;EAEE,qBAAA;A7BmkEV;;A6BhkEQ;;EAEE,qBAAA;A7BmkEV;;A6B1kEQ;;EAEE,mBAAA;A7B6kEV;;A6B1kEQ;;EAEE,mBAAA;A7B6kEV;;A6BplEQ;;EAEE,qBAAA;A7BulEV;;A6BplEQ;;EAEE,qBAAA;A7BulEV;;A6B9lEQ;;EAEE,mBAAA;A7BimEV;;A6B9lEQ;;EAEE,mBAAA;A7BimEV;;A2B3pEI;EEUE;IACE,WAAA;E7BqpEN;E6BlpEI;IApCJ,cAAA;IACA,WAAA;E7ByrEA;E6B3qEA;IACE,cAAA;IACA,WAAA;E7B6qEF;E6B/qEA;IACE,cAAA;IACA,UAAA;E7BirEF;E6BnrEA;IACE,cAAA;IACA,mBAAA;E7BqrEF;E6BvrEA;IACE,cAAA;IACA,UAAA;E7ByrEF;E6B3rEA;IACE,cAAA;IACA,UAAA;E7B6rEF;E6B/rEA;IACE,cAAA;IACA,mBAAA;E7BisEF;E6BlqEI;IAhDJ,cAAA;IACA,WAAA;E7BqtEA;E6BhqEQ;IAhEN,cAAA;IACA,kBAAA;E7BmuEF;E6BpqEQ;IAhEN,cAAA;IACA,mBAAA;E7BuuEF;E6BxqEQ;IAhEN,cAAA;IACA,UAAA;E7B2uEF;E6B5qEQ;IAhEN,cAAA;IACA,mBAAA;E7B+uEF;E6BhrEQ;IAhEN,cAAA;IACA,mBAAA;E7BmvEF;E6BprEQ;IAhEN,cAAA;IACA,UAAA;E7BuvEF;E6BxrEQ;IAhEN,cAAA;IACA,mBAAA;E7B2vEF;E6B5rEQ;IAhEN,cAAA;IACA,mBAAA;E7B+vEF;E6BhsEQ;IAhEN,cAAA;IACA,UAAA;E7BmwEF;E6BpsEQ;IAhEN,cAAA;IACA,mBAAA;E7BuwEF;E6BxsEQ;IAhEN,cAAA;IACA,mBAAA;E7B2wEF;E6B5sEQ;IAhEN,cAAA;IACA,WAAA;E7B+wEF;E6BxsEU;IAxDV,cAAA;E7BmwEA;E6B3sEU;IAxDV,wBAAA;E7BswEA;E6B9sEU;IAxDV,yBAAA;E7BywEA;E6BjtEU;IAxDV,gBAAA;E7B4wEA;E6BptEU;IAxDV,yBAAA;E7B+wEA;E6BvtEU;IAxDV,yBAAA;E7BkxEA;E6B1tEU;IAxDV,gBAAA;E7BqxEA;E6B7tEU;IAxDV,yBAAA;E7BwxEA;E6BhuEU;IAxDV,yBAAA;E7B2xEA;E6BnuEU;IAxDV,gBAAA;E7B8xEA;E6BtuEU;IAxDV,yBAAA;E7BiyEA;E6BzuEU;IAxDV,yBAAA;E7BoyEA;E6BjuEM;;IAEE,gBAAA;E7BmuER;E6BhuEM;;IAEE,gBAAA;E7BkuER;E6BzuEM;;IAEE,sBAAA;E7B2uER;E6BxuEM;;IAEE,sBAAA;E7B0uER;E6BjvEM;;IAEE,qBAAA;E7BmvER;E6BhvEM;;IAEE,qBAAA;E7BkvER;E6BzvEM;;IAEE,mBAAA;E7B2vER;E6BxvEM;;IAEE,mBAAA;E7B0vER;E6BjwEM;;IAEE,qBAAA;E7BmwER;E6BhwEM;;IAEE,qBAAA;E7BkwER;E6BzwEM;;IAEE,mBAAA;E7B2wER;E6BxwEM;;IAEE,mBAAA;E7B0wER;AACF;A2Br0EI;EEUE;IACE,WAAA;E7B8zEN;E6B3zEI;IApCJ,cAAA;IACA,WAAA;E7Bk2EA;E6Bp1EA;IACE,cAAA;IACA,WAAA;E7Bs1EF;E6Bx1EA;IACE,cAAA;IACA,UAAA;E7B01EF;E6B51EA;IACE,cAAA;IACA,mBAAA;E7B81EF;E6Bh2EA;IACE,cAAA;IACA,UAAA;E7Bk2EF;E6Bp2EA;IACE,cAAA;IACA,UAAA;E7Bs2EF;E6Bx2EA;IACE,cAAA;IACA,mBAAA;E7B02EF;E6B30EI;IAhDJ,cAAA;IACA,WAAA;E7B83EA;E6Bz0EQ;IAhEN,cAAA;IACA,kBAAA;E7B44EF;E6B70EQ;IAhEN,cAAA;IACA,mBAAA;E7Bg5EF;E6Bj1EQ;IAhEN,cAAA;IACA,UAAA;E7Bo5EF;E6Br1EQ;IAhEN,cAAA;IACA,mBAAA;E7Bw5EF;E6Bz1EQ;IAhEN,cAAA;IACA,mBAAA;E7B45EF;E6B71EQ;IAhEN,cAAA;IACA,UAAA;E7Bg6EF;E6Bj2EQ;IAhEN,cAAA;IACA,mBAAA;E7Bo6EF;E6Br2EQ;IAhEN,cAAA;IACA,mBAAA;E7Bw6EF;E6Bz2EQ;IAhEN,cAAA;IACA,UAAA;E7B46EF;E6B72EQ;IAhEN,cAAA;IACA,mBAAA;E7Bg7EF;E6Bj3EQ;IAhEN,cAAA;IACA,mBAAA;E7Bo7EF;E6Br3EQ;IAhEN,cAAA;IACA,WAAA;E7Bw7EF;E6Bj3EU;IAxDV,cAAA;E7B46EA;E6Bp3EU;IAxDV,wBAAA;E7B+6EA;E6Bv3EU;IAxDV,yBAAA;E7Bk7EA;E6B13EU;IAxDV,gBAAA;E7Bq7EA;E6B73EU;IAxDV,yBAAA;E7Bw7EA;E6Bh4EU;IAxDV,yBAAA;E7B27EA;E6Bn4EU;IAxDV,gBAAA;E7B87EA;E6Bt4EU;IAxDV,yBAAA;E7Bi8EA;E6Bz4EU;IAxDV,yBAAA;E7Bo8EA;E6B54EU;IAxDV,gBAAA;E7Bu8EA;E6B/4EU;IAxDV,yBAAA;E7B08EA;E6Bl5EU;IAxDV,yBAAA;E7B68EA;E6B14EM;;IAEE,gBAAA;E7B44ER;E6Bz4EM;;IAEE,gBAAA;E7B24ER;E6Bl5EM;;IAEE,sBAAA;E7Bo5ER;E6Bj5EM;;IAEE,sBAAA;E7Bm5ER;E6B15EM;;IAEE,qBAAA;E7B45ER;E6Bz5EM;;IAEE,qBAAA;E7B25ER;E6Bl6EM;;IAEE,mBAAA;E7Bo6ER;E6Bj6EM;;IAEE,mBAAA;E7Bm6ER;E6B16EM;;IAEE,qBAAA;E7B46ER;E6Bz6EM;;IAEE,qBAAA;E7B26ER;E6Bl7EM;;IAEE,mBAAA;E7Bo7ER;E6Bj7EM;;IAEE,mBAAA;E7Bm7ER;AACF;A2B9+EI;EEUE;IACE,WAAA;E7Bu+EN;E6Bp+EI;IApCJ,cAAA;IACA,WAAA;E7B2gFA;E6B7/EA;IACE,cAAA;IACA,WAAA;E7B+/EF;E6BjgFA;IACE,cAAA;IACA,UAAA;E7BmgFF;E6BrgFA;IACE,cAAA;IACA,mBAAA;E7BugFF;E6BzgFA;IACE,cAAA;IACA,UAAA;E7B2gFF;E6B7gFA;IACE,cAAA;IACA,UAAA;E7B+gFF;E6BjhFA;IACE,cAAA;IACA,mBAAA;E7BmhFF;E6Bp/EI;IAhDJ,cAAA;IACA,WAAA;E7BuiFA;E6Bl/EQ;IAhEN,cAAA;IACA,kBAAA;E7BqjFF;E6Bt/EQ;IAhEN,cAAA;IACA,mBAAA;E7ByjFF;E6B1/EQ;IAhEN,cAAA;IACA,UAAA;E7B6jFF;E6B9/EQ;IAhEN,cAAA;IACA,mBAAA;E7BikFF;E6BlgFQ;IAhEN,cAAA;IACA,mBAAA;E7BqkFF;E6BtgFQ;IAhEN,cAAA;IACA,UAAA;E7BykFF;E6B1gFQ;IAhEN,cAAA;IACA,mBAAA;E7B6kFF;E6B9gFQ;IAhEN,cAAA;IACA,mBAAA;E7BilFF;E6BlhFQ;IAhEN,cAAA;IACA,UAAA;E7BqlFF;E6BthFQ;IAhEN,cAAA;IACA,mBAAA;E7BylFF;E6B1hFQ;IAhEN,cAAA;IACA,mBAAA;E7B6lFF;E6B9hFQ;IAhEN,cAAA;IACA,WAAA;E7BimFF;E6B1hFU;IAxDV,cAAA;E7BqlFA;E6B7hFU;IAxDV,wBAAA;E7BwlFA;E6BhiFU;IAxDV,yBAAA;E7B2lFA;E6BniFU;IAxDV,gBAAA;E7B8lFA;E6BtiFU;IAxDV,yBAAA;E7BimFA;E6BziFU;IAxDV,yBAAA;E7BomFA;E6B5iFU;IAxDV,gBAAA;E7BumFA;E6B/iFU;IAxDV,yBAAA;E7B0mFA;E6BljFU;IAxDV,yBAAA;E7B6mFA;E6BrjFU;IAxDV,gBAAA;E7BgnFA;E6BxjFU;IAxDV,yBAAA;E7BmnFA;E6B3jFU;IAxDV,yBAAA;E7BsnFA;E6BnjFM;;IAEE,gBAAA;E7BqjFR;E6BljFM;;IAEE,gBAAA;E7BojFR;E6B3jFM;;IAEE,sBAAA;E7B6jFR;E6B1jFM;;IAEE,sBAAA;E7B4jFR;E6BnkFM;;IAEE,qBAAA;E7BqkFR;E6BlkFM;;IAEE,qBAAA;E7BokFR;E6B3kFM;;IAEE,mBAAA;E7B6kFR;E6B1kFM;;IAEE,mBAAA;E7B4kFR;E6BnlFM;;IAEE,qBAAA;E7BqlFR;E6BllFM;;IAEE,qBAAA;E7BolFR;E6B3lFM;;IAEE,mBAAA;E7B6lFR;E6B1lFM;;IAEE,mBAAA;E7B4lFR;AACF;A2BvpFI;EEUE;IACE,WAAA;E7BgpFN;E6B7oFI;IApCJ,cAAA;IACA,WAAA;E7BorFA;E6BtqFA;IACE,cAAA;IACA,WAAA;E7BwqFF;E6B1qFA;IACE,cAAA;IACA,UAAA;E7B4qFF;E6B9qFA;IACE,cAAA;IACA,mBAAA;E7BgrFF;E6BlrFA;IACE,cAAA;IACA,UAAA;E7BorFF;E6BtrFA;IACE,cAAA;IACA,UAAA;E7BwrFF;E6B1rFA;IACE,cAAA;IACA,mBAAA;E7B4rFF;E6B7pFI;IAhDJ,cAAA;IACA,WAAA;E7BgtFA;E6B3pFQ;IAhEN,cAAA;IACA,kBAAA;E7B8tFF;E6B/pFQ;IAhEN,cAAA;IACA,mBAAA;E7BkuFF;E6BnqFQ;IAhEN,cAAA;IACA,UAAA;E7BsuFF;E6BvqFQ;IAhEN,cAAA;IACA,mBAAA;E7B0uFF;E6B3qFQ;IAhEN,cAAA;IACA,mBAAA;E7B8uFF;E6B/qFQ;IAhEN,cAAA;IACA,UAAA;E7BkvFF;E6BnrFQ;IAhEN,cAAA;IACA,mBAAA;E7BsvFF;E6BvrFQ;IAhEN,cAAA;IACA,mBAAA;E7B0vFF;E6B3rFQ;IAhEN,cAAA;IACA,UAAA;E7B8vFF;E6B/rFQ;IAhEN,cAAA;IACA,mBAAA;E7BkwFF;E6BnsFQ;IAhEN,cAAA;IACA,mBAAA;E7BswFF;E6BvsFQ;IAhEN,cAAA;IACA,WAAA;E7B0wFF;E6BnsFU;IAxDV,cAAA;E7B8vFA;E6BtsFU;IAxDV,wBAAA;E7BiwFA;E6BzsFU;IAxDV,yBAAA;E7BowFA;E6B5sFU;IAxDV,gBAAA;E7BuwFA;E6B/sFU;IAxDV,yBAAA;E7B0wFA;E6BltFU;IAxDV,yBAAA;E7B6wFA;E6BrtFU;IAxDV,gBAAA;E7BgxFA;E6BxtFU;IAxDV,yBAAA;E7BmxFA;E6B3tFU;IAxDV,yBAAA;E7BsxFA;E6B9tFU;IAxDV,gBAAA;E7ByxFA;E6BjuFU;IAxDV,yBAAA;E7B4xFA;E6BpuFU;IAxDV,yBAAA;E7B+xFA;E6B5tFM;;IAEE,gBAAA;E7B8tFR;E6B3tFM;;IAEE,gBAAA;E7B6tFR;E6BpuFM;;IAEE,sBAAA;E7BsuFR;E6BnuFM;;IAEE,sBAAA;E7BquFR;E6B5uFM;;IAEE,qBAAA;E7B8uFR;E6B3uFM;;IAEE,qBAAA;E7B6uFR;E6BpvFM;;IAEE,mBAAA;E7BsvFR;E6BnvFM;;IAEE,mBAAA;E7BqvFR;E6B5vFM;;IAEE,qBAAA;E7B8vFR;E6B3vFM;;IAEE,qBAAA;E7B6vFR;E6BpwFM;;IAEE,mBAAA;E7BswFR;E6BnwFM;;IAEE,mBAAA;E7BqwFR;AACF;A2Bh0FI;EEUE;IACE,WAAA;E7ByzFN;E6BtzFI;IApCJ,cAAA;IACA,WAAA;E7B61FA;E6B/0FA;IACE,cAAA;IACA,WAAA;E7Bi1FF;E6Bn1FA;IACE,cAAA;IACA,UAAA;E7Bq1FF;E6Bv1FA;IACE,cAAA;IACA,mBAAA;E7By1FF;E6B31FA;IACE,cAAA;IACA,UAAA;E7B61FF;E6B/1FA;IACE,cAAA;IACA,UAAA;E7Bi2FF;E6Bn2FA;IACE,cAAA;IACA,mBAAA;E7Bq2FF;E6Bt0FI;IAhDJ,cAAA;IACA,WAAA;E7By3FA;E6Bp0FQ;IAhEN,cAAA;IACA,kBAAA;E7Bu4FF;E6Bx0FQ;IAhEN,cAAA;IACA,mBAAA;E7B24FF;E6B50FQ;IAhEN,cAAA;IACA,UAAA;E7B+4FF;E6Bh1FQ;IAhEN,cAAA;IACA,mBAAA;E7Bm5FF;E6Bp1FQ;IAhEN,cAAA;IACA,mBAAA;E7Bu5FF;E6Bx1FQ;IAhEN,cAAA;IACA,UAAA;E7B25FF;E6B51FQ;IAhEN,cAAA;IACA,mBAAA;E7B+5FF;E6Bh2FQ;IAhEN,cAAA;IACA,mBAAA;E7Bm6FF;E6Bp2FQ;IAhEN,cAAA;IACA,UAAA;E7Bu6FF;E6Bx2FQ;IAhEN,cAAA;IACA,mBAAA;E7B26FF;E6B52FQ;IAhEN,cAAA;IACA,mBAAA;E7B+6FF;E6Bh3FQ;IAhEN,cAAA;IACA,WAAA;E7Bm7FF;E6B52FU;IAxDV,cAAA;E7Bu6FA;E6B/2FU;IAxDV,wBAAA;E7B06FA;E6Bl3FU;IAxDV,yBAAA;E7B66FA;E6Br3FU;IAxDV,gBAAA;E7Bg7FA;E6Bx3FU;IAxDV,yBAAA;E7Bm7FA;E6B33FU;IAxDV,yBAAA;E7Bs7FA;E6B93FU;IAxDV,gBAAA;E7By7FA;E6Bj4FU;IAxDV,yBAAA;E7B47FA;E6Bp4FU;IAxDV,yBAAA;E7B+7FA;E6Bv4FU;IAxDV,gBAAA;E7Bk8FA;E6B14FU;IAxDV,yBAAA;E7Bq8FA;E6B74FU;IAxDV,yBAAA;E7Bw8FA;E6Br4FM;;IAEE,gBAAA;E7Bu4FR;E6Bp4FM;;IAEE,gBAAA;E7Bs4FR;E6B74FM;;IAEE,sBAAA;E7B+4FR;E6B54FM;;IAEE,sBAAA;E7B84FR;E6Br5FM;;IAEE,qBAAA;E7Bu5FR;E6Bp5FM;;IAEE,qBAAA;E7Bs5FR;E6B75FM;;IAEE,mBAAA;E7B+5FR;E6B55FM;;IAEE,mBAAA;E7B85FR;E6Br6FM;;IAEE,qBAAA;E7Bu6FR;E6Bp6FM;;IAEE,qBAAA;E7Bs6FR;E6B76FM;;IAEE,mBAAA;E7B+6FR;E6B56FM;;IAEE,mBAAA;E7B86FR;AACF;A8BpiGA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mBXkYO;EWjYP,mBXusB4B;EWtsB5B,0CAAA;A9BmiGF;A8B5hGE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CX+sB0B;EW9sB1B,2GAAA;A9B6hGJ;A8B1hGE;EACE,uBAAA;A9B4hGJ;A8BzhGE;EACE,sBAAA;A9B2hGJ;;A8BvhGA;EACE,+DAAA;A9B0hGF;;A8BnhGA;EACE,iBAAA;A9BshGF;;A8B5gGE;EACE,wBAAA;A9B+gGJ;;A8BhgGE;EACE,sCAAA;A9BmgGJ;A8BhgGI;EACE,sCAAA;A9BkgGN;;A8B3/FE;EACE,sBAAA;A9B8/FJ;A8B3/FE;EACE,mBAAA;A9B6/FJ;;A8Bn/FE;EACE,oDAAA;EACA,8CAAA;A9Bs/FJ;;A8Bh/FE;EACE,oDAAA;EACA,8CAAA;A9Bm/FJ;;A8B3+FA;EACE,oDAAA;EACA,8CAAA;A9B8+FF;;A8Bt+FE;EACE,mDAAA;EACA,6CAAA;A9By+FJ;;A+BrnGE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;A/BinGJ;;A+BnoGE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;A/B+nGJ;;A+BjpGE;EAOE,sBAAA;EACA,mCAAA;EACA,kDAAA;EACA,kDAAA;EACA,8BAAA;EACA,+CAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;A/B6oGJ;;A+B/pGE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;A/B2pGJ;;A+B7qGE;EAOE,sBAAA;EACA,qCAAA;EACA,iDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,mDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;A/ByqGJ;;A+B3rGE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;A/BurGJ;;A+BzsGE;EAOE,sBAAA;EACA,sBAAA;EACA,+CAAA;EACA,gDAAA;EACA,8BAAA;EACA,4CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;A/BqsGJ;;A+BvtGE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,4CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,6CAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;A/BmtGJ;;A8BlkGI;EACE,gBAAA;EACA,iCAAA;A9BqkGN;;A2BhqGI;EGyFA;IACE,gBAAA;IACA,iCAAA;E9B2kGJ;AACF;A2BvqGI;EGyFA;IACE,gBAAA;IACA,iCAAA;E9BilGJ;AACF;A2B7qGI;EGyFA;IACE,gBAAA;IACA,iCAAA;E9BulGJ;AACF;A2BnrGI;EGyFA;IACE,gBAAA;IACA,iCAAA;E9B6lGJ;AACF;A2BzrGI;EGyFA;IACE,gBAAA;IACA,iCAAA;E9BmmGJ;AACF;AgCvwGA;EACE,qBbu2BsC;AnBk6ExC;;AgChwGA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBb+lB4B;AnBkqF9B;;AgC7vGA;EACE,kDAAA;EACA,qDAAA;EhBoQI,kBALI;AhBkgGV;;AgC7vGA;EACE,mDAAA;EACA,sDAAA;EhB8PI,mBALI;AhBwgGV;;AiC9xGA;EACE,mBd+1BsC;EHrkBlC,kBALI;EiBjRR,gCd+1BsC;AnBg8ExC;;AkCpyGA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,eALI;EkBhRR,gBfkmB4B;EejmB5B,gBfymB4B;EexmB5B,2Bf43BsC;Ee33BtC,gBAAA;EACA,mCfq3BsC;Eep3BtC,4BAAA;EACA,2DAAA;EdGE,sCAAA;EeHE,wEDMJ;AlCkyGF;AmCpyGM;EDhBN;ICiBQ,gBAAA;EnCuyGN;AACF;AkCryGE;EACE,gBAAA;AlCuyGJ;AkCryGI;EACE,eAAA;AlCuyGN;AkClyGE;EACE,2Bfs2BoC;Eer2BpC,mCfg2BoC;Ee/1BpC,kCf82BoC;Ee72BpC,UAAA;EAKE,kDfkhBkB;AnB8wFxB;AkC5xGE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AlCgxGJ;AkC3wGE;EACE,cAAA;EACA,UAAA;AlC6wGJ;AkCzwGE;EACE,gCf40BoC;Ee10BpC,UAAA;AlC0wGJ;AkClwGE;EAEE,wCf8yBoC;Ee3yBpC,UAAA;AlCiwGJ;AkC7vGE;EACE,yBAAA;EACA,0BAAA;EACA,0BforB0B;EenrB1B,2BfsyBoC;EiBp4BtC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qID0FF;AlC+vGJ;AmCr1GM;ED0EJ;ICzEM,gBAAA;EnCw1GN;AACF;AkCjwGE;EACE,wCf47B8B;AnBu0ElC;;AkC1vGA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;AlC6vGF;AkC3vGE;EACE,UAAA;AlC6vGJ;AkC1vGE;EAEE,gBAAA;EACA,eAAA;AlC2vGJ;;AkChvGA;EACE,mEf4wBsC;Ee3wBtC,uBAAA;ElByII,mBALI;EIvQN,yCAAA;ApBw3GJ;AkCjvGE;EACE,uBAAA;EACA,wBAAA;EACA,yBfooB0B;AnB+mF9B;;AkC/uGA;EACE,iEfgwBsC;Ee/vBtC,oBAAA;ElB4HI,kBALI;EIvQN,yCAAA;ApBo4GJ;AkChvGE;EACE,oBAAA;EACA,qBAAA;EACA,uBf2nB0B;AnBunF9B;;AkC1uGE;EACE,oEf6uBoC;AnBggFxC;AkC1uGE;EACE,mEf0uBoC;AnBkgFxC;AkCzuGE;EACE,iEfuuBoC;AnBogFxC;;AkCtuGA;EACE,WfquBsC;EepuBtC,gEf8tBsC;Ee7tBtC,iBfilB4B;AnBwpF9B;AkCvuGE;EACE,eAAA;AlCyuGJ;AkCtuGE;EACE,oBAAA;EdvLA,sCAAA;ApBg6GJ;AkCruGE;EACE,oBAAA;Ed5LA,sCAAA;ApBo6GJ;AkCpuGE;EAAoB,+Df8sBkB;AnByhFxC;AkCtuGE;EAAoB,6Df8sBkB;AnB2hFxC;;AqCx7GA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;ErBqRI,eALI;EqB7QR,gBlB+lB4B;EkB9lB5B,gBlBsmB4B;EkBrmB5B,2BlBy3BsC;EkBx3BtC,gBAAA;EACA,mClBk3BsC;EkBj3BtC,mFAAA;EACA,4BAAA;EACA,yClB+9BkC;EkB99BlC,0BlB+9BkC;EkB99BlC,2DAAA;EjBHE,sCAAA;EeHE,wEESJ;ArCw7GF;AmC77GM;EEfN;IFgBQ,gBAAA;EnCg8GN;AACF;AqC37GE;EACE,kClBs3BoC;EkBr3BpC,UAAA;EAKE,kDlBi+B4B;AnBw9ElC;AqCr7GE;EAEE,sBlB6uB0B;EkB5uB1B,sBAAA;ArCs7GJ;AqCn7GE;EAEE,wClBu1BoC;AnB6lFxC;AqC/6GE;EACE,kBAAA;EACA,uCAAA;ArCi7GJ;;AqC76GA;EACE,oBlBsuB4B;EkBruB5B,uBlBquB4B;EkBpuB5B,oBlBquB4B;EHlgBxB,mBALI;EIvQN,yCAAA;ApB29GJ;;AqC76GA;EACE,mBlBkuB4B;EkBjuB5B,sBlBiuB4B;EkBhuB5B,kBlBiuB4B;EHtgBxB,kBALI;EIvQN,yCAAA;ApBm+GJ;;AqC36GI;EACE,gEAAA;ArC86GN;;AsCt/GA;EACE,cAAA;EACA,kBnBq6BwC;EmBp6BxC,mBnBq6BwC;EmBp6BxC,uBnBq6BwC;AnBolF1C;AsCv/GE;EACE,WAAA;EACA,mBAAA;AtCy/GJ;;AsCr/GA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;AtCw/GF;AsCt/GE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AtCw/GJ;;AsCp/GA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DnB24BwC;EmB14BxC,yBAAA;AtCs/GF;AsCn/GE;ElB3BE,qBAAA;ApBihHJ;AsCl/GE;EAEE,kBnBm4BsC;AnBgnF1C;AsCh/GE;EACE,uBnB03BsC;AnBwnF1C;AsC/+GE;EACE,kCnBs1BoC;EmBr1BpC,UAAA;EACA,kDnB8foB;AnBm/FxB;AsC9+GE;EACE,yBnB5BM;EmB6BN,qBnB7BM;AnB6gHV;AsC9+GI;EAII,iEAAA;AtC6+GR;AsCz+GI;EAII,iEAAA;AtCw+GR;AsCn+GE;EACE,yBnBjDM;EmBkDN,qBnBlDM;EmBuDJ,kEAAA;AtCi+GN;AsC79GE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;AnB6nF3C;AsCx9GI;EACE,eAAA;EACA,YnBy1BqC;AnBioF3C;;AsC58GA;EACE,mBnBo1BgC;AnB2nFlC;AsC78GE;EACE,6DAAA;EAEA,UnB80B8B;EmB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;AtC88GJ;AmChkHM;EG0GJ;IHzGM,gBAAA;EnCmkHN;AACF;AsCj9GI;EACE,6DAAA;AtCm9GN;AsCh9GI;EACE,iCnB60B4B;EmBx0B1B,6DAAA;AtC88GR;AsCz8GE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;AtC28GJ;AsCz8GI;EACE,oBAAA;EACA,cAAA;AtC28GN;;AsCt8GA;EACE,qBAAA;EACA,kBnBsyBgC;AnBmqFlC;;AsCt8GA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AtCy8GF;AsCr8GI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;AnBizF9B;;AsCh8GI;EACE,6DAAA;AtCm8GN;;AuCtnHA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;AvCynHF;AuCvnHE;EACE,UAAA;AvCynHJ;AuCrnHI;EAA0B,kEpB8gCa;AnB0mF3C;AuCvnHI;EAA0B,kEpB6gCa;AnB6mF3C;AuCvnHE;EACE,SAAA;AvCynHJ;AuCtnHE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBjBkCQ;EoBNN,SpB6/BuC;EC1gCvC,mBAAA;EeHE,4GImBF;AvCunHJ;AmCtoHM;EIMJ;IJLM,gBAAA;EnCyoHN;AACF;AuC1nHI;EHjCF,0CjB8hCyC;AnBgoF3C;AuCxnHE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;ApBwpHJ;AuCtnHE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,gBAAA;EHpDF,yBjBkCQ;EoBoBN,SpBm+BuC;EC1gCvC,mBAAA;EeHE,4GI6CF;AvCunHJ;AmChqHM;EIiCJ;IJhCM,gBAAA;EnCmqHN;AACF;AuC1nHI;EH3DF,0CjB8hCyC;AnB0pF3C;AuCxnHE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;ApBkrHJ;AuCtnHE;EACE,oBAAA;AvCwnHJ;AuCtnHI;EACE,2CpBg9BqC;AnBwqF3C;AuCrnHI;EACE,2CpB48BqC;AnB2qF3C;;AwC9sHA;EACE,kBAAA;AxCitHF;AwC/sHE;;;EAGE,uDrBwiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;AnB0qFxC;AwC9sHE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,2CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELVE,gEKWF;AxCgtHJ;AmCvtHM;EKTJ;ILUM,gBAAA;EnC0tHN;AACF;AwCltHE;;EAEE,qBAAA;AxCotHJ;AwCltHI;;EACE,kBAAA;AxCqtHN;AwCltHI;;;EAEE,qBrB0gCkC;EqBzgClC,wBrB0gCkC;AnB2sFxC;AwCltHI;;EACE,qBrBqgCkC;EqBpgClC,wBrBqgCkC;AnBgtFxC;AwCjtHE;EACE,qBrB+/BoC;EqB9/BpC,wBrB+/BoC;EqB9/BpC,qBrBguB0B;AnBm/F9B;AwC5sHI;;;;EACE,8DrBy/BkC;AnBwtFxC;AwC5sHI;EACE,8DrBm/BkC;AnB2tFxC;AwCzsHI;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,arBw+BkC;EqBv+BlC,WAAA;EACA,mCrBqzBkC;ECh3BpC,sCAAA;ApBwwHJ;AwCzsHE;EACE,wCrBkzBoC;AnBy5FxC;AwCvsHI;EACE,sCAAA;AxCysHN;AwCrsHE;;EAEE,crBhFO;AnBuxHX;;AyCjyHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AzCoyHF;AyClyHE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AzCoyHJ;AyChyHE;;;EAGE,UAAA;AzCkyHJ;AyC5xHE;EACE,kBAAA;EACA,UAAA;AzC8xHJ;AyC5xHI;EACE,UAAA;AzC8xHN;;AyCnxHA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,eALI;EyBvOR,gBtByjB4B;EsBxjB5B,gBtBgkB4B;EsB/jB5B,2BtBm1BsC;EsBl1BtC,kBAAA;EACA,mBAAA;EACA,uCtB06BsC;EsBz6BtC,2DAAA;ErBtCE,sCAAA;ApB6zHJ;;AyC7wHA;;;;EAIE,oBAAA;EzBwNI,kBALI;EIvQN,yCAAA;ApBs0HJ;;AyC7wHA;;;;EAIE,uBAAA;EzB+MI,mBALI;EIvQN,yCAAA;ApB+0HJ;;AyC7wHA;;EAEE,mBAAA;AzCgxHF;;AyCnwHI;;;;ErBjEA,0BAAA;EACA,6BAAA;ApB20HJ;AyClwHI;;;;ErB1EA,0BAAA;EACA,6BAAA;ApBk1HJ;AyC5vHE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;ApBy0HJ;AyC5vHE;;ErB9EE,yBAAA;EACA,4BAAA;ApB80HJ;;A0Ct2HE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,iCvBkjCqB;AnBszFzB;;A0Cr2HE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,sCAAA;ApBm4HJ;;A0Cn2HI;;;;EAEE,cAAA;A1Cw2HN;;A0Cv5HI;EAqDE,+CvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A1Co2HR;A0Cj2HM;EACE,+CvB4gCiB;EuBvgCf,2DvBugCe;AnBw1FzB;;A0Cp6HI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A1Cy1HR;;A0Cz6HI;EAuFE,+CvBq/BmB;AnBi2FzB;A0Cn1HQ;EAEE,kEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A1Co1HV;A0Ch1HM;EACE,+CvBw+BiB;EuBn+Bf,2DvBm+Be;AnB22FzB;;A0Cv7HI;EAkHI,yCAAA;A1Cy0HR;;A0C37HI;EAyHE,+CvBm9BmB;AnBm3FzB;A0Cp0HM;EACE,4CvBg9BiB;AnBs3FzB;A0Cn0HM;EACE,2DvB48BiB;AnBy3FzB;A0Cl0HM;EACE,iCvBw8BiB;AnB43FzB;;A0C/zHI;EACE,kBAAA;A1Ck0HN;;A0C58HI;;;;;EAoJM,UAAA;A1Cg0HV;;A0Ch8HE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,mCvBkjCqB;AnBg5FzB;;A0C/7HE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,sCAAA;ApB69HJ;;A0C77HI;;;;EAEE,cAAA;A1Ck8HN;;A0Cj/HI;EAqDE,iDvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A1C87HR;A0C37HM;EACE,iDvB4gCiB;EuBvgCf,0DvBugCe;AnBk7FzB;;A0C9/HI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A1Cm7HR;;A0CngII;EAuFE,iDvBq/BmB;AnB27FzB;A0C76HQ;EAEE,kEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A1C86HV;A0C16HM;EACE,iDvBw+BiB;EuBn+Bf,0DvBm+Be;AnBq8FzB;;A0CjhII;EAkHI,yCAAA;A1Cm6HR;;A0CrhII;EAyHE,iDvBm9BmB;AnB68FzB;A0C95HM;EACE,8CvBg9BiB;AnBg9FzB;A0C75HM;EACE,0DvB48BiB;AnBm9FzB;A0C55HM;EACE,mCvBw8BiB;AnBs9FzB;;A0Cz5HI;EACE,kBAAA;A1C45HN;;A0CtiII;;;;;EAsJM,UAAA;A1Cw5HV;;A2ChjIA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E3BuRI,wBALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;A3C8iIF;AmClkIM;EQhBN;IRiBQ,gBAAA;EnCqkIN;AACF;A2CjjIE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A3CkjIJ;A2C/iIE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A3CgjIJ;A2C7iIE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A3C2iIN;A2CviIE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A3CqiIN;A2CjiIE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A3C6hIJ;A2C1hII;EAKI,0CAAA;A3CwhIR;A2CnhIE;EAKI,0CAAA;A3CihIN;A2C7gIE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A3C4gIJ;;A2ChgIE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A5CmnIF;;A2CjhIE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A5CooIF;;A2CliIE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,+CAAA;EACA,uCAAA;EACA,2BAAA;EACA,sCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A5CqpIF;;A2CnjIE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,oDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A5CsqIF;;A2CpkIE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,sCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A5CurIF;;A2CrlIE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,iDAAA;EACA,sCAAA;EACA,2BAAA;EACA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A5CwsIF;;A2CtmIE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A5CytIF;;A2CvnIE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A5C0uIF;;A2C9mIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A5CkuIF;;A2C/nIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A5CmvIF;;A2ChpIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A5CowIF;;A2CjqIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A5CqxIF;;A2ClrIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A5CsyIF;;A2CnsIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A5CuzIF;;A2CptIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A5Cw0IF;;A2CruIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A5Cy1IF;;A2C1uIA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BxB8QwC;AnB89H1C;A2CluIE;EACE,0BAAA;A3CouIJ;A2CjuIE;EACE,gCAAA;A3CmuIJ;;A2CxtIA;ECjJE,0BAAA;EACA,wBAAA;E5B8NI,2BALI;E4BvNR,kDAAA;A5C62IF;;A2C3tIA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,4BALI;E4BvNR,kDAAA;A5Co3IF;;A6Cv7IA;EVgBM,gCUfJ;A7C07IF;AmCv6IM;EUpBN;IVqBQ,gBAAA;EnC06IN;AACF;A6C77IE;EACE,UAAA;A7C+7IJ;;A6Cz7IE;EACE,aAAA;A7C47IJ;;A6Cx7IA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;A7C27IF;AmCz7IM;EULN;IVMQ,gBAAA;EnC47IN;AACF;A6C97IE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;A7Cg8IJ;AmCn8IM;EUAJ;IVCM,gBAAA;EnCs8IN;AACF;;A8C39IA;;;;;;EAME,kBAAA;A9C89IF;;A8C39IA;EACE,mBAAA;A9C89IF;A+Ct8II;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A/C8+IF;A+Cp7II;EACE,cAAA;A/Cs7IN;;A8Cp+IA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,6BALI;E8BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;ApB8gJJ;A8Cj+IE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;A9Cm+IJ;;A8C38II;EACE,oBAAA;A9C88IN;A8C58IM;EACE,WAAA;EACA,OAAA;A9C88IR;;A8C18II;EACE,kBAAA;A9C68IN;A8C38IM;EACE,QAAA;EACA,UAAA;A9C68IR;;A2Bv/II;EmB4BA;IACE,oBAAA;E9C+9IJ;E8C79II;IACE,WAAA;IACA,OAAA;E9C+9IN;E8C39IE;IACE,kBAAA;E9C69IJ;E8C39II;IACE,QAAA;IACA,UAAA;E9C69IN;AACF;A2BxgJI;EmB4BA;IACE,oBAAA;E9C++IJ;E8C7+II;IACE,WAAA;IACA,OAAA;E9C++IN;E8C3+IE;IACE,kBAAA;E9C6+IJ;E8C3+II;IACE,QAAA;IACA,UAAA;E9C6+IN;AACF;A2BxhJI;EmB4BA;IACE,oBAAA;E9C+/IJ;E8C7/II;IACE,WAAA;IACA,OAAA;E9C+/IN;E8C3/IE;IACE,kBAAA;E9C6/IJ;E8C3/II;IACE,QAAA;IACA,UAAA;E9C6/IN;AACF;A2BxiJI;EmB4BA;IACE,oBAAA;E9C+gJJ;E8C7gJI;IACE,WAAA;IACA,OAAA;E9C+gJN;E8C3gJE;IACE,kBAAA;E9C6gJJ;E8C3gJI;IACE,QAAA;IACA,UAAA;E9C6gJN;AACF;A2BxjJI;EmB4BA;IACE,oBAAA;E9C+hJJ;E8C7hJI;IACE,WAAA;IACA,OAAA;E9C+hJN;E8C3hJE;IACE,kBAAA;E9C6hJJ;E8C3hJI;IACE,QAAA;IACA,UAAA;E9C6hJN;AACF;A8CphJE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;A9CshJJ;A+C1mJI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A/C2oJF;A+CxlJI;EACE,cAAA;A/C0lJN;;A8C1hJE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;A9C6hJJ;A+C/nJI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A/CypJF;A+C7mJI;EACE,cAAA;A/C+mJN;A8CriJI;EACE,iBAAA;A9CuiJN;;A8CjiJE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;A9CoiJJ;A+CvpJI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;A/CypJN;A+C9oJM;EACE,aAAA;A/CgpJR;A+C7oJM;EACE,qBAAA;EACA,qB5B0gBsB;E4BzgBtB,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;A/CmrJF;A+C7oJI;EACE,cAAA;A/C+oJN;A8CpjJI;EACE,iBAAA;A9CsjJN;;A8C/iJA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;A9CkjJF;;A8C5iJA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Byb4B;E2Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;ApBstJJ;A8C7iJE;EAEE,0CAAA;EV1LF,kDU4LuB;A9C6iJzB;A8C1iJE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;A9C2iJzB;A8CxiJE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;A9CyiJJ;;A8CniJA;EACE,cAAA;A9CsiJF;;A8CliJA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,sCAAA;EACA,mBAAA;A9CqiJF;;A8CjiJA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;A9CoiJF;;A8ChiJA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;A9CkiJF;;AgDxxJA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AhD2xJF;AgDzxJE;;EACE,kBAAA;EACA,cAAA;AhD4xJJ;AgDvxJE;;;;;;;;;;;;EAME,UAAA;AhD+xJJ;;AgD1xJA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AhD6xJF;AgD3xJE;EACE,WAAA;AhD6xJJ;;AgDzxJA;E5BhBI,sCAAA;ApB6yJJ;AgDzxJE;;EAEE,8CAAA;AhD2xJJ;AgDvxJE;;;E5BVE,0BAAA;EACA,6BAAA;ApBsyJJ;AgDnxJE;;;E5BNE,yBAAA;EACA,4BAAA;ApB8xJJ;;AgDtwJA;EACE,wBAAA;EACA,uBAAA;AhDywJF;AgDvwJE;EAGE,cAAA;AhDuwJJ;AgDpwJE;EACE,eAAA;AhDswJJ;;AgDlwJA;EACE,uBAAA;EACA,sBAAA;AhDqwJF;;AgDlwJA;EACE,sBAAA;EACA,qBAAA;AhDqwJF;;AgDjvJA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AhDovJF;AgDlvJE;;EAEE,WAAA;AhDovJJ;AgDjvJE;;EAEE,6CAAA;AhDmvJJ;AgD/uJE;;E5B1FE,6BAAA;EACA,4BAAA;ApB60JJ;AgD3uJE;;;E5BjHE,yBAAA;EACA,0BAAA;ApBi2JJ;;AiDz3JA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AjDw3JF;;AiDr3JA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;AjDw3JF;AmCp4JM;EcGN;IdFQ,gBAAA;EnCu4JN;AACF;AiD33JE;EAEE,qCAAA;AjD43JJ;AiDx3JE;EACE,UAAA;EACA,kD9BkhBoB;AnBw2IxB;AiDt3JE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;AjDu3JJ;;AiD/2JA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;AjD+2JF;AiD72JE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;ApB65JJ;AiD92JI;EAGE,kBAAA;EACA,wDAAA;AjD82JN;AiD12JE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AjD42JJ;AiDz2JE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;ApB46JJ;;AiDj2JA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;AjDm2JF;AiDh2JE;E7B5FE,gDAAA;ApB+7JJ;AiD/1JE;;EAEE,4CAAA;EbjHF,oDakHuB;AjDi2JzB;;AiDx1JA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;AjDw1JF;AiDt1JE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;AjDw1JJ;AiDt1JI;EAEE,iCAAA;AjDu1JN;AiDn1JE;;EAEE,gB9B0d0B;E8Bzd1B,gDAAA;EACA,iCAAA;AjDq1JJ;;AiD30JE;;EAEE,cAAA;EACA,kBAAA;AjD80JJ;;AiDz0JE;;EAEE,YAAA;EACA,aAAA;EACA,kBAAA;AjD40JJ;;AiDt0JE;;EACE,WAAA;AjD00JJ;;AiDh0JE;EACE,aAAA;AjDm0JJ;AiDj0JE;EACE,cAAA;AjDm0JJ;;AkDhgKA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AlDggKF;AkD1/JE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AlDkgKJ;AkD9+JA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;AlDg/JF;AkD9+JE;EAEE,yCAAA;AlD++JJ;;AkDr+JA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AlDo+JF;AkDj+JI;EAEE,oCAAA;AlDk+JN;AkD99JE;EACE,gBAAA;AlDg+JJ;;AkDv9JA;EACE,mB/B8gCkC;E+B7gClC,sB/B6gCkC;E+B5gClC,6BAAA;AlD09JF;AkDx9JE;;;EAGE,oCAAA;AlD09JJ;;AkD78JA;EACE,YAAA;EACA,gBAAA;EAGA,mBAAA;AlD88JF;;AkD18JA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;AlD68JF;AmCtlKM;EeiIN;IfhIQ,gBAAA;EnCylKN;AACF;AkDh9JE;EACE,qBAAA;AlDk9JJ;AkD/8JE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AlDi9JJ;;AkD38JA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AlD88JF;;AkD38JA;EACE,yCAAA;EACA,gBAAA;AlD88JF;;A2BxkKI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ElDq8JN;EkDn8JM;IACE,mBAAA;ElDq8JR;EkDn8JQ;IACE,kBAAA;ElDq8JV;EkDl8JQ;IACE,kDAAA;IACA,iDAAA;ElDo8JV;EkDh8JM;IACE,iBAAA;ElDk8JR;EkD/7JM;IACE,wBAAA;IACA,gBAAA;ElDi8JR;EkD97JM;IACE,aAAA;ElDg8JR;EkD77JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ElD67JR;EkD17JQ;IACE,aAAA;ElD47JV;EkDz7JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ElD27JV;AACF;A2BxnKI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ElDo/JN;EkDl/JM;IACE,mBAAA;ElDo/JR;EkDl/JQ;IACE,kBAAA;ElDo/JV;EkDj/JQ;IACE,kDAAA;IACA,iDAAA;ElDm/JV;EkD/+JM;IACE,iBAAA;ElDi/JR;EkD9+JM;IACE,wBAAA;IACA,gBAAA;ElDg/JR;EkD7+JM;IACE,aAAA;ElD++JR;EkD5+JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ElD4+JR;EkDz+JQ;IACE,aAAA;ElD2+JV;EkDx+JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ElD0+JV;AACF;A2BvqKI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ElDmiKN;EkDjiKM;IACE,mBAAA;ElDmiKR;EkDjiKQ;IACE,kBAAA;ElDmiKV;EkDhiKQ;IACE,kDAAA;IACA,iDAAA;ElDkiKV;EkD9hKM;IACE,iBAAA;ElDgiKR;EkD7hKM;IACE,wBAAA;IACA,gBAAA;ElD+hKR;EkD5hKM;IACE,aAAA;ElD8hKR;EkD3hKM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ElD2hKR;EkDxhKQ;IACE,aAAA;ElD0hKV;EkDvhKQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ElDyhKV;AACF;A2BttKI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ElDklKN;EkDhlKM;IACE,mBAAA;ElDklKR;EkDhlKQ;IACE,kBAAA;ElDklKV;EkD/kKQ;IACE,kDAAA;IACA,iDAAA;ElDilKV;EkD7kKM;IACE,iBAAA;ElD+kKR;EkD5kKM;IACE,wBAAA;IACA,gBAAA;ElD8kKR;EkD3kKM;IACE,aAAA;ElD6kKR;EkD1kKM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ElD0kKR;EkDvkKQ;IACE,aAAA;ElDykKV;EkDtkKQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ElDwkKV;AACF;A2BrwKI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ElDioKN;EkD/nKM;IACE,mBAAA;ElDioKR;EkD/nKQ;IACE,kBAAA;ElDioKV;EkD9nKQ;IACE,kDAAA;IACA,iDAAA;ElDgoKV;EkD5nKM;IACE,iBAAA;ElD8nKR;EkD3nKM;IACE,wBAAA;IACA,gBAAA;ElD6nKR;EkD1nKM;IACE,aAAA;ElD4nKR;EkDznKM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ElDynKR;EkDtnKQ;IACE,aAAA;ElDwnKV;EkDrnKQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ElDunKV;AACF;AkD9qKI;EAEI,iBAAA;EACA,2BAAA;AlD+qKR;AkD7qKQ;EACE,mBAAA;AlD+qKV;AkD7qKU;EACE,kBAAA;AlD+qKZ;AkD5qKU;EACE,kDAAA;EACA,iDAAA;AlD8qKZ;AkD1qKQ;EACE,iBAAA;AlD4qKV;AkDzqKQ;EACE,wBAAA;EACA,gBAAA;AlD2qKV;AkDxqKQ;EACE,aAAA;AlD0qKV;AkDvqKQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;AlDuqKV;AkDpqKU;EACE,aAAA;AlDsqKZ;AkDnqKU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AlDqqKZ;;AkDppKA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;AlDspKF;;AkDhpKI;EACE,qEAAA;AlDmpKN;;AmD56KA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;ApB87KJ;AmDz6KE;EACE,eAAA;EACA,cAAA;AnD26KJ;AmDx6KE;EACE,mBAAA;EACA,sBAAA;AnD06KJ;AmDx6KI;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;ApBi8KJ;AmDx6KI;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;ApBw7KJ;AmDr6KE;;EAEE,aAAA;AnDu6KJ;;AmDn6KA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AnDo6KF;;AmDj6KA;EACE,4CAAA;EACA,iCAAA;AnDo6KF;;AmDj6KA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AnDo6KF;;AmDj6KA;EACE,gBAAA;AnDo6KF;;AmD55KE;EACE,oCAAA;AnD+5KJ;;AmDv5KA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AnD05KF;AmDx5KE;E/B7FE,wFAAA;ApBw/KJ;;AmDt5KA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AnDy5KF;AmDv5KE;E/BxGE,wFAAA;ApBkgLJ;;AmDh5KA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AnDm5KF;AmDj5KE;EACE,mCAAA;EACA,sCAAA;AnDm5KJ;;AmD/4KA;EACE,uDAAA;EACA,sDAAA;AnDk5KF;;AmD94KA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;ApB4hLJ;;AmD94KA;;;EAGE,WAAA;AnDi5KF;;AmD94KA;;E/B3II,0DAAA;EACA,2DAAA;ApB8hLJ;;AmD/4KA;;E/BlII,8DAAA;EACA,6DAAA;ApBshLJ;;AmDx4KE;EACE,0CAAA;AnD24KJ;A2BtgLI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EnD24KF;EmDx4KE;IACE,WAAA;IACA,gBAAA;EnD04KJ;EmDx4KI;IACE,cAAA;IACA,cAAA;EnD04KN;EmDr4KM;I/B1KJ,0BAAA;IACA,6BAAA;EpBkjLF;EmDt4KQ;;IAGE,0BAAA;EnDu4KV;EmDr4KQ;;IAGE,6BAAA;EnDs4KV;EmDl4KM;I/B3KJ,yBAAA;IACA,4BAAA;EpBgjLF;EmDn4KQ;;IAGE,yBAAA;EnDo4KV;EmDl4KQ;;IAGE,4BAAA;EnDm4KV;AACF;;AoDvmLA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;ApDymLF;;AoDrmLA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,eALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;ApDwmLF;AmC/nLM;EiBUN;IjBTQ,gBAAA;EnCkoLN;AACF;AoD3mLE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;ApD6mLJ;AoD3mLI;EACE,qDAAA;EACA,iDAAA;ApD6mLN;AoDxmLE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;ApD0mLJ;AmCxpLM;EiBqCJ;IjBpCM,gBAAA;EnC2pLN;AACF;AoD5mLE;EACE,UAAA;ApD8mLJ;AoD3mLE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;ApD6mLJ;;AoDzmLA;EACE,gBAAA;ApD4mLF;;AoDzmLA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;ApD4mLF;AoD1mLE;EhC7DE,yDAAA;EACA,0DAAA;ApB0qLJ;AoD3mLI;EhChEA,+DAAA;EACA,gEAAA;ApB8qLJ;AoD1mLE;EACE,aAAA;ApD4mLJ;AoDxmLE;EhC5DE,6DAAA;EACA,4DAAA;ApBuqLJ;AoDxmLM;EhChEF,mEAAA;EACA,kEAAA;ApB2qLJ;AoDvmLI;EhCrEA,6DAAA;EACA,4DAAA;ApB+qLJ;;AoDrmLA;EACE,8EAAA;ApDwmLF;;AoD/lLE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;ApBitLJ;AoDhmLI;EAAgB,aAAA;ApDmmLpB;AoDlmLI;EAAe,gBAAA;ApDqmLnB;AoDlmLI;;;EhCrHA,gBAAA;ApB4tLJ;;AoD5lLI;EACE,iEAAA;EACA,wEAAA;ApD+lLN;;AqDpvLA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;ApBovLJ;;AqD9uLE;EACE,iDAAA;ArDivLJ;AqD/uLI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;ArDivLN;AqD7uLE;EACE,6CAAA;ArD+uLJ;;AsDpxLA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AtByyLF;;AsDlxLA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;AtDqxLF;AmCtyLM;EmBQN;InBPQ,gBAAA;EnCyyLN;AACF;AsDxxLE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;AtDyxLJ;AsDtxLE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;AtDwxLJ;AsDrxLE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;AtDsxLJ;AsDnxLE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AtDoxLJ;;AsD/wLE;EACE,8CnC8sCgC;AnBokJpC;AsD7wLM;ElC9BF,0DAAA;EACA,6DAAA;ApB8yLJ;AsD3wLM;ElClDF,2DAAA;EACA,8DAAA;ApBg0LJ;;AsD9vLA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,kCALI;EuCnRR,yDAAA;AvDo2LF;;AsDjwLA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,yDAAA;AvD22LF;;AwD72LA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;ApBk3LJ;AwDz2LE;EACE,aAAA;AxD22LJ;;AwDt2LA;EACE,kBAAA;EACA,SAAA;AxDy2LF;;AyDz4LA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;ApB64LJ;;AyDr4LA;EAEE,cAAA;AzDu4LF;;AyDn4LA;EACE,gBtC6kB4B;EsC5kB5B,iCAAA;AzDs4LF;;AyD93LA;EACE,mBtCs+C8B;AnB25IhC;AyD93LE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;AzDg4LJ;;AyDx3LE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AzD23LJ;;AyD/3LE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;AzDk4LJ;;AyDt4LE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AzDy4LJ;;AyD74LE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AzDg5LJ;;AyDp5LE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AzDu5LJ;;AyD35LE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;AzD85LJ;;AyDl6LE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;AzDq6LJ;;AyDz6LE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AzD46LJ;;A0Dx+LE;EACE;IAAK,gDAAA;E1D4+LP;AACF;A0Dx+LA;;EAGE,0BAAA;E1CkRI,gCALI;E0C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;ApBg/LJ;;A0Dn+LA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A1Ds+LF;AmC3/LM;EuBYN;IvBXQ,gBAAA;EnC8/LN;AACF;;A0Dx+LA;EtBAE,qMAAA;EsBEA,oEAAA;A1D2+LF;;A0Dx+LA;EACE,iBAAA;A1D2+LF;;A0Dx+LA;EACE,WAAA;A1D2+LF;;A0Dv+LE;EACE,kDAAA;A1D0+LJ;A0Dv+LM;EAJJ;IAKM,eAAA;E1D0+LN;AACF;;A2DtiMA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;ApBgjMJ;;A2DjiMA;EACE,qBAAA;EACA,sBAAA;A3DoiMF;A2DliME;EAEE,oCAAA;EACA,0BAAA;A3DmiMJ;;A2D3hMA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A3D8hMF;A2D5hME;EvC9BE,+BAAA;EACA,gCAAA;ApB6jMJ;A2D5hME;EvCpBE,mCAAA;EACA,kCAAA;ApBmjMJ;A2D5hME;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A3D6hMJ;A2DzhME;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A3D2hMJ;A2DvhME;EACE,mBAAA;A3DyhMJ;A2DvhMI;EACE,wDAAA;EACA,mDAAA;A3DyhMN;;A2D/gMA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A3DkhMF;A2D9gMI;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A3D+gMN;A2D5gMI;EACE,+CAAA;EACA,uDAAA;A3D8gMN;;A2DjgMI;EACE,mBAAA;A3DogMN;A2DjgMQ;EvCzDJ,6DAAA;EAZA,0BAAA;ApB0kMJ;A2DhgMQ;EvC1EJ,2DAAA;EAYA,4BAAA;ApBkkMJ;A2D//LQ;EACE,aAAA;A3DigMV;A2D9/LQ;EACE,mDAAA;EACA,oBAAA;A3DggMV;A2D9/LU;EACE,yDAAA;EACA,oDAAA;A3DggMZ;;A2BxlMI;EgCgEA;IACE,mBAAA;E3D4hMJ;E2DzhMM;IvCzDJ,6DAAA;IAZA,0BAAA;EpBkmMF;E2DxhMM;IvC1EJ,2DAAA;IAYA,4BAAA;EpB0lMF;E2DvhMM;IACE,aAAA;E3DyhMR;E2DthMM;IACE,mDAAA;IACA,oBAAA;E3DwhMR;E2DthMQ;IACE,yDAAA;IACA,oDAAA;E3DwhMV;AACF;A2BjnMI;EgCgEA;IACE,mBAAA;E3DojMJ;E2DjjMM;IvCzDJ,6DAAA;IAZA,0BAAA;EpB0nMF;E2DhjMM;IvC1EJ,2DAAA;IAYA,4BAAA;EpBknMF;E2D/iMM;IACE,aAAA;E3DijMR;E2D9iMM;IACE,mDAAA;IACA,oBAAA;E3DgjMR;E2D9iMQ;IACE,yDAAA;IACA,oDAAA;E3DgjMV;AACF;A2BzoMI;EgCgEA;IACE,mBAAA;E3D4kMJ;E2DzkMM;IvCzDJ,6DAAA;IAZA,0BAAA;EpBkpMF;E2DxkMM;IvC1EJ,2DAAA;IAYA,4BAAA;EpB0oMF;E2DvkMM;IACE,aAAA;E3DykMR;E2DtkMM;IACE,mDAAA;IACA,oBAAA;E3DwkMR;E2DtkMQ;IACE,yDAAA;IACA,oDAAA;E3DwkMV;AACF;A2BjqMI;EgCgEA;IACE,mBAAA;E3DomMJ;E2DjmMM;IvCzDJ,6DAAA;IAZA,0BAAA;EpB0qMF;E2DhmMM;IvC1EJ,2DAAA;IAYA,4BAAA;EpBkqMF;E2D/lMM;IACE,aAAA;E3DimMR;E2D9lMM;IACE,mDAAA;IACA,oBAAA;E3DgmMR;E2D9lMQ;IACE,yDAAA;IACA,oDAAA;E3DgmMV;AACF;A2BzrMI;EgCgEA;IACE,mBAAA;E3D4nMJ;E2DznMM;IvCzDJ,6DAAA;IAZA,0BAAA;EpBksMF;E2DxnMM;IvC1EJ,2DAAA;IAYA,4BAAA;EpB0rMF;E2DvnMM;IACE,aAAA;E3DynMR;E2DtnMM;IACE,mDAAA;IACA,oBAAA;E3DwnMR;E2DtnMQ;IACE,yDAAA;IACA,oDAAA;E3DwnMV;AACF;A2D3mMA;EvClJI,gBAAA;ApBgwMJ;A2D3mME;EACE,mDAAA;A3D6mMJ;A2D3mMI;EACE,sBAAA;A3D6mMN;;A2DhmME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A3DmmMJ;;A2D7mME;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A3DgnMJ;;A2D1nME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A3D6nMJ;;A2DvoME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A3D0oMJ;;A2DppME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A3DupMJ;;A2DjqME;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A3DoqMJ;;A2D9qME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A3DirMJ;;A2D3rME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A3D8rMJ;;A4D53MA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EAGA,uBAAA;EACA,UzCupD2B;EyCtpD3B,WzCspD2B;EyCrpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,kCAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;A5D43MF;A4Dz3ME;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;A5D23MJ;A4Dx3ME;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;A5D03MJ;A4Dv3ME;EAEE,oBAAA;EACA,iBAAA;EACA,6CAAA;A5Dw3MJ;;A4Dh3MA;EAHE,iEAAA;A5Du3MF;;A4Dh3MA;;EAEE,uBAAA;A5Dm3MF;;AiB95MI;E2CkCF,iEAAA;A5Dg4MF;;A6Dj7MA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;ApB07MJ;A6D/6ME;EACE,UAAA;A7Di7MJ;A6D96ME;EACE,aAAA;A7Dg7MJ;;A6D56MA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;A7D86MF;A6D56ME;EACE,sCAAA;A7D86MJ;;A6D16MA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;ApB88MJ;A6D56ME;EACE,oDAAA;EACA,sCAAA;A7D86MJ;;A6D16MA;EACE,kCAAA;EACA,qBAAA;A7D66MF;;A8D3+MA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sCAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;A9Dy+MF;;A8Dl+MA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;A9Do+MF;A8Dj+ME;EACE,8B3Cm8CgC;EgBh/C9B,mC2B8CF;A9Dm+MJ;AmC7gNM;E2BwCJ;I3BvCM,gBAAA;EnCghNN;AACF;A8Dt+ME;EACE,e3Cg8CgC;AnBwiKpC;A8Dp+ME;EACE,sB3C67CgC;AnByiKpC;;A8Dl+MA;EACE,+CAAA;A9Dq+MF;A8Dn+ME;EACE,gBAAA;EACA,gBAAA;A9Dq+MJ;A8Dl+ME;EACE,gBAAA;A9Do+MJ;;A8Dh+MA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;A9Dm+MF;;A8D/9MA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;A9D+9MF;;A8D39MA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;A9Di+M9D;A+D7kNE;EAAS,UAAA;A/DglNX;A+D/kNE;EAAS,mCD2GiF;A9Du+M5F;;A8Dl+MA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;ApB2kNJ;A8Dp+ME;EACE,kGAAA;EAEA,yDAAA;EACA,2DAAA;EACA,4DAAA;EACA,iBAAA;A9Dq+MJ;;A8Dh+MA;EACE,gBAAA;EACA,8CAAA;A9Dm+MF;;A8D99MA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;A9D+9MF;;A8D39MA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C7HE,+DAAA;EACA,8DAAA;ApB4lNJ;A8D19ME;EACE,8CAAA;A9D49MJ;;A2B3kNI;EmCqHF;IACE,0BAAA;IACA,2CAAA;E9D09MF;E8Dt9MA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;E9Dw9MF;E8Dr9MA;IACE,uBAAA;E9Du9MF;AACF;A2B1lNI;EmCuIF;;IAEE,uBAAA;E9Ds9MF;AACF;A2BhmNI;EmC8IF;IACE,wBAAA;E9Dq9MF;AACF;A8D58MI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;A9D88MN;A8D58MM;EACE,YAAA;EACA,SAAA;E1C7MJ,gBAAA;ApB4pNJ;A8D38MM;;E1CjNF,gBAAA;ApBgqNJ;A8D18MM;EACE,gBAAA;A9D48MR;;A2B1mNI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;E9Dk+MJ;E8Dh+MI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EpBgrNF;E8D/9MI;;I1CjNF,gBAAA;EpBorNF;E8D99MI;IACE,gBAAA;E9Dg+MN;AACF;A2B/nNI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;E9Ds/MJ;E8Dp/MI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EpBosNF;E8Dn/MI;;I1CjNF,gBAAA;EpBwsNF;E8Dl/MI;IACE,gBAAA;E9Do/MN;AACF;A2BnpNI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;E9D0gNJ;E8DxgNI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EpBwtNF;E8DvgNI;;I1CjNF,gBAAA;EpB4tNF;E8DtgNI;IACE,gBAAA;E9DwgNN;AACF;A2BvqNI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;E9D8hNJ;E8D5hNI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EpB4uNF;E8D3hNI;;I1CjNF,gBAAA;EpBgvNF;E8D1hNI;IACE,gBAAA;E9D4hNN;AACF;A2B3rNI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;E9DkjNJ;E8DhjNI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EpBgwNF;E8D/iNI;;I1CjNF,gBAAA;EpBowNF;E8D9iNI;IACE,gBAAA;E9DgjNN;AACF;AgE1xNA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,gCALI;EgDjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AhEkyNF;AgEhyNE;EAAS,kCAAA;AhEmyNX;AgEjyNE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AhEmyNJ;AgEjyNI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AhEmyNN;;AgE9xNA;EACE,iDAAA;AhEiyNF;AgE/xNE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AhEiyNJ;;AgE7xNA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AhEgyNF;AgE9xNE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AhEgyNJ;;AgE5xNA,mBAAA;AAEA;EACE,8CAAA;AhE8xNF;AgE5xNE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AhE8xNJ;;AgE1xNA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AhE6xNF;AgE3xNE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AhE6xNJ;;AgEzxNA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;ApB62NJ;;AkEh4NA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,gCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;ApB25NJ;AkEv4NE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AlEy4NJ;AkEv4NI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AlEw4NN;;AkEl4NE;EACE,oFAAA;AlEq4NJ;AkEn4NI;EAEE,wFAAA;AlEo4NN;AkEj4NI;EACE,SAAA;EACA,gDAAA;AlEm4NN;AkEh4NI;EACE,sCAAA;EACA,sCAAA;AlEk4NN;;AkE73NA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AlE+3NJ;AkE73NI;EAEE,kIAAA;AlE83NN;AkE33NI;EACE,OAAA;EACA,kDAAA;AlE63NN;AkE13NI;EACE,oCAAA;EACA,wCAAA;AlE43NN;;AkEv3NA,mBAAA;AAGE;EACE,iFAAA;AlEw3NJ;AkEt3NI;EAEE,wFAAA;AlEu3NN;AkEp3NI;EACE,MAAA;EACA,mDAAA;AlEs3NN;AkEn3NI;EACE,mCAAA;EACA,yCAAA;AlEq3NN;AkEh3NE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AlEk3NJ;;AkE92NA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AlEg3NJ;AkE92NI;EAEE,kIAAA;AlE+2NN;AkE52NI;EACE,QAAA;EACA,iDAAA;AlE82NN;AkE32NI;EACE,qCAAA;EACA,uCAAA;AlE62NN;;AkEx2NA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;ApBu/NJ;AkEz1NE;EACE,aAAA;AlE21NJ;;AkEv1NA;EACE,0EAAA;EACA,mCAAA;AlE01NF;;AmE/gOA;EACE,kBAAA;AnEkhOF;;AmE/gOA;EACE,mBAAA;AnEkhOF;;AmE/gOA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AnEkhOF;AoExiOE;EACE,cAAA;EACA,WAAA;EACA,WAAA;ApE0iOJ;;AmEnhOA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AnEshOF;AmCriOM;EgCQN;IhCPQ,gBAAA;EnCwiON;AACF;;AmExhOA;;;EAGE,cAAA;AnE2hOF;;AmExhOA;;EAEE,2BAAA;AnE2hOF;;AmExhOA;;EAEE,4BAAA;AnE2hOF;;AmElhOE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AnEqhOJ;AmElhOE;;;EAGE,UAAA;EACA,UAAA;AnEohOJ;AmEjhOE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AnEmhOJ;AmC5kOM;EgCqDJ;;IhCpDM,gBAAA;EnCglON;AACF;;AmEhhOA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDkhDmC;EgDjhDnC,UAAA;EACA,WhD1FS;EgD2FT,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,SAAA;EACA,YhD4gDmC;EgBnmD/B,8BgCwFJ;AnEkhOF;AmCtmOM;EgCkEN;;IhCjEQ,gBAAA;EnC0mON;AACF;AmErhOE;;;EAEE,WhDrGO;EgDsGP,qBAAA;EACA,UAAA;EACA,YhDogDiC;AnBohLrC;;AmErhOA;EACE,OAAA;AnEwhOF;;AmErhOA;EACE,QAAA;AnEwhOF;;AmEnhOA;;EAEE,qBAAA;EACA,WhDsgDmC;EgDrgDnC,YhDqgDmC;EgDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AnEshOF;;AmEnhOA;EACE,0TAAA;AnEshOF;;AmEphOA;EACE,yTAAA;AnEuhOF;;AmE/gOA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDq9CmC;EgDp9CnC,mBAAA;EACA,gBhDm9CmC;AnB8jLrC;AmE/gOE;EACE,uBAAA;EACA,cAAA;EACA,WhDo9CiC;EgDn9CjC,WhDo9CiC;EgDn9CjC,UAAA;EACA,iBhDo9CiC;EgDn9CjC,gBhDm9CiC;EgDl9CjC,mBAAA;EACA,eAAA;EACA,wDAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhD28CiC;EgB5mD/B,6BgCkKF;AnEghOJ;AmC9qOM;EgC6IJ;IhC5IM,gBAAA;EnCirON;AACF;AmElhOE;EACE,UhDw8CiC;AnB4kLrC;;AmE3gOA;EACE,kBAAA;EACA,UAAA;EACA,ehDk8CmC;EgDj8CnC,SAAA;EACA,oBhD+7CmC;EgD97CnC,uBhD87CmC;EgD77CnC,uCAAA;EACA,kBAAA;AnE8gOF;;AmEngOA;EALE,uCAAA;EACA,iCAAA;EACA,2DAAA;AnE4gOF;;AmErgOA;;EAEE,uCAAA;EACA,iCAAA;EACA,mCAAA;AnEwgOF;;AiBntOI;EkD8LF,uCAAA;EACA,iCAAA;EACA,2DAAA;AnEyhOF;;AqEpuOA;;EAEE,qBAAA;EACA,cAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;ArEsuOF;;AqEluOA;EACE;IAAK,0CAAA;ErEsuOL;AACF;AqEnuOA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;ArEkuOF;;AqE/tOA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;ArEiuOF;;AqExtOA;EACE;IACE,mBAAA;ErE2tOF;EqEztOA;IACE,UAAA;IACA,eAAA;ErE2tOF;AACF;AqEvtOA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;ArEstOF;;AqEntOA;EACE,wBAAA;EACA,yBAAA;ArEstOF;;AqEltOE;EACE;;IAEE,kCAAA;ErEqtOJ;AACF;AsEtyOA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;AtEuyOF;;A2B1uOI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EtEwxOJ;AACF;AmCnzOM;EmCYJ;InCXM,gBAAA;EnCszON;AACF;A2BhwOI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EtE+xON;EsE5xOI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EtE8xON;EsE3xOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EtE6xON;EsE1xOI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EtE4xON;EsEzxOI;IAEE,eAAA;EtE0xON;EsEvxOI;IAGE,mBAAA;EtEuxON;AACF;A2BpzOI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EtEsxON;EsEpxOM;IACE,aAAA;EtEsxOR;EsEnxOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EtEoxOR;AACF;;A2BxzOI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EtEs2OJ;AACF;AmCj4OM;EmCYJ;InCXM,gBAAA;EnCo4ON;AACF;A2B90OI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EtE62ON;EsE12OI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EtE42ON;EsEz2OI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EtE22ON;EsEx2OI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EtE02ON;EsEv2OI;IAEE,eAAA;EtEw2ON;EsEr2OI;IAGE,mBAAA;EtEq2ON;AACF;A2Bl4OI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EtEo2ON;EsEl2OM;IACE,aAAA;EtEo2OR;EsEj2OM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EtEk2OR;AACF;;A2Bt4OI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EtEo7OJ;AACF;AmC/8OM;EmCYJ;InCXM,gBAAA;EnCk9ON;AACF;A2B55OI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EtE27ON;EsEx7OI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EtE07ON;EsEv7OI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EtEy7ON;EsEt7OI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EtEw7ON;EsEr7OI;IAEE,eAAA;EtEs7ON;EsEn7OI;IAGE,mBAAA;EtEm7ON;AACF;A2Bh9OI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EtEk7ON;EsEh7OM;IACE,aAAA;EtEk7OR;EsE/6OM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EtEg7OR;AACF;;A2Bp9OI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EtEkgPJ;AACF;AmC7hPM;EmCYJ;InCXM,gBAAA;EnCgiPN;AACF;A2B1+OI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EtEygPN;EsEtgPI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EtEwgPN;EsErgPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EtEugPN;EsEpgPI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EtEsgPN;EsEngPI;IAEE,eAAA;EtEogPN;EsEjgPI;IAGE,mBAAA;EtEigPN;AACF;A2B9hPI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EtEggPN;EsE9/OM;IACE,aAAA;EtEggPR;EsE7/OM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EtE8/OR;AACF;;A2BliPI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EtEglPJ;AACF;AmC3mPM;EmCYJ;InCXM,gBAAA;EnC8mPN;AACF;A2BxjPI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EtEulPN;EsEplPI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EtEslPN;EsEnlPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EtEqlPN;EsEllPI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EtEolPN;EsEjlPI;IAEE,eAAA;EtEklPN;EsE/kPI;IAGE,mBAAA;EtE+kPN;AACF;A2B5mPI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EtE8kPN;EsE5kPM;IACE,aAAA;EtE8kPR;EsE3kPM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EtE4kPR;AACF;;AsE5pPE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;AtE6pPN;AmCvrPM;EmCYJ;InCXM,gBAAA;EnC0rPN;AACF;AsEhqPM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AtEkqPR;AsE/pPM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AtEiqPR;AsE9pPM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AtEgqPR;AsE7pPM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AtE+pPR;AsE5pPM;EAEE,eAAA;AtE6pPR;AsE1pPM;EAGE,mBAAA;AtE0pPR;;AsE/nPA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,sB5CUS;AnB6uPX;A+DpvPE;EAAS,UAAA;A/DuvPX;A+DtvPE;EAAS,Y5Cm+CyB;AnBsxMpC;;AsE3oPA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;AtE8oPF;AsE5oPE;EACE,4FAAA;EAEA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iBAAA;AtE6oPJ;;AsEzoPA;EACE,gBAAA;EACA,kDAAA;AtE4oPF;;AsEzoPA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AtE4oPF;;AuE7xPA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDgzCkC;AnBg/MpC;AuE9xPE;EACE,qBAAA;EACA,WAAA;AvEgyPJ;;AuE3xPA;EACE,iBAAA;AvE8xPF;;AuE3xPA;EACE,iBAAA;AvE8xPF;;AuE3xPA;EACE,iBAAA;AvE8xPF;;AuEzxPE;EACE,mDAAA;AvE4xPJ;;AuExxPA;EACE;IACE,YpDmxCgC;EnBwgNlC;AACF;AuExxPA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;AvE0xPF;;AuEvxPA;EACE;IACE,uBAAA;EvE0xPF;AACF;AoEz0PE;EACE,cAAA;EACA,WAAA;EACA,WAAA;ApE20PJ;;AwE90PE;EACE,sBAAA;EACA,iFAAA;AxEi1PJ;;AwEn1PE;EACE,sBAAA;EACA,mFAAA;AxEs1PJ;;AwEx1PE;EACE,sBAAA;EACA,iFAAA;AxE21PJ;;AwE71PE;EACE,sBAAA;EACA,8EAAA;AxEg2PJ;;AwEl2PE;EACE,sBAAA;EACA,iFAAA;AxEq2PJ;;AwEv2PE;EACE,sBAAA;EACA,gFAAA;AxE02PJ;;AwE52PE;EACE,sBAAA;EACA,+EAAA;AxE+2PJ;;AwEj3PE;EACE,sBAAA;EACA,8EAAA;AxEo3PJ;;AyEt3PE;EACE,wEAAA;EACA,kGAAA;AzEy3PJ;AyEt3PM;EAGE,8DAAA;EACA,wFAAA;AzEs3PR;;AyE/3PE;EACE,0EAAA;EACA,oGAAA;AzEk4PJ;AyE/3PM;EAGE,8DAAA;EACA,wFAAA;AzE+3PR;;AyEx4PE;EACE,wEAAA;EACA,kGAAA;AzE24PJ;AyEx4PM;EAGE,8DAAA;EACA,wFAAA;AzEw4PR;;AyEj5PE;EACE,qEAAA;EACA,+FAAA;AzEo5PJ;AyEj5PM;EAGE,+DAAA;EACA,yFAAA;AzEi5PR;;AyE15PE;EACE,wEAAA;EACA,kGAAA;AzE65PJ;AyE15PM;EAGE,+DAAA;EACA,yFAAA;AzE05PR;;AyEn6PE;EACE,uEAAA;EACA,iGAAA;AzEs6PJ;AyEn6PM;EAGE,8DAAA;EACA,wFAAA;AzEm6PR;;AyE56PE;EACE,sEAAA;EACA,gGAAA;AzE+6PJ;AyE56PM;EAGE,gEAAA;EACA,0FAAA;AzE46PR;;AyEr7PE;EACE,qEAAA;EACA,+FAAA;AzEw7PJ;AyEr7PM;EAGE,6DAAA;EACA,uFAAA;AzEq7PR;;AyE96PA;EACE,+EAAA;EACA,yGAAA;AzEi7PF;AyE96PI;EAEE,kFAAA;EACA,4GAAA;AzE+6PN;;A0Ez8PA;EACE,UAAA;EAEA,kJAAA;A1E28PF;;A2E98PA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,kFAAA;EACA,6BxD2c4B;EwD1c5B,2BAAA;A3Ei9PF;A2E/8PE;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;A3Ei9PJ;AmC18PM;EwCZJ;IxCaM,gBAAA;EnC68PN;AACF;;A2E/8PI;EACE,mEAAA;A3Ek9PN;;A4Er+PA;EACE,kBAAA;EACA,WAAA;A5Ew+PF;A4Et+PE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A5Ew+PJ;A4Er+PE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A5Eu+PJ;;A4El+PE;EACE,uBAAA;A5Eq+PJ;;A4Et+PE;EACE,sBAAA;A5Ey+PJ;;A4E1+PE;EACE,yBAAA;A5E6+PJ;;A4E9+PE;EACE,iCAAA;A5Ei/PJ;;A6EtgQA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DumCkC;AnBk6NpC;;A6EtgQA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+lCkC;AnB06NpC;;A6EjgQI;EACE,gBAAA;EACA,MAAA;EACA,a1DmlC8B;AnBi7NpC;;A6EjgQI;EACE,gBAAA;EACA,SAAA;EACA,a1D6kC8B;AnBu7NpC;;A2Br+PI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EnB87NlC;E6E9gQE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EnBm8NlC;AACF;A2Bl/PI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EnB08NlC;E6E1hQE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EnB+8NlC;AACF;A2B9/PI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EnBs9NlC;E6EtiQE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EnB29NlC;AACF;A2B1gQI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EnBk+NlC;E6EljQE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EnBu+NlC;AACF;A2BthQI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EnB8+NlC;E6E9jQE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EnBm/NlC;AACF;A8EhmQA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;A9EkmQF;;A8E/lQA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;A9EkmQF;;A+E1mQA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AhF2mQF;AgFxmQE;;EACE,6BAAA;AhF2mQJ;AgFvmQE;;EACE,2BAAA;AhF0mQJ;;AiF7nQE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DgcsC;E8D/btC,WAAA;AjFgoQJ;;AkFxoQA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AnF4oQF;;AoFlpQA;EACE,qBAAA;EACA,mBAAA;EACA,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,ajE2rB4B;AnB09O9B;;AqFzlQQ;EAOI,mCAAA;ArFslQZ;;AqF7lQQ;EAOI,8BAAA;ArF0lQZ;;AqFjmQQ;EAOI,iCAAA;ArF8lQZ;;AqFrmQQ;EAOI,iCAAA;ArFkmQZ;;AqFzmQQ;EAOI,sCAAA;ArFsmQZ;;AqF7mQQ;EAOI,mCAAA;ArF0mQZ;;AqFjnQQ;EAOI,sBAAA;ArF8mQZ;;AqFrnQQ;EAOI,uBAAA;ArFknQZ;;AqFznQQ;EAOI,sBAAA;ArFsnQZ;;AqF7nQQ;EAOI,8BAAA;ArF0nQZ;;AqFjoQQ;EAOI,4BAAA;ArF8nQZ;;AqFroQQ;EAOI,2BAAA;ArFkoQZ;;AqFzoQQ;EAOI,iCAAA;ArFsoQZ;;AqF7oQQ;EAOI,2BAAA;ArF0oQZ;;AqFjpQQ;EAOI,qBAAA;ArF8oQZ;;AqFrpQQ;EAOI,wBAAA;ArFkpQZ;;AqFzpQQ;EAOI,uBAAA;ArFspQZ;;AqF7pQQ;EAOI,wBAAA;ArF0pQZ;;AqFjqQQ;EAOI,qBAAA;ArF8pQZ;;AqFrqQQ;EAOI,yBAAA;ArFkqQZ;;AqFzqQQ;EAOI,2BAAA;ArFsqQZ;;AqF7qQQ;EAOI,4BAAA;ArF0qQZ;;AqFjrQQ;EAOI,2BAAA;ArF8qQZ;;AqFrrQQ;EAOI,2BAAA;ArFkrQZ;;AqFzrQQ;EAOI,6BAAA;ArFsrQZ;;AqF7rQQ;EAOI,8BAAA;ArF0rQZ;;AqFjsQQ;EAOI,6BAAA;ArF8rQZ;;AqFrsQQ;EAOI,2BAAA;ArFksQZ;;AqFzsQQ;EAOI,6BAAA;ArFssQZ;;AqF7sQQ;EAOI,8BAAA;ArF0sQZ;;AqFjtQQ;EAOI,6BAAA;ArF8sQZ;;AqFrtQQ;EAOI,0BAAA;ArFktQZ;;AqFztQQ;EAOI,gCAAA;ArFstQZ;;AqF7tQQ;EAOI,yBAAA;ArF0tQZ;;AqFjuQQ;EAOI,wBAAA;ArF8tQZ;;AqFruQQ;EAOI,+BAAA;ArFkuQZ;;AqFzuQQ;EAOI,yBAAA;ArFsuQZ;;AqF7uQQ;EAOI,6BAAA;ArF0uQZ;;AqFjvQQ;EAOI,8BAAA;ArF8uQZ;;AqFrvQQ;EAOI,wBAAA;ArFkvQZ;;AqFzvQQ;EAOI,+BAAA;ArFsvQZ;;AqF7vQQ;EAOI,wBAAA;ArF0vQZ;;AqFjwQQ;EAOI,2CAAA;ArF8vQZ;;AqFrwQQ;EAOI,8CAAA;ArFkwQZ;;AqFzwQQ;EAOI,8CAAA;ArFswQZ;;AqF7wQQ;EAOI,2BAAA;ArF0wQZ;;AqF3xQQ;EACE,gFAAA;ArF8xQV;;AqF/xQQ;EACE,kFAAA;ArFkyQV;;AqFnyQQ;EACE,gFAAA;ArFsyQV;;AqFvyQQ;EACE,6EAAA;ArF0yQV;;AqF3yQQ;EACE,gFAAA;ArF8yQV;;AqF/yQQ;EACE,+EAAA;ArFkzQV;;AqFnzQQ;EACE,8EAAA;ArFszQV;;AqFvzQQ;EACE,6EAAA;ArF0zQV;;AqFjzQQ;EAOI,2BAAA;ArF8yQZ;;AqFrzQQ;EAOI,6BAAA;ArFkzQZ;;AqFzzQQ;EAOI,6BAAA;ArFszQZ;;AqF7zQQ;EAOI,0BAAA;ArF0zQZ;;AqFj0QQ;EAOI,2BAAA;ArF8zQZ;;AqFr0QQ;EAOI,iBAAA;ArFk0QZ;;AqFz0QQ;EAOI,mBAAA;ArFs0QZ;;AqF70QQ;EAOI,oBAAA;ArF00QZ;;AqFj1QQ;EAOI,oBAAA;ArF80QZ;;AqFr1QQ;EAOI,sBAAA;ArFk1QZ;;AqFz1QQ;EAOI,uBAAA;ArFs1QZ;;AqF71QQ;EAOI,kBAAA;ArF01QZ;;AqFj2QQ;EAOI,oBAAA;ArF81QZ;;AqFr2QQ;EAOI,qBAAA;ArFk2QZ;;AqFz2QQ;EAOI,mBAAA;ArFs2QZ;;AqF72QQ;EAOI,qBAAA;ArF02QZ;;AqFj3QQ;EAOI,sBAAA;ArF82QZ;;AqFr3QQ;EAOI,2CAAA;ArFk3QZ;;AqFz3QQ;EAOI,sCAAA;ArFs3QZ;;AqF73QQ;EAOI,sCAAA;ArF03QZ;;AqFj4QQ;EAOI,uFAAA;ArF83QZ;;AqFr4QQ;EAOI,oBAAA;ArFk4QZ;;AqFz4QQ;EAOI,2FAAA;ArFs4QZ;;AqF74QQ;EAOI,wBAAA;ArF04QZ;;AqFj5QQ;EAOI,6FAAA;ArF84QZ;;AqFr5QQ;EAOI,0BAAA;ArFk5QZ;;AqFz5QQ;EAOI,8FAAA;ArFs5QZ;;AqF75QQ;EAOI,2BAAA;ArF05QZ;;AqFj6QQ;EAOI,4FAAA;ArF85QZ;;AqFr6QQ;EAOI,yBAAA;ArFk6QZ;;AqFz6QQ;EAIQ,sBAAA;EAGJ,8EAAA;ArFu6QZ;;AqF96QQ;EAIQ,sBAAA;EAGJ,gFAAA;ArF46QZ;;AqFn7QQ;EAIQ,sBAAA;EAGJ,8EAAA;ArFi7QZ;;AqFx7QQ;EAIQ,sBAAA;EAGJ,2EAAA;ArFs7QZ;;AqF77QQ;EAIQ,sBAAA;EAGJ,8EAAA;ArF27QZ;;AqFl8QQ;EAIQ,sBAAA;EAGJ,6EAAA;ArFg8QZ;;AqFv8QQ;EAIQ,sBAAA;EAGJ,4EAAA;ArFq8QZ;;AqF58QQ;EAIQ,sBAAA;EAGJ,2EAAA;ArF08QZ;;AqFj9QQ;EAIQ,sBAAA;EAGJ,4EAAA;ArF+8QZ;;AqFt9QQ;EAIQ,sBAAA;EAGJ,4EAAA;ArFo9QZ;;AqF39QQ;EAOI,wDAAA;ArFw9QZ;;AqF/9QQ;EAOI,0DAAA;ArF49QZ;;AqFn+QQ;EAOI,wDAAA;ArFg+QZ;;AqFv+QQ;EAOI,qDAAA;ArFo+QZ;;AqF3+QQ;EAOI,wDAAA;ArFw+QZ;;AqF/+QQ;EAOI,uDAAA;ArF4+QZ;;AqFn/QQ;EAOI,sDAAA;ArFg/QZ;;AqFv/QQ;EAOI,qDAAA;ArFo/QZ;;AqF3/QQ;EAOI,4BAAA;ArFw/QZ;;AqF//QQ;EAOI,4BAAA;ArF4/QZ;;AqFngRQ;EAOI,4BAAA;ArFggRZ;;AqFvgRQ;EAOI,4BAAA;ArFogRZ;;AqF3gRQ;EAOI,4BAAA;ArFwgRZ;;AqFzhRQ;EACE,wBAAA;ArF4hRV;;AqF7hRQ;EACE,yBAAA;ArFgiRV;;AqFjiRQ;EACE,wBAAA;ArFoiRV;;AqFriRQ;EACE,yBAAA;ArFwiRV;;AqFziRQ;EACE,sBAAA;ArF4iRV;;AqFniRQ;EAOI,qBAAA;ArFgiRZ;;AqFviRQ;EAOI,qBAAA;ArFoiRZ;;AqF3iRQ;EAOI,qBAAA;ArFwiRZ;;AqF/iRQ;EAOI,sBAAA;ArF4iRZ;;AqFnjRQ;EAOI,sBAAA;ArFgjRZ;;AqFvjRQ;EAOI,0BAAA;ArFojRZ;;AqF3jRQ;EAOI,uBAAA;ArFwjRZ;;AqF/jRQ;EAOI,2BAAA;ArF4jRZ;;AqFnkRQ;EAOI,sBAAA;ArFgkRZ;;AqFvkRQ;EAOI,sBAAA;ArFokRZ;;AqF3kRQ;EAOI,sBAAA;ArFwkRZ;;AqF/kRQ;EAOI,uBAAA;ArF4kRZ;;AqFnlRQ;EAOI,uBAAA;ArFglRZ;;AqFvlRQ;EAOI,2BAAA;ArFolRZ;;AqF3lRQ;EAOI,wBAAA;ArFwlRZ;;AqF/lRQ;EAOI,4BAAA;ArF4lRZ;;AqFnmRQ;EAOI,yBAAA;ArFgmRZ;;AqFvmRQ;EAOI,8BAAA;ArFomRZ;;AqF3mRQ;EAOI,iCAAA;ArFwmRZ;;AqF/mRQ;EAOI,sCAAA;ArF4mRZ;;AqFnnRQ;EAOI,yCAAA;ArFgnRZ;;AqFvnRQ;EAOI,uBAAA;ArFonRZ;;AqF3nRQ;EAOI,uBAAA;ArFwnRZ;;AqF/nRQ;EAOI,yBAAA;ArF4nRZ;;AqFnoRQ;EAOI,yBAAA;ArFgoRZ;;AqFvoRQ;EAOI,0BAAA;ArFooRZ;;AqF3oRQ;EAOI,4BAAA;ArFwoRZ;;AqF/oRQ;EAOI,kCAAA;ArF4oRZ;;AqFnpRQ;EAOI,sCAAA;ArFgpRZ;;AqFvpRQ;EAOI,oCAAA;ArFopRZ;;AqF3pRQ;EAOI,kCAAA;ArFwpRZ;;AqF/pRQ;EAOI,yCAAA;ArF4pRZ;;AqFnqRQ;EAOI,wCAAA;ArFgqRZ;;AqFvqRQ;EAOI,wCAAA;ArFoqRZ;;AqF3qRQ;EAOI,kCAAA;ArFwqRZ;;AqF/qRQ;EAOI,gCAAA;ArF4qRZ;;AqFnrRQ;EAOI,8BAAA;ArFgrRZ;;AqFvrRQ;EAOI,gCAAA;ArForRZ;;AqF3rRQ;EAOI,+BAAA;ArFwrRZ;;AqF/rRQ;EAOI,oCAAA;ArF4rRZ;;AqFnsRQ;EAOI,kCAAA;ArFgsRZ;;AqFvsRQ;EAOI,gCAAA;ArFosRZ;;AqF3sRQ;EAOI,uCAAA;ArFwsRZ;;AqF/sRQ;EAOI,sCAAA;ArF4sRZ;;AqFntRQ;EAOI,iCAAA;ArFgtRZ;;AqFvtRQ;EAOI,2BAAA;ArFotRZ;;AqF3tRQ;EAOI,iCAAA;ArFwtRZ;;AqF/tRQ;EAOI,+BAAA;ArF4tRZ;;AqFnuRQ;EAOI,6BAAA;ArFguRZ;;AqFvuRQ;EAOI,+BAAA;ArFouRZ;;AqF3uRQ;EAOI,8BAAA;ArFwuRZ;;AqF/uRQ;EAOI,oBAAA;ArF4uRZ;;AqFnvRQ;EAOI,mBAAA;ArFgvRZ;;AqFvvRQ;EAOI,mBAAA;ArFovRZ;;AqF3vRQ;EAOI,mBAAA;ArFwvRZ;;AqF/vRQ;EAOI,mBAAA;ArF4vRZ;;AqFnwRQ;EAOI,mBAAA;ArFgwRZ;;AqFvwRQ;EAOI,mBAAA;ArFowRZ;;AqF3wRQ;EAOI,mBAAA;ArFwwRZ;;AqF/wRQ;EAOI,oBAAA;ArF4wRZ;;AqFnxRQ;EAOI,0BAAA;ArFgxRZ;;AqFvxRQ;EAOI,yBAAA;ArFoxRZ;;AqF3xRQ;EAOI,uBAAA;ArFwxRZ;;AqF/xRQ;EAOI,yBAAA;ArF4xRZ;;AqFnyRQ;EAOI,uBAAA;ArFgyRZ;;AqFvyRQ;EAOI,uBAAA;ArFoyRZ;;AqF3yRQ;EAOI,0BAAA;EAAA,yBAAA;ArFyyRZ;;AqFhzRQ;EAOI,gCAAA;EAAA,+BAAA;ArF8yRZ;;AqFrzRQ;EAOI,+BAAA;EAAA,8BAAA;ArFmzRZ;;AqF1zRQ;EAOI,6BAAA;EAAA,4BAAA;ArFwzRZ;;AqF/zRQ;EAOI,+BAAA;EAAA,8BAAA;ArF6zRZ;;AqFp0RQ;EAOI,6BAAA;EAAA,4BAAA;ArFk0RZ;;AqFz0RQ;EAOI,6BAAA;EAAA,4BAAA;ArFu0RZ;;AqF90RQ;EAOI,wBAAA;EAAA,2BAAA;ArF40RZ;;AqFn1RQ;EAOI,8BAAA;EAAA,iCAAA;ArFi1RZ;;AqFx1RQ;EAOI,6BAAA;EAAA,gCAAA;ArFs1RZ;;AqF71RQ;EAOI,2BAAA;EAAA,8BAAA;ArF21RZ;;AqFl2RQ;EAOI,6BAAA;EAAA,gCAAA;ArFg2RZ;;AqFv2RQ;EAOI,2BAAA;EAAA,8BAAA;ArFq2RZ;;AqF52RQ;EAOI,2BAAA;EAAA,8BAAA;ArF02RZ;;AqFj3RQ;EAOI,wBAAA;ArF82RZ;;AqFr3RQ;EAOI,8BAAA;ArFk3RZ;;AqFz3RQ;EAOI,6BAAA;ArFs3RZ;;AqF73RQ;EAOI,2BAAA;ArF03RZ;;AqFj4RQ;EAOI,6BAAA;ArF83RZ;;AqFr4RQ;EAOI,2BAAA;ArFk4RZ;;AqFz4RQ;EAOI,2BAAA;ArFs4RZ;;AqF74RQ;EAOI,0BAAA;ArF04RZ;;AqFj5RQ;EAOI,gCAAA;ArF84RZ;;AqFr5RQ;EAOI,+BAAA;ArFk5RZ;;AqFz5RQ;EAOI,6BAAA;ArFs5RZ;;AqF75RQ;EAOI,+BAAA;ArF05RZ;;AqFj6RQ;EAOI,6BAAA;ArF85RZ;;AqFr6RQ;EAOI,6BAAA;ArFk6RZ;;AqFz6RQ;EAOI,2BAAA;ArFs6RZ;;AqF76RQ;EAOI,iCAAA;ArF06RZ;;AqFj7RQ;EAOI,gCAAA;ArF86RZ;;AqFr7RQ;EAOI,8BAAA;ArFk7RZ;;AqFz7RQ;EAOI,gCAAA;ArFs7RZ;;AqF77RQ;EAOI,8BAAA;ArF07RZ;;AqFj8RQ;EAOI,8BAAA;ArF87RZ;;AqFr8RQ;EAOI,yBAAA;ArFk8RZ;;AqFz8RQ;EAOI,+BAAA;ArFs8RZ;;AqF78RQ;EAOI,8BAAA;ArF08RZ;;AqFj9RQ;EAOI,4BAAA;ArF88RZ;;AqFr9RQ;EAOI,8BAAA;ArFk9RZ;;AqFz9RQ;EAOI,4BAAA;ArFs9RZ;;AqF79RQ;EAOI,4BAAA;ArF09RZ;;AqFj+RQ;EAOI,qBAAA;ArF89RZ;;AqFr+RQ;EAOI,2BAAA;ArFk+RZ;;AqFz+RQ;EAOI,0BAAA;ArFs+RZ;;AqF7+RQ;EAOI,wBAAA;ArF0+RZ;;AqFj/RQ;EAOI,0BAAA;ArF8+RZ;;AqFr/RQ;EAOI,wBAAA;ArFk/RZ;;AqFz/RQ;EAOI,2BAAA;EAAA,0BAAA;ArFu/RZ;;AqF9/RQ;EAOI,iCAAA;EAAA,gCAAA;ArF4/RZ;;AqFngSQ;EAOI,gCAAA;EAAA,+BAAA;ArFigSZ;;AqFxgSQ;EAOI,8BAAA;EAAA,6BAAA;ArFsgSZ;;AqF7gSQ;EAOI,gCAAA;EAAA,+BAAA;ArF2gSZ;;AqFlhSQ;EAOI,8BAAA;EAAA,6BAAA;ArFghSZ;;AqFvhSQ;EAOI,yBAAA;EAAA,4BAAA;ArFqhSZ;;AqF5hSQ;EAOI,+BAAA;EAAA,kCAAA;ArF0hSZ;;AqFjiSQ;EAOI,8BAAA;EAAA,iCAAA;ArF+hSZ;;AqFtiSQ;EAOI,4BAAA;EAAA,+BAAA;ArFoiSZ;;AqF3iSQ;EAOI,8BAAA;EAAA,iCAAA;ArFyiSZ;;AqFhjSQ;EAOI,4BAAA;EAAA,+BAAA;ArF8iSZ;;AqFrjSQ;EAOI,yBAAA;ArFkjSZ;;AqFzjSQ;EAOI,+BAAA;ArFsjSZ;;AqF7jSQ;EAOI,8BAAA;ArF0jSZ;;AqFjkSQ;EAOI,4BAAA;ArF8jSZ;;AqFrkSQ;EAOI,8BAAA;ArFkkSZ;;AqFzkSQ;EAOI,4BAAA;ArFskSZ;;AqF7kSQ;EAOI,2BAAA;ArF0kSZ;;AqFjlSQ;EAOI,iCAAA;ArF8kSZ;;AqFrlSQ;EAOI,gCAAA;ArFklSZ;;AqFzlSQ;EAOI,8BAAA;ArFslSZ;;AqF7lSQ;EAOI,gCAAA;ArF0lSZ;;AqFjmSQ;EAOI,8BAAA;ArF8lSZ;;AqFrmSQ;EAOI,4BAAA;ArFkmSZ;;AqFzmSQ;EAOI,kCAAA;ArFsmSZ;;AqF7mSQ;EAOI,iCAAA;ArF0mSZ;;AqFjnSQ;EAOI,+BAAA;ArF8mSZ;;AqFrnSQ;EAOI,iCAAA;ArFknSZ;;AqFznSQ;EAOI,+BAAA;ArFsnSZ;;AqF7nSQ;EAOI,0BAAA;ArF0nSZ;;AqFjoSQ;EAOI,gCAAA;ArF8nSZ;;AqFroSQ;EAOI,+BAAA;ArFkoSZ;;AqFzoSQ;EAOI,6BAAA;ArFsoSZ;;AqF7oSQ;EAOI,+BAAA;ArF0oSZ;;AqFjpSQ;EAOI,6BAAA;ArF8oSZ;;AqFrpSQ;EAOI,iBAAA;ArFkpSZ;;AqFzpSQ;EAOI,uBAAA;ArFspSZ;;AqF7pSQ;EAOI,sBAAA;ArF0pSZ;;AqFjqSQ;EAOI,oBAAA;ArF8pSZ;;AqFrqSQ;EAOI,sBAAA;ArFkqSZ;;AqFzqSQ;EAOI,oBAAA;ArFsqSZ;;AqF7qSQ;EAOI,qBAAA;ArF0qSZ;;AqFjrSQ;EAOI,2BAAA;ArF8qSZ;;AqFrrSQ;EAOI,0BAAA;ArFkrSZ;;AqFzrSQ;EAOI,wBAAA;ArFsrSZ;;AqF7rSQ;EAOI,0BAAA;ArF0rSZ;;AqFjsSQ;EAOI,wBAAA;ArF8rSZ;;AqFrsSQ;EAOI,wBAAA;ArFksSZ;;AqFzsSQ;EAOI,8BAAA;ArFssSZ;;AqF7sSQ;EAOI,6BAAA;ArF0sSZ;;AqFjtSQ;EAOI,2BAAA;ArF8sSZ;;AqFrtSQ;EAOI,6BAAA;ArFktSZ;;AqFztSQ;EAOI,2BAAA;ArFstSZ;;AqF7tSQ;EAOI,gDAAA;ArF0tSZ;;AqFjuSQ;EAOI,4CAAA;ArF8tSZ;;AqFruSQ;EAOI,4CAAA;ArFkuSZ;;AqFzuSQ;EAOI,0CAAA;ArFsuSZ;;AqF7uSQ;EAOI,4CAAA;ArF0uSZ;;AqFjvSQ;EAOI,6BAAA;ArF8uSZ;;AqFrvSQ;EAOI,0BAAA;ArFkvSZ;;AqFzvSQ;EAOI,6BAAA;ArFsvSZ;;AqF7vSQ;EAOI,6BAAA;ArF0vSZ;;AqFjwSQ;EAOI,+BAAA;ArF8vSZ;;AqFrwSQ;EAOI,2BAAA;ArFkwSZ;;AqFzwSQ;EAOI,2BAAA;ArFswSZ;;AqF7wSQ;EAOI,2BAAA;ArF0wSZ;;AqFjxSQ;EAOI,2BAAA;ArF8wSZ;;AqFrxSQ;EAOI,2BAAA;ArFkxSZ;;AqFzxSQ;EAOI,8BAAA;ArFsxSZ;;AqF7xSQ;EAOI,yBAAA;ArF0xSZ;;AqFjySQ;EAOI,4BAAA;ArF8xSZ;;AqFrySQ;EAOI,2BAAA;ArFkySZ;;AqFzySQ;EAOI,yBAAA;ArFsySZ;;AqF7ySQ;EAOI,2BAAA;ArF0ySZ;;AqFjzSQ;EAOI,4BAAA;ArF8ySZ;;AqFrzSQ;EAOI,6BAAA;ArFkzSZ;;AqFzzSQ;EAOI,gCAAA;ArFszSZ;;AqF7zSQ;EAOI,qCAAA;ArF0zSZ;;AqFj0SQ;EAOI,wCAAA;ArF8zSZ;;AqFr0SQ;EAOI,oCAAA;ArFk0SZ;;AqFz0SQ;EAOI,oCAAA;ArFs0SZ;;AqF70SQ;EAOI,qCAAA;ArF00SZ;;AqFj1SQ;EAOI,8BAAA;ArF80SZ;;AqFr1SQ;EAOI,8BAAA;ArFk1SZ;;AqFv2SQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;ArFw1SZ;;AqFr0SQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;ArF81SZ;;AqFr2SQ;EAIQ,oBAAA;EAGJ,uEAAA;ArFm2SZ;;AqF12SQ;EAIQ,oBAAA;EAGJ,qEAAA;ArFw2SZ;;AqF/2SQ;EAIQ,oBAAA;EAGJ,kEAAA;ArF62SZ;;AqFp3SQ;EAIQ,oBAAA;EAGJ,qEAAA;ArFk3SZ;;AqFz3SQ;EAIQ,oBAAA;EAGJ,oEAAA;ArFu3SZ;;AqF93SQ;EAIQ,oBAAA;EAGJ,mEAAA;ArF43SZ;;AqFn4SQ;EAIQ,oBAAA;EAGJ,kEAAA;ArFi4SZ;;AqFx4SQ;EAIQ,oBAAA;EAGJ,mEAAA;ArFs4SZ;;AqF74SQ;EAIQ,oBAAA;EAGJ,mEAAA;ArF24SZ;;AqFl5SQ;EAIQ,oBAAA;EAGJ,wEAAA;ArFg5SZ;;AqFv5SQ;EAIQ,oBAAA;EAGJ,2CAAA;ArFq5SZ;;AqF55SQ;EAIQ,oBAAA;EAGJ,oCAAA;ArF05SZ;;AqFj6SQ;EAIQ,oBAAA;EAGJ,0CAAA;ArF+5SZ;;AqFt6SQ;EAIQ,oBAAA;EAGJ,2CAAA;ArFo6SZ;;AqF36SQ;EAIQ,oBAAA;EAGJ,0CAAA;ArFy6SZ;;AqFh7SQ;EAIQ,oBAAA;EAGJ,0CAAA;ArF86SZ;;AqFr7SQ;EAIQ,oBAAA;EAGJ,yBAAA;ArFm7SZ;;AqFp8SQ;EACE,uBAAA;ArFu8SV;;AqFx8SQ;EACE,sBAAA;ArF28SV;;AqF58SQ;EACE,uBAAA;ArF+8SV;;AqFh9SQ;EACE,oBAAA;ArFm9SV;;AqF18SQ;EAOI,iDAAA;ArFu8SZ;;AqF98SQ;EAOI,mDAAA;ArF28SZ;;AqFl9SQ;EAOI,iDAAA;ArF+8SZ;;AqFt9SQ;EAOI,8CAAA;ArFm9SZ;;AqF19SQ;EAOI,iDAAA;ArFu9SZ;;AqF99SQ;EAOI,gDAAA;ArF29SZ;;AqFl+SQ;EAOI,+CAAA;ArF+9SZ;;AqFt+SQ;EAOI,8CAAA;ArFm+SZ;;AqFp/SQ;EACE,sBAAA;ArFu/SV;;AqFn/SU;EACE,sBAAA;ArFs/SZ;;AqF5/SQ;EACE,uBAAA;ArF+/SV;;AqF3/SU;EACE,uBAAA;ArF8/SZ;;AqFpgTQ;EACE,sBAAA;ArFugTV;;AqFngTU;EACE,sBAAA;ArFsgTZ;;AqF5gTQ;EACE,uBAAA;ArF+gTV;;AqF3gTU;EACE,uBAAA;ArF8gTZ;;AqFphTQ;EACE,oBAAA;ArFuhTV;;AqFnhTU;EACE,oBAAA;ArFshTZ;;AqFlhTQ;EAOI,yCAAA;ArF+gTZ;;AqF1gTU;EAOI,yCAAA;ArFugTd;;AqF1hTQ;EAOI,wCAAA;ArFuhTZ;;AqFlhTU;EAOI,wCAAA;ArF+gTd;;AqFliTQ;EAOI,yCAAA;ArF+hTZ;;AqF1hTU;EAOI,yCAAA;ArFuhTd;;AqF1iTQ;EAIQ,8BAAA;EAGJ,+FAAA;ArFwiTZ;;AqF/iTQ;EAIQ,8BAAA;EAGJ,iGAAA;ArF6iTZ;;AqFpjTQ;EAIQ,8BAAA;EAGJ,+FAAA;ArFkjTZ;;AqFzjTQ;EAIQ,8BAAA;EAGJ,4FAAA;ArFujTZ;;AqF9jTQ;EAIQ,8BAAA;EAGJ,+FAAA;ArF4jTZ;;AqFnkTQ;EAIQ,8BAAA;EAGJ,8FAAA;ArFikTZ;;AqFxkTQ;EAIQ,8BAAA;EAGJ,6FAAA;ArFskTZ;;AqF7kTQ;EAIQ,8BAAA;EAGJ,4FAAA;ArF2kTZ;;AqFllTQ;EAIQ,8BAAA;EAGJ,qGAAA;ArFglTZ;;AqFjmTQ;EACE,8BAAA;ArFomTV;;AqFhmTU;EACE,8BAAA;ArFmmTZ;;AqFzmTQ;EACE,gCAAA;ArF4mTV;;AqFxmTU;EACE,gCAAA;ArF2mTZ;;AqFjnTQ;EACE,iCAAA;ArFonTV;;AqFhnTU;EACE,iCAAA;ArFmnTZ;;AqFznTQ;EACE,gCAAA;ArF4nTV;;AqFxnTU;EACE,gCAAA;ArF2nTZ;;AqFjoTQ;EACE,iCAAA;ArFooTV;;AqFhoTU;EACE,iCAAA;ArFmoTZ;;AqFzoTQ;EACE,8BAAA;ArF4oTV;;AqFxoTU;EACE,8BAAA;ArF2oTZ;;AqFvoTQ;EAIQ,kBAAA;EAGJ,8EAAA;ArFqoTZ;;AqF5oTQ;EAIQ,kBAAA;EAGJ,gFAAA;ArF0oTZ;;AqFjpTQ;EAIQ,kBAAA;EAGJ,8EAAA;ArF+oTZ;;AqFtpTQ;EAIQ,kBAAA;EAGJ,2EAAA;ArFopTZ;;AqF3pTQ;EAIQ,kBAAA;EAGJ,8EAAA;ArFypTZ;;AqFhqTQ;EAIQ,kBAAA;EAGJ,6EAAA;ArF8pTZ;;AqFrqTQ;EAIQ,kBAAA;EAGJ,4EAAA;ArFmqTZ;;AqF1qTQ;EAIQ,kBAAA;EAGJ,2EAAA;ArFwqTZ;;AqF/qTQ;EAIQ,kBAAA;EAGJ,4EAAA;ArF6qTZ;;AqFprTQ;EAIQ,kBAAA;EAGJ,4EAAA;ArFkrTZ;;AqFzrTQ;EAIQ,kBAAA;EAGJ,8EAAA;ArFurTZ;;AqF9rTQ;EAIQ,kBAAA;EAGJ,wCAAA;ArF4rTZ;;AqFnsTQ;EAIQ,kBAAA;EAGJ,mFAAA;ArFisTZ;;AqFxsTQ;EAIQ,kBAAA;EAGJ,kFAAA;ArFssTZ;;AqFvtTQ;EACE,oBAAA;ArF0tTV;;AqF3tTQ;EACE,qBAAA;ArF8tTV;;AqF/tTQ;EACE,oBAAA;ArFkuTV;;AqFnuTQ;EACE,qBAAA;ArFsuTV;;AqFvuTQ;EACE,kBAAA;ArF0uTV;;AqFjuTQ;EAOI,wDAAA;ArF8tTZ;;AqFruTQ;EAOI,0DAAA;ArFkuTZ;;AqFzuTQ;EAOI,wDAAA;ArFsuTZ;;AqF7uTQ;EAOI,qDAAA;ArF0uTZ;;AqFjvTQ;EAOI,wDAAA;ArF8uTZ;;AqFrvTQ;EAOI,uDAAA;ArFkvTZ;;AqFzvTQ;EAOI,sDAAA;ArFsvTZ;;AqF7vTQ;EAOI,qDAAA;ArF0vTZ;;AqFjwTQ;EAOI,+CAAA;ArF8vTZ;;AqFrwTQ;EAOI,2BAAA;ArFkwTZ;;AqFzwTQ;EAOI,4BAAA;ArFswTZ;;AqF7wTQ;EAOI,4BAAA;ArF0wTZ;;AqFjxTQ;EAOI,+BAAA;ArF8wTZ;;AqFrxTQ;EAOI,+BAAA;ArFkxTZ;;AqFzxTQ;EAOI,iDAAA;ArFsxTZ;;AqF7xTQ;EAOI,2BAAA;ArF0xTZ;;AqFjyTQ;EAOI,oDAAA;ArF8xTZ;;AqFryTQ;EAOI,iDAAA;ArFkyTZ;;AqFzyTQ;EAOI,oDAAA;ArFsyTZ;;AqF7yTQ;EAOI,oDAAA;ArF0yTZ;;AqFjzTQ;EAOI,qDAAA;ArF8yTZ;;AqFrzTQ;EAOI,6BAAA;ArFkzTZ;;AqFzzTQ;EAOI,sDAAA;ArFszTZ;;AqF7zTQ;EAOI,0DAAA;EAAA,2DAAA;ArF2zTZ;;AqFl0TQ;EAOI,oCAAA;EAAA,qCAAA;ArFg0TZ;;AqFv0TQ;EAOI,6DAAA;EAAA,8DAAA;ArFq0TZ;;AqF50TQ;EAOI,0DAAA;EAAA,2DAAA;ArF00TZ;;AqFj1TQ;EAOI,6DAAA;EAAA,8DAAA;ArF+0TZ;;AqFt1TQ;EAOI,6DAAA;EAAA,8DAAA;ArFo1TZ;;AqF31TQ;EAOI,8DAAA;EAAA,+DAAA;ArFy1TZ;;AqFh2TQ;EAOI,sCAAA;EAAA,uCAAA;ArF81TZ;;AqFr2TQ;EAOI,+DAAA;EAAA,gEAAA;ArFm2TZ;;AqF12TQ;EAOI,2DAAA;EAAA,8DAAA;ArFw2TZ;;AqF/2TQ;EAOI,qCAAA;EAAA,wCAAA;ArF62TZ;;AqFp3TQ;EAOI,8DAAA;EAAA,iEAAA;ArFk3TZ;;AqFz3TQ;EAOI,2DAAA;EAAA,8DAAA;ArFu3TZ;;AqF93TQ;EAOI,8DAAA;EAAA,iEAAA;ArF43TZ;;AqFn4TQ;EAOI,8DAAA;EAAA,iEAAA;ArFi4TZ;;AqFx4TQ;EAOI,+DAAA;EAAA,kEAAA;ArFs4TZ;;AqF74TQ;EAOI,uCAAA;EAAA,0CAAA;ArF24TZ;;AqFl5TQ;EAOI,gEAAA;EAAA,mEAAA;ArFg5TZ;;AqFv5TQ;EAOI,8DAAA;EAAA,6DAAA;ArFq5TZ;;AqF55TQ;EAOI,wCAAA;EAAA,uCAAA;ArF05TZ;;AqFj6TQ;EAOI,iEAAA;EAAA,gEAAA;ArF+5TZ;;AqFt6TQ;EAOI,8DAAA;EAAA,6DAAA;ArFo6TZ;;AqF36TQ;EAOI,iEAAA;EAAA,gEAAA;ArFy6TZ;;AqFh7TQ;EAOI,iEAAA;EAAA,gEAAA;ArF86TZ;;AqFr7TQ;EAOI,kEAAA;EAAA,iEAAA;ArFm7TZ;;AqF17TQ;EAOI,0CAAA;EAAA,yCAAA;ArFw7TZ;;AqF/7TQ;EAOI,mEAAA;EAAA,kEAAA;ArF67TZ;;AqFp8TQ;EAOI,6DAAA;EAAA,0DAAA;ArFk8TZ;;AqFz8TQ;EAOI,uCAAA;EAAA,oCAAA;ArFu8TZ;;AqF98TQ;EAOI,gEAAA;EAAA,6DAAA;ArF48TZ;;AqFn9TQ;EAOI,6DAAA;EAAA,0DAAA;ArFi9TZ;;AqFx9TQ;EAOI,gEAAA;EAAA,6DAAA;ArFs9TZ;;AqF79TQ;EAOI,gEAAA;EAAA,6DAAA;ArF29TZ;;AqFl+TQ;EAOI,iEAAA;EAAA,8DAAA;ArFg+TZ;;AqFv+TQ;EAOI,yCAAA;EAAA,sCAAA;ArFq+TZ;;AqF5+TQ;EAOI,kEAAA;EAAA,+DAAA;ArF0+TZ;;AqFj/TQ;EAOI,8BAAA;ArF8+TZ;;AqFr/TQ;EAOI,6BAAA;ArFk/TZ;;AqFz/TQ;EAOI,sBAAA;ArFs/TZ;;AqF7/TQ;EAOI,qBAAA;ArF0/TZ;;AqFjgUQ;EAOI,qBAAA;ArF8/TZ;;AqFrgUQ;EAOI,qBAAA;ArFkgUZ;;AqFzgUQ;EAOI,qBAAA;ArFsgUZ;;A2BhhUI;E0DGI;IAOI,sBAAA;ErF2gUV;EqFlhUM;IAOI,uBAAA;ErF8gUV;EqFrhUM;IAOI,sBAAA;ErFihUV;EqFxhUM;IAOI,8BAAA;ErFohUV;EqF3hUM;IAOI,4BAAA;ErFuhUV;EqF9hUM;IAOI,2BAAA;ErF0hUV;EqFjiUM;IAOI,iCAAA;ErF6hUV;EqFpiUM;IAOI,2BAAA;ErFgiUV;EqFviUM;IAOI,0BAAA;ErFmiUV;EqF1iUM;IAOI,gCAAA;ErFsiUV;EqF7iUM;IAOI,yBAAA;ErFyiUV;EqFhjUM;IAOI,wBAAA;ErF4iUV;EqFnjUM;IAOI,+BAAA;ErF+iUV;EqFtjUM;IAOI,yBAAA;ErFkjUV;EqFzjUM;IAOI,6BAAA;ErFqjUV;EqF5jUM;IAOI,8BAAA;ErFwjUV;EqF/jUM;IAOI,wBAAA;ErF2jUV;EqFlkUM;IAOI,+BAAA;ErF8jUV;EqFrkUM;IAOI,wBAAA;ErFikUV;EqFxkUM;IAOI,yBAAA;ErFokUV;EqF3kUM;IAOI,8BAAA;ErFukUV;EqF9kUM;IAOI,iCAAA;ErF0kUV;EqFjlUM;IAOI,sCAAA;ErF6kUV;EqFplUM;IAOI,yCAAA;ErFglUV;EqFvlUM;IAOI,uBAAA;ErFmlUV;EqF1lUM;IAOI,uBAAA;ErFslUV;EqF7lUM;IAOI,yBAAA;ErFylUV;EqFhmUM;IAOI,yBAAA;ErF4lUV;EqFnmUM;IAOI,0BAAA;ErF+lUV;EqFtmUM;IAOI,4BAAA;ErFkmUV;EqFzmUM;IAOI,kCAAA;ErFqmUV;EqF5mUM;IAOI,sCAAA;ErFwmUV;EqF/mUM;IAOI,oCAAA;ErF2mUV;EqFlnUM;IAOI,kCAAA;ErF8mUV;EqFrnUM;IAOI,yCAAA;ErFinUV;EqFxnUM;IAOI,wCAAA;ErFonUV;EqF3nUM;IAOI,wCAAA;ErFunUV;EqF9nUM;IAOI,kCAAA;ErF0nUV;EqFjoUM;IAOI,gCAAA;ErF6nUV;EqFpoUM;IAOI,8BAAA;ErFgoUV;EqFvoUM;IAOI,gCAAA;ErFmoUV;EqF1oUM;IAOI,+BAAA;ErFsoUV;EqF7oUM;IAOI,oCAAA;ErFyoUV;EqFhpUM;IAOI,kCAAA;ErF4oUV;EqFnpUM;IAOI,gCAAA;ErF+oUV;EqFtpUM;IAOI,uCAAA;ErFkpUV;EqFzpUM;IAOI,sCAAA;ErFqpUV;EqF5pUM;IAOI,iCAAA;ErFwpUV;EqF/pUM;IAOI,2BAAA;ErF2pUV;EqFlqUM;IAOI,iCAAA;ErF8pUV;EqFrqUM;IAOI,+BAAA;ErFiqUV;EqFxqUM;IAOI,6BAAA;ErFoqUV;EqF3qUM;IAOI,+BAAA;ErFuqUV;EqF9qUM;IAOI,8BAAA;ErF0qUV;EqFjrUM;IAOI,oBAAA;ErF6qUV;EqFprUM;IAOI,mBAAA;ErFgrUV;EqFvrUM;IAOI,mBAAA;ErFmrUV;EqF1rUM;IAOI,mBAAA;ErFsrUV;EqF7rUM;IAOI,mBAAA;ErFyrUV;EqFhsUM;IAOI,mBAAA;ErF4rUV;EqFnsUM;IAOI,mBAAA;ErF+rUV;EqFtsUM;IAOI,mBAAA;ErFksUV;EqFzsUM;IAOI,oBAAA;ErFqsUV;EqF5sUM;IAOI,0BAAA;ErFwsUV;EqF/sUM;IAOI,yBAAA;ErF2sUV;EqFltUM;IAOI,uBAAA;ErF8sUV;EqFrtUM;IAOI,yBAAA;ErFitUV;EqFxtUM;IAOI,uBAAA;ErFotUV;EqF3tUM;IAOI,uBAAA;ErFutUV;EqF9tUM;IAOI,0BAAA;IAAA,yBAAA;ErF2tUV;EqFluUM;IAOI,gCAAA;IAAA,+BAAA;ErF+tUV;EqFtuUM;IAOI,+BAAA;IAAA,8BAAA;ErFmuUV;EqF1uUM;IAOI,6BAAA;IAAA,4BAAA;ErFuuUV;EqF9uUM;IAOI,+BAAA;IAAA,8BAAA;ErF2uUV;EqFlvUM;IAOI,6BAAA;IAAA,4BAAA;ErF+uUV;EqFtvUM;IAOI,6BAAA;IAAA,4BAAA;ErFmvUV;EqF1vUM;IAOI,wBAAA;IAAA,2BAAA;ErFuvUV;EqF9vUM;IAOI,8BAAA;IAAA,iCAAA;ErF2vUV;EqFlwUM;IAOI,6BAAA;IAAA,gCAAA;ErF+vUV;EqFtwUM;IAOI,2BAAA;IAAA,8BAAA;ErFmwUV;EqF1wUM;IAOI,6BAAA;IAAA,gCAAA;ErFuwUV;EqF9wUM;IAOI,2BAAA;IAAA,8BAAA;ErF2wUV;EqFlxUM;IAOI,2BAAA;IAAA,8BAAA;ErF+wUV;EqFtxUM;IAOI,wBAAA;ErFkxUV;EqFzxUM;IAOI,8BAAA;ErFqxUV;EqF5xUM;IAOI,6BAAA;ErFwxUV;EqF/xUM;IAOI,2BAAA;ErF2xUV;EqFlyUM;IAOI,6BAAA;ErF8xUV;EqFryUM;IAOI,2BAAA;ErFiyUV;EqFxyUM;IAOI,2BAAA;ErFoyUV;EqF3yUM;IAOI,0BAAA;ErFuyUV;EqF9yUM;IAOI,gCAAA;ErF0yUV;EqFjzUM;IAOI,+BAAA;ErF6yUV;EqFpzUM;IAOI,6BAAA;ErFgzUV;EqFvzUM;IAOI,+BAAA;ErFmzUV;EqF1zUM;IAOI,6BAAA;ErFszUV;EqF7zUM;IAOI,6BAAA;ErFyzUV;EqFh0UM;IAOI,2BAAA;ErF4zUV;EqFn0UM;IAOI,iCAAA;ErF+zUV;EqFt0UM;IAOI,gCAAA;ErFk0UV;EqFz0UM;IAOI,8BAAA;ErFq0UV;EqF50UM;IAOI,gCAAA;ErFw0UV;EqF/0UM;IAOI,8BAAA;ErF20UV;EqFl1UM;IAOI,8BAAA;ErF80UV;EqFr1UM;IAOI,yBAAA;ErFi1UV;EqFx1UM;IAOI,+BAAA;ErFo1UV;EqF31UM;IAOI,8BAAA;ErFu1UV;EqF91UM;IAOI,4BAAA;ErF01UV;EqFj2UM;IAOI,8BAAA;ErF61UV;EqFp2UM;IAOI,4BAAA;ErFg2UV;EqFv2UM;IAOI,4BAAA;ErFm2UV;EqF12UM;IAOI,qBAAA;ErFs2UV;EqF72UM;IAOI,2BAAA;ErFy2UV;EqFh3UM;IAOI,0BAAA;ErF42UV;EqFn3UM;IAOI,wBAAA;ErF+2UV;EqFt3UM;IAOI,0BAAA;ErFk3UV;EqFz3UM;IAOI,wBAAA;ErFq3UV;EqF53UM;IAOI,2BAAA;IAAA,0BAAA;ErFy3UV;EqFh4UM;IAOI,iCAAA;IAAA,gCAAA;ErF63UV;EqFp4UM;IAOI,gCAAA;IAAA,+BAAA;ErFi4UV;EqFx4UM;IAOI,8BAAA;IAAA,6BAAA;ErFq4UV;EqF54UM;IAOI,gCAAA;IAAA,+BAAA;ErFy4UV;EqFh5UM;IAOI,8BAAA;IAAA,6BAAA;ErF64UV;EqFp5UM;IAOI,yBAAA;IAAA,4BAAA;ErFi5UV;EqFx5UM;IAOI,+BAAA;IAAA,kCAAA;ErFq5UV;EqF55UM;IAOI,8BAAA;IAAA,iCAAA;ErFy5UV;EqFh6UM;IAOI,4BAAA;IAAA,+BAAA;ErF65UV;EqFp6UM;IAOI,8BAAA;IAAA,iCAAA;ErFi6UV;EqFx6UM;IAOI,4BAAA;IAAA,+BAAA;ErFq6UV;EqF56UM;IAOI,yBAAA;ErFw6UV;EqF/6UM;IAOI,+BAAA;ErF26UV;EqFl7UM;IAOI,8BAAA;ErF86UV;EqFr7UM;IAOI,4BAAA;ErFi7UV;EqFx7UM;IAOI,8BAAA;ErFo7UV;EqF37UM;IAOI,4BAAA;ErFu7UV;EqF97UM;IAOI,2BAAA;ErF07UV;EqFj8UM;IAOI,iCAAA;ErF67UV;EqFp8UM;IAOI,gCAAA;ErFg8UV;EqFv8UM;IAOI,8BAAA;ErFm8UV;EqF18UM;IAOI,gCAAA;ErFs8UV;EqF78UM;IAOI,8BAAA;ErFy8UV;EqFh9UM;IAOI,4BAAA;ErF48UV;EqFn9UM;IAOI,kCAAA;ErF+8UV;EqFt9UM;IAOI,iCAAA;ErFk9UV;EqFz9UM;IAOI,+BAAA;ErFq9UV;EqF59UM;IAOI,iCAAA;ErFw9UV;EqF/9UM;IAOI,+BAAA;ErF29UV;EqFl+UM;IAOI,0BAAA;ErF89UV;EqFr+UM;IAOI,gCAAA;ErFi+UV;EqFx+UM;IAOI,+BAAA;ErFo+UV;EqF3+UM;IAOI,6BAAA;ErFu+UV;EqF9+UM;IAOI,+BAAA;ErF0+UV;EqFj/UM;IAOI,6BAAA;ErF6+UV;EqFp/UM;IAOI,iBAAA;ErFg/UV;EqFv/UM;IAOI,uBAAA;ErFm/UV;EqF1/UM;IAOI,sBAAA;ErFs/UV;EqF7/UM;IAOI,oBAAA;ErFy/UV;EqFhgVM;IAOI,sBAAA;ErF4/UV;EqFngVM;IAOI,oBAAA;ErF+/UV;EqFtgVM;IAOI,qBAAA;ErFkgVV;EqFzgVM;IAOI,2BAAA;ErFqgVV;EqF5gVM;IAOI,0BAAA;ErFwgVV;EqF/gVM;IAOI,wBAAA;ErF2gVV;EqFlhVM;IAOI,0BAAA;ErF8gVV;EqFrhVM;IAOI,wBAAA;ErFihVV;EqFxhVM;IAOI,wBAAA;ErFohVV;EqF3hVM;IAOI,8BAAA;ErFuhVV;EqF9hVM;IAOI,6BAAA;ErF0hVV;EqFjiVM;IAOI,2BAAA;ErF6hVV;EqFpiVM;IAOI,6BAAA;ErFgiVV;EqFviVM;IAOI,2BAAA;ErFmiVV;EqF1iVM;IAOI,2BAAA;ErFsiVV;EqF7iVM;IAOI,4BAAA;ErFyiVV;EqFhjVM;IAOI,6BAAA;ErF4iVV;AACF;A2BvjVI;E0DGI;IAOI,sBAAA;ErFijVV;EqFxjVM;IAOI,uBAAA;ErFojVV;EqF3jVM;IAOI,sBAAA;ErFujVV;EqF9jVM;IAOI,8BAAA;ErF0jVV;EqFjkVM;IAOI,4BAAA;ErF6jVV;EqFpkVM;IAOI,2BAAA;ErFgkVV;EqFvkVM;IAOI,iCAAA;ErFmkVV;EqF1kVM;IAOI,2BAAA;ErFskVV;EqF7kVM;IAOI,0BAAA;ErFykVV;EqFhlVM;IAOI,gCAAA;ErF4kVV;EqFnlVM;IAOI,yBAAA;ErF+kVV;EqFtlVM;IAOI,wBAAA;ErFklVV;EqFzlVM;IAOI,+BAAA;ErFqlVV;EqF5lVM;IAOI,yBAAA;ErFwlVV;EqF/lVM;IAOI,6BAAA;ErF2lVV;EqFlmVM;IAOI,8BAAA;ErF8lVV;EqFrmVM;IAOI,wBAAA;ErFimVV;EqFxmVM;IAOI,+BAAA;ErFomVV;EqF3mVM;IAOI,wBAAA;ErFumVV;EqF9mVM;IAOI,yBAAA;ErF0mVV;EqFjnVM;IAOI,8BAAA;ErF6mVV;EqFpnVM;IAOI,iCAAA;ErFgnVV;EqFvnVM;IAOI,sCAAA;ErFmnVV;EqF1nVM;IAOI,yCAAA;ErFsnVV;EqF7nVM;IAOI,uBAAA;ErFynVV;EqFhoVM;IAOI,uBAAA;ErF4nVV;EqFnoVM;IAOI,yBAAA;ErF+nVV;EqFtoVM;IAOI,yBAAA;ErFkoVV;EqFzoVM;IAOI,0BAAA;ErFqoVV;EqF5oVM;IAOI,4BAAA;ErFwoVV;EqF/oVM;IAOI,kCAAA;ErF2oVV;EqFlpVM;IAOI,sCAAA;ErF8oVV;EqFrpVM;IAOI,oCAAA;ErFipVV;EqFxpVM;IAOI,kCAAA;ErFopVV;EqF3pVM;IAOI,yCAAA;ErFupVV;EqF9pVM;IAOI,wCAAA;ErF0pVV;EqFjqVM;IAOI,wCAAA;ErF6pVV;EqFpqVM;IAOI,kCAAA;ErFgqVV;EqFvqVM;IAOI,gCAAA;ErFmqVV;EqF1qVM;IAOI,8BAAA;ErFsqVV;EqF7qVM;IAOI,gCAAA;ErFyqVV;EqFhrVM;IAOI,+BAAA;ErF4qVV;EqFnrVM;IAOI,oCAAA;ErF+qVV;EqFtrVM;IAOI,kCAAA;ErFkrVV;EqFzrVM;IAOI,gCAAA;ErFqrVV;EqF5rVM;IAOI,uCAAA;ErFwrVV;EqF/rVM;IAOI,sCAAA;ErF2rVV;EqFlsVM;IAOI,iCAAA;ErF8rVV;EqFrsVM;IAOI,2BAAA;ErFisVV;EqFxsVM;IAOI,iCAAA;ErFosVV;EqF3sVM;IAOI,+BAAA;ErFusVV;EqF9sVM;IAOI,6BAAA;ErF0sVV;EqFjtVM;IAOI,+BAAA;ErF6sVV;EqFptVM;IAOI,8BAAA;ErFgtVV;EqFvtVM;IAOI,oBAAA;ErFmtVV;EqF1tVM;IAOI,mBAAA;ErFstVV;EqF7tVM;IAOI,mBAAA;ErFytVV;EqFhuVM;IAOI,mBAAA;ErF4tVV;EqFnuVM;IAOI,mBAAA;ErF+tVV;EqFtuVM;IAOI,mBAAA;ErFkuVV;EqFzuVM;IAOI,mBAAA;ErFquVV;EqF5uVM;IAOI,mBAAA;ErFwuVV;EqF/uVM;IAOI,oBAAA;ErF2uVV;EqFlvVM;IAOI,0BAAA;ErF8uVV;EqFrvVM;IAOI,yBAAA;ErFivVV;EqFxvVM;IAOI,uBAAA;ErFovVV;EqF3vVM;IAOI,yBAAA;ErFuvVV;EqF9vVM;IAOI,uBAAA;ErF0vVV;EqFjwVM;IAOI,uBAAA;ErF6vVV;EqFpwVM;IAOI,0BAAA;IAAA,yBAAA;ErFiwVV;EqFxwVM;IAOI,gCAAA;IAAA,+BAAA;ErFqwVV;EqF5wVM;IAOI,+BAAA;IAAA,8BAAA;ErFywVV;EqFhxVM;IAOI,6BAAA;IAAA,4BAAA;ErF6wVV;EqFpxVM;IAOI,+BAAA;IAAA,8BAAA;ErFixVV;EqFxxVM;IAOI,6BAAA;IAAA,4BAAA;ErFqxVV;EqF5xVM;IAOI,6BAAA;IAAA,4BAAA;ErFyxVV;EqFhyVM;IAOI,wBAAA;IAAA,2BAAA;ErF6xVV;EqFpyVM;IAOI,8BAAA;IAAA,iCAAA;ErFiyVV;EqFxyVM;IAOI,6BAAA;IAAA,gCAAA;ErFqyVV;EqF5yVM;IAOI,2BAAA;IAAA,8BAAA;ErFyyVV;EqFhzVM;IAOI,6BAAA;IAAA,gCAAA;ErF6yVV;EqFpzVM;IAOI,2BAAA;IAAA,8BAAA;ErFizVV;EqFxzVM;IAOI,2BAAA;IAAA,8BAAA;ErFqzVV;EqF5zVM;IAOI,wBAAA;ErFwzVV;EqF/zVM;IAOI,8BAAA;ErF2zVV;EqFl0VM;IAOI,6BAAA;ErF8zVV;EqFr0VM;IAOI,2BAAA;ErFi0VV;EqFx0VM;IAOI,6BAAA;ErFo0VV;EqF30VM;IAOI,2BAAA;ErFu0VV;EqF90VM;IAOI,2BAAA;ErF00VV;EqFj1VM;IAOI,0BAAA;ErF60VV;EqFp1VM;IAOI,gCAAA;ErFg1VV;EqFv1VM;IAOI,+BAAA;ErFm1VV;EqF11VM;IAOI,6BAAA;ErFs1VV;EqF71VM;IAOI,+BAAA;ErFy1VV;EqFh2VM;IAOI,6BAAA;ErF41VV;EqFn2VM;IAOI,6BAAA;ErF+1VV;EqFt2VM;IAOI,2BAAA;ErFk2VV;EqFz2VM;IAOI,iCAAA;ErFq2VV;EqF52VM;IAOI,gCAAA;ErFw2VV;EqF/2VM;IAOI,8BAAA;ErF22VV;EqFl3VM;IAOI,gCAAA;ErF82VV;EqFr3VM;IAOI,8BAAA;ErFi3VV;EqFx3VM;IAOI,8BAAA;ErFo3VV;EqF33VM;IAOI,yBAAA;ErFu3VV;EqF93VM;IAOI,+BAAA;ErF03VV;EqFj4VM;IAOI,8BAAA;ErF63VV;EqFp4VM;IAOI,4BAAA;ErFg4VV;EqFv4VM;IAOI,8BAAA;ErFm4VV;EqF14VM;IAOI,4BAAA;ErFs4VV;EqF74VM;IAOI,4BAAA;ErFy4VV;EqFh5VM;IAOI,qBAAA;ErF44VV;EqFn5VM;IAOI,2BAAA;ErF+4VV;EqFt5VM;IAOI,0BAAA;ErFk5VV;EqFz5VM;IAOI,wBAAA;ErFq5VV;EqF55VM;IAOI,0BAAA;ErFw5VV;EqF/5VM;IAOI,wBAAA;ErF25VV;EqFl6VM;IAOI,2BAAA;IAAA,0BAAA;ErF+5VV;EqFt6VM;IAOI,iCAAA;IAAA,gCAAA;ErFm6VV;EqF16VM;IAOI,gCAAA;IAAA,+BAAA;ErFu6VV;EqF96VM;IAOI,8BAAA;IAAA,6BAAA;ErF26VV;EqFl7VM;IAOI,gCAAA;IAAA,+BAAA;ErF+6VV;EqFt7VM;IAOI,8BAAA;IAAA,6BAAA;ErFm7VV;EqF17VM;IAOI,yBAAA;IAAA,4BAAA;ErFu7VV;EqF97VM;IAOI,+BAAA;IAAA,kCAAA;ErF27VV;EqFl8VM;IAOI,8BAAA;IAAA,iCAAA;ErF+7VV;EqFt8VM;IAOI,4BAAA;IAAA,+BAAA;ErFm8VV;EqF18VM;IAOI,8BAAA;IAAA,iCAAA;ErFu8VV;EqF98VM;IAOI,4BAAA;IAAA,+BAAA;ErF28VV;EqFl9VM;IAOI,yBAAA;ErF88VV;EqFr9VM;IAOI,+BAAA;ErFi9VV;EqFx9VM;IAOI,8BAAA;ErFo9VV;EqF39VM;IAOI,4BAAA;ErFu9VV;EqF99VM;IAOI,8BAAA;ErF09VV;EqFj+VM;IAOI,4BAAA;ErF69VV;EqFp+VM;IAOI,2BAAA;ErFg+VV;EqFv+VM;IAOI,iCAAA;ErFm+VV;EqF1+VM;IAOI,gCAAA;ErFs+VV;EqF7+VM;IAOI,8BAAA;ErFy+VV;EqFh/VM;IAOI,gCAAA;ErF4+VV;EqFn/VM;IAOI,8BAAA;ErF++VV;EqFt/VM;IAOI,4BAAA;ErFk/VV;EqFz/VM;IAOI,kCAAA;ErFq/VV;EqF5/VM;IAOI,iCAAA;ErFw/VV;EqF//VM;IAOI,+BAAA;ErF2/VV;EqFlgWM;IAOI,iCAAA;ErF8/VV;EqFrgWM;IAOI,+BAAA;ErFigWV;EqFxgWM;IAOI,0BAAA;ErFogWV;EqF3gWM;IAOI,gCAAA;ErFugWV;EqF9gWM;IAOI,+BAAA;ErF0gWV;EqFjhWM;IAOI,6BAAA;ErF6gWV;EqFphWM;IAOI,+BAAA;ErFghWV;EqFvhWM;IAOI,6BAAA;ErFmhWV;EqF1hWM;IAOI,iBAAA;ErFshWV;EqF7hWM;IAOI,uBAAA;ErFyhWV;EqFhiWM;IAOI,sBAAA;ErF4hWV;EqFniWM;IAOI,oBAAA;ErF+hWV;EqFtiWM;IAOI,sBAAA;ErFkiWV;EqFziWM;IAOI,oBAAA;ErFqiWV;EqF5iWM;IAOI,qBAAA;ErFwiWV;EqF/iWM;IAOI,2BAAA;ErF2iWV;EqFljWM;IAOI,0BAAA;ErF8iWV;EqFrjWM;IAOI,wBAAA;ErFijWV;EqFxjWM;IAOI,0BAAA;ErFojWV;EqF3jWM;IAOI,wBAAA;ErFujWV;EqF9jWM;IAOI,wBAAA;ErF0jWV;EqFjkWM;IAOI,8BAAA;ErF6jWV;EqFpkWM;IAOI,6BAAA;ErFgkWV;EqFvkWM;IAOI,2BAAA;ErFmkWV;EqF1kWM;IAOI,6BAAA;ErFskWV;EqF7kWM;IAOI,2BAAA;ErFykWV;EqFhlWM;IAOI,2BAAA;ErF4kWV;EqFnlWM;IAOI,4BAAA;ErF+kWV;EqFtlWM;IAOI,6BAAA;ErFklWV;AACF;A2B7lWI;E0DGI;IAOI,sBAAA;ErFulWV;EqF9lWM;IAOI,uBAAA;ErF0lWV;EqFjmWM;IAOI,sBAAA;ErF6lWV;EqFpmWM;IAOI,8BAAA;ErFgmWV;EqFvmWM;IAOI,4BAAA;ErFmmWV;EqF1mWM;IAOI,2BAAA;ErFsmWV;EqF7mWM;IAOI,iCAAA;ErFymWV;EqFhnWM;IAOI,2BAAA;ErF4mWV;EqFnnWM;IAOI,0BAAA;ErF+mWV;EqFtnWM;IAOI,gCAAA;ErFknWV;EqFznWM;IAOI,yBAAA;ErFqnWV;EqF5nWM;IAOI,wBAAA;ErFwnWV;EqF/nWM;IAOI,+BAAA;ErF2nWV;EqFloWM;IAOI,yBAAA;ErF8nWV;EqFroWM;IAOI,6BAAA;ErFioWV;EqFxoWM;IAOI,8BAAA;ErFooWV;EqF3oWM;IAOI,wBAAA;ErFuoWV;EqF9oWM;IAOI,+BAAA;ErF0oWV;EqFjpWM;IAOI,wBAAA;ErF6oWV;EqFppWM;IAOI,yBAAA;ErFgpWV;EqFvpWM;IAOI,8BAAA;ErFmpWV;EqF1pWM;IAOI,iCAAA;ErFspWV;EqF7pWM;IAOI,sCAAA;ErFypWV;EqFhqWM;IAOI,yCAAA;ErF4pWV;EqFnqWM;IAOI,uBAAA;ErF+pWV;EqFtqWM;IAOI,uBAAA;ErFkqWV;EqFzqWM;IAOI,yBAAA;ErFqqWV;EqF5qWM;IAOI,yBAAA;ErFwqWV;EqF/qWM;IAOI,0BAAA;ErF2qWV;EqFlrWM;IAOI,4BAAA;ErF8qWV;EqFrrWM;IAOI,kCAAA;ErFirWV;EqFxrWM;IAOI,sCAAA;ErForWV;EqF3rWM;IAOI,oCAAA;ErFurWV;EqF9rWM;IAOI,kCAAA;ErF0rWV;EqFjsWM;IAOI,yCAAA;ErF6rWV;EqFpsWM;IAOI,wCAAA;ErFgsWV;EqFvsWM;IAOI,wCAAA;ErFmsWV;EqF1sWM;IAOI,kCAAA;ErFssWV;EqF7sWM;IAOI,gCAAA;ErFysWV;EqFhtWM;IAOI,8BAAA;ErF4sWV;EqFntWM;IAOI,gCAAA;ErF+sWV;EqFttWM;IAOI,+BAAA;ErFktWV;EqFztWM;IAOI,oCAAA;ErFqtWV;EqF5tWM;IAOI,kCAAA;ErFwtWV;EqF/tWM;IAOI,gCAAA;ErF2tWV;EqFluWM;IAOI,uCAAA;ErF8tWV;EqFruWM;IAOI,sCAAA;ErFiuWV;EqFxuWM;IAOI,iCAAA;ErFouWV;EqF3uWM;IAOI,2BAAA;ErFuuWV;EqF9uWM;IAOI,iCAAA;ErF0uWV;EqFjvWM;IAOI,+BAAA;ErF6uWV;EqFpvWM;IAOI,6BAAA;ErFgvWV;EqFvvWM;IAOI,+BAAA;ErFmvWV;EqF1vWM;IAOI,8BAAA;ErFsvWV;EqF7vWM;IAOI,oBAAA;ErFyvWV;EqFhwWM;IAOI,mBAAA;ErF4vWV;EqFnwWM;IAOI,mBAAA;ErF+vWV;EqFtwWM;IAOI,mBAAA;ErFkwWV;EqFzwWM;IAOI,mBAAA;ErFqwWV;EqF5wWM;IAOI,mBAAA;ErFwwWV;EqF/wWM;IAOI,mBAAA;ErF2wWV;EqFlxWM;IAOI,mBAAA;ErF8wWV;EqFrxWM;IAOI,oBAAA;ErFixWV;EqFxxWM;IAOI,0BAAA;ErFoxWV;EqF3xWM;IAOI,yBAAA;ErFuxWV;EqF9xWM;IAOI,uBAAA;ErF0xWV;EqFjyWM;IAOI,yBAAA;ErF6xWV;EqFpyWM;IAOI,uBAAA;ErFgyWV;EqFvyWM;IAOI,uBAAA;ErFmyWV;EqF1yWM;IAOI,0BAAA;IAAA,yBAAA;ErFuyWV;EqF9yWM;IAOI,gCAAA;IAAA,+BAAA;ErF2yWV;EqFlzWM;IAOI,+BAAA;IAAA,8BAAA;ErF+yWV;EqFtzWM;IAOI,6BAAA;IAAA,4BAAA;ErFmzWV;EqF1zWM;IAOI,+BAAA;IAAA,8BAAA;ErFuzWV;EqF9zWM;IAOI,6BAAA;IAAA,4BAAA;ErF2zWV;EqFl0WM;IAOI,6BAAA;IAAA,4BAAA;ErF+zWV;EqFt0WM;IAOI,wBAAA;IAAA,2BAAA;ErFm0WV;EqF10WM;IAOI,8BAAA;IAAA,iCAAA;ErFu0WV;EqF90WM;IAOI,6BAAA;IAAA,gCAAA;ErF20WV;EqFl1WM;IAOI,2BAAA;IAAA,8BAAA;ErF+0WV;EqFt1WM;IAOI,6BAAA;IAAA,gCAAA;ErFm1WV;EqF11WM;IAOI,2BAAA;IAAA,8BAAA;ErFu1WV;EqF91WM;IAOI,2BAAA;IAAA,8BAAA;ErF21WV;EqFl2WM;IAOI,wBAAA;ErF81WV;EqFr2WM;IAOI,8BAAA;ErFi2WV;EqFx2WM;IAOI,6BAAA;ErFo2WV;EqF32WM;IAOI,2BAAA;ErFu2WV;EqF92WM;IAOI,6BAAA;ErF02WV;EqFj3WM;IAOI,2BAAA;ErF62WV;EqFp3WM;IAOI,2BAAA;ErFg3WV;EqFv3WM;IAOI,0BAAA;ErFm3WV;EqF13WM;IAOI,gCAAA;ErFs3WV;EqF73WM;IAOI,+BAAA;ErFy3WV;EqFh4WM;IAOI,6BAAA;ErF43WV;EqFn4WM;IAOI,+BAAA;ErF+3WV;EqFt4WM;IAOI,6BAAA;ErFk4WV;EqFz4WM;IAOI,6BAAA;ErFq4WV;EqF54WM;IAOI,2BAAA;ErFw4WV;EqF/4WM;IAOI,iCAAA;ErF24WV;EqFl5WM;IAOI,gCAAA;ErF84WV;EqFr5WM;IAOI,8BAAA;ErFi5WV;EqFx5WM;IAOI,gCAAA;ErFo5WV;EqF35WM;IAOI,8BAAA;ErFu5WV;EqF95WM;IAOI,8BAAA;ErF05WV;EqFj6WM;IAOI,yBAAA;ErF65WV;EqFp6WM;IAOI,+BAAA;ErFg6WV;EqFv6WM;IAOI,8BAAA;ErFm6WV;EqF16WM;IAOI,4BAAA;ErFs6WV;EqF76WM;IAOI,8BAAA;ErFy6WV;EqFh7WM;IAOI,4BAAA;ErF46WV;EqFn7WM;IAOI,4BAAA;ErF+6WV;EqFt7WM;IAOI,qBAAA;ErFk7WV;EqFz7WM;IAOI,2BAAA;ErFq7WV;EqF57WM;IAOI,0BAAA;ErFw7WV;EqF/7WM;IAOI,wBAAA;ErF27WV;EqFl8WM;IAOI,0BAAA;ErF87WV;EqFr8WM;IAOI,wBAAA;ErFi8WV;EqFx8WM;IAOI,2BAAA;IAAA,0BAAA;ErFq8WV;EqF58WM;IAOI,iCAAA;IAAA,gCAAA;ErFy8WV;EqFh9WM;IAOI,gCAAA;IAAA,+BAAA;ErF68WV;EqFp9WM;IAOI,8BAAA;IAAA,6BAAA;ErFi9WV;EqFx9WM;IAOI,gCAAA;IAAA,+BAAA;ErFq9WV;EqF59WM;IAOI,8BAAA;IAAA,6BAAA;ErFy9WV;EqFh+WM;IAOI,yBAAA;IAAA,4BAAA;ErF69WV;EqFp+WM;IAOI,+BAAA;IAAA,kCAAA;ErFi+WV;EqFx+WM;IAOI,8BAAA;IAAA,iCAAA;ErFq+WV;EqF5+WM;IAOI,4BAAA;IAAA,+BAAA;ErFy+WV;EqFh/WM;IAOI,8BAAA;IAAA,iCAAA;ErF6+WV;EqFp/WM;IAOI,4BAAA;IAAA,+BAAA;ErFi/WV;EqFx/WM;IAOI,yBAAA;ErFo/WV;EqF3/WM;IAOI,+BAAA;ErFu/WV;EqF9/WM;IAOI,8BAAA;ErF0/WV;EqFjgXM;IAOI,4BAAA;ErF6/WV;EqFpgXM;IAOI,8BAAA;ErFggXV;EqFvgXM;IAOI,4BAAA;ErFmgXV;EqF1gXM;IAOI,2BAAA;ErFsgXV;EqF7gXM;IAOI,iCAAA;ErFygXV;EqFhhXM;IAOI,gCAAA;ErF4gXV;EqFnhXM;IAOI,8BAAA;ErF+gXV;EqFthXM;IAOI,gCAAA;ErFkhXV;EqFzhXM;IAOI,8BAAA;ErFqhXV;EqF5hXM;IAOI,4BAAA;ErFwhXV;EqF/hXM;IAOI,kCAAA;ErF2hXV;EqFliXM;IAOI,iCAAA;ErF8hXV;EqFriXM;IAOI,+BAAA;ErFiiXV;EqFxiXM;IAOI,iCAAA;ErFoiXV;EqF3iXM;IAOI,+BAAA;ErFuiXV;EqF9iXM;IAOI,0BAAA;ErF0iXV;EqFjjXM;IAOI,gCAAA;ErF6iXV;EqFpjXM;IAOI,+BAAA;ErFgjXV;EqFvjXM;IAOI,6BAAA;ErFmjXV;EqF1jXM;IAOI,+BAAA;ErFsjXV;EqF7jXM;IAOI,6BAAA;ErFyjXV;EqFhkXM;IAOI,iBAAA;ErF4jXV;EqFnkXM;IAOI,uBAAA;ErF+jXV;EqFtkXM;IAOI,sBAAA;ErFkkXV;EqFzkXM;IAOI,oBAAA;ErFqkXV;EqF5kXM;IAOI,sBAAA;ErFwkXV;EqF/kXM;IAOI,oBAAA;ErF2kXV;EqFllXM;IAOI,qBAAA;ErF8kXV;EqFrlXM;IAOI,2BAAA;ErFilXV;EqFxlXM;IAOI,0BAAA;ErFolXV;EqF3lXM;IAOI,wBAAA;ErFulXV;EqF9lXM;IAOI,0BAAA;ErF0lXV;EqFjmXM;IAOI,wBAAA;ErF6lXV;EqFpmXM;IAOI,wBAAA;ErFgmXV;EqFvmXM;IAOI,8BAAA;ErFmmXV;EqF1mXM;IAOI,6BAAA;ErFsmXV;EqF7mXM;IAOI,2BAAA;ErFymXV;EqFhnXM;IAOI,6BAAA;ErF4mXV;EqFnnXM;IAOI,2BAAA;ErF+mXV;EqFtnXM;IAOI,2BAAA;ErFknXV;EqFznXM;IAOI,4BAAA;ErFqnXV;EqF5nXM;IAOI,6BAAA;ErFwnXV;AACF;A2BnoXI;E0DGI;IAOI,sBAAA;ErF6nXV;EqFpoXM;IAOI,uBAAA;ErFgoXV;EqFvoXM;IAOI,sBAAA;ErFmoXV;EqF1oXM;IAOI,8BAAA;ErFsoXV;EqF7oXM;IAOI,4BAAA;ErFyoXV;EqFhpXM;IAOI,2BAAA;ErF4oXV;EqFnpXM;IAOI,iCAAA;ErF+oXV;EqFtpXM;IAOI,2BAAA;ErFkpXV;EqFzpXM;IAOI,0BAAA;ErFqpXV;EqF5pXM;IAOI,gCAAA;ErFwpXV;EqF/pXM;IAOI,yBAAA;ErF2pXV;EqFlqXM;IAOI,wBAAA;ErF8pXV;EqFrqXM;IAOI,+BAAA;ErFiqXV;EqFxqXM;IAOI,yBAAA;ErFoqXV;EqF3qXM;IAOI,6BAAA;ErFuqXV;EqF9qXM;IAOI,8BAAA;ErF0qXV;EqFjrXM;IAOI,wBAAA;ErF6qXV;EqFprXM;IAOI,+BAAA;ErFgrXV;EqFvrXM;IAOI,wBAAA;ErFmrXV;EqF1rXM;IAOI,yBAAA;ErFsrXV;EqF7rXM;IAOI,8BAAA;ErFyrXV;EqFhsXM;IAOI,iCAAA;ErF4rXV;EqFnsXM;IAOI,sCAAA;ErF+rXV;EqFtsXM;IAOI,yCAAA;ErFksXV;EqFzsXM;IAOI,uBAAA;ErFqsXV;EqF5sXM;IAOI,uBAAA;ErFwsXV;EqF/sXM;IAOI,yBAAA;ErF2sXV;EqFltXM;IAOI,yBAAA;ErF8sXV;EqFrtXM;IAOI,0BAAA;ErFitXV;EqFxtXM;IAOI,4BAAA;ErFotXV;EqF3tXM;IAOI,kCAAA;ErFutXV;EqF9tXM;IAOI,sCAAA;ErF0tXV;EqFjuXM;IAOI,oCAAA;ErF6tXV;EqFpuXM;IAOI,kCAAA;ErFguXV;EqFvuXM;IAOI,yCAAA;ErFmuXV;EqF1uXM;IAOI,wCAAA;ErFsuXV;EqF7uXM;IAOI,wCAAA;ErFyuXV;EqFhvXM;IAOI,kCAAA;ErF4uXV;EqFnvXM;IAOI,gCAAA;ErF+uXV;EqFtvXM;IAOI,8BAAA;ErFkvXV;EqFzvXM;IAOI,gCAAA;ErFqvXV;EqF5vXM;IAOI,+BAAA;ErFwvXV;EqF/vXM;IAOI,oCAAA;ErF2vXV;EqFlwXM;IAOI,kCAAA;ErF8vXV;EqFrwXM;IAOI,gCAAA;ErFiwXV;EqFxwXM;IAOI,uCAAA;ErFowXV;EqF3wXM;IAOI,sCAAA;ErFuwXV;EqF9wXM;IAOI,iCAAA;ErF0wXV;EqFjxXM;IAOI,2BAAA;ErF6wXV;EqFpxXM;IAOI,iCAAA;ErFgxXV;EqFvxXM;IAOI,+BAAA;ErFmxXV;EqF1xXM;IAOI,6BAAA;ErFsxXV;EqF7xXM;IAOI,+BAAA;ErFyxXV;EqFhyXM;IAOI,8BAAA;ErF4xXV;EqFnyXM;IAOI,oBAAA;ErF+xXV;EqFtyXM;IAOI,mBAAA;ErFkyXV;EqFzyXM;IAOI,mBAAA;ErFqyXV;EqF5yXM;IAOI,mBAAA;ErFwyXV;EqF/yXM;IAOI,mBAAA;ErF2yXV;EqFlzXM;IAOI,mBAAA;ErF8yXV;EqFrzXM;IAOI,mBAAA;ErFizXV;EqFxzXM;IAOI,mBAAA;ErFozXV;EqF3zXM;IAOI,oBAAA;ErFuzXV;EqF9zXM;IAOI,0BAAA;ErF0zXV;EqFj0XM;IAOI,yBAAA;ErF6zXV;EqFp0XM;IAOI,uBAAA;ErFg0XV;EqFv0XM;IAOI,yBAAA;ErFm0XV;EqF10XM;IAOI,uBAAA;ErFs0XV;EqF70XM;IAOI,uBAAA;ErFy0XV;EqFh1XM;IAOI,0BAAA;IAAA,yBAAA;ErF60XV;EqFp1XM;IAOI,gCAAA;IAAA,+BAAA;ErFi1XV;EqFx1XM;IAOI,+BAAA;IAAA,8BAAA;ErFq1XV;EqF51XM;IAOI,6BAAA;IAAA,4BAAA;ErFy1XV;EqFh2XM;IAOI,+BAAA;IAAA,8BAAA;ErF61XV;EqFp2XM;IAOI,6BAAA;IAAA,4BAAA;ErFi2XV;EqFx2XM;IAOI,6BAAA;IAAA,4BAAA;ErFq2XV;EqF52XM;IAOI,wBAAA;IAAA,2BAAA;ErFy2XV;EqFh3XM;IAOI,8BAAA;IAAA,iCAAA;ErF62XV;EqFp3XM;IAOI,6BAAA;IAAA,gCAAA;ErFi3XV;EqFx3XM;IAOI,2BAAA;IAAA,8BAAA;ErFq3XV;EqF53XM;IAOI,6BAAA;IAAA,gCAAA;ErFy3XV;EqFh4XM;IAOI,2BAAA;IAAA,8BAAA;ErF63XV;EqFp4XM;IAOI,2BAAA;IAAA,8BAAA;ErFi4XV;EqFx4XM;IAOI,wBAAA;ErFo4XV;EqF34XM;IAOI,8BAAA;ErFu4XV;EqF94XM;IAOI,6BAAA;ErF04XV;EqFj5XM;IAOI,2BAAA;ErF64XV;EqFp5XM;IAOI,6BAAA;ErFg5XV;EqFv5XM;IAOI,2BAAA;ErFm5XV;EqF15XM;IAOI,2BAAA;ErFs5XV;EqF75XM;IAOI,0BAAA;ErFy5XV;EqFh6XM;IAOI,gCAAA;ErF45XV;EqFn6XM;IAOI,+BAAA;ErF+5XV;EqFt6XM;IAOI,6BAAA;ErFk6XV;EqFz6XM;IAOI,+BAAA;ErFq6XV;EqF56XM;IAOI,6BAAA;ErFw6XV;EqF/6XM;IAOI,6BAAA;ErF26XV;EqFl7XM;IAOI,2BAAA;ErF86XV;EqFr7XM;IAOI,iCAAA;ErFi7XV;EqFx7XM;IAOI,gCAAA;ErFo7XV;EqF37XM;IAOI,8BAAA;ErFu7XV;EqF97XM;IAOI,gCAAA;ErF07XV;EqFj8XM;IAOI,8BAAA;ErF67XV;EqFp8XM;IAOI,8BAAA;ErFg8XV;EqFv8XM;IAOI,yBAAA;ErFm8XV;EqF18XM;IAOI,+BAAA;ErFs8XV;EqF78XM;IAOI,8BAAA;ErFy8XV;EqFh9XM;IAOI,4BAAA;ErF48XV;EqFn9XM;IAOI,8BAAA;ErF+8XV;EqFt9XM;IAOI,4BAAA;ErFk9XV;EqFz9XM;IAOI,4BAAA;ErFq9XV;EqF59XM;IAOI,qBAAA;ErFw9XV;EqF/9XM;IAOI,2BAAA;ErF29XV;EqFl+XM;IAOI,0BAAA;ErF89XV;EqFr+XM;IAOI,wBAAA;ErFi+XV;EqFx+XM;IAOI,0BAAA;ErFo+XV;EqF3+XM;IAOI,wBAAA;ErFu+XV;EqF9+XM;IAOI,2BAAA;IAAA,0BAAA;ErF2+XV;EqFl/XM;IAOI,iCAAA;IAAA,gCAAA;ErF++XV;EqFt/XM;IAOI,gCAAA;IAAA,+BAAA;ErFm/XV;EqF1/XM;IAOI,8BAAA;IAAA,6BAAA;ErFu/XV;EqF9/XM;IAOI,gCAAA;IAAA,+BAAA;ErF2/XV;EqFlgYM;IAOI,8BAAA;IAAA,6BAAA;ErF+/XV;EqFtgYM;IAOI,yBAAA;IAAA,4BAAA;ErFmgYV;EqF1gYM;IAOI,+BAAA;IAAA,kCAAA;ErFugYV;EqF9gYM;IAOI,8BAAA;IAAA,iCAAA;ErF2gYV;EqFlhYM;IAOI,4BAAA;IAAA,+BAAA;ErF+gYV;EqFthYM;IAOI,8BAAA;IAAA,iCAAA;ErFmhYV;EqF1hYM;IAOI,4BAAA;IAAA,+BAAA;ErFuhYV;EqF9hYM;IAOI,yBAAA;ErF0hYV;EqFjiYM;IAOI,+BAAA;ErF6hYV;EqFpiYM;IAOI,8BAAA;ErFgiYV;EqFviYM;IAOI,4BAAA;ErFmiYV;EqF1iYM;IAOI,8BAAA;ErFsiYV;EqF7iYM;IAOI,4BAAA;ErFyiYV;EqFhjYM;IAOI,2BAAA;ErF4iYV;EqFnjYM;IAOI,iCAAA;ErF+iYV;EqFtjYM;IAOI,gCAAA;ErFkjYV;EqFzjYM;IAOI,8BAAA;ErFqjYV;EqF5jYM;IAOI,gCAAA;ErFwjYV;EqF/jYM;IAOI,8BAAA;ErF2jYV;EqFlkYM;IAOI,4BAAA;ErF8jYV;EqFrkYM;IAOI,kCAAA;ErFikYV;EqFxkYM;IAOI,iCAAA;ErFokYV;EqF3kYM;IAOI,+BAAA;ErFukYV;EqF9kYM;IAOI,iCAAA;ErF0kYV;EqFjlYM;IAOI,+BAAA;ErF6kYV;EqFplYM;IAOI,0BAAA;ErFglYV;EqFvlYM;IAOI,gCAAA;ErFmlYV;EqF1lYM;IAOI,+BAAA;ErFslYV;EqF7lYM;IAOI,6BAAA;ErFylYV;EqFhmYM;IAOI,+BAAA;ErF4lYV;EqFnmYM;IAOI,6BAAA;ErF+lYV;EqFtmYM;IAOI,iBAAA;ErFkmYV;EqFzmYM;IAOI,uBAAA;ErFqmYV;EqF5mYM;IAOI,sBAAA;ErFwmYV;EqF/mYM;IAOI,oBAAA;ErF2mYV;EqFlnYM;IAOI,sBAAA;ErF8mYV;EqFrnYM;IAOI,oBAAA;ErFinYV;EqFxnYM;IAOI,qBAAA;ErFonYV;EqF3nYM;IAOI,2BAAA;ErFunYV;EqF9nYM;IAOI,0BAAA;ErF0nYV;EqFjoYM;IAOI,wBAAA;ErF6nYV;EqFpoYM;IAOI,0BAAA;ErFgoYV;EqFvoYM;IAOI,wBAAA;ErFmoYV;EqF1oYM;IAOI,wBAAA;ErFsoYV;EqF7oYM;IAOI,8BAAA;ErFyoYV;EqFhpYM;IAOI,6BAAA;ErF4oYV;EqFnpYM;IAOI,2BAAA;ErF+oYV;EqFtpYM;IAOI,6BAAA;ErFkpYV;EqFzpYM;IAOI,2BAAA;ErFqpYV;EqF5pYM;IAOI,2BAAA;ErFwpYV;EqF/pYM;IAOI,4BAAA;ErF2pYV;EqFlqYM;IAOI,6BAAA;ErF8pYV;AACF;A2BzqYI;E0DGI;IAOI,sBAAA;ErFmqYV;EqF1qYM;IAOI,uBAAA;ErFsqYV;EqF7qYM;IAOI,sBAAA;ErFyqYV;EqFhrYM;IAOI,8BAAA;ErF4qYV;EqFnrYM;IAOI,4BAAA;ErF+qYV;EqFtrYM;IAOI,2BAAA;ErFkrYV;EqFzrYM;IAOI,iCAAA;ErFqrYV;EqF5rYM;IAOI,2BAAA;ErFwrYV;EqF/rYM;IAOI,0BAAA;ErF2rYV;EqFlsYM;IAOI,gCAAA;ErF8rYV;EqFrsYM;IAOI,yBAAA;ErFisYV;EqFxsYM;IAOI,wBAAA;ErFosYV;EqF3sYM;IAOI,+BAAA;ErFusYV;EqF9sYM;IAOI,yBAAA;ErF0sYV;EqFjtYM;IAOI,6BAAA;ErF6sYV;EqFptYM;IAOI,8BAAA;ErFgtYV;EqFvtYM;IAOI,wBAAA;ErFmtYV;EqF1tYM;IAOI,+BAAA;ErFstYV;EqF7tYM;IAOI,wBAAA;ErFytYV;EqFhuYM;IAOI,yBAAA;ErF4tYV;EqFnuYM;IAOI,8BAAA;ErF+tYV;EqFtuYM;IAOI,iCAAA;ErFkuYV;EqFzuYM;IAOI,sCAAA;ErFquYV;EqF5uYM;IAOI,yCAAA;ErFwuYV;EqF/uYM;IAOI,uBAAA;ErF2uYV;EqFlvYM;IAOI,uBAAA;ErF8uYV;EqFrvYM;IAOI,yBAAA;ErFivYV;EqFxvYM;IAOI,yBAAA;ErFovYV;EqF3vYM;IAOI,0BAAA;ErFuvYV;EqF9vYM;IAOI,4BAAA;ErF0vYV;EqFjwYM;IAOI,kCAAA;ErF6vYV;EqFpwYM;IAOI,sCAAA;ErFgwYV;EqFvwYM;IAOI,oCAAA;ErFmwYV;EqF1wYM;IAOI,kCAAA;ErFswYV;EqF7wYM;IAOI,yCAAA;ErFywYV;EqFhxYM;IAOI,wCAAA;ErF4wYV;EqFnxYM;IAOI,wCAAA;ErF+wYV;EqFtxYM;IAOI,kCAAA;ErFkxYV;EqFzxYM;IAOI,gCAAA;ErFqxYV;EqF5xYM;IAOI,8BAAA;ErFwxYV;EqF/xYM;IAOI,gCAAA;ErF2xYV;EqFlyYM;IAOI,+BAAA;ErF8xYV;EqFryYM;IAOI,oCAAA;ErFiyYV;EqFxyYM;IAOI,kCAAA;ErFoyYV;EqF3yYM;IAOI,gCAAA;ErFuyYV;EqF9yYM;IAOI,uCAAA;ErF0yYV;EqFjzYM;IAOI,sCAAA;ErF6yYV;EqFpzYM;IAOI,iCAAA;ErFgzYV;EqFvzYM;IAOI,2BAAA;ErFmzYV;EqF1zYM;IAOI,iCAAA;ErFszYV;EqF7zYM;IAOI,+BAAA;ErFyzYV;EqFh0YM;IAOI,6BAAA;ErF4zYV;EqFn0YM;IAOI,+BAAA;ErF+zYV;EqFt0YM;IAOI,8BAAA;ErFk0YV;EqFz0YM;IAOI,oBAAA;ErFq0YV;EqF50YM;IAOI,mBAAA;ErFw0YV;EqF/0YM;IAOI,mBAAA;ErF20YV;EqFl1YM;IAOI,mBAAA;ErF80YV;EqFr1YM;IAOI,mBAAA;ErFi1YV;EqFx1YM;IAOI,mBAAA;ErFo1YV;EqF31YM;IAOI,mBAAA;ErFu1YV;EqF91YM;IAOI,mBAAA;ErF01YV;EqFj2YM;IAOI,oBAAA;ErF61YV;EqFp2YM;IAOI,0BAAA;ErFg2YV;EqFv2YM;IAOI,yBAAA;ErFm2YV;EqF12YM;IAOI,uBAAA;ErFs2YV;EqF72YM;IAOI,yBAAA;ErFy2YV;EqFh3YM;IAOI,uBAAA;ErF42YV;EqFn3YM;IAOI,uBAAA;ErF+2YV;EqFt3YM;IAOI,0BAAA;IAAA,yBAAA;ErFm3YV;EqF13YM;IAOI,gCAAA;IAAA,+BAAA;ErFu3YV;EqF93YM;IAOI,+BAAA;IAAA,8BAAA;ErF23YV;EqFl4YM;IAOI,6BAAA;IAAA,4BAAA;ErF+3YV;EqFt4YM;IAOI,+BAAA;IAAA,8BAAA;ErFm4YV;EqF14YM;IAOI,6BAAA;IAAA,4BAAA;ErFu4YV;EqF94YM;IAOI,6BAAA;IAAA,4BAAA;ErF24YV;EqFl5YM;IAOI,wBAAA;IAAA,2BAAA;ErF+4YV;EqFt5YM;IAOI,8BAAA;IAAA,iCAAA;ErFm5YV;EqF15YM;IAOI,6BAAA;IAAA,gCAAA;ErFu5YV;EqF95YM;IAOI,2BAAA;IAAA,8BAAA;ErF25YV;EqFl6YM;IAOI,6BAAA;IAAA,gCAAA;ErF+5YV;EqFt6YM;IAOI,2BAAA;IAAA,8BAAA;ErFm6YV;EqF16YM;IAOI,2BAAA;IAAA,8BAAA;ErFu6YV;EqF96YM;IAOI,wBAAA;ErF06YV;EqFj7YM;IAOI,8BAAA;ErF66YV;EqFp7YM;IAOI,6BAAA;ErFg7YV;EqFv7YM;IAOI,2BAAA;ErFm7YV;EqF17YM;IAOI,6BAAA;ErFs7YV;EqF77YM;IAOI,2BAAA;ErFy7YV;EqFh8YM;IAOI,2BAAA;ErF47YV;EqFn8YM;IAOI,0BAAA;ErF+7YV;EqFt8YM;IAOI,gCAAA;ErFk8YV;EqFz8YM;IAOI,+BAAA;ErFq8YV;EqF58YM;IAOI,6BAAA;ErFw8YV;EqF/8YM;IAOI,+BAAA;ErF28YV;EqFl9YM;IAOI,6BAAA;ErF88YV;EqFr9YM;IAOI,6BAAA;ErFi9YV;EqFx9YM;IAOI,2BAAA;ErFo9YV;EqF39YM;IAOI,iCAAA;ErFu9YV;EqF99YM;IAOI,gCAAA;ErF09YV;EqFj+YM;IAOI,8BAAA;ErF69YV;EqFp+YM;IAOI,gCAAA;ErFg+YV;EqFv+YM;IAOI,8BAAA;ErFm+YV;EqF1+YM;IAOI,8BAAA;ErFs+YV;EqF7+YM;IAOI,yBAAA;ErFy+YV;EqFh/YM;IAOI,+BAAA;ErF4+YV;EqFn/YM;IAOI,8BAAA;ErF++YV;EqFt/YM;IAOI,4BAAA;ErFk/YV;EqFz/YM;IAOI,8BAAA;ErFq/YV;EqF5/YM;IAOI,4BAAA;ErFw/YV;EqF//YM;IAOI,4BAAA;ErF2/YV;EqFlgZM;IAOI,qBAAA;ErF8/YV;EqFrgZM;IAOI,2BAAA;ErFigZV;EqFxgZM;IAOI,0BAAA;ErFogZV;EqF3gZM;IAOI,wBAAA;ErFugZV;EqF9gZM;IAOI,0BAAA;ErF0gZV;EqFjhZM;IAOI,wBAAA;ErF6gZV;EqFphZM;IAOI,2BAAA;IAAA,0BAAA;ErFihZV;EqFxhZM;IAOI,iCAAA;IAAA,gCAAA;ErFqhZV;EqF5hZM;IAOI,gCAAA;IAAA,+BAAA;ErFyhZV;EqFhiZM;IAOI,8BAAA;IAAA,6BAAA;ErF6hZV;EqFpiZM;IAOI,gCAAA;IAAA,+BAAA;ErFiiZV;EqFxiZM;IAOI,8BAAA;IAAA,6BAAA;ErFqiZV;EqF5iZM;IAOI,yBAAA;IAAA,4BAAA;ErFyiZV;EqFhjZM;IAOI,+BAAA;IAAA,kCAAA;ErF6iZV;EqFpjZM;IAOI,8BAAA;IAAA,iCAAA;ErFijZV;EqFxjZM;IAOI,4BAAA;IAAA,+BAAA;ErFqjZV;EqF5jZM;IAOI,8BAAA;IAAA,iCAAA;ErFyjZV;EqFhkZM;IAOI,4BAAA;IAAA,+BAAA;ErF6jZV;EqFpkZM;IAOI,yBAAA;ErFgkZV;EqFvkZM;IAOI,+BAAA;ErFmkZV;EqF1kZM;IAOI,8BAAA;ErFskZV;EqF7kZM;IAOI,4BAAA;ErFykZV;EqFhlZM;IAOI,8BAAA;ErF4kZV;EqFnlZM;IAOI,4BAAA;ErF+kZV;EqFtlZM;IAOI,2BAAA;ErFklZV;EqFzlZM;IAOI,iCAAA;ErFqlZV;EqF5lZM;IAOI,gCAAA;ErFwlZV;EqF/lZM;IAOI,8BAAA;ErF2lZV;EqFlmZM;IAOI,gCAAA;ErF8lZV;EqFrmZM;IAOI,8BAAA;ErFimZV;EqFxmZM;IAOI,4BAAA;ErFomZV;EqF3mZM;IAOI,kCAAA;ErFumZV;EqF9mZM;IAOI,iCAAA;ErF0mZV;EqFjnZM;IAOI,+BAAA;ErF6mZV;EqFpnZM;IAOI,iCAAA;ErFgnZV;EqFvnZM;IAOI,+BAAA;ErFmnZV;EqF1nZM;IAOI,0BAAA;ErFsnZV;EqF7nZM;IAOI,gCAAA;ErFynZV;EqFhoZM;IAOI,+BAAA;ErF4nZV;EqFnoZM;IAOI,6BAAA;ErF+nZV;EqFtoZM;IAOI,+BAAA;ErFkoZV;EqFzoZM;IAOI,6BAAA;ErFqoZV;EqF5oZM;IAOI,iBAAA;ErFwoZV;EqF/oZM;IAOI,uBAAA;ErF2oZV;EqFlpZM;IAOI,sBAAA;ErF8oZV;EqFrpZM;IAOI,oBAAA;ErFipZV;EqFxpZM;IAOI,sBAAA;ErFopZV;EqF3pZM;IAOI,oBAAA;ErFupZV;EqF9pZM;IAOI,qBAAA;ErF0pZV;EqFjqZM;IAOI,2BAAA;ErF6pZV;EqFpqZM;IAOI,0BAAA;ErFgqZV;EqFvqZM;IAOI,wBAAA;ErFmqZV;EqF1qZM;IAOI,0BAAA;ErFsqZV;EqF7qZM;IAOI,wBAAA;ErFyqZV;EqFhrZM;IAOI,wBAAA;ErF4qZV;EqFnrZM;IAOI,8BAAA;ErF+qZV;EqFtrZM;IAOI,6BAAA;ErFkrZV;EqFzrZM;IAOI,2BAAA;ErFqrZV;EqF5rZM;IAOI,6BAAA;ErFwrZV;EqF/rZM;IAOI,2BAAA;ErF2rZV;EqFlsZM;IAOI,2BAAA;ErF8rZV;EqFrsZM;IAOI,4BAAA;ErFisZV;EqFxsZM;IAOI,6BAAA;ErFosZV;AACF;AsF3vZA;ED+CQ;IAOI,4BAAA;ErFysZV;EqFhtZM;IAOI,0BAAA;ErF4sZV;EqFntZM;IAOI,6BAAA;ErF+sZV;EqFttZM;IAOI,4BAAA;ErFktZV;AACF;AsFtvZA;ED4BQ;IAOI,0BAAA;ErFutZV;EqF9tZM;IAOI,gCAAA;ErF0tZV;EqFjuZM;IAOI,yBAAA;ErF6tZV;EqFpuZM;IAOI,wBAAA;ErFguZV;EqFvuZM;IAOI,+BAAA;ErFmuZV;EqF1uZM;IAOI,yBAAA;ErFsuZV;EqF7uZM;IAOI,6BAAA;ErFyuZV;EqFhvZM;IAOI,8BAAA;ErF4uZV;EqFnvZM;IAOI,wBAAA;ErF+uZV;EqFtvZM;IAOI,+BAAA;ErFkvZV;EqFzvZM;IAOI,wBAAA;ErFqvZV;AACF;AuF5zZA;E7EyEQ,6CAAA;EAAA,kEAAA;EAAA,6CAAA;EAAA,wEAAA;EAAA,wEAAA;EAAA,wEAAA;EAAA,8EAAA;EAAA,8EAAA;EAAA,8DAAA;EAAA,yDAAA;EAAA,qDAAA;EAAA,mEAAA;AViwZR;;AuFjzZE;EACE,oCAAA;AvFozZJ;;AuFjzZE;EACE,uBAAA;EACA,uBAAA;AvFozZJ;AuFlzZI;EACE,uBAAA;AvFozZN;AuFjzZI;EACE,4BAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,gDAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AvFmzZN;AuFhzZI;EACE,mDAAA;AvFkzZN;AuFhzZM;EACE,uBAAA;AvFkzZR;AuF/yZI;EACE,YAAA;AvFizZN;AuF9yZI;EACE,2DAAA;AvFgzZN;AuF9yZM;EACE,wCAAA;AvFgzZR;AuF9yZQ;EACE,gDAAA;AvFgzZV;;AuF1yZA;EACE,0CAAA;EACA,0CAAA;AvF6yZF;;AuF1yZA;EACE,sDAAA;EACA,wCAAA;AvF6yZF;;AuF1yZA;EACE,iBAAA;EACA,mBAAA;EACA,qBAAA;AvF6yZF;;AuF1yZA;EACE,sBAAA;EACA,qBAAA;AvF6yZF;;AuF1yZA;EACE,qBAAA;AvF6yZF;;AuF1yZA;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,UAAA;EACA,qDAAA;AvF6yZF;;AuF1yZA;EACE,qCAAA;AvF6yZF;;AuF1yZA;EACE,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,4BAAA;AvF6yZF;;AuF1yZA;EACE,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;AvF6yZF;;AwFz6ZA;EACE,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,0DAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,uBAAA;EACA,qBAAA;AxF46ZF;AwF16ZE;EACE,WAAA;EACA,YAAA;E9EyDI,6EAAA;EAAA,kEAAA;AVq3ZR;AwFx6ZI;EACE,WAAA;AxF06ZN;AwFx6ZM;EACE,UAAA;AxF06ZR;AwFp6ZE;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;AxFs6ZJ;AwFn6ZE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AxFq6ZJ;AwFn6ZI;EACE,gBAAA;AxFq6ZN;AwFh6ZE;EACE;IACE,uBAAA;ExFk6ZJ;EwFh6ZE;IACE,2BAAA;ExFk6ZJ;AACF;AwF/5ZE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,0DAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;AxFi6ZJ;AwF95ZE;EACE,eAAA;EACA,gBAAA;AxFg6ZJ;AwF75ZE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AxF+5ZJ;AwF55ZE;EACE,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,qBAAA;AxF85ZJ;AwF35ZE;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;AxF65ZJ;AwF15ZE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AxF45ZJ;AwFz5ZE;EACE,0BAAA;EACA,+BAAA;AxF25ZJ;AwFx5ZE;EACE,gDAAA;EACA,qCAAA;AxF05ZJ;AwFv5ZE;EACE,iBAAA;EACA,kBAAA;AxFy5ZJ;;AyFniaA;;;;;;EAAA;ApFAA;;;;;;EAAA;AqFGE;EACE,wCAAA;EACA,YAAA;A1FijaJ;;A0F7iaE;EACE,YAAA;EACA,mDAAA;A1FgjaJ;A0F7iaE;EAEE,yBAAA;A1F8iaJ;A0F3iaE;EAEE,yBAAA;A1F4iaJ;;A0FxiaA;EACE,UAAA;A1F2iaF;;A0FtiaA;EACE,0BAAA;A1FyiaF;;A0FtiaA;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;A1FyiaF;;A0FliaA,4HAAA;AAKA;EACE,yBAAA;EACA,WAAA;EACA,oBAAA;A1FiiaF;;A0F9haA;EACE,cAAA;A1FiiaF;;A0F9haA;EACE,aAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;A1FiiaF;A0F1haA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;A1F4haF;A0F1haE;EACE,yBAAA;EACA,mBAAA;A1F4haJ;A0F1haI;EACE,aAAA;EACA,eAAA;EACA,sBAAA;A1F4haN;A0FxhaE;EAEE,+HAAA;EACA,+HAAA;A1FyhaJ;A0FxhaI;EAGE,+HAAA;A1FwhaN;A0F/gaA;EACE,UAAA;EACA,aAAA;A1FihaF;A0F/gaE;EACE,mBAAA;A1FihaJ;A0F/gaI;EACE,cAAA;A1FihaN;;A0F5gaA;EACE,aAAA;A1F+gaF;A0F7gaE;EACE,UAAA;EACA,gBAAA;A1F+gaJ;;A0F3gaA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;A1F8gaF;A0F5gaE;EACE,yBAAA;A1F8gaJ;;AKlpaA;;;;;;EAAA;AsFIE;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,wCAAA;EACA,YAAA;A3FwpaJ;A2FrpaE;EACE,YAAA;A3FupaJ;;A2FjpaA;EACE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,iBAAA;A3FopaF;;A2FhpaE;EACE,4BAAA;EACA,0BAAA;A3FmpaJ;A2FhpaE;EACE,eAAA;EACA,gBAAA;A3FkpaJ;A2F/oaE;EACE,uBAAA;A3FipaJ;A2F9oaE;EACE,4BAAA;EACA,sBAAA;A3FgpaJ;;A2F3oaA;EACE,sBAAA;A3F8oaF;;A2F3oaA;EACE,YAAA;A3F8oaF;;A2F3oaA;EACE,cAAA;EACA,8BAAA;A3F8oaF;;A2F3oaA;EACE,oCAAA;A3F8oaF;;A2F1oaA;EACE,cAAA;A3F6oaF;;A2F1oaA;EACE,WAAA;EACA,mBAAA;EACA,UAAA;A3F6oaF;;A2F3oaA;EACE,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;A3F8oaF;;A2F3oaA;EACE,kBAAA;A3F8oaF;;A2F3oaA;EAEE,iBAAA;A3F6oaF;;A2FpoaA;EACE,sBAAA;EACA,eAAA;A3FuoaF;;A2FpoaA;EAGI,eAAA;EACA,WAAA;EACA,YAAA;A3FqoaJ;;A2FloaA;EACE,cCtFQ;A5F2taV;;A2F7naA;EACE,YAAA;A3FgoaF;;A2F7naA;EACE,yBCrFS;A5FqtaX;;A2F9naA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;A3FioaF;;A2FvnaA;EACE,yBCxGS;A5FkuaX;;A2FvnaA;EACE,qDAAA;A3F0naF;;A2FpnaA;EACE,cAAA;EACA,eAAA;A3FunaF;;A2F5maA;;EAAA;AAGA;EACE,sBAAA;A3F+maF;;A2FpmaA;EACE,sDAAA;A3FumaF;;A2FpmaA;EACE,YAAA;A3FumaF;;A2FpmaA;EACE,sDAAA;A3FumaF;;A2FpmaA;EACE,kBAAA;EACA,8BAAA;EACA,WAAA;A3FumaF;;A2FpmaA;EACE,aAAA;A3FumaF;;A2FpmaA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;A3FumaF;;A2FpmaA;EACE,gBAAA;EACA,qBAAA;A3FumaF;;A2FpmaA;EACE,YAAA;A3FumaF;;A2FhmaA;EACE,sBAAA;EACA,uBAAA;EACA,eAAA;A3FmmaF;;A2FhmaA;EACE,0BAAA;A3FmmaF;;A2FhmaA;EACE,qCAAA;A3FmmaF;;A2FhmaA;EACE,iBAAA;A3FmmaF;;A2FhmaA;EACE,iBAAA;A3FmmaF;;A2FhmaA;EACE,4BAAA;EACA,6DAAA;EACA,kBAAA;A3FmmaF;;A2FhmaA;EACE,UAAA;EACA,WAAA;A3FmmaF;;A2FhmaA;EACE,uBAAA;EACA,oBAAA;A3FmmaF;;A2FhmaA;EACE,8BAAA;A3FmmaF;;A2FjmaA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;A3FomaF;;A2FlmaA;EACE,cCxPQ;A5F61aV;;AK53aA;;;;;;EAAA;AwFEA;EACE,6BAAA;EACA,eAAA;EACA,mBAAA;A7Fo4aF;;A6Fj4aA;EACE,kBAAA;A7Fo4aF;;A6Fj4aA;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;EACA,UAAA;EACA,OAAA;EACA,gBAAA;A7Fo4aF;;A6Fj4aA;EACE,0BAAA;A7Fo4aF;;A6Fj4aA;EACE,UAAA;A7Fo4aF;;A6Fj4aA;EACE,kBAAA;EACA,WAAA;A7Fo4aF;;A6Fj4aA;EACE,wBAAA;A7Fo4aF;;A6Fj4aA;EACE,sDAAA;EACA,wCAAA;EACA,yBAAA;A7Fo4aF;;A6Fj4aA;EACE,mDAAA;EACA,2CAAA;A7Fo4aF;;A6Fj4aA;EACE,+BAAA;EACA,8BAAA;EACA,2BAAA;A7Fo4aF;;A6Fj4aA;EACE,+BAAA;EACA,8BAAA;EACA,2BAAA;A7Fo4aF;;A6Fj4aA;EACE,+BAAA;EACA,8BAAA;EACA,2BAAA;A7Fo4aF;;A6Fj4aA;EACE,+BAAA;EACA,8BAAA;EACA,2BAAA;A7Fo4aF;;A6Fj4aA;EACE,+BAAA;EACA,8BAAA;EACA,2BAAA;A7Fo4aF;;A6Fj4aA;EACE,+BAAA;EACA,8BAAA;EACA,2BAAA;A7Fo4aF;;AK39aA;;;;;;EAAA;AyFEE;EACE,wCAAA;A9Fm+aJ;A8Fh+aE;EACE,wCAAA;A9Fk+aJ;;A8F79aE;EACE,4BAAA;A9Fg+aJ;A8F79aE;EACE,6BAAA;A9F+9aJ;A8F59aE;EACE,6BAAA;A9F89aJ;A8F39aE;EACE,4BAAA;A9F69aJ;;A8Fz9aA;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;A9F49aF;;A8Fz9aA;EACE,yBAAA;A9F49aF;;A8Fz9aA;EACE,gBAAA;A9F49aF;;A8Fz9aA;EACE,gBAAA;EACA,6BAAA;EACA,oBAAA;EACA,0BAAA;A9F49aF;A8F39aE;EACE,qBAAA;EACA,6BAAA;EACA,2BAAA;EACA,YAAA;A9F69aJ;A8F39aE;EACE,2BAAA;A9F69aJ;;A8Fz9aA;EACE,2BAAA;A9F49aF;A8F39aE;EACE,qBAAA;EACA,yBAAA;A9F69aJ;;A8Fv9aA;EACE,YAAA;EACA,eAAA;A9F09aF;;A8Fv9aA;EACE,mBAAA;EACA,WAAA;A9F09aF;;A8Fv9aA,sCAAA;AACA;EACE,2BAAA;EACA,iBAAA;EACA,SAAA;EACA,wCAAA;EACA,UAAA;EACA,gBAAA;EAEA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,iCAAA;A9Fy9aF;;A8Ft9aA;EACE,qBAAA;A9Fy9aF;;A8Ft9aA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kCAAA;EACA,mBAAA;EACA,qBAAA;A9Fy9aF;;A8Fv9aA,oCAAA;AAEA,+BAAA;AACA;EACE,6CAAA;EACA,0BAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;A9Fy9aF;;A8Ft9aA;EACE,qBAAA;A9Fy9aF;;A8Ft9aA;EACE,qBAAA;A9Fy9aF;;A8Ft9aA;EAEE,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;A9Fw9aF;;A8Fr9aA;EACE,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;A9Fw9aF;;A8Fr9aA;EACE,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,6BAAA;EACA,oCAAA;EACA,0EAAA;EACA,kEAAA;EACA,uBAAA;A9Fw9aF;;A8Fn9aA;EACE,wBAAA;A9Fs9aF;;A8Fn9aA;EACE,wBAAA;A9Fs9aF;;A8Fn9aA;EACE,cAAA;EACA,0BAAA;EACA,8BAAA;EACA,qBAAA;A9Fs9aF;;A8Fn9aA;EACE,qBAAA;A9Fs9aF;;A8Fn9aA;EACE,aAAA;A9Fs9aF;;A8Fp9aA,6BAAA;AAEA,gCAAA;AACA;EACE,mBAAA;EACA,eAAA;EACA,cAAA;EACA,8BAAA;EACA,gBAAA;EACA,8BAAA;A9Fs9aF;;A8Fn9aA;EACE,SAAA;A9Fs9aF;;A8Fn9aA;EACE,6BAAA;A9Fs9aF;;A8Fn9aA;EACE,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;A9Fs9aF;;A8Fn9aA;EACE,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;A9Fs9aF;;A8Fp9aA,8BAAA;AAEA,+HAAA;AAKA,+HAAA;AAQA;EACE,8BAAA;A9F28aF;;A8Fx8aA;EACE,wBAAA;A9F28aF;;A8Fx8aA;EACE,oBAAA;A9F28aF;;A8Fx8aA;EACE,YAAA;A9F28aF;;A8Fx8aA;EACE,aAAA;A9F28aF;;A8Fx8aA;EACE,wBAAA;A9F28aF;;A8Fx8aA;EACE,kBAAA;A9F28aF;;A8Fx8aA;EACE,cAAA;A9F28aF;;A8Fv8aA;EACE,WAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,+BAAA;EACA,2BAAA;A9F08aF;;A8Ft8aA;EACE,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,qBAAA;A9Fy8aF;;A8Fr8aA;EACE,iBAAA;A9Fw8aF;;A8Fp8aA;EACE,iBAAA;EACA,mBAAA;A9Fu8aF;;A8Fp8aA;EACE,iBAAA;EACA,kBAAA;A9Fu8aF;;A8Fp8aA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;A9Fu8aF;;A8Fp8aA;EACE,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;A9Fu8aF;;A8Fp8aA;EACE,YAAA;A9Fu8aF;;AK3xbA;;;;;;EAAA;A0FEA;EACE,uBAAA;EACA,oBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;A/FmybF;;A+FhybA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;A/FmybF;;A+FhybA;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;A/FmybF;;A+FjybA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;A/FoybF;;A+F9xbA;EACE,cAAA;A/FiybF;;A+F9xbA;EACE,cHTQ;EGUR,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;A/FiybF;;A+F9xbA;EACE,cHlBQ;EGmBR,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;A/FiybF;;A+F/xbA;EACE,yBHhBS;EGiBT,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;A/FkybF;;A+F/xbA;EACE,wCAAA;A/FkybF;;A+F/xbA;EACE,kBAAA;EACA,yBH7BS;EG8BT,eAAA;EACA,cAAA;A/FkybF;;A+F/xbA;EACE,YAAA;EACA,WAAA;EACA,eAAA;A/FkybF;;A+F/xbA;EACE,kBAAA;A/FkybF;;AKx3bA;;;;;;EAAA;A2FGA,qBAAA;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AhG83bF;AgG53bE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;AhG83bJ;AgG53bI;EACE,UAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AhG83bN;AgG53bM;EACE,eAAA;AhG83bR;AgG33bM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AhG63bR;AgGz3bI;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,6BAAA;AhG23bN;AgGz3bM;EAAU,aAAA;AhG43bhB;AgG13bM;EACE,kBAAA;EACA,QAAA;AhG43bR;AgGv3bE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,uBAAA;AhGy3bJ;AgGv3bI;EACE,kBAAA;EACA,SAAA;AhGy3bN;AgGt3bI;EACE,qBAAA;EACA,iBAAA;AhGw3bN;AgGr3bI;EACE,uBAAA;EACA,gBAAA;AhGu3bN;AgGp3bI;EACE,eAAA;EACA,kBAAA;AhGs3bN;AgGl3bE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AhGo3bJ;AgGl3bI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;AhGo3bN;AgGl3bM;EACE,aAAA;AhGo3bR;AgGj3bM;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;AhGm3bR;AgGj3bQ;EACE,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AhGm3bV;AgGj3bU;EACE,WAAA;EACA,YAAA;AhGm3bZ;AgGj3bY;EACE,2BAAA;EACA,gBAAA;AhGm3bd;AgGj3bc;EACE,UAAA;EACA,YAAA;AhGm3bhB;AgG12bE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;AhG42bJ;AgG12bI;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AhG42bN;AgG12bM;EACE,0BAAA;AhG42bR;AgGx2bI;EACE,aAAA;EACA,8BAAA;AhG02bN;AgGx2bM;EACE,uBAAA;AhG02bR;AgGt2bQ;EACE,2CJzJQ;A5FigclB;AgGp2bM;EACE,yBJ1IG;A5Fg/bX;AgGn2bM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;AhGq2bR;AgGh2bE;EACE,+BJ3JO;EI4JP,eAAA;AhGk2bJ;;AgG91bA;EACE,kBAAA;EACA,qBAAA;EACA,+BAAA;AhGi2bF;;AgG91bA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AhGi2bF;;AgG91bA;EACE,mBAAA;AhGi2bF;;AgG91bA;EACE,iBAAA;EACA,cAAA;AhGi2bF;AgG71bM;EACE,0BAAA;AhG+1bR;;AgGt1bI;EACE,6BAAA;AhGy1bN;AgGr1bM;EACE,mBAAA;EACA,6BAAA;AhGu1bR;AgGr1bQ;EACE,cAAA;EACA,kCAAA;AhGu1bV;;AgG/0bE;EACE,sBAAA;AhGk1bJ;AgGh1bI;EACE,0EAAA;AhGk1bN;AgG/0bI;EACE,yEAAA;AhGi1bN;AgG50bI;EACE,uBAAA;EACA,6CAAA;EACA,yDAAA;AhG80bN;AgG50bM;EACE,oCAAA;AhG80bR;;AgGv0bE;EACE,+CAAA;AhG00bJ;;AgGr0bE;EACE,yBJjQqB;A5FykczB;AgGr0bE;EACE,+CAAA;AhGu0bJ;AgGn0bI;EACE,YJ3Pe;A5FgkcrB;AgGn0bM;EACE,sKAAA;AhGq0bR;;AgG9zbA,0BAAA;AAIA;EACE,wDAAA;AhG8zbF;;AgG3zbC,gBAAA;AA6BD,cAAA;AACC;EACE;IACE,6BAAA;EhGkybH;EgGhybC;IACE,4BAAA;EhGkybH;AACF;AKzocA;;;;;;EAAA;A4FEA;EACE,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;AjGgpcF;;AiG3ocA;EACE,aAAA;EACA,2BAAA;EACA,sBAAA;AjG8ocF;AiG5ocE;EACE,oBAAA;EACA,8BAAA;EACA,kBAAA;AjG8ocJ;;AiG1ocA;EACE,cAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;AjG6ocF;;AiG1ocA;EACE,oBAAA;AjG6ocF;;AiG1ocA;EACE,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AjG6ocF;;AiGzocA;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AjG4ocF;;AiGzocA;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kCAAA;EACA,uBAAA;AjG4ocF;;AiGxocA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;AjG2ocF;;AiGxocA;EACE,kBAAA;AjG2ocF;;AiGxocA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AjG2ocF;;AiGxocA;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;AjG2ocF;;AiGxocA;EACE,aAAA;EACA,mBAAA;AjG2ocF;;AiGxocA;EACE,6BAAA;EACA,cL7CS;EK8CT,8BAAA;AjG2ocF;;AiGxocA;EACE,kBAAA;AjG2ocF;;AiGpocA;EACE,WAAA;AjGuocF;;AiGnocA;EACE,yBAAA;AjGsocF;;AiGnocA;EACE,UAAA;EACA,aAAA;AjGsocF;AiGpocE;EACE,mBAAA;AjGsocJ;;AiGlocA;EACE,aAAA;AjGqocF;AiGnocE;EACE,UAAA;EACA,gBAAA;EACA,6BAAA;AjGqocJ;;AiGjocA;EACE,aAAA;EACA,2BAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;AjGoocF;;AiGjocA;EACE,cAAA;AjGoocF;;AiGhocA;EACE,oBAAA;AjGmocF;;AiG/ncA;EACE,8BAAA;AjGkocF;;AiG/ncA;EACE,WAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;AjGkocF;;AiG9ncA;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,oBAAA;EACA,mBAAA;AjGiocF;AiG/ncE;EACE,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AjGiocJ;;AiG1ncA;EACE,qBAAA;AjG6ncF;;AiG1ncA;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;AjG6ncF;;AiG1ncA;EACE,UAAA;AjG6ncF;;AiG1ncA;EACE,iBAAA;AjG6ncF;;AiGzncA;EACE,4BAAA;AjG4ncF;;AiGzncA;EACE,4BAAA;AjG4ncF;;AiGzncA;EACE,wBAAA;EACA,UAAA;AjG4ncF;;AiG1ncA;EACE,kBAAA;EACA,oCAAA;EACA,oDAAA;AjG6ncF;;AiG1ncA,4HAAA;AACA;EACE,uBAAA;AjG6ncF;;AiGxncE;EACE,0BAAA;EACA,eAAA;EACA,iDAAA;AjG2ncJ;;AiGrncA;EACE,mDAAA;EACA,yCAAA;AjGwncF;AiGtncE;EACE,yBLrMO;EKsMP,gBAAA;AjGwncJ;;AiG/lcA,mBAAA;AACA;EACE,WAAA;EACA,YAAA;AjGkmcF;AiGhmcE;EACE,2BAAA;EACA,2CAAA;AjGkmcJ;AiGhmcI;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;AjGkmcN;AiG/lcI;EACE,uBAAA;EACA,sBAAA;AjGimcN;AiG9lcI;EACE,wBAAA;EACA,oBAAA;AjGgmcN;AiG7lcI;EACE,wBAAA;EACA,sBAAA;AjG+lcN;AiG5lcI;EACE,wBAAA;EACA,sBAAA;AjG8lcN;AiG3lcI;EACE,yBAAA;EACA,sBAAA;AjG6lcN;AiG1lcI;EACE,yBAAA;EACA,sBAAA;AjG4lcN;AiGzlcI;EACE,yBAAA;EACA,sBAAA;AjG2lcN;AiGxlcI;EACE,yBAAA;EACA,sBAAA;AjG0lcN;AiGvlcI;EACE,yBAAA;EACA,sBAAA;AjGylcN;AiGtlcI;EACE,yBAAA;EACA,sBAAA;AjGwlcN;AiGrlcI;EACE,yBAAA;EACA,sBAAA;AjGulcN;AiGplcI;EACE,yBAAA;EACA,mBAAA;AjGslcN;;AK/6cA;;;;;;EAAA;A6FIE;EACE,6BAAA;AlGq7cJ;AkGn7cI;EACE,6BAAA;AlGq7cN;;AkG/6cA;EACE,wCAAA;AlGk7cF;;AkG/6cA;EACE,oCAAA;EACA,yBAAA;AlGk7cF;AkGj7cE;EACE,yBAAA;AlGm7cJ;;AkGh7cA;EACE,c9FvBgC;AJ08clC;;AkG/6cE;EACE,cAAA;AlGk7cJ;AkG/6cE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AlGi7cJ;;AkG96cA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;AlGi7cF;;AkG96cA;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AlGi7cF;;AKr+cA;;;;;;EAAA;A8FGA;EACE,aAAA;EACA,sBAAA;AnG4+cF;;AmG1+cA;EACE,WAAA;AnG6+cF;;AmG3+cA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AnG8+cF;;AmG3+cA;EACE,aAAA;EACA,kBAAA;EACA,0BAAA;AnG8+cF;;AmG3+cA;EACE,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AnG8+cF;;AmG3+cA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;AnG8+cF;;AmG3+cA,uBAAA;AACA;EACE,aAAA;AnG8+cF;;AmG5+cA;EACE,aAAA;EACA,cAAA;AnG++cF;;AmG5+cA;EACE,+CAAA;AnG++cF;;AmG5+cA;EACE,mCAAA;EACA,0BAAA;AnG++cF;;AmG5+cA;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AnG++cF;AmG5+cE;EACE,oBAAA;AnG8+cJ;;AmG1+cA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AnG6+cF;;AmG1+cA;EACE,YAAA;EACA,eAAA;EACA,wBAAA;EACA,4BAAA;AnG6+cF;;AmG1+cA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AnG6+cF;;AmG3+cA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,6BAAA;EACA,uBAAA;AnG8+cF;;AmG3+cA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;AnG8+cF;;AmG3+cA;EACE,kBAAA;EACA,QAAA;EACA,MAAA;AnG8+cF;;AmG3+cA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;AnG8+cF;;AmG3+cA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AnG8+cF;;AmG3+cA;EACE,aAAA;AnG8+cF;;AmG3+cA;EACE,YAAA;AnG8+cF;;AmG3+cA;EACE,kBAAA;AnG8+cF;;AmG3+cA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AnG8+cF;;AmG5+cA;EACE,0CPrIgB;EOsIhB,UAAA;AnG++cF;;AmG7+cA;EACE,iBAAA;AnGg/cF;;AmG9+cA;EACE,kBAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,2DAAA;EACA,iBAAA;EACA,eAAA;AnGi/cF;;AmG9+cA;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;AnGi/cF;;AmG9+cA;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;AnGi/cF;;AmG9+cA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AnGi/cF;;AmG9+cA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;AnGi/cF;;AmG9+cA;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;AnGi/cF;;AmG9+cA;EACE,WAAA;AnGi/cF;;AmG9+cA;EACE,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,UAAA;AnGi/cF;;AmG9+cA;EACE,kBAAA;EACA,6BAAA;AnGi/cF;;AmG9+cA;EACE;IACE,iBAAA;EnGi/cF;AACF;AmG9+cA;EACE;IACE,iBAAA;EnGg/cF;AACF;AK/tdA;;;;;;EAAA;A+FIA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qCAAA;EACA,wCAAA;ApGoudF;;AoG/tdA;EACE,cAAA;EACA,kCAAA;EACA,0BAAA;EACA,4CAAA;ApGkudF;;AoG/tdA;EACE,aAAA;EACA,mBAAA;ApGkudF;;AoG/tdA;EACE,kBAAA;ApGkudF;;AoG/tdA;EACE,cAAA;ApGkudF;;AoG/tdA;EACE,cAAA;ApGkudF;;AoG/tdA;EACE,cAAA;ApGkudF;;AoG/tdA;EACE,aAAA;EACA,sBAAA;ApGkudF;;AoG/tdA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;ApGkudF;;AoG/tdA;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;ApGkudF;;AoG/tdA;EACE,iBAAA;EACA,eAAA;ApGkudF;;AoG/tdA;EACE,OAAA;ApGkudF;;AoG9tdA;EACE,aAAA;ApGiudF;;AoG9tdA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;ApGiudF;;AoG9tdA;EACE,UAAA;ApGiudF;;AoG7tdA;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;ApGgudF;;AoG7tdA;EACE,mBAAA;ApGgudF;;AoG7tdA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ApGgudF;;AoG7tdA;EACE,cAAA;ApGgudF;;AoG9tdA;EACE,cAAA;ApGiudF;;AoG/tdA;EACE,cAAA;ApGkudF;;AoGhudA;EACE,cAAA;ApGmudF;;AoGhudA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;ApGmudF;;AoGhudA;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;ApGmudF;;AoG/tdA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;ApGkudF;;AoG/tdA;EACE,kBAAA;ApGkudF;;AoG/tdA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;ApGkudF;;AoG/tdA;EACE,cAAA;ApGkudF;;AoG/tdA;EACE,cAAA;ApGkudF;;AoG/tdA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;ApGkudF;;AoG/tdA;EACE,eAAA;ApGkudF;;AoG/tdA;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;ApGkudF;;AoG9tdA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,WAAA;ApGiudF;;AoG9tdA;EACE,4DAAA;EACA,SAAA;ApGiudF;;AoG7tdA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;ApGgudF;;AoG7tdA;EACE,eAAA;EACA,qDAAA;EACA,qCAAA;ApGgudF;;AoG7tdA;EACE,2BAAA;EACA,0CAAA;ApGgudF;;AoG7tdA;EACE,kBAAA;EACA,kBAAA;ApGgudF;;AoG7tdA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;ApGgudF;;AoG7tdA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;ApGgudF;;AoG7tdA;EACE,SAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;ApGgudF;;AoG5tdA;EACE,kBAAA;EACA,mBAAA;ApG+tdF;;AoG5tdA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;ApG+tdF;;AoG5tdA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,uBAAA;ApG+tdF;;AoG3tdA;EACE,eAAA;EACA,4DAAA;EACA,uBAAA;EACA,eAAA;ApG8tdF;AoG5tdE;;EAEE,mBAAA;EACA,gBAAA;ApG8tdJ;AoG1tdE;EACE,mCAAA;EACA,gDAAA;ApG4tdJ;AoG1tdI;EACE,mDAAA;EACA,kEAAA;ApG4tdN;AoGvtdE;EACE,oCAAA;ApGytdJ;AoGvtdI;EACE,oDAAA;ApGytdN;;AoGntdE;EACE,mCAAA;ApGstdJ;AoGptdI;EACE,oDAAA;ApGstdN;AoGltdE;EACE,oCAAA;ApGotdJ;AoGltdI;EACE,qDAAA;ApGotdN;;AoG9sdA,2HAAA;AAEE;EACE,QAAA;ApGgtdJ;;AoG3sdA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;ApG8sdF;;AoG3sdA;EACE,gBAAA;ApG8sdF;;AoG1sdA;EACE,aAAA;EACA,aAAA;EACA,kCAAA;EACA,yCAAA;EACA,SAAA;EACA,qBAAA;EACA,cAAA;ApG6sdF;;AoG1sdA;EACE,OAAA;EACA,SAAA;ApG6sdF;AoG5rdE;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;ApG8rdJ;;AoG1rdA;EACE,YAAA;EACA,gBAAA;ApG6rdF;;AoGzrdA;EACE;IACE,aAAA;EpG4rdF;EoGzrdA;IACE,kBAAA;EpG2rdF;EoGxrdA;IACE,mBAAA;EpG0rdF;EoGvrdA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EpGyrdF;EoGtrdA;IACE,eAAA;EpGwrdF;EoGrrdA;IACE,eAAA;EpGurdF;EoGprdA;IACE,0BAAA;IACA,SAAA;IACA,mBAAA;EpGsrdF;EoGnrdA;IACE,kBAAA;EpGqrdF;EoGlrdA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EpGordF;EoGjrdA;IACE,0BAAA;IACA,SAAA;EpGmrdF;EoGhrdA;IACE,sBAAA;IACA,QAAA;IACA,mBAAA;EpGkrdF;EoG/qdA;IACE,kBAAA;EpGirdF;EoG9qdA;IACE,eAAA;IACA,WAAA;IACA,YAAA;EpGgrdF;EoG7qdA;IACE,eAAA;EpG+qdF;EoG5qdA;IACE,eAAA;EpG8qdF;EoG3qdA;IACE,aAAA;EpG6qdF;EoG1qdA;IACE,aAAA;EpG4qdF;EoGzqdA;IACE,eAAA;EpG2qdF;AACF;AqGtneA;;;;;;EAAA;AAQA;EACE,uCAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;ArGuneF;AqGrneE;EANF;IAOI,gBAAA;IACA,gBAAA;ErGwneF;AACF;AqGtneE;EAXF;IAYI,4BAAA;IACA,gBAAA;ErGyneF;AACF;;AqGtneA;;;EAAA;AASA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;ArGoneF;AqGlneE;EACE,uBAAA;EACA,4CAAA;EACA,cAAA;ArGoneJ;AqGlneI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;ArGoneN;AqGjneI;EACE,SAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;ArGmneN;AqG/meE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;ArGineJ;AqG/meI;EACE,OAAA;EACA,aAAA;ArGineN;AqG/meM;EACE,eAAA;EACA,iBAAA;ArGineR;AqG/meQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;ArGineV;AqG/meU;EACE,eAAA;EACA,WAAA;EACA,YAAA;ArGineZ;AqG7meQ;EACE,mBAAA;ArG+meV;AqG5meQ;EACE,WAAA;ArG8meV;AqGxmeE;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;ArG0meJ;AqGvmeM;EACE,kBAAA;EACA,6BAAA;ArGymeR;AqGvmeQ;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kCAAA;ArGymeV;AqGtmeQ;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;ArGwmeV;;AqGjmeA;;;EAAA;AAKA;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;ArGmmeF;AqG/leE;EACE,cAAA;ArGimeJ;AqG9leE;EACE,yCAAA;EACA,sBAAA;EACA,wCAAA;ArGgmeJ;AqG9leI;EACE,uBAAA;ArGgmeN;AqG5leE;EACE,yCAAA;EACA,uBAAA;EACA,wCAAA;ArG8leJ;AqG5leI;EACE,uBAAA;ArG8leN;AqG1leE;EACE,0CAAA;EACA,uBAAA;EACA,yCAAA;ArG4leJ;AqG1leI;EACE,wBAAA;EACA,kCAAA;ArG4leN;;AqGvleA;;;EAAA;AAKA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,yBAAA;ArGyleF;AqGvleE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;ArGyleJ;AqGvleI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;ArGyleN;AqGrleE;EACE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ArGuleJ;AqGrleI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;ArGuleN;AqGpleI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;ArGsleN;AqGpleM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;ArGsleR;AqGnleM;EACE,kBAAA;EACA,eAAA;ArGqleR;AqGnleQ;EACE,gBAAA;EACA,WAAA;ArGqleV;AqGlleQ;EACE,WAAA;EACA,eAAA;ArGoleV;AqG9keE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;ArGgleJ;AqG9keI;EACE,eAAA;EACA,WAAA;EACA,YAAA;ArGgleN;;AqG1keA;;;EAAA;AAKA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;ArG4keF;AqGpkeA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;ArGskeF;AqGpkeE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;ArGskeJ;AqGpkeI;EACE,eAAA;EACA,WAAA;EACA,YAAA;ArGskeN;;AqGhkeA;;;EAAA;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;ArGkkeF;AqGhkeE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;ArGkkeJ;AqG/jeE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;ArGikeJ;;AqG7jeA;;;EAAA;AAKA;EACE,eAAA;ArG+jeF;AqG7jeE;EACE,gCAAA;ArG+jeJ;;AqG3ieA;;;EAAA;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ArG6ieF;;AqG1ieA;EAEE,8BAAA;ArG4ieF;;AqGzieA;EACE,eAAA;EACA,gCAAA;EACA,6BAAA;EACA,kBAAA;ArG4ieF;AqG1ieE;EACE,qCAAA;EACA,wCAAA;ArG4ieJ;AqGzieE;EACE,qBAAA;EACA,0CAAA;ArG2ieJ;AqGvieE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;ArGyieJ;AqGvieI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;ArGyieN;AqGtieI;EACE,OAAA;ArGwieN;AqGtieM;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;ArGwieR;AqGtieQ;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;ArGwieV;AqGpieM;EACE,eAAA;EACA,WAAA;EACA,sBAAA;ArGsieR;AqGjieE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;ArGmieJ;;AqGngeA;;;EAAA;AAKA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;ArGqgeF;AqGlgeI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;ArGogeN;AqGlgeM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;ArGogeR;AqGjgeM;EACE,gBAAA;EACA,WAAA;ArGmgeR;AqG//dI;EACE,eAAA;EACA,WAAA;EACA,mBAAA;ArGigeN;AqG7/dM;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;ArG+/dR;AqG5/dM;EACE,qCAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;ArG8/dR;;AqGx/dA;;;EAAA;AAKA;EACE,mBAAA;ArG0/dF;AqGx/dE;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;ArG0/dJ;;AqGt/dA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;ArGy/dF;AqGv/dE;EACE,wCAAA;EACA,cAAA;EACA,wCAAA;ArGy/dJ;AqGv/dI;EACE,cAAA;ArGy/dN;AqGr/dE;EACE,wCAAA;EACA,cAAA;EACA,wCAAA;ArGu/dJ;AqGr/dI;EACE,cAAA;ArGu/dN;AqGn/dE;EACE,yCAAA;EACA,cAAA;EACA,yCAAA;ArGq/dJ;AqGn/dI;EACE,cAAA;ArGq/dN;;AqGh/dA;EACE,kBAAA;ArGm/dF;;AqGh/dA;;;EAAA;AAKA;EACE;IACE,uBAAA;ErGk/dF;EqGh/dA;IACE,yBAAA;ErGk/dF;AACF;AqG/+dA;;;EAAA;AAMI;EACE,4CAAA;ArG++dN;AqGr+dA;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;ArGu+dF;;AqGp+dA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;ArGu+dF;AqGr+dE;EACE,eAAA;EACA,WAAA;EACA,YAAA;ArGu+dJ;;AqGn+dA;;;EAAA;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ArGs+dF;;AqGn+dA;EACE,aAAA;ArGs+dF;;AqGn+dA;EACE,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;ArGs+dF;AqGp+dE;EACE,kBAAA;EACA,yBAAA;ArGs+dJ;AqGn+dE;EACE,qBAAA;EACA,0CAAA;ArGq+dJ;AqGn+dI;EACE,UAAA;ArGq+dN;AqGj+dE;EACE,qBAAA;EACA,yCAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA;ArGm+dJ;AqGh+dE;EACE,2BAAA;EACA,aAAA;ArGk+dJ;AqG/9dE;EACE,qBAAA;EACA,yCAAA;ArGi+dJ;AqG99dE;EACE,6BAAA;ArGg+dJ;AqG99dI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;ArGg+dN;AqG79dI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;ArG+9dN;AqG59dI;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;ArG89dN;AqG59dM;EACE,cAAA;EACA,0BAAA;EACA,eAAA;ArG89dR;AqGz9dM;EACE,yBAAA;EACA,eAAA;ArG29dR;AqGr9dI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,6BAAA;ArGu9dN;AqGp9dI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;ArGs9dN;AqGj9dE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;ArGm9dJ;AqGj9dI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,cAAA;ArGm9dN;AqGh9dI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,cAAA;ArGk9dN;AqG/8dI;EACE,OAAA;EACA,YAAA;EACA,kBAAA;ArGi9dN;AqG/8dM;EACE,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;ArGi9dR;AqG98dM;EACE,eAAA;EACA,yBAAA;ArGg9dR;AqGz8dE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;ArG28dJ;AqGz8dI;EACE,cAAA;ArG28dN;AqGz8dM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;ArG28dR;AqGv8dI;EACE,OAAA;EACA,YAAA;ArGy8dN;AqGv8dM;EACE,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;ArGy8dR;AqGt8dM;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;ArGw8dR;AqGr8dM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;ArGu8dR;AqGr8dQ;EACE,cAAA;ArGu8dV;AqGp8dQ;EACE,cAAA;ArGs8dV;AqGn8dQ;EACE,cAAA;ArGq8dV;AqGl8dQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;ArGo8dV;;AqG57dA;;;EAAA;AAKE;EACE,WAAA;ArG87dJ;AqGt7dA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ArGw7dF;AqGt7dE;EACE,sBAAA;ArGw7dJ;AqGp7dI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,kBAAA;EACA,wCAAA;ArGs7dN;AqGp7dM;EACE,eAAA;EACA,WAAA;EACA,YAAA;ArGs7dR;AqGl7dI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,kBAAA;EACA,wCAAA;ArGo7dN;AqGl7dM;EACE,eAAA;EACA,WAAA;EACA,YAAA;ArGo7dR;;AqG96dA;;;EAAA;AAMI;EACE,gBAAA;EACA,0BAAA;EACA,gBAAA;ArG+6dN;AqG56dI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;ArG86dN;AqG56dM;EACE,eAAA;EACA,yBAAA;EACA,6BAAA;ArG86dR;AqG56dQ;EACE,yCAAA;EACA,qCAAA;ArG86dV;AqG36dQ;EACE,qBAAA;EACA,8CAAA;ArG66dV;AqGz7dM;EAcE;GAAA;ArG+6dR;AqG76dQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,wBAAA;ArG+6dV;AqG36dU;EACE,OAAA;ArG66dZ;AqG36dY;EACE,gBAAA;EACA,0BAAA;EACA,kBAAA;ArG66dd;AqG16dY;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;ArG46dd;AqGp6dU;EACE,cAAA;ArGs6dZ;;AqG75dA;;;EAAA;AAIA;EACE,gBAAA;EACA,iBAAA;ArGg6dF;AqG95dE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;ArGg6dJ;AqG95dI;EACE,eAAA;EACA,WAAA;EACA,YAAA;ArGg6dN;AqG55dE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArG85dJ;AqGr5dE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,yCAAA;EACA,kBAAA;EACA,wCAAA;ArGu5dJ;AqGr5dI;EACE,eAAA;EACA,WAAA;EACA,YAAA;ArGu5dN;AqGn5dE;EACE,gBAAA;ArGq5dJ;AqGn5dI;EACE,eAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;ArGq5dN;AqGn5dM;EACE,0BAAA;ArGq5dR;AqGj5dI;EACE,eAAA;ArGm5dN;AqGj5dM;EACE,eAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;ArGm5dR;AqGh5dM;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,yBAAA;ArGk5dR;;AqG54dA;;;EAAA;AAIA;EACE,gBAAA;ArG+4dF;AqG74dE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;ArG+4dJ;AqG74dI;EACE,eAAA;EACA,WAAA;EACA,YAAA;ArG+4dN;AqG34dE;EACE,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,yBAAA;ArG64dJ;AqG34dI;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;ArG64dN;AqG14dI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;ArG44dN;AqG14dM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ArG44dR;;AqGt4dA;;;EAAA;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,yCAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;ArGy4dF;AqGv4dE;EACE,eAAA;EACA,WAAA;EACA,YAAA;ArGy4dJ;;AqGr4dA;;;EAAA;AAIA;EACE;IACE,wBAAA;ErGw4dF;EqGt4dA;IACE,4BAAA;ErGw4dF;EqGt4dA;IACE,2BAAA;ErGw4dF;AACF;AqGr4dA;EACE;IACE,mBAAA;IACA,UAAA;ErGu4dF;EqGr4dA;IACE,mBAAA;IACA,UAAA;ErGu4dF;AACF;AqGp4dA;;;EAAA;AAIA;EACE;IACE,uBAAA;ErGs4dF;EqGp4dE;IACE,eAAA;ErGs4dJ;EqGl4dA;IACE,eAAA;ErGo4dF;EqGj4dA;IACE,uBAAA;IACA,sBAAA;ErGm4dF;EqG53dA;IACE,eAAA;IACA,iBAAA;ErG83dF;EqG33dA;IACE,kBAAA;IACA,aAAA;ErG63dF;EqG13dI;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;ErG43dN;EqGz3dI;IACE,eAAA;ErG23dN;EqGx3dI;IACE,eAAA;ErG03dN;EqGt3dE;IACE,sBAAA;IACA,kBAAA;IACA,SAAA;ErGw3dJ;EqGt3dI;IACE,WAAA;IACA,YAAA;ErGw3dN;EqGl3dE;IACE,sBAAA;IACA,kBAAA;IACA,SAAA;ErGo3dJ;EqGl3dI;IACE,eAAA;IACA,WAAA;IACA,YAAA;ErGo3dN;EqG32dI;IACE,0BAAA;ErG62dN;EqG91dI;IACE,kBAAA;ErGg2dN;EqG91dM;IACE,eAAA;IACA,WAAA;IACA,YAAA;ErGg2dR;AACF;AqG11dA;;;EAAA;AAIA;;EAEE,0BAAA;EACA,mBAAA;ArG41dF;;AqGz1dA;;EAEE,0BAAA;EACA,mBAAA;ArG41dF;;AsG5pgBA;;;;;;;;;EAAA;AA8BA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AtG2ogBF;;AsGpogBA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AtGuogBF;;AsGpogBA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;AtGuogBF;;AsGpogBA;EACE,OAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AtGuogBF;;AsGpogBA;EACE,kBAAA;EACA,mBAAA;AtGuogBF;AsGrogBE;EAJF;IAKI,oBAAA;IACA,qBAAA;EtGwogBF;AACF;;AsGrogBA;EACE,gBAvDwB;EAwDxB,iBAAA;EACA,kBAAA;EACA,iBAAA,EAAA,4CAAA;AtGwogBF;;AsGrogBA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AtGwogBF;;AsGjogBA;EACE,qBAjFyB;EAkFzB,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,iFAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,sCAAA;AtGoogBF;AsGlogBE;EACE,yBAAA;AtGoogBJ;AsGjogBE;EACE,aAAA;AtGmogBJ;AsGhogBE;EACE,4EAAA;AtGkogBJ;AsG/ngBE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AtGiogBJ;AsG9ngBE;EACE,yBAAA;EACA,qBAAA;AtGgogBJ;AsG9ngBI;EACE,yBAAA;AtGgogBN;AsG7ngBI;EACE,cAAA;AtG+ngBN;;AsGtngBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;EACA,8EAAA;AtGyngBF;;AsGjngBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AtGongBF;;AsG7mgBA;EACE,mEAAA;EACA,yDAAA;AtGgngBF;AsG9mgBE;EACE,oCAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AtGgngBJ;AsG7mgBE;EACE,iDAAA;AtG+mgBJ;;AsGvmgBA;EACE,kBAAA;AtG0mgBF;;AsGvmgBA;EACE,gBAlLwB;EAmLxB,iBAAA;EACA,kBAAA;EACA,0BAAA;AtG0mgBF;AsGxmgBE;EANF;IAOI,yBAAA;EtG2mgBF;AACF;;AsGpmgBA;EACE,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,qBAAA;EACA,gBArMwB;EAsMxB,iBAAA;EACA,kBAAA;AtGumgBF;;AsGhmgBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;EACA,yBAAA;EACA,0FAAA;EACA,mBA7N0B;AtGg0gB5B;AsGjmgBE;EACE,yBAAA;AtGmmgBJ;;AsG3lgBA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AtG8lgBF;;AsG3lgBA;EACE,aAAA;EACA,mBAAA;AtG8lgBF;;AsG3lgBA;EACE,kBAAA;AtG8lgBF;;AsGvlgBA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;EACA,mCAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AtG0lgBF;AsGxlgBE;EACE,0BAAA;AtG0lgBJ;AsGvlgBE;EACE,+BAAA;AtGylgBJ;AsGtlgBE;EACE,aAAA;EACA,YAAA;AtGwlgBJ;;AsGhlgBA;EACE,cAAA;EACA,WAAA;AtGmlgBF;;AsGhlgBA;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;AtGmlgBF;;AsG5kgBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAxTuB;EAyTvB,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;AtG+kgBF;AsG7kgBE;EACE,oBAAA;EACA,YAAA;EACA,mBAAA;AtG+kgBJ;AsG5kgBE;EACE,6BAAA;EACA,4CAAA;AtG8kgBJ;AsG3kgBE;;;;EAEE,oBAAA;EACA,cAAA;AtG+kgBJ;;AsGvkgBA;EAGE,qBA3VyB;EA4VzB,YA/Ve;EAgWf,WAhWe;AtGw6gBjB;;AsGrkgBA;EACE,yBAAA;EACA,cAAA;AtGwkgBF;AsGtkgBE;EACE,YAAA;AtGwkgBJ;AsGrkgBE;EACE,qCAAA;EACA,sBAAA;EACA,UAAA;AtGukgBJ;AsGpkgBE;EACE,yBAAA;EACA,cAAA;AtGskgBJ;AsGpkgBI;EACE,yBAAA;EACA,cAAA;AtGskgBN;;AsGjkgBA;EACE,6BAAA;EACA,cAAA;AtGokgBF;AsGlkgBE;EACE,yBAAA;EACA,cAAA;AtGokgBJ;AsGjkgBE;EACE,6BAAA;EACA,cAAA;AtGmkgBJ;AsGhkgBE;EACE,cAAA;EACA,qBAAA;AtGkkgBJ;AsGhkgBI;EACE,yBAAA;EACA,cAAA;AtGkkgBN;AsG/jgBI;EACE,6BAAA;EACA,cAAA;AtGikgBN;;AsG5jgBA;EACE,oBAAA;AtG+jgBF;;AsG5jgBA;EACE,mBAAA;AtG+jgBF;;AsG5jgBA;EACE,kBAAA;AtG+jgBF;;AsGxjgBA;EAGE,UAAA;EACA,sBAAA;EACA,6BAAA;EACA,YA/akB;EAgblB,WAhbkB;EAiblB,kBA9auB;AtGu+gBzB;AsGvjgBE;EACE,yBAAA;EACA,sBAAA;AtGyjgBJ;AsGtjgBE;EACE,yBAAA;AtGwjgBJ;AsGtjgBI;EACE,yBAAA;EACA,yBAAA;AtGwjgBN;;AsGnjgBA;EACE,YAlckB;EAmclB,WAnckB;AtGy/gBpB;;AsG/igBA;EAGE,qBA5cyB;EA6czB,YAhde;EAidf,kBAAA;EACA,WAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;AtGgjgBF;AsG9igBE;EACE,yBAAA;EACA,cAAA;AtGgjgBJ;AsG7igBE;EACE,6BAAA;EACA,cAAA;EACA,mBAAA;AtG+igBJ;AsG5igBE;EACE,cAAA;EACA,qBAAA;AtG8igBJ;AsG5igBI;EACE,yBAAA;EACA,cAAA;AtG8igBN;AsG3igBI;EACE,6BAAA;EACA,cAAA;AtG6igBN;;AsGxigBA;EACE,mBAAA;EACA,gBAAA;AtG2igBF;;AsGpigBA;EACE,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBA1fuB;EA2fvB,mFAAA;EACA,gBAAA;AtGuigBF;AsGrigBE;EACE,yBAAA;EACA,qBAAA;AtGuigBJ;;AsGnigBA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AtGsigBF;AsGpigBE;EACE,yBAAA;AtGsigBJ;;AsGligBA;EACE,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AtGqigBF;AsGnigBE;EACE,yBAAA;AtGqigBJ;AsGligBE;EACE,yBAAA;AtGoigBJ;;AsGhigBA;EACE,iBAAA;AtGmigBF;;AsG5hgBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AtG+hgBF;;AsGxhgBA;EACE,WAAA;EACA,YAAA;EACA,qBA5jByB;EA6jBzB,mCAAA;EACA,kEAAA;EACA,oBAAA;AtG2hgBF;;AsGphgBA;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EAGA,mCAAA;AtGqhgBF;AsGlhgBE;EACE,wBAAA;AtGohgBJ;;AsGhhgBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AtGmhgBF;;AsG5ggBA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,8BAAA;AtG+ggBF;;AsG5ggBA;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;EACA,qDAAA;AtG+ggBF;;AsG5ggBA;EACE;IAAK,yBAAA;EtGghgBL;AACF;AsG9ggBA;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;AtGghgBF;;AsG7ggBA;EACE,YAAA;AtGghgBF;;AsG7ggBA;EACE,aAAA;AtGghgBF;AsG9ggBE;EACE,kBAAA;AtGghgBJ;;AsG5ggBA;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,8BAAA;AtG+ggBF;;AsGxggBA;EACE,WAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AtG2ggBF;;AsGpggBA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;AtGuggBF;AsGpggBE;EACE,mBAAA;AtGsggBJ;;AsG9/fA;EACE,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;AtGiggBF;AsG//fE;EACE,oBAAA;EACA,uBAAA;AtGiggBJ;;AsGz/fA;EACE,WAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AtG4/fF;;AsGr/fA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AtGw/fF;;AsGr/fA;EACE,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AtGw/fF;;AuGtuhBA;EACE,qDAAA;EACA,gBAAA;AvGyuhBF;;AuGruhBA;EACE,oDAAA;EACA,gDAAA;EACA,gBAAA;AvGwuhBF;;AuGpuhBA;EACE,uDAAA;AvGuuhBF;;AuGjuhBA;EACE,iEAAA;EACA,wEAAA;EACA,2CAAA;AvGouhBF;;AuGhuhBA;EACE,0CAAA;EACA,wCAAA;EACA,2CAAA;AvGmuhBF;;AuG/thBA;EACE,wBAAA;AvGkuhBF;;AuG9thBA;EACE,wBAAA;AvGiuhBF;;AuG3thBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yCAAA;EACA,iBAAA;AvG8thBF;AuG5thBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AvG8thBJ;AuG3thBE;EACE,kEAAA;EACA,wBAAA;EACA,wEAAA;AvG6thBJ;AuG1thBE;EACE,0CAAA;EACA,2BAAA;EACA,2EAAA;AvG4thBJ;AuGzthBE;EACE,yEAAA;EACA,wCAAA;EACA,gDAAA;AvG2thBJ;AuGxthBE;EACE,yEAAA;EACA,wCAAA;EACA,gDAAA;AvG0thBJ;AuGvthBE;EACE,kEAAA;EACA,wBAAA;EACA,wEAAA;AvGythBJ;;AwGpyhBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AxGuyhBF;;AwGryhBA;EACE,2BAAA;AxGwyhBF;;AwGryhBA;EACE,2BAAA;AxGwyhBF;;AyGl0hBA,0BAAA;AACA;EACE,qBAAA;EACA,kCAAA;AzGq0hBF;;AyGl0hBA;EACE,qCAAA;EACA,gBAAA;EACA,WAAA;AzGq0hBF;;AyGj0hBA;EACE,8EAAA;EACA,0BAAA;EACA,+CAAA;AzGo0hBF;;AyGj0hBA;EACE;IAAG,0BAAA;EzGq0hBH;EyGp0hBA;IAAI,6BAAA;EzGu0hBJ;EyGt0hBA;IAAK,0BAAA;EzGy0hBL;AACF;AyGv0hBA;EACE,gBAAA;EACA,aAAA;AzGy0hBF;;AyGr0hBA,mBAAA;AACA;EACE,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,iBAAA;AzGw0hBF;AyGt0hBE;EACE,uBAAA;EACA,0BAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,kCAAA;AzGw0hBJ;AyGr0hBE;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,kGAAA;EACA,2BAAA;EACA,iBAAA;AzGu0hBJ;AyGr0hBI;EACE,uBAAA;AzGu0hBN;AyGp0hBI;EACE,uBAAA;AzGs0hBN;;AyGh0hBA;EACE,wCAAA;AzGm0hBF;AyGj0hBE;EACE,6CAAA;AzGm0hBJ;AyGh0hBE;EACE,4FAAA;AzGk0hBJ;;AyG9zhBA;EACE,mFAAA;EACA,eAAA;AzGi0hBF;;AyG7zhBA;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;AzGg0hBF;;AyG7zhBA;EACE,0BAAA;EACA,uBAAA;EACA,eAAA;EACA,6BAAA;EACA,yBAAA;AzGg0hBF;;AyG7zhBA;EACE,iBAAA;EACA,gDAAA;EACA,qBAAA;AzGg0hBF;;AyG7zhBA;EACE,kCAAA;EACA,2BAAA;EACA,kDAAA;EACA,2CAAA;AzGg0hBF;;AyG7zhBA,8BAAA;AAEA,oCAAA;AACA;EACE,kBAAA;EACA,+BAAA;AzG+zhBF;;AyG5zhBA;EACE,4DAAA;AzG+zhBF;;AyG5zhBA,YAAA;AAEA;EACE,aAAA;AzG8zhBF;AyG5zhBE;EACE,uBAAA;EACA,kBAAA;AzG8zhBJ;;AyG1zhBA;EACE,aAAA;AzG6zhBF;AyG3zhBE;EACE,uBAAA;EACA,kBAAA;AzG6zhBJ;;AyGzzhBA;EACE,aAAA;AzG4zhBF;AyG1zhBE;EACE,uBAAA;EACA,kBAAA;AzG4zhBJ;;AyGxzhBA;EACE,aAAA;AzG2zhBF;AyGzzhBE;EACE,uBAAA;EACA,kBAAA;AzG2zhBJ;;AyGvzhBA;EACE,6BAAA;AzG0zhBF;;AyGvzhBA;EACE,kCAAA;AzG0zhBF;;AyGvzhBA;EACE,kBAAA;EACA,8BAAA;AzG0zhBF;;AyGvzhBA;EACE,kBAAA;EACA,+BAAA;AzG0zhBF;;AyGvzhBA;EACE,wDAAA;AzG0zhBF;;AyGvzhBA;EACE,kBAAA;EACA,kCAAA;AzG0zhBF;;AyGvzhBA;EACE,kBAAA;EACA,gCAAA;AzG0zhBF;;AyGvzhBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AzG0zhBF;;AyGvzhBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mUAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;AzG0zhBF;;AyGxzhBA,wCAAA;AAEA,iCAAA;AACA;EACE,YAAA;EACA,wBAAA;AzG0zhBF;;AyGxzhBA;EACE,WAAA;EACA,UAAA;EACA,0BAAA;EACA,4BAAA;AzG2zhBF;AyG1zhBE;EACE,gBAAA;AzG4zhBJ;;AyGxzhBA;EACE,WAAA;AzG2zhBF;;AyGxzhBA;EACE,YAAA;EACA,qEAAA;AzG2zhBF;;AyGtzhBA,qCAAA;AAGA,wBAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,0CAAA;EACA,sBAAA;EACA,UAAA;AzGuzhBF;;AyGpzhBA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AzGuzhBF;;AyGpzhBA,YAAA;AACA;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;AzGuzhBF;;AyGpzhBA;EACE,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AzGuzhBF;;AyGpzhBA;EACE,kBAAA;EACA,YAAA;EACA,gDAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,eAAA;AzGuzhBF;;AyGpzhBA;EACE,mBAAA;AzGuzhBF;;AyGpzhBA;EACE,aAAA;AzGuzhBF;;AyGpzhBA;EACE,eAAA;AzGuzhBF;;AyGpzhBA;EACE,uBAAA;EACA,cAAA;AzGuzhBF;;AyGpzhBA;EACE,QAAA;AzGuzhBF;;AyGpzhBA;EACE,sBAAA;EACA,uBAAA;EACA,4BAAA;AzGuzhBF;;AyGpzhBA;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;AzGuzhBF;;AyGpzhBA;;EAEE,kCAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;AzGuzhBF;;AyGpzhBA;EACE,gBAAA;AzGuzhBF;;AyGpzhBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AzGuzhBF;;AyGpzhBA;EACE,iBAAA;AzGuzhBF;;AyGpzhBA;EACE,0DAAA;EACA,YAAA;EACA,WAAA;AzGuzhBF;;AyGpzhBA;EACE,0DAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;AzGuzhBF;;AyGpzhBA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,+CAAA;AzGuzhBF;;AyGpzhBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AzGuzhBF;;AyGrzhBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,4BAAA;AzGwzhBF;;AyGtzhBA;EACE,YAAA;EACA,kBAAA;AzGyzhBF;;AyGtzhBA;EACE,mBAAA;AzGyzhBF;;AyGtzhBA;;;;EAIE,gBAAA;EACA,eAAA;AzGyzhBF;;AyGtzhBA;EACE,+BAAA;AzGyzhBF;;AyGtzhBA;EACE,+BAAA;AzGyzhBF;;AyGtzhBA;;EAEE,2BAAA;EACA,mBAAA;AzGyzhBF;;AyGtzhBA;;EAEE,sBAAA;AzGyzhBF;;AyGtzhBA;;EAEE,0BAAA;EACA,mBAAA;AzGyzhBF;;AyGtzhBA;EACE,SAAA;AzGyzhBF;;AyGtzhBA;EACE,UAAA;AzGyzhBF;;AyGtzhBA;EACE,SAAA;EACA,oBAAA;AzGyzhBF;;AyGtzhBA;EACE,yBAAA;AzGyzhBF;;AyGtzhBA;EACE,UAAA;AzGyzhBF;;AyGtzhBA;EACE,oCAAA;EACA,iBAAA;AzGyzhBF;;AyGtzhBA;EACE,uBAAA;EACA,uBAAA;AzGyzhBF;;AyGtzhBA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AzGyzhBF;;AyGtzhBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AzGyzhBF;;AyGtzhBA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AzGyzhBF;;AyGtzhBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AzGyzhBF;;AyGvzhBA;EACE,SAAA;EACA,sCAAA;AzG0zhBF;;AyGxzhBA;EACE,SAAA;EACA,sCAAA;AzG2zhBF;;AyGzzhBA;EACE,UAAA;EACA,sCAAA;AzG4zhBF;;AyG1zhBA;EACE,UAAA;EACA,sCAAA;AzG6zhBF;;AyG3zhBA;EACE;IACE,mBAAA;EzG8zhBF;EyG5zhBA;IACE,mBAAA;EzG8zhBF;AACF;AyG5zhBA;EACE;IACE,mBAAA;EzG8zhBF;EyG5zhBA;IACE,mBAAA;EzG8zhBF;AACF;AyG5zhBA;EACE;IACE,0BAAA;EzG8zhBF;EyG5zhBA;IACE,6BAAA;EzG8zhBF;AACF;AyG5zhBA,4BAAA;AAEA,wBAAA;AACA;EACE;IACE,2DAAA;EzG6zhBF;EyG3zhBA;IACE,4DAAA;EzG6zhBF;AACF;AyG1zhBA;EACE;IACE,2DAAA;EzG4zhBF;EyG1zhBA;IACE,uDAAA;EzG4zhBF;AACF;AyGzzhBA;EACE;IACE,wDAAA;EzG2zhBF;EyGzzhBA;IACE,eAAA;EzG2zhBF;AACF;AyGxzhBA;EACE;IACE,4DAAA;EzG0zhBF;EyGxzhBA;IACE,wDAAA;EzG0zhBF;AACF;AyGtzhBA;EACE;IACE,4DAAA;EzGwzhBF;EyGtzhBA;IACE,wDAAA;EzGwzhBF;EyGtzhBA;IACE,4DAAA;EzGwzhBF;AACF;AyGpzhBA,4BAAA;AvGzkBA;EACE,QAAA;EACA,SAAA;EACA,gCAAA;AFg4iBF;;AE93iBA;EACE,MAAA;EACA,QAAA;EACA,WAAA;AFi4iBF;;AE/3iBA;EACE,SAAA;EACA,QAAA;EACA,WAAA;AFk4iBF;;AEh4iBA;EACE,MAAA;EACA,QAAA;EACA,WAAA;AFm4iBF;;AEj4iBA;EACE,SAAA;EACA,QAAA;EACA,WAAA;AFo4iBF;;AEl4iBA;EACE,SAAA;EACA,UAAA;AFq4iBF;;AEn4iBA;EACE,SAAA;EACA,WAAA;AFs4iBF;;AEp4iBA;EACE,WAAA;EACA,YAAA;AFu4iBF;;AEr4iBA;EACE,YAAA;EACA,UAAA;AFw4iBF;;AEr4iBA,iBAAA;AACA;EACE,iBAAA;AFw4iBF;;AEt4iBA;EACE,qBAAA;AFy4iBF;;AEv4iBA;;EAEE,cAAA;AF04iBF;;AEx4iBA;EACE,cAAA;EACA,qBAAA;AF24iBF;;AEz4iBA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;AF44iBF;;AE14iBA;;EAEE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;AF64iBF;;AE34iBA;;yDAAA;AAGA;EACE,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AF84iBF;;AE54iBA;EACE,oBAAA;EACA,eAAA;EACA,eAAA;AF+4iBF;;AE74iBA;EACE,sBAAA;AFg5iBF;;AE94iBA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,4BAAA;EACA,qBAAA;EACA,4BAAA;EACA,cAAA;AFi5iBF;;AE/4iBA;EACE,4BAAA;EACA,UAAA;EACA,eAAA;AFk5iBF;;AEh5iBA,iHAAA;AACA;EACE,0DAAA;AFm5iBF;;AEj5iBA,kHAAA;AACA;EACE,0DAAA;AFo5iBF;;AEl5iBA,2GAAA;AACA;EACE,0DAAA;AFq5iBF;;AEn5iBA,0HAAA;AACA;EACE,0DAAA;AFs5iBF;;AEp5iBA;;EAEE,YAAA;EACA,iBAAA;EACA,kBAAA;AFu5iBF;;AEr5iBA;;EAEE,UAAA;EACA,iBAAA;EACA,kBAAA;AFw5iBF;;AEt5iBA;EACE,yBAAA;EACA,oBAAA;AFy5iBF;;AEv5iBA;EACE,yBAAA;AF05iBF;;AEx5iBA;EACE,yBAAA;AF25iBF;;AEz5iBA;EACE,yBAAA;AF45iBF;;AE15iBA;EACE,yBAAA;AF65iBF;;AE35iBA;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;AF85iBF;;AE35iBA,sBAAA;AACA;EACE;IACE,yBAAA;IACA,WAAA;EF85iBF;EE55iBA;IACE,aAAA;IACA,WAAA;EF85iBF;AACF;AE55iBA;EACE;IACE,yBAAA;IACA,WAAA;EF85iBF;EE55iBA;IACE,aAAA;IACA,WAAA;EF85iBF;AACF;AE55iBA;EACE;IACE,4BAAA;IACA,WAAA;EF85iBF;AACF;AClljBA;EACE,sBAAA;ADoljBF;;ACjljBA,gCAAA;AAEA;EACE,oCAAA;EACA,qBAAA;ADmljBF;;AChljBA;EACE,mBAAA;EACA,iBAAA;ADmljBF;;AChljBA;wFAAA;AAEA;;EAEE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;ADmljBF;;AChljBA;;EAEE,YAAA;ADmljBF;;AC/kjBA;EACE,gCAAA;EACA,4BAAA;EACA,8BAAA;EACA,0BAAA;ADkljBF;;AC/kjBA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,aAAA;EACA,kCAAA;ADkljBF;;AC/kjBA;EACE,YAAA;ADkljBF;;AChljBA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,aAAA;EACA,kCAAA;ADmljBF;;AChljBA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,aAAA;EACA,kCAAA;ADmljBF;;AChljBA;EACE,2BAAA;ADmljBF;;AChljBA;EACE,aAAA;EACA,oBAAA;EACA,aAAA;EACA,kCAAA;ADmljBF;;AChljBA;EACE,+BAAA;EACA,aAAA;EACA,kCAAA;EACA,kBAAA;ADmljBF;;AChljBA;EACE,kBAAA;ADmljBF;;AChljBA;EACE,aAAA;EACA,sCAAA;EACA,kBAAA;ADmljBF;;AChljBA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;ADmljBF;;A0GjsjBA;EhGyEQ,iDAAA;AV4njBR;A0G/rjBI;EAEE,aAAA;A1GgsjBN;;A0G1rjBA;EhG2DQ,8CAAA;AVmojBR;A0GxrjBI;EACE,wBAAA;A1G0rjBN;;A2G7sjBA,uCAAA;AACA;EnGiOM,kDAAA;EAAA,6CAAA;EAAA,uDAAA;EAAA,0DAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,qDAAA;EAAA,gDAAA;EAAA,0DAAA;EAAA,kDAAA;EAAA,4DAAA;EAAA,wDAAA;EAAA,gEAAA;EAAA,oDAAA;EAAA,8DAAA;EAAA,0DAAA;EAAA,kEAAA;EAAA,kDAAA;EAAA,0DAAA;EAAA,mDAAA;EAAA,6DAAA;EAAA,yDAAA;EAAA,iEAAA;EAAA,+CAAA;EAAA,uDAAA;EAAA,+CAAA;EAAA,yDAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA,6CAAA;EAAA,iDAAA;EAAA,2DAAA;EAAA,uDAAA;EAAA,2DAAA;EAAA,8CAAA;EAAA,+CAAA;EAAA,sDAAA;EAAA,yDAAA;EAAA,8DAAA;EAAA,iEAAA;EAAA,6DAAA;EAAA,gEAAA;EAAA,mDAAA;EAAA,oDAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,0DAAA;EAAA,sDAAA;EAAA,0DAAA;EAAA,oCAAA;EAAA,4BAAA;EAoDA,8HAAA;EAAA,+HAAA;EAAA,+HAAA;EAAA,iIAAA;EAAA,iIAAA;EAAA,kIAAA;EAQA,kCAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,6CAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,yCAAA;EAAA,6BAAA;EAAA,wBAAA;EAAA,2BAAA;EAQA,2CAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,2CAAA;EA7FE,0BAAA;EAAA,6BAAA;EAAA,oCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,oCAAA;EAAA,kCAAA;EAAA,qCAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA,0BAAA;EAAA,iCAAA;AR6ljBR;;A2G7wjBA;EnGgLQ,0BAAA;EAAA,6BAAA;EAAA,oCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,oCAAA;EAAA,kCAAA;EAAA,qCAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA,0BAAA;EAAA,iCAAA;AR4mjBR;;A2G3wjBA;EACE,2BAAA;EACA,2BAAA;A3G8wjBF;;A2G3wjBA;EACE,sBAAA;A3G8wjBF;;AAnzjBA;EACE,YAAA;EACA,SAAA;EACA,UAAA;AAszjBF;;AAnzjBA;EACE,iBAAA;EACA,+BAAA;AAszjBF;;AAnzjBA;EACE,kBAAA;AAszjBF;;AAnzjBA;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;AAszjBF;;AAlzjBE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;AAqzjBJ;;AAjzjBA;EACE,2BAAA;EACA,2CAAA;AAozjBF;;AAlzjBA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAqzjBF;;AAnzjBA;EACE,uBAAA;EACA,sBAAA;AAszjBF;;AApzjBA;EACE,wBAAA;EACA,oBAAA;AAuzjBF;;AArzjBA;EACE,wBAAA;EACA,sBAAA;AAwzjBF;;AAtzjBA;EACE,wBAAA;EACA,sBAAA;AAyzjBF;;AAvzjBA;EACE,yBAAA;EACA,sBAAA;AA0zjBF;;AAxzjBA;EACE,yBAAA;EACA,sBAAA;AA2zjBF;;AAzzjBA;EACE,yBAAA;EACA,sBAAA;AA4zjBF;;AA1zjBA;EACE,yBAAA;EACA,sBAAA;AA6zjBF;;AA3zjBA;EACE,yBAAA;EACA,sBAAA;AA8zjBF;;AA5zjBA;EACE,yBAAA;EACA,sBAAA;AA+zjBF;;AA7zjBA;EACE,yBAAA;EACA,sBAAA;AAg0jBF;;AA9zjBA;EACE,yBAAA;EACA,mBAAA;AAi0jBF;;AA/zjBA;EACE;IACE,UAAA;EAk0jBF;EAh0jBA;IACE,UAAA;EAk0jBF;AACF;AAh0jBA;EACE,aAAA;AAk0jBF","sourcesContent":["@use \"./fonts\"; // load local fonts definitions\n@use \"./theme\" as theme; // load theme variables to override values\n@use '@angular/material' as mat;\n// then load de global styles with the overrides\n@use \"@vision/viewer-components/styles/globals\" with (\n    $ortho-status-preview-color: theme.$ortho-status-preview-color,\n    $ortho-status-preview-text-color: theme.$ortho-status-preview-text-color ,\n);\n\n\n@use \"@vision/viewer-components/styles/viewer-global-styles\"; // viewer library global styles\n@use \"./material-custom-styles\";\n@use \"./auth-styles\";\n@use \"./home-styles\";\n@use \"./custom-styles\";\n\nhtml, body {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  min-height: 100vh;\n  font-family: Roboto, sans-serif;\n}\n\n.unsupportedMessage {\n  visibility: hidden;\n}\n\n.lds-spinner {\n  color: gray;\n  display: inline-block;\n  position: absolute;\n  width: 80px;\n  height: 80px;\n  top: 50%;\n}\n\n.mat-mdc-dialog-container {\n  .lds-spinner {\n    position: relative;\n    left: 0;\n    top: 0;\n  }\n}\n\n.lds-spinner div {\n  transform-origin: 40px 40px;\n  animation: lds-spinner 1.2s linear infinite;\n}\n.lds-spinner div:after {\n  content: \" \";\n  display: block;\n  position: absolute;\n  top: 3px;\n  left: 37px;\n  width: 6px;\n  height: 18px;\n  border-radius: 20%;\n  background: black;\n}\n.lds-spinner div:nth-child(1) {\n  transform: rotate(0deg);\n  animation-delay: -1.1s;\n}\n.lds-spinner div:nth-child(2) {\n  transform: rotate(30deg);\n  animation-delay: -1s;\n}\n.lds-spinner div:nth-child(3) {\n  transform: rotate(60deg);\n  animation-delay: -0.9s;\n}\n.lds-spinner div:nth-child(4) {\n  transform: rotate(90deg);\n  animation-delay: -0.8s;\n}\n.lds-spinner div:nth-child(5) {\n  transform: rotate(120deg);\n  animation-delay: -0.7s;\n}\n.lds-spinner div:nth-child(6) {\n  transform: rotate(150deg);\n  animation-delay: -0.6s;\n}\n.lds-spinner div:nth-child(7) {\n  transform: rotate(180deg);\n  animation-delay: -0.5s;\n}\n.lds-spinner div:nth-child(8) {\n  transform: rotate(210deg);\n  animation-delay: -0.4s;\n}\n.lds-spinner div:nth-child(9) {\n  transform: rotate(240deg);\n  animation-delay: -0.3s;\n}\n.lds-spinner div:nth-child(10) {\n  transform: rotate(270deg);\n  animation-delay: -0.2s;\n}\n.lds-spinner div:nth-child(11) {\n  transform: rotate(300deg);\n  animation-delay: -0.1s;\n}\n.lds-spinner div:nth-child(12) {\n  transform: rotate(330deg);\n  animation-delay: 0s;\n}\n@keyframes lds-spinner {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.loaded {\n  display: none;\n}\n\n","/*External css imports for viewer components/core map*/\n@import 'ol/ol.css';\n@import 'ol-ext/control/Status.css';\n@import 'ol-ext/control/LayerSwitcher.css';\n@import 'ol-ext/control/Overview.css';\n@import 'ol-ext/overlay/Popup.css';\n@import 'ol-ext/control/Swipe.css';\n@import 'ol-contextmenu/dist/ol-contextmenu.css';\n@import 'ngx-toastr/toastr';\n@import \"tippy.js/dist/tippy.css\";\n\n.tippy-box {\n  background-color: #555;\n}\n\n/*Override toast default styles*/\n\n.toast-progress {\n  background-color: #FFFFFF !important;\n  opacity: 1 !important;\n}\n\n.toast-container {\n  /*  height: 70px; */\n  padding-top: 40px;\n}\n\n/* Compact top-right warning card. The toast id doubles as its CSS class\n   (see VisionToastComponent.createToast), so every id using this look is listed here. */\n.toast-warning-expire,\n.toast-warning-geofencing {\n  width: 250px;\n  font-size: 12px;\n  margin-top: 30px;\n  color: white;\n  border-radius: 4px;\n  padding: 5px;\n}\n\n.toast-warning-expire .toast-container,\n.toast-warning-geofencing .toast-container {\n  height: 70px;\n}\n\n\n.toast-warning {\n  background-size: 16px !important;\n  background-repeat: no-repeat;\n  background-origin: content-box;\n  background-position-y: 5px;\n}\n\n.download-imagery-warning {\n  width: 300px;\n  color: white;\n  border-radius: 4px;\n  pointer-events: none !important;\n  display: flex;\n  justify-content: center !important;\n}\n\n.download-imagery-warning .toast-container {\n  height: 70px;\n}\n.download-image-toast, .screenshot-download-toast {\n  width: 300px;\n  color: white;\n  border-radius: 4px;\n  pointer-events: none !important;\n  display: flex;\n  justify-content: center !important;\n}\n\n.damage-assessment-toast, .screenshot-download-toast {\n  width: 300px;\n  color: white;\n  border-radius: 4px;\n  pointer-events: none !important;\n  display: flex;\n  justify-content: center !important;\n}\n\n.toast-container .ngx-toastr {\n  box-shadow: none !important;\n}\n\n.toast-bottom-center {\n  height: 145px;\n  padding-bottom: 40px;\n  display: flex;\n  justify-content: center !important;\n}\n\n.download-toast .toast-container .ngx-toastr {\n  pointer-events: none !important;\n  display: flex;\n  justify-content: center !important;\n  text-align: center;\n}\n\n.toast-warning .toast-text {\n  padding-left: 20px;\n}\n\n.toast-text {\n  display: flex;\n  justify-content: flex-start !important;\n  align-self: center;\n}\n\nbutton.toast-close-button {\n  position: relative;\n  top: -20px;\n  left: 7px;\n}\n\n","/* based on angular-toastr css https://github.com/Foxandxss/angular-toastr/blob/cb508fe6801d6b288d3afc525bb40fee1b101650/dist/angular-toastr.css */\n\n/* position */\n.toast-center-center {\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.toast-top-center {\n  top: 0;\n  right: 0;\n  width: 100%;\n}\n.toast-bottom-center {\n  bottom: 0;\n  right: 0;\n  width: 100%;\n}\n.toast-top-full-width {\n  top: 0;\n  right: 0;\n  width: 100%;\n}\n.toast-bottom-full-width {\n  bottom: 0;\n  right: 0;\n  width: 100%;\n}\n.toast-top-left {\n  top: 12px;\n  left: 12px;\n}\n.toast-top-right {\n  top: 12px;\n  right: 12px;\n}\n.toast-bottom-right {\n  right: 12px;\n  bottom: 12px;\n}\n.toast-bottom-left {\n  bottom: 12px;\n  left: 12px;\n}\n\n/* toast styles */\n.toast-title {\n  font-weight: bold;\n}\n.toast-message {\n  word-wrap: break-word;\n}\n.toast-message a,\n.toast-message label {\n  color: #FFFFFF;\n}\n.toast-message a:hover {\n  color: #CCCCCC;\n  text-decoration: none;\n}\n.toast-close-button {\n  position: relative;\n  right: -0.3em;\n  top: -0.3em;\n  float: right;\n  font-size: 20px;\n  font-weight: bold;\n  color: #FFFFFF;\n  text-shadow: 0 1px 0 #ffffff;\n  /* opacity: 0.8; */\n}\n.toast-close-button:hover,\n.toast-close-button:focus {\n  color: #000000;\n  text-decoration: none;\n  cursor: pointer;\n  opacity: 0.4;\n}\n/*Additional properties for button version\n iOS requires the button element instead of an anchor tag.\n If you want the anchor version, it requires `href=\"#\"`.*/\nbutton.toast-close-button {\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n}\n.toast-container {\n  pointer-events: none;\n  position: fixed;\n  z-index: 999999;\n}\n.toast-container * {\n  box-sizing: border-box;\n}\n.toast-container .ngx-toastr {\n  position: relative;\n  overflow: hidden;\n  margin: 0 0 6px;\n  padding: 15px 15px 15px 50px;\n  width: 300px;\n  border-radius: 3px 3px 3px 3px;\n  background-position: 15px center;\n  background-repeat: no-repeat;\n  background-size: 24px;\n  box-shadow: 0 0 12px #999999;\n  color: #FFFFFF;\n}\n.toast-container .ngx-toastr:hover {\n  box-shadow: 0 0 12px #000000;\n  opacity: 1;\n  cursor: pointer;\n}\n/* https://github.com/FortAwesome/Font-Awesome-Pro/blob/master/advanced-options/raw-svg/regular/info-circle.svg */\n.toast-info {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA1MTIgNTEyJyB3aWR0aD0nNTEyJyBoZWlnaHQ9JzUxMic+PHBhdGggZmlsbD0ncmdiKDI1NSwyNTUsMjU1KScgZD0nTTI1NiA4QzExOS4wNDMgOCA4IDExOS4wODMgOCAyNTZjMCAxMzYuOTk3IDExMS4wNDMgMjQ4IDI0OCAyNDhzMjQ4LTExMS4wMDMgMjQ4LTI0OEM1MDQgMTE5LjA4MyAzOTIuOTU3IDggMjU2IDh6bTAgMTEwYzIzLjE5NiAwIDQyIDE4LjgwNCA0MiA0MnMtMTguODA0IDQyLTQyIDQyLTQyLTE4LjgwNC00Mi00MiAxOC44MDQtNDIgNDItNDJ6bTU2IDI1NGMwIDYuNjI3LTUuMzczIDEyLTEyIDEyaC04OGMtNi42MjcgMC0xMi01LjM3My0xMi0xMnYtMjRjMC02LjYyNyA1LjM3My0xMiAxMi0xMmgxMnYtNjRoLTEyYy02LjYyNyAwLTEyLTUuMzczLTEyLTEydi0yNGMwLTYuNjI3IDUuMzczLTEyIDEyLTEyaDY0YzYuNjI3IDAgMTIgNS4zNzMgMTIgMTJ2MTAwaDEyYzYuNjI3IDAgMTIgNS4zNzMgMTIgMTJ2MjR6Jy8+PC9zdmc+\");\n}\n/* https://github.com/FortAwesome/Font-Awesome-Pro/blob/master/advanced-options/raw-svg/regular/times-circle.svg */\n.toast-error {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA1MTIgNTEyJyB3aWR0aD0nNTEyJyBoZWlnaHQ9JzUxMic+PHBhdGggZmlsbD0ncmdiKDI1NSwyNTUsMjU1KScgZD0nTTI1NiA4QzExOSA4IDggMTE5IDggMjU2czExMSAyNDggMjQ4IDI0OCAyNDgtMTExIDI0OC0yNDhTMzkzIDggMjU2IDh6bTEyMS42IDMxMy4xYzQuNyA0LjcgNC43IDEyLjMgMCAxN0wzMzggMzc3LjZjLTQuNyA0LjctMTIuMyA0LjctMTcgMEwyNTYgMzEybC02NS4xIDY1LjZjLTQuNyA0LjctMTIuMyA0LjctMTcgMEwxMzQuNCAzMzhjLTQuNy00LjctNC43LTEyLjMgMC0xN2w2NS42LTY1LTY1LjYtNjUuMWMtNC43LTQuNy00LjctMTIuMyAwLTE3bDM5LjYtMzkuNmM0LjctNC43IDEyLjMtNC43IDE3IDBsNjUgNjUuNyA2NS4xLTY1LjZjNC43LTQuNyAxMi4zLTQuNyAxNyAwbDM5LjYgMzkuNmM0LjcgNC43IDQuNyAxMi4zIDAgMTdMMzEyIDI1Nmw2NS42IDY1LjF6Jy8+PC9zdmc+\");\n}\n/* https://github.com/FortAwesome/Font-Awesome-Pro/blob/master/advanced-options/raw-svg/regular/check.svg */\n.toast-success {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA1MTIgNTEyJyB3aWR0aD0nNTEyJyBoZWlnaHQ9JzUxMic+PHBhdGggZmlsbD0ncmdiKDI1NSwyNTUsMjU1KScgZD0nTTE3My44OTggNDM5LjQwNGwtMTY2LjQtMTY2LjRjLTkuOTk3LTkuOTk3LTkuOTk3LTI2LjIwNiAwLTM2LjIwNGwzNi4yMDMtMzYuMjA0YzkuOTk3LTkuOTk4IDI2LjIwNy05Ljk5OCAzNi4yMDQgMEwxOTIgMzEyLjY5IDQzMi4wOTUgNzIuNTk2YzkuOTk3LTkuOTk3IDI2LjIwNy05Ljk5NyAzNi4yMDQgMGwzNi4yMDMgMzYuMjA0YzkuOTk3IDkuOTk3IDkuOTk3IDI2LjIwNiAwIDM2LjIwNGwtMjk0LjQgMjk0LjQwMWMtOS45OTggOS45OTctMjYuMjA3IDkuOTk3LTM2LjIwNC0uMDAxeicvPjwvc3ZnPg==\");\n}\n/* https://github.com/FortAwesome/Font-Awesome-Pro/blob/master/advanced-options/raw-svg/regular/exclamation-triangle.svg */\n.toast-warning {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA1NzYgNTEyJyB3aWR0aD0nNTc2JyBoZWlnaHQ9JzUxMic+PHBhdGggZmlsbD0ncmdiKDI1NSwyNTUsMjU1KScgZD0nTTU2OS41MTcgNDQwLjAxM0M1ODcuOTc1IDQ3Mi4wMDcgNTY0LjgwNiA1MTIgNTI3Ljk0IDUxMkg0OC4wNTRjLTM2LjkzNyAwLTU5Ljk5OS00MC4wNTUtNDEuNTc3LTcxLjk4N0wyNDYuNDIzIDIzLjk4NWMxOC40NjctMzIuMDA5IDY0LjcyLTMxLjk1MSA4My4xNTQgMGwyMzkuOTQgNDE2LjAyOHpNMjg4IDM1NGMtMjUuNDA1IDAtNDYgMjAuNTk1LTQ2IDQ2czIwLjU5NSA0NiA0NiA0NiA0Ni0yMC41OTUgNDYtNDYtMjAuNTk1LTQ2LTQ2LTQ2em0tNDMuNjczLTE2NS4zNDZsNy40MTggMTM2Yy4zNDcgNi4zNjQgNS42MDkgMTEuMzQ2IDExLjk4MiAxMS4zNDZoNDguNTQ2YzYuMzczIDAgMTEuNjM1LTQuOTgyIDExLjk4Mi0xMS4zNDZsNy40MTgtMTM2Yy4zNzUtNi44NzQtNS4wOTgtMTIuNjU0LTExLjk4Mi0xMi42NTRoLTYzLjM4M2MtNi44ODQgMC0xMi4zNTYgNS43OC0xMS45ODEgMTIuNjU0eicvPjwvc3ZnPg==\");\n}\n.toast-container.toast-top-center .ngx-toastr,\n.toast-container.toast-bottom-center .ngx-toastr {\n  width: 300px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.toast-container.toast-top-full-width .ngx-toastr,\n.toast-container.toast-bottom-full-width .ngx-toastr {\n  width: 96%;\n  margin-left: auto;\n  margin-right: auto;\n}\n.ngx-toastr {\n  background-color: #030303;\n  pointer-events: auto;\n}\n.toast-success {\n  background-color: #51A351;\n}\n.toast-error {\n  background-color: #BD362F;\n}\n.toast-info {\n  background-color: #2F96B4;\n}\n.toast-warning {\n  background-color: #F89406;\n}\n.toast-progress {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 4px;\n  background-color: #000000;\n  opacity: 0.4;\n}\n\n/* Responsive Design */\n@media all and (max-width: 240px) {\n  .toast-container .ngx-toastr.div {\n    padding: 8px 8px 8px 50px;\n    width: 11em;\n  }\n  .toast-container .toast-close-button {\n    right: -0.2em;\n    top: -0.2em;\n  }\n}\n@media all and (min-width: 241px) and (max-width: 480px) {\n  .toast-container .ngx-toastr.div {\n    padding: 8px 8px 8px 50px;\n    width: 18em;\n  }\n  .toast-container .toast-close-button {\n    right: -0.2em;\n    top: -0.2em;\n  }\n}\n@media all and (min-width: 481px) and (max-width: 768px) {\n  .toast-container .ngx-toastr.div {\n    padding: 15px 15px 15px 50px;\n    width: 25em;\n  }\n}\n","/* Roboto - Normal (400) */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url('../assets/fonts/Roboto-Regular.woff2') format('woff2');\n}\n\n/* Roboto - Light (300) */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url('../assets/fonts/Roboto-Light.woff2') format('woff2');\n}\n\n/* Roboto - Medium (500) */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url('../assets/fonts/Roboto-Medium.woff2') format('woff2');\n}\n\n/* Roboto - Bold (700) */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url('../assets/fonts/Roboto-Bold.woff2') format('woff2');\n}\n\n/* Material Icons */\n@font-face {\n  font-family: 'Material Icons';\n  font-style: normal;\n  font-weight: 400;\n  font-display: block;\n  src: url('../assets/fonts/MaterialIcons-Regular.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Material Icons Outlined';\n  font-style: normal;\n  font-weight: 400;\n  font-display: block;\n  src: url('../assets/fonts/MaterialIconsOutlined-Regular.woff2') format('woff2');\n}\n\n.material-icons {\n  font-family: 'Material Icons', sans-serif;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  line-height: 1;\n  letter-spacing: normal;\n  text-transform: none;\n  display: inline-block;\n  white-space: nowrap;\n  word-wrap: normal;\n  direction: ltr;\n  -webkit-font-feature-settings: 'liga';\n  -webkit-font-smoothing: antialiased;\n}\n\n.material-icons-outlined {\n  font-family: 'Material Icons Outlined', sans-serif;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  line-height: 1;\n  letter-spacing: normal;\n  text-transform: none;\n  display: inline-block;\n  white-space: nowrap;\n  word-wrap: normal;\n  direction: ltr;\n  -webkit-font-feature-settings: 'liga';\n  -webkit-font-smoothing: antialiased;\n}\n","/* ==========  COLOR CUSTOMIZATION -- VDP ========== */\n\n$ortho-status-preview-color: #FFFFFF ;\n$ortho-status-preview-text-color: #414344 ;\n\n","/**\n * Re-export variables and palette modules.\n *\n * This file forwards the 'styles/variables' and 'styles/palette' modules,\n * making their members available to any file that imports _globals.scss.\n * This centralizes configuration and ensures consistent theming across the library.\n */\n@forward 'styles/variables';\n@forward 'styles/palette';\n\n","/**\n * Global Styles for the Library\n *\n * The following styles are loaded globally to ensure that Material classes and\n * theme customizations have the highest priority in the CSS cascade.\n *\n * We use the Sass module system (@use) for our custom styles to encapsulate scope\n * and avoid namespace collisions, while @import is used for legacy or third-party\n * libraries that are not modularized.\n */\n\n/* -------------------------------------------------------------------------\n * Global Material Customizations\n * -------------------------------------------------------------------------\n * Import custom Material styles that adjust the Material theme and component\n * appearances. These are loaded globally to ensure they take precedence.\n */\n//@use \"styles/viewer-material-global\";\n@use \"styles/custom-material\";\n@use \"styles/viewer-md-global\";\n@use \"styles/vx-tokens\";\n//\n///* Agent UI global styles */\n//@use \"styles/agent-ui-global\";\n\n/* Import Bootstrap styles.\n * Note: @import is used here because Bootstrap is not yet fully modularized\n * and we need to preserve its original cascade order.\n */\n@import \"bootstrap\";\n","/* -------------------------------------------------------------------------\n * Angular Material Theme Customization - Multi-Theme Support\n * -------------------------------------------------------------------------\n * This file sets up Material 3 theming with runtime theme switching support.\n *\n * Architecture:\n * - Base structural styles applied once to html element\n * - Theme-specific color variants via classes: .theme-brand, .theme-generic-a, .theme-generic-b\n * - Dark mode variants via .dark-mode class\n * - Total of 6 theme variants: 3 themes × 2 modes (light/dark)\n */\n\n@use \"@angular/material\" as mat;\n@use \"styles/globals\" as *;\n@use \"styles/theme-default-colors\" as default-theme;\n\n/* -------------------------------------------------------------------------\n * Base Structural Styles\n * Applied once to all themes - includes typography, density, and structure\n * ------------------------------------------------------------------------- */\nhtml {\n  color-scheme: light;\n  @include mat.theme(\n                  (\n                          typography: (\n                                  brand-family: \"Roboto\",\n                                  plain-family: \"Roboto\",\n                          ),\n                          density: 0,\n                  )\n  );\n\n  @include mat.system-classes();\n}\n\n.dark-mode {\n  color-scheme: dark;\n}\n\n/* Brand Theme - Light Mode (Default) */\n.theme-default {\n  @include mat.theme(\n                  (\n                          color: (\n                                  primary: default-theme.$primary-palette,\n                                  tertiary: default-theme.$tertiary-palette,\n                          ),\n                  )\n  );\n}\n\n/* Light Theme */\n.theme-generic-a {\n  @include mat.theme-overrides(\n                  (\n                          primary: #006c51,\n                          on-primary: #ffffff,\n                          primary-container: #92f6d0,\n                          on-primary-container: #002117,\n                          inverse-primary: #75d9b5,\n                          primary-fixed: #92f6d0,\n                          primary-fixed-dim: #75d9b5,\n                          on-primary-fixed: #002117,\n                          on-primary-fixed-variant: #00513d,\n                          secondary: #426557,\n                          on-secondary: #ffffff,\n                          secondary-container: #c4ebd9,\n                          on-secondary-container: #002117,\n                          secondary-fixed: #c4ebd9,\n                          secondary-fixed-dim: #a9cfbe,\n                          on-secondary-fixed: #002117,\n                          on-secondary-fixed-variant: #2b4d40,\n                          tertiary: #2f666f,\n                          on-tertiary: #ffffff,\n                          tertiary-container: #b5ecf6,\n                          on-tertiary-container: #001f24,\n                          tertiary-fixed: #b5ecf6,\n                          tertiary-fixed-dim: #99cfda,\n                          on-tertiary-fixed: #001f24,\n                          on-tertiary-fixed-variant: #104e57,\n                          background: #fcf9f7,\n                          on-background: #1c1b1b,\n                          surface: #fcf9f7,\n                          surface-dim: #dcd9d8,\n                          surface-bright: #fcf9f7,\n                          surface-container-lowest: #ffffff,\n                          surface-container-low: #f6f3f2,\n                          surface-container: #f0edec,\n                          surface-container-high: #ebe7e6,\n                          surface-container-highest: #e5e2e1,\n                          on-surface: #1c1b1b,\n                          shadow: #000000,\n                          scrim: #000000,\n                          surface-tint: #5a5f5d,\n                          inverse-surface: #313030,\n                          inverse-on-surface: #f3f0ef,\n                          outline: #747875,\n                          outline-variant: #c3c8c4,\n                          neutral: #787776,\n                          neutral10: #1c1b1b,\n                          error: #ba1a1a,\n                          error-container: #ffdad6,\n                          on-error: #ffffff,\n                          on-error-container: #410002,\n                          surface-variant: #dfe4df,\n                          on-surface-variant: #434845,\n                          neutral-variant: #737875,\n                          neutral-variant20: #2c322f,\n                          inverse-secondary: #a9cfbe,\n                          inverse-tertiary: #99cfda,\n                  )\n  );\n}\n\n/* Dark Theme */\n.dark-mode .theme-generic-a {\n  @include mat.theme-overrides(\n                  (\n                          primary: #75d9b5,\n                          on-primary: #003829,\n                          primary-container: #00513d,\n                          on-primary-container: #92f6d0,\n                          inverse-primary: #006c51,\n                          primary-fixed: #92f6d0,\n                          primary-fixed-dim: #75d9b5,\n                          on-primary-fixed: #002117,\n                          on-primary-fixed-variant: #00513d,\n                          secondary: #a9cfbe,\n                          on-secondary: #13362a,\n                          secondary-container: #2b4d40,\n                          on-secondary-container: #c4ebd9,\n                          secondary-fixed: #c4ebd9,\n                          secondary-fixed-dim: #a9cfbe,\n                          on-secondary-fixed: #002117,\n                          on-secondary-fixed-variant: #2b4d40,\n                          tertiary: #99cfda,\n                          on-tertiary: #00363d,\n                          tertiary-container: #104e57,\n                          on-tertiary-container: #b5ecf6,\n                          tertiary-fixed: #b5ecf6,\n                          tertiary-fixed-dim: #99cfda,\n                          on-tertiary-fixed: #001f24,\n                          on-tertiary-fixed-variant: #104e57,\n                          background: #131313,\n                          on-background: #e5e2e1,\n                          surface: #131313,\n                          surface-dim: #131313,\n                          surface-bright: #3a3939,\n                          surface-container-lowest: #0e0e0e,\n                          surface-container-low: #1c1b1b,\n                          surface-container: #201f1f,\n                          surface-container-high: #2a2a29,\n                          surface-container-highest: #353534,\n                          on-surface: #e5e2e1,\n                          shadow: #000000,\n                          scrim: #000000,\n                          surface-tint: #c3c8c4,\n                          inverse-surface: #e5e2e1,\n                          inverse-on-surface: #313030,\n                          outline: #8d928f,\n                          outline-variant: #434845,\n                          neutral: #787776,\n                          neutral10: #1c1b1b,\n                          error: #ffb4ab,\n                          error-container: #93000a,\n                          on-error: #690005,\n                          on-error-container: #ffdad6,\n                          surface-variant: #434845,\n                          on-surface-variant: #c3c8c4,\n                          neutral-variant: #737875,\n                          neutral-variant20: #2c322f,\n                          inverse-secondary: #426557,\n                          inverse-tertiary: #2f666f,\n                  )\n  );\n}\n\n/* -------------------------------------------------------------------------\n * Component-Specific Overrides\n * Applied to all themes\n * ------------------------------------------------------------------------- */\n.mat-toolbar-header {\n  @include mat.toolbar-overrides(\n                  (\n                          container-background-color: var(--mat-sys-primary-fixed-dim),\n                          container-text-color: var(--mat-sys-on-primary),\n                  )\n  );\n\n  .mat-mdc-icon-button {\n    color: inherit;\n\n    mat-icon {\n      color: inherit;\n    }\n  }\n}\n\n@include mat.button-toggle-overrides(\n                (\n                        shape: 20px,\n                        selected-state-text-color: var(--mat-sys-primary),\n                        selected-state-background-color: transparent,\n                )\n);\n\n@include mat.form-field-overrides(\n                (\n                        filled-container-color: transparent,\n                        filled-active-indicator-color: var(--mat-sys-outline),\n                        filled-focus-active-indicator-color: var(--mat-sys-primary),\n                )\n);\n\n@include mat.fab-overrides((\n        container-shape: 30px,\n));\n\n@include mat.slide-toggle-overrides((\n        selected-handle-size: 12px,\n        unselected-handle-size: 12px,\n        pressed-handle-size: 12px,\n        touch-target-size: 40px,\n        track-height: 22px,\n        track-width: 40px,\n        track-shape: 11px,\n        state-layer-size: 0px,\n        selected-handle-horizontal-margin: 0 22px,\n        unselected-handle-horizontal-margin: 0 6px,\n        selected-pressed-handle-horizontal-margin: 0 22px,\n        unselected-pressed-handle-horizontal-margin: 0 6px,\n        selected-handle-color: var(--mat-sys-secondary),\n        selected-hover-handle-color: var(--mat-sys-secondary),\n        selected-focus-handle-color: var(--mat-sys-secondary),\n        selected-pressed-handle-color: var(--mat-sys-secondary),\n        selected-track-color: var(--mat-sys-primary),\n        selected-hover-track-color: var(--mat-sys-primary),\n        selected-focus-track-color: var(--mat-sys-primary),\n        unselected-pressed-handle-color: var(--mat-sys-secondary),\n        unselected-handle-color: var(--mat-sys-secondary),\n        unselected-hover-handle-color: var(--mat-sys-secondary),\n        unselected-focus-handle-color: var(--mat-sys-secondary),\n));\n\n/* -------------------------------------------------------------------------\n * Override for surface variant cards overlays timeline etc\n * Applied to all themes\n * ------------------------------------------------------------------------- */\n\n.inverse-surface {\n\n  --mat-icon-button-icon-color: var(--mat-sys-inverse-on-surface);\n  //--mat-icon-color: var(--mat-sys-inverse-on-surface);\n  background-color: var(--mat-sys-inverse-surface);\n  color: var(--mat-sys-inverse-on-surface);\n  @include mat.checkbox-overrides(\n                  (\n                          label-text-color: var(--mat-sys-inverse-on-surface),\n                          disabled-label-color: rgb(from var(--mat-sys-secondary-container) r g b / 0.7),\n                          disabled-selected-icon-color: rgb(from var(--mat-sys-secondary-container) r g b / 0.7),\n                          disabled-unselected-icon-color: rgb(from var(--mat-sys-secondary-container) r g b / 0.7),\n                          disabled-selected-checkmark-color: rgb(from var(--mat-sys-secondary-container) r g b / 0.7),\n                          unselected-icon-color: var(--mat-sys-inverse-on-surface),\n                          unselected-hover-icon-color: var(--mat-sys-inverse-on-surface),\n                          unselected-focus-icon-color: var(--mat-sys-inverse-on-surface),\n                  )\n  );\n  @include mat.select-overrides(\n                  (\n                          enabled-trigger-text-color: var(--mat-sys-inverse-on-surface),\n                          disabled-trigger-text-color: var(--mat-sys-inverse-on-surface),\n                  )\n  );\n  @include mat.button-overrides(\n                  (\n                          text-label-text-color: var(--mat-sys-inverse-on-surface),\n                          text-state-layer-color: var(--mat-sys-inverse-on-surface),\n                  )\n  );\n\n  &.overlay {\n    background-color: color-mix(in srgb, var(--mat-sys-inverse-surface), transparent 35%);\n    border-radius: var(--mat-sys-corner-medium);\n    padding: 0.5em;\n    margin: 0.25em;\n  }\n\n  @include mat.slide-toggle-overrides((\n          selected-handle-color: var(--mat-sys-on-primary),\n          selected-hover-handle-color: var(--mat-sys-on-primary),\n          selected-focus-handle-color: var(--mat-sys-on-primary),\n          selected-pressed-handle-color: var(--mat-sys-on-primary),\n          selected-track-color: var(--mat-sys-primary),\n          selected-pressed-track-color: var(--mat-sys-primary),\n          selected-hover-track-color: var(--mat-sys-primary),\n          selected-focus-track-color: var(--mat-sys-primary),\n          unselected-pressed-handle-color: var(--mat-sys-on-primary),\n          unselected-handle-color: var(--mat-sys-on-primary),\n          unselected-hover-handle-color: var(--mat-sys-on-primary),\n          unselected-focus-handle-color: var(--mat-sys-on-primary),\n          unselected-track-color: var(--mat-sys-inverse-surface),\n          unselected-pressed-track-color: var(--mat-sys-inverse-surface),\n          unselected-hover-track-color: var(--mat-sys-inverse-surface),\n          unselected-focus-track-color: var(--mat-sys-inverse-surface),\n          label-text-color: var(--mat-sys-on-primary),\n          disabled-label-text-color: rgb(from var(--mat-sys-on-primary) r g b / 0.7),\n          disabled-unselected-handle-color: var(--mat-sys-on-primary),\n          disabled-unselected-track-color: var(--mat-sys-on-primary),\n  ));\n\n}\n\n.mat-checkbox-slim {\n  @include mat.checkbox-density(-4);\n\n  .mdc-form-field {\n    padding: 0;\n  }\n\n  .mdc-label {\n    padding: 0;\n  }\n}\n\n// ── Slim mat-select: compact height, arrow on the left ───────────────────────\n.mat-select-slim {\n  font-size: 0.75rem;\n  width: auto !important;\n  .mat-mdc-select-trigger {\n    height: 1.5rem;\n    min-height: 1.5rem;\n    padding: 0 0.25rem;\n  }\n\n  // Move the dropdown arrow to the left\n  .mat-mdc-select-arrow-wrapper {\n    order: -1;\n    margin-right: 0.25rem;\n    margin-left: 0;\n  }\n\n  .mat-mdc-select-value {\n    font-size: 0.75rem;\n    line-height: 1.5rem;\n  }\n}\n\n// Panel rendered in CDK overlay — must be global, not inside component styles\n.mat-select-slim-panel {\n  font-size: 0.75rem !important;\n  width: fit-content !important;\n\n  .mat-mdc-option {\n    min-height: 2rem !important;\n    font-size: 0.75rem !important;\n    padding: 0 0.5rem !important;\n  }\n}\n\n// Compact matIconButton: shrinks all internal MDC layers in lockstep so\n// the state-layer ripple stays perfectly centred on the icon. Uses M3\n// tokens for forward compatibility AND hard-sizes the rendered DOM,\n// because the tokens alone don't resize .mat-mdc-button-persistent-ripple\n// in the current Angular Material — without this, the hover circle drifts.\n@mixin compact-icon-button($size, $icon-size) {\n  --mat-icon-button-state-layer-size: #{$size};\n  --mat-icon-button-icon-size: #{$icon-size};\n\n  .mat-mdc-button-persistent-ripple,\n  .mat-mdc-button-ripple,\n  .mat-ripple {\n    inset: 0;\n    border-radius: 50%;\n  }\n\n  .mat-mdc-button-touch-target {\n    width: $size !important;\n    height: $size !important;\n  }\n\n  .mat-icon {\n    width: #{$icon-size};\n    height: #{$icon-size};\n    font-size: #{$icon-size};\n    line-height: #{$icon-size};\n  }\n}\n\n@mixin mat-icon-size($size) {\n  font-size: $size;\n  width: $size;\n  height: $size;\n  line-height: $size;\n  svg {\n    width: $size;\n    height: $size;\n  }\n}\n.mat-icon {\n  &.mat-icon-xs { @include mat-icon-size(14px); }\n  &.mat-icon-sm { @include mat-icon-size(16px); }\n  &.mat-icon-md { @include mat-icon-size(20px); }\n  &.mat-icon-xl { @include mat-icon-size(48px); }\n\n}\n\n@mixin compact-mini-fab($size: 40px, $icon-size: 24px) {\n  width: $size !important;\n  height: $size !important;\n  min-width: $size !important;\n  min-height: $size !important;\n\n  .mat-mdc-button-touch-target {\n    width: $size !important;\n    height: $size !important;\n  }\n\n  .mat-icon {\n    width: $icon-size;\n    height: $icon-size;\n    font-size: $icon-size;\n    line-height: $icon-size;\n  }\n}\n.mat-button-slim {\n  @include mat.button-density(-4);\n  font-size: 0.6rem !important;\n}\n\n/* -------------------------------------------------------------------------\n * Chips - Compact, no border, theme colors\n * ------------------------------------------------------------------------- */\n@include mat.chips-overrides((\n  outline-width: 0,\n  label-text-size: 0.75rem,\n  container-height: 1.5rem,\n  container-shape-radius: 1rem,\n));\n\n.mat-mdc-chip:not(.chip-empty) {\n  @include mat.chips-overrides((\n          label-text-color: var(--mat-sys-primary-fixed-dim),\n          elevated-container-color: color-mix(in srgb, var(--mat-sys-primary) 40%, transparent),\n  ));\n}\n\n.mat-mdc-chip.chip-empty {\n  @include mat.chips-overrides((\n          label-text-color: var(--mat-sys-outline),\n          elevated-container-color:  var(--mat-sys-surface-container-high),\n  ));\n}\n\n/* -------------------------------------------------------------------------\n * Progress Bar - percentage variant (opt-in via .bar-percent class)\n * Does NOT affect loading bars or other mat-progress-bar usages.\n * Usage: add class=\"bar-percent\" to any mat-progress-bar.\n * ------------------------------------------------------------------------- */\nmat-progress-bar.bar-percent {\n  width: 100%;\n  //Container of the bar\n  &,\n  .mdc-linear-progress,\n  .mdc-linear-progress__buffer,\n  .mdc-linear-progress__bar {\n    height: 1rem !important;\n    border-radius: 0.4rem !important;\n  }\n  //Color bar\n  .mdc-linear-progress__bar-inner {\n    border-radius: 0.4rem !important;\n    border-top-width: 1rem !important;\n    border-color: var(--bar-color, var(--mat-sys-primary)) !important;\n  }\n}\n//Container of the bar and the label\n.bar-row {\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 5rem;\n}\n//Add this to the span label to center it in the progress bar\n.bar-percent-label {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  pointer-events: none;\n  line-height: 1;\n}\n\n/* -------------------------------------------------------------------------\n * Expansion Panel - Compact layout, indicator on left\n * ------------------------------------------------------------------------- */\n@include mat.expansion-overrides((\n  header-collapsed-state-height: 2.5rem,\n  header-expanded-state-height: 2.5rem,\n));\n\n.mat-expansion-panel-header {\n  padding: 0 0.75rem !important;\n\n  .mat-expansion-indicator {\n    order: -1;\n    margin-right: 0.5rem;\n    transform: rotate(180deg);\n  }\n\n  mat-panel-title {\n    flex: 1;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  mat-panel-description {\n    flex: 0 0 auto;\n    margin: 0;\n    padding: 0;\n    color: inherit;\n  }\n}\n\n.mat-expansion-panel-body {\n  padding: 0 0.25rem 0.5rem !important;\n  line-height: 1.3;\n}\n\n.mat-expansion-panel.mat-expanded > .mat-expansion-panel-header .mat-expansion-indicator {\n  transform: rotate(0deg);\n}\n// Lo aplicas donde lo necesites\n.mat-icon-button-small {\n  @include compact-icon-button(24px, 16px);\n}\n\n.mat-icon-button-medium {\n  @include compact-icon-button(32px, 18px);\n}\n\n/* ── mat-stroked-button: compact global override ─────────────────────────── */\n.mat-mdc-outlined-button {\n  font-size: 0.8rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n\n  &.mat-mdc-button-base {\n    --mdc-outlined-button-container-shape: 3px;\n  }\n\n  &.mat-mdc-button-base:not([disabled]) {\n    border-color: var(--mat-sys-primary);\n  }\n}\n\n/* ── btn-loaded: filled primary state (data already loaded) ──────────────── */\n.btn-loaded {\n  background-color: var(--mat-sys-primary) !important;\n  color: var(--mat-sys-inverse-on-surface) !important;\n}\n\n.hidden {\n  display: none !important;\n}\n\n// Reusable eyebrow label for panel headers (step kicker, section kicker, etc.)\n.panel-eyebrow {\n  color: var(--mat-sys-primary);\n  letter-spacing: var(--vx-tracking-wide);\n}\n\n// Primary-colored icon utility\n.icon-primary {\n  color: var(--mat-sys-primary);\n}\n\napp-overlay-layer-item {\n  @include mat.checkbox-overrides(\n    (\n\n    )\n  );\n}\n\n.filters-panel {\n  @include mat.checkbox-overrides((\n          state-layer-size: 26px,\n  ));\n}\n\napp-full-screen-image {\n  @include mat.icon-button-overrides((\n          icon-color: var(--mat-sys-on-primary),\n  ));\n}\n\n.property-button-panel {\n  @include mat.fab-overrides((\n          container-color: var(--mat-sys-surface-container-low),\n          foreground-color: var(--mat-sys-primary),\n          state-layer-color: var(--mat-sys-primary),\n  ));\n}\n\n.scale-bar {\n  @include mat.menu-overrides((\n          container-color: var(--mat-sys-inverse-surface),\n          item-label-text-color: var(--mat-sys-inverse-on-surface)\n  ));\n}\n","@use '../../button-toggle/m3-button-toggle';\n@use '../../button/m3-button';\n@use '../../button/m3-fab';\n@use '../../button/m3-icon-button';\n@use '../../checkbox/m3-checkbox';\n@use '../../chips/m3-chip';\n@use '../../expansion/m3-expansion';\n@use '../../form-field/m3-form-field';\n@use '../../list/m3-list';\n@use '../../paginator/m3-paginator';\n@use '../../radio/m3-radio';\n@use '../../select/m3-select';\n@use '../../stepper/m3-stepper';\n@use '../../table/m3-table';\n@use '../../tabs/m3-tabs';\n@use '../../toolbar/m3-toolbar';\n@use '../../tree/m3-tree';\n@use '../style/elevation';\n@use '../theming/config-validation';\n@use '../theming/definition';\n@use '../theming/inspection';\n@use '../theming/m2-inspection';\n@use '../theming/palettes';\n@use '../style/sass-utils';\n@use './m2';\n@use './m3';\n@use 'sass:list';\n@use 'sass:map';\n@use 'sass:meta';\n\n/// Emits necessary CSS variables for Material's system level values for the values defined in the\n/// config map. The config map can have values color, typography, and/or density.\n///\n/// If the config map's color value is an Angular Material color palette, it will be used as the\n/// primary and tertiary colors with a `color-scheme` theme type. Otherwise if the color value is a\n/// map, it must have a `primary` value containing an Angular Material color palette, and\n/// optionally a different `tertiary` palette (defaults to primary palette) and `theme-type` that\n/// is either `light`, `dark`, or 'color-scheme` (defaults to `color-scheme`). Color variable\n/// definitions will not be emitted if there are no color values in the config.\n///\n/// If the config map's typography value is a font family string, it will be used as the\n/// plain and brand font family with default bold, medium, and regular weights of 700, 500, and 400,\n/// respectfully. Otherwise if the typography value is a map, it must have a `plain-family` font\n/// family value, and optionally a different `brand-family` font family (defaults to the plain\n/// value) and weights for `bold-weight` (default: 700), `bold-weight` (default: 500), and\n/// `bold-weight` (default: 400). Typography variable definitions will not be emitted if there are\n/// no typography values in the config.\n///\n/// If the config map's density value is a number, it will be used as the density scale. Otherwise\n/// if the density value is a map, it must have a `scale` value. Density variable definitions will\n/// not be emitted if there are no density values in the config.\n///\n/// The application variables emitted use the namespace prefix \"--mat-sys\".\n/// e.g. --mat-sys-surface: #E5E5E5\n///\n/// @param {Map} $config The color configuration with optional keys color, typography, or density.\n@mixin theme($config, $overrides: ()) {\n  $color: map.get($config, color);\n  $color-config: null;\n  @if ($color) {\n    // validate-palette returns null if it is a valid M3 palette\n    $is-palette: config-validation.validate-palette($color) == null;\n\n    // Default to \"color-scheme\" theme type if the config's color does not provide one.\n    @if (not $is-palette and not map.has-key($color, theme-type)) {\n      $color: map.set($color, theme-type, color-scheme);\n    }\n\n    $color-config: $color;\n    @if ($is-palette) {\n      $color: map.set($color, tertiary, $color);\n      $color-config: (\n        definition.$internals: (\n          palettes: (\n            primary: map.remove($color, neutral, neutral-variant, secondary),\n            secondary: map.get($color, secondary),\n            tertiary: map.remove($color, neutral, neutral-variant, secondary, error),\n            neutral: map.get($color, neutral),\n            neutral-variant: map.get($color, neutral-variant),\n            error: map.get($color, error),\n          ),\n          theme-type: color-scheme,\n        )\n      );\n    } @else {\n      $primary: map.get($color, primary) or palettes.$violet-palette;\n      $tertiary: map.get($color, tertiary) or $primary;\n      $color-config: (\n        definition.$internals: (\n          palettes: (\n            primary: map.remove($primary, neutral, neutral-variant, secondary),\n            secondary: map.get($primary, secondary),\n            tertiary: map.remove($tertiary, neutral, neutral-variant, secondary, error),\n            neutral: map.get($primary, neutral),\n            neutral-variant: map.get($primary, neutral-variant),\n            error: map.get($primary, error),\n          ),\n          theme-type: map.get($color, theme-type),\n        )\n      );\n    }\n\n    @include system-level-colors($color-config, $overrides, definition.$system-fallback-prefix);\n    @include system-level-elevation($color-config, $overrides, definition.$system-fallback-prefix);\n  }\n\n  $typography: map.get($config, typography);\n  $typography-config: null;\n  @if ($typography) {\n    $plain: (Roboto, sans-serif);\n    $brand: $plain;\n    $bold: 700;\n    $medium: 500;\n    $regular: 400;\n    @if (meta.type-of($typography) == map) {\n      $plain: map.get($typography, plain-family);\n      $brand: map.get($typography, brand-family) or $plain;\n      $bold: map.get($typography, bold-weight) or $bold;\n      $medium: map.get($typography, medium-weight) or $medium;\n      $regular: map.get($typography, regular-weight) or $regular;\n    } @else {\n      $plain: $typography;\n      $brand: $typography;\n    }\n    $typography-config: (\n      definition.$internals: (\n        font-definition: (\n          plain: $plain,\n          brand: $brand,\n          bold: $bold,\n          medium: $medium,\n          regular: $regular,\n        )\n      )\n    );\n    @include system-level-typography(\n        $typography-config, $overrides, definition.$system-fallback-prefix);\n  }\n\n  $density: map.get($config, density);\n  $density-config: null;\n  @if ($density) {\n    $scale: 0;\n    @if (meta.type-of($density) == map) {\n      $scale: map.get($density, scale);\n    } @else {\n      $scale: $density;\n    }\n    @if ($scale != 0) {\n      // Emit component-level density tokens if the scale is lower than 0. The density tokens\n      // do not fallback to any system-level values and must be defined if the scale is different.\n      $density-tokens: get-density-tokens($scale);\n      @each $tokens in $density-tokens {\n        @each $token-name, $token-value in $tokens {\n          --mat-#{$token-name}: #{$token-value};\n        }\n      }\n    }\n  }\n\n  @include system-level-shape($overrides: $overrides, $prefix: definition.$system-fallback-prefix);\n  @include system-level-state($overrides: $overrides, $prefix: definition.$system-fallback-prefix);\n}\n\n// Gets all density-related tokens from the components.\n@function get-density-tokens($scale) {\n  @return (\n    m3-checkbox.get-density-tokens($scale),\n    m3-chip.get-density-tokens($scale),\n    m3-expansion.get-density-tokens($scale),\n    m3-fab.get-density-tokens($scale),\n    m3-button.get-density-tokens($scale),\n    m3-form-field.get-density-tokens($scale),\n    m3-icon-button.get-density-tokens($scale),\n    m3-list.get-density-tokens($scale),\n    m3-paginator.get-density-tokens($scale),\n    m3-radio.get-density-tokens($scale),\n    m3-tabs.get-density-tokens($scale),\n    m3-select.get-density-tokens($scale),\n    m3-button-toggle.get-density-tokens($scale),\n    m3-stepper.get-density-tokens($scale),\n    m3-table.get-density-tokens($scale),\n    m3-toolbar.get-density-tokens($scale),\n    m3-tree.get-density-tokens($scale),\n  );\n}\n\n/// Emits the system-level CSS variables for each of the provided override values. E.g. to\n/// change the primary color to red, use `mat.theme-overrides((primary: red));`\n@mixin theme-overrides($overrides, $prefix: definition.$system-fallback-prefix) {\n  $sys-names: map-merge-all(\n      m3.md-sys-color-values-light(palettes.$blue-palette),\n      m3.md-sys-typescale-values((\n        brand: (Roboto),\n        plain: (Roboto),\n        bold: 700,\n        medium: 500,\n        regular: 400\n      )),\n      m3.md-sys-elevation-values(),\n      m3.md-sys-shape-values(),\n      m3.md-sys-state-values());\n\n  @include sass-utils.current-selector-or-root {\n    @each $name, $value in $overrides {\n      @if (map.has-key($sys-names, $name)) {\n        --#{$prefix}-#{$name}: #{map.get($overrides, $name)};\n      }\n    }\n  }\n}\n\n@mixin system-level-colors($theme, $overrides: (), $prefix: null) {\n  $palettes: map.get($theme, definition.$internals, palettes);\n  $type: map.get($theme, definition.$internals, theme-type);\n\n  @if (not $prefix) {\n    $prefix: map.get($theme, definition.$internals,\n        color-system-variables-prefix) or definition.$system-level-prefix;\n  }\n\n\n  $sys-colors: _generate-sys-colors($palettes, $type);\n\n  // Manually insert a subset of palette values that are used directly by components\n  // instead of system variables.\n  $sys-colors: map.set($sys-colors, neutral-variant20, map.get($palettes, neutral-variant, 20));\n  $sys-colors: map.set($sys-colors, neutral10, map.get($palettes, neutral, 10));\n\n  @include sass-utils.current-selector-or-root {\n    @each $name, $value in $sys-colors {\n      --#{$prefix}-#{$name}: #{map.get($overrides, $name) or $value};\n    }\n  }\n}\n\n@function _generate-sys-colors($palettes, $type) {\n  $light-sys-colors: m3.md-sys-color-values-light($palettes);\n  @if ($type == light) {\n    @return $light-sys-colors;\n  }\n\n  $dark-sys-colors: m3.md-sys-color-values-dark($palettes);\n  @if ($type == dark) {\n    @return $dark-sys-colors;\n  }\n\n  @if ($type == color-scheme) {\n    $light-dark-sys-colors: ();\n    @each $name, $light-value in $light-sys-colors {\n      $dark-value: map.get($dark-sys-colors, $name);\n      $light-dark-sys-colors:\n          map.set($light-dark-sys-colors, $name, light-dark($light-value, $dark-value));\n    }\n    @return $light-dark-sys-colors;\n  }\n\n  @error 'Unknown theme-type provided: #{$type}';\n}\n\n@mixin system-level-typography($theme, $overrides: (), $prefix: null) {\n  $font-definition: map.get($theme, definition.$internals, font-definition);\n\n  @if (not $prefix) {\n    $prefix: map.get($theme, definition.$internals,\n        typography-system-variables-prefix) or definition.$system-level-prefix;\n  }\n\n  @include sass-utils.current-selector-or-root {\n    @each $name, $value in m3.md-sys-typescale-values($font-definition) {\n      --#{$prefix}-#{$name}: #{map.get($overrides, $name) or $value};\n    }\n  }\n}\n\n@mixin system-level-elevation($theme, $overrides: (), $prefix: definition.$system-level-prefix) {\n  $shadow-color: map.get(\n      $theme, definition.$internals, palettes, neutral, 0);\n\n  @include sass-utils.current-selector-or-root {\n    @each $name, $value in m3.md-sys-elevation-values() {\n      $level: map.get($overrides, $name) or $value;\n      $value: elevation.get-box-shadow($level, $shadow-color);\n      --#{$prefix}-#{$name}: #{$value};\n    }\n  }\n}\n\n@mixin system-level-shape($theme: (), $overrides: (), $prefix: definition.$system-level-prefix) {\n  @include sass-utils.current-selector-or-root {\n    @each $name, $value in m3.md-sys-shape-values() {\n      --#{$prefix}-#{$name}: #{map.get($overrides, $name) or $value};\n    }\n  }\n}\n\n@mixin system-level-state($theme: (), $overrides: (), $prefix: definition.$system-level-prefix) {\n  @include sass-utils.current-selector-or-root {\n    @each $name, $value in m3.md-sys-state-values() {\n      --#{$prefix}-#{$name}: #{map.get($overrides, $name) or $value};\n    }\n  }\n}\n\n/// Creates a single merged map from the provided variable-length map arguments\n@function map-merge-all($maps...) {\n  $result: ();\n  @each $map in $maps {\n    $result: map.merge($result, $map);\n  }\n  @return $result;\n}\n\n// Defines Angular Material system variables using M2 values provided by\n// an M2 theme config created with `mat.m2-define-light-theme` or `mat.m2-define-dark-theme`.\n//\n// This enables applications to style custom components with system-level CSS\n// variables instead of creating a separate component theme mixin that relies on\n// the theme config.\n//\n// For example, use `var(--mat-sys-primary)` to get a theme's primary color instead of\n// pulling it from the theme with `m2-get-color-from-palette($primary-palette, default)`.\n//\n// Unlike M3's `mat.theme()`, this mixin does not replace the need to call\n// individual component theme mixins for Angular Material components.\n@mixin m2-theme($theme-config, $overrides: ()) {\n  @if inspection.get-theme-version($theme-config) == 1 {\n    @error '`m2-theme` mixin should only be called for M2 theme ' +\n        'configs created with define-light-theme or define-dark-theme';\n  }\n\n  // Check whether any override keys do not match keys in the theme\n  // config system map.\n  $invalid-keys: ();\n  $config-system: map.get($theme-config, _mat-system);\n  @each $key, $value in $overrides {\n    @if (not map.has-key($config-system, $key)) {\n      $invalid-keys: list.append($invalid-keys, $key);\n    }\n  }\n  @if (list.length($invalid-keys) > 0) {\n    @error 'The following overrides are not valid system variables: #{$invalid-keys}. ' +\n        'Valid keys are: #{map.keys($config-system)}';\n  }\n\n  $config: m2-inspection.get-m2-config($theme-config);\n\n  $color: map.get($config, color);\n  @if (m2-inspection.theme-has($theme-config, color)) {\n    $system-colors: null;\n\n    @if (map.get($color, is-dark)) {\n      $system-colors: m2.md-sys-color-values-dark($color);\n    } @else {\n      $system-colors: m2.md-sys-color-values-light($color);\n    }\n\n    @include _define-m2-system-vars($system-colors, $overrides);\n\n    $shadow: map.get($theme-config, _mat-system, shadow);\n    $system-elevations: ();\n    @each $name, $value in m2.md-sys-elevation-values() {\n      $level: map.get($overrides, $name) or $value;\n      $value: elevation.get-box-shadow($level, $shadow);\n      $system-elevations: map.set($system-elevations, $name, $value);\n    }\n    @include _define-m2-system-vars($system-elevations, $overrides);\n  }\n\n  $typography: map.get($config, typography);\n  @if ($typography) {\n    $system-typography: m2.md-sys-typescale-values($typography);\n    @include _define-m2-system-vars($system-typography, $overrides);\n  }\n\n  @include _define-m2-system-vars(m2.md-sys-shape-values(), $overrides);\n  @include _define-m2-system-vars(m2.md-sys-state-values(), $overrides);\n\n  // The icon button's color token is set to `inherit` for M2 and intended to display\n  // the color inherited from its parent element. This is crucial because it's unknown\n  // whether the icon button sits on a container with background like \"surface\" or \"primary\",\n  // where both may have different contrast colors like white or black.\n  // However, variables set to inherit AND define a fallback will always use the fallback,\n  // which is \"on-surface-variant\". This mixin now defines this value.\n  // To avoid this, and continue using `inherit` for the icon button color, set the color explicitly\n  // to the token without a fallback.\n  .mat-mdc-button-base.mat-mdc-icon-button:not(.mat-mdc-button-disabled) {\n    color: var(--mat-icon-button-icon-color);\n  }\n}\n\n@mixin _define-m2-system-vars($vars, $overrides) {\n  @include sass-utils.current-selector-or-root {\n    @each $name, $value in $vars {\n      --#{definition.$system-fallback-prefix}-#{$name}: #{map.get($overrides, $name) or $value};\n    }\n  }\n}\n","// Utility classes that can be used to style elements with the most commonly used system tokens in\n// Material Design. Includes color, typography, elevation, state, and shape.\n@mixin system-classes() {\n\n  // ***********************************************************************************************\n  // Background - Applies background colors defined by Material Design.\n  // See https://m3.material.io/styles/color/roles for detailed guidance.\n  // ***********************************************************************************************\n\n  // Styles an element with a primary color background. Use for key components across the UI, such\n  // as buttons that have greater importance on the page. In Angular Material, this is used for the\n  // selected date in a datepicker, the handle of a slider, and the background of a checkbox.\n  .mat-bg-primary {\n    background-color: var(--mat-sys-primary);\n  }\n\n  // Styles an element with a primary container color background. Use for filling components that\n  // should stand out on a surface. In Angular Material, this is used for the container of a\n  // floating action button.\n  .mat-bg-primary-container {\n    background-color: var(--mat-sys-primary-container);\n  }\n\n  // Styles an element with a secondary color background. Use for less prominent components in the\n  // UI that have a different color scheme than the primary.\n  .mat-bg-secondary {\n    background-color: var(--mat-sys-secondary);\n  }\n\n  // Styles an element with a secondary container color background. Use for components that need\n  // less emphasis than secondary, such as filter chips. In Angular Material, this is used for\n  // selected items in a list and the container of a tonal button.\n  .mat-bg-secondary-container {\n    background-color: var(--mat-sys-secondary-container);\n  }\n\n  // Styles an element with an error color background. Use for indicating an error state, such as\n  // an invalid text field, or for the background of an important notification. In Angular\n  // Material, this is used for the background of a badge.\n  .mat-bg-error {\n    background-color: var(--mat-sys-error);\n  }\n\n  // Styles an element with an error container color background. Use for components that need less\n  // emphasis than error, such as a container for error text.\n  .mat-bg-error-container {\n    background-color: var(--mat-sys-error-container);\n  }\n\n  // Styles an element with a surface color background. Use for general surfaces of components. In\n  // Angular Material, this is used for the background of many components, like tables, dialogs,\n  // menus, and toolbars.\n  .mat-bg-surface {\n    background-color: var(--mat-sys-surface);\n  }\n\n  // Styles an element with a surface variant color background. Use for surfaces that need to stand\n  // out from the main surface color. In Angular Material, this is used for the background of a\n  // filled form field and the track of a progress bar.\n  .mat-bg-surface-variant {\n    background-color: var(--mat-sys-surface-variant);\n  }\n\n  // Styles an element with the \"highest\" surface container color background. Use for surfaces that\n  // need the most emphasis against the main surface color. In Angular Material, this is used for\n  // the background of a filled card.\n  .mat-bg-surface-container-highest {\n    background-color: var(--mat-sys-surface-container-highest);\n  }\n\n  // Styles an element with a \"high\" surface container color background. Use for surfaces that need\n  // more emphasis against the main surface color. In Angular Material, this is used for the\n  // background of a datepicker.\n  .mat-bg-surface-container-high {\n    background-color: var(--mat-sys-surface-container-high);\n  }\n\n  // Styles an element with a surface container color background. Use for surfaces that need to\n  // stand out from the main surface color. In Angular Material, this is used for the background\n  // of a menu.\n  .mat-bg-surface-container {\n    background-color: var(--mat-sys-surface-container);\n  }\n\n  // Styles an element with a \"low\" surface container color background. Use for surfaces that need\n  // less emphasis against the main surface color. In Angular Material, this is used for the\n  // background of a bottom sheet.\n  .mat-bg-surface-container-low {\n    background-color: var(--mat-sys-surface-container-low);\n  }\n\n  // Styles an element with the \"lowest\" surface container color background. Use for surfaces that\n  // need the least emphasis against the main surface color.\n  .mat-bg-surface-container-lowest {\n    background-color: var(--mat-sys-surface-container-lowest);\n  }\n\n  // Styles an element with an inverse surface color background. Use for making elements stand out\n  // against the default color scheme. Good for temporary notifications. In Angular Material, this\n  // is used for the background of a snackbar and a tooltip.\n  .mat-bg-inverse-surface {\n    background-color: var(--mat-sys-inverse-surface);\n  }\n\n  // Styles an element with a disabled color background. Use for disabled components. In Angular\n  // Material, this is used for components generally filled with the primary color but are\n  // currently disabled.\n  .mat-bg-disabled {\n    background-color: color-mix(in srgb, var(--mat-sys-on-surface) 12%, transparent);\n  }\n\n\n  // ***********************************************************************************************\n  // Text - Apply colors to text\n  // ***********************************************************************************************\n\n  // Styles the text of an element with the primary color. Use for text that needs to stand out.\n  // In Angular Material, this is used for the text of a text button and the selected tab label.\n  .mat-text-primary {\n    color: var(--mat-sys-primary);\n  }\n\n  // Styles the text of an element with the secondary color. Use for text that needs to stand out.\n  .mat-text-secondary {\n    color: var(--mat-sys-secondary);\n  }\n\n  // Styles the text of an element with the error color. Use for text that indicates an error, such\n  // as validation messages. In Angular Material, this is used for the error text in a form field.\n  .mat-text-error {\n    color: var(--mat-sys-error);\n  }\n\n  // Styles the text of an element with the disabled color. Use for text in disabled components.\n  .mat-text-disabled {\n    color: color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent);\n  }\n\n  // Styles the text of an element with the on-surface-variant color. Use for text that should have\n  // a lower emphasis than the surrounding text. This can include subheading, captions, and hint\n  // text.\n  .mat-text-on-surface-variant {\n    color: var(--mat-sys-on-surface-variant);\n  }\n\n  // Styles the text of an element with a color that contrasts well against a primary background.\n  .mat-text-on-primary {\n    color: var(--mat-sys-on-primary);\n  }\n\n  // Styles the text of an element with a color that contrasts well against a primary-container\n  // background.\n  .mat-text-on-primary-container {\n    color: var(--mat-sys-on-primary-container);\n  }\n\n  // Styles the text of an element with a color that contrasts well against a secondary background.\n  .mat-text-on-secondary {\n    color: var(--mat-sys-on-secondary);\n  }\n\n  // Styles the text of an element with a color that contrasts well against a secondary-container\n  // background.\n  .mat-text-on-secondary-container {\n    color: var(--mat-sys-on-secondary-container);\n  }\n\n  // Styles the text of an element with a color that contrasts well against an error background.\n  .mat-text-on-error {\n    color: var(--mat-sys-on-error);\n  }\n\n  // Styles the text of an element with a color that contrasts well against an error-container\n  // background.\n  .mat-text-on-error-container {\n    color: var(--mat-sys-on-error-container);\n  }\n\n  // Styles the text of an element with a color that contrasts well against a surface background.\n  .mat-text-on-surface {\n    color: var(--mat-sys-on-surface);\n  }\n\n  // Styles the text of an element with a color that contrasts well against an inverse-surface\n  // background.\n  .mat-text-inverse-on-surface {\n    color: var(--mat-sys-inverse-on-surface);\n  }\n\n  // ***********************************************************************************************\n  // Font - Apply typography styles\n  // See https://m3.material.io/styles/typography/applying-type for guidance.\n  // ***********************************************************************************************\n\n  // Sets the font to the body small typeface. Use for small body text, such as captions. In Angular\n  // Material, this is used for the subscript text in a form field and the text in a paginator.\n  .mat-font-body-sm {\n    font: var(--mat-sys-body-small);\n    letter-spacing: var(--mat-sys-body-small-tracking);\n  }\n\n  // Sets the font to the body medium typeface. Use for medium body text, this is the default\n  // body font. In Angular Material, this is used for the text in a table row and the supporting\n  // text in a dialog.\n  .mat-font-body-md {\n    font: var(--mat-sys-body-medium);\n    letter-spacing: var(--mat-sys-body-medium-tracking);\n  }\n\n  // Sets the font to the body large typeface. Use for large body text, such as an introductory\n  // paragraph. In Angular Material, this is used for the text in a list item and the text in a\n  // select trigger.\n  .mat-font-body-lg {\n    font: var(--mat-sys-body-large);\n    letter-spacing: var(--mat-sys-body-large-tracking);\n  }\n\n  // Sets the font to the display small typeface. Use for small display text, such as a date.\n  .mat-font-display-sm {\n    font: var(--mat-sys-display-small);\n    letter-spacing: var(--mat-sys-display-small-tracking);\n  }\n\n  // Sets the font to the display medium typeface. Use for medium display text, such as a hero\n  // title.\n  .mat-font-display-md {\n    font: var(--mat-sys-display-medium);\n    letter-spacing: var(--mat-sys-display-medium-tracking);\n  }\n\n  // Sets the font to the display large typeface. Use for large display text, such as a hero title.\n  .mat-font-display-lg {\n    font: var(--mat-sys-display-large);\n    letter-spacing: var(--mat-sys-display-large-tracking);\n  }\n\n  // Sets the font to the headline small typeface. Use for small headlines, such as a page title. In\n  // Angular Material, this is used for the headline in a dialog.\n  .mat-font-headline-sm {\n    font: var(--mat-sys-headline-small);\n    letter-spacing: var(--mat-sys-headline-small-tracking);\n  }\n\n  // Sets the font to the headline medium typeface. Use for medium headlines, such as a section\n  // title.\n  .mat-font-headline-md {\n    font: var(--mat-sys-headline-medium);\n    letter-spacing: var(--mat-sys-headline-medium-tracking);\n  }\n\n  // Sets the font to the headline large typeface. Use for large headlines, such as a page title on\n  // a large screen.\n  .mat-font-headline-lg {\n    font: var(--mat-sys-headline-large);\n    letter-spacing: var(--mat-sys-headline-large-tracking);\n  }\n\n  // Sets the font to the label small typeface. Use for small labels, such as text in a badge.\n  .mat-font-label-sm {\n    font: var(--mat-sys-label-small);\n    letter-spacing: var(--mat-sys-label-small-tracking);\n  }\n\n  // Sets the font to the label medium typeface. Use for medium labels. In Angular Material, this\n  // is used for the slider label.\n  .mat-font-label-md {\n    font: var(--mat-sys-label-medium);\n    letter-spacing: var(--mat-sys-label-medium-tracking);\n  }\n\n  // Sets the font to the label large typeface. Use for large labels. In Angular Material, this is\n  // used for buttons, chips, and menu labels.\n  .mat-font-label-lg {\n    font: var(--mat-sys-label-large);\n    letter-spacing: var(--mat-sys-label-large-tracking);\n  }\n\n  // Sets the font to the title small typeface. Use for small titles, such as a card title. In\n  // Angular Material, this is used for the header of a table and the label of an option group.\n  .mat-font-title-sm {\n    font: var(--mat-sys-title-small);\n    letter-spacing: var(--mat-sys-title-small-tracking);\n  }\n\n  // Sets the font to the title medium typeface. Use for medium titles, such as a dialog title\n  // or the primary text in a list item. In Angular Material, this is used for the subtitle\n  // of a card and the header of an expansion panel.\n  .mat-font-title-md {\n    font: var(--mat-sys-title-medium);\n    letter-spacing: var(--mat-sys-title-medium-tracking);\n  }\n\n  // Sets the font to the title large typeface. Use for large titles, such as a page title on a\n  // small screen. In Angular Material, this is used for the title of a card and the title of a\n  // toolbar.\n  .mat-font-title-lg {\n    font: var(--mat-sys-title-large);\n    letter-spacing: var(--mat-sys-title-large-tracking);\n  }\n\n\n  // ***********************************************************************************************\n  // Corner - Apply varying amounts of a border radius\n  // See https://m3.material.io/styles/shape/corner-radius-scale for guidance.\n  // ***********************************************************************************************\n\n  // Sets the border radius to extra small. Use for components that need a small amount of rounding,\n  // such as a chip. In Angular Material, this is used for the shape of a snackbar and a tooltip.\n  .mat-corner-xs {\n    border-radius: var(--mat-sys-corner-extra-small);\n  }\n\n  // Sets the border radius to small. Use for components that need a small amount of rounding, such\n  // as a text field.\n  .mat-corner-sm {\n    border-radius: var(--mat-sys-corner-small);\n  }\n\n  // Sets the border radius to medium. Use for components that need a medium amount of rounding,\n  // such as a button. In Angular Material, this is used for the shape of a card.\n  .mat-corner-md {\n    border-radius: var(--mat-sys-corner-medium);\n  }\n\n  // Sets the border radius to large. Use for components that need a large amount of rounding, such\n  // as a card. In Angular Material, this is used for the shape of a floating action button and a\n  // datepicker.\n  .mat-corner-lg {\n    border-radius: var(--mat-sys-corner-large);\n  }\n\n  // Sets the border radius to extra large. Use for components that need a large amount of\n  // rounding. In Angular Material, this is used for the shape of a button toggle and the shape of\n  // a dialog.\n  .mat-corner-xl {\n    border-radius: var(--mat-sys-corner-extra-large);\n  }\n\n  // Sets the border radius to full. Use for components that are circular, such as a user avatar.\n  // In Angular Material, this is used for the shape of a badge and the shape of a button.\n  .mat-corner-full {\n    border-radius: var(--mat-sys-corner-full);\n  }\n\n\n  // ***********************************************************************************************\n  // Border - Applies a 1px solid border\n  // ***********************************************************************************************\n\n  // Adds an outline to an element. Use for components that need a visible boundary. In Angular\n  // Material, this is used for the outline of an outlined button.\n  .mat-border {\n    border: 1px solid var(--mat-sys-outline);\n  }\n\n  // Adds a less prominent outline to an element. Use for components that need a less obvious\n  // boundary. In Angular Material, this is used for the outline of an outlined card and the color\n  // of the divider\n  .mat-border-subtle {\n    border: 1px solid var(--mat-sys-outline-variant);\n  }\n\n  // ***********************************************************************************************\n  // Shadow - Applies elevation levels through box-shadow\n  // See https://m3.material.io/styles/elevation/applying-elevation for guidance.\n  // ***********************************************************************************************\n\n  // Use to slightly raise the appearance of a surface. In Angular Material, this is used for the\n  // elevation of an elevated card and the handle of a slider.\n  .mat-shadow-1 {\n    box-shadow: var(--mat-sys-level1);\n  }\n\n  // Use to raise the appearance of a surface. In Angular Material, this is used for the\n  // elevation of a menu and a select panel.\n  .mat-shadow-2 {\n    box-shadow: var(--mat-sys-level2);\n  }\n\n  // Used to raise the appearance of a surface. In Angular Material, this is used for the elevation\n  // of a floating action button.\n  .mat-shadow-3 {\n    box-shadow: var(--mat-sys-level3);\n  }\n\n  // Used to raise the appearance of a surface. This is generally reserved for elevation changes\n  // due to interaction like focus and hover. In Angular Material, this is used for the elevation\n  // of a hovered floating action button.\n  .mat-shadow-4 {\n    box-shadow: var(--mat-sys-level4);\n  }\n\n  // Used to greatly raise the appearance of a surface. This is generally reserved for elevation\n  // changes due to interaction like focus and hover.\n  .mat-shadow-5 {\n    box-shadow: var(--mat-sys-level5);\n  }\n}\n","@use '../style/sass-utils';\n@use 'sass:list';\n@use 'sass:map';\n@use 'sass:string';\n\n// Creates a CSS variable, including the fallback if provided.\n@function _create-var($name, $fallback: null) {\n  @if ($fallback) {\n    @return var($name, $fallback);\n  } @else {\n    @return var($name);\n  }\n}\n\n// Returns a list of overrides for the given M3 get-tokens mixin and prefix. Each token has its\n// prefix removed since the overrides API expects its absence. The returned map includes \"all\" for\n// all override tokens, and also the subsets with keys base, color, typography, and density.\n@function get-overrides($tokens, $prefix) {\n  $base: remove-token-prefixes(map.get($tokens, base), $prefix);\n  $color: remove-token-prefixes(map.get($tokens, color), $prefix);\n  $typography: remove-token-prefixes(map.get($tokens, typography), $prefix);\n  $density: remove-token-prefixes(map.get($tokens, density), $prefix);\n  $all: ();\n  @each $map in ($base, $color, $typography, $density) {\n    $all: map.merge($all, $map);\n  }\n\n  @return (\n    all: $all,\n    base: $base,\n    color: $color,\n    typography: $typography,\n    density: $density,\n  );\n}\n\n// Removes a prefix from each component token in the provided map of prefixed tokens.\n@function remove-token-prefixes($prefixed-tokens: (), $prefix) {\n  $tokens: ();\n  @each $prefixed-token, $value in $prefixed-tokens {\n    $token: string.slice($prefixed-token, string.length($prefix) + 2);\n    $tokens: map.set($tokens, $token, $value);\n  }\n  @return $tokens;\n}\n\n// Returns the token slot value.\n// Accepts an optional fallback parameter to include in the CSS variable.\n// If $fallback is `true`, then use the tokens map to get the fallback.\n@function slot($token, $fallbacks, $fallback: null) {\n  // Fallbacks are a map of base, color, typography, and density tokens. To simplify\n  // lookup, flatten these token groups into a single map.\n  $fallbacks-flattened: ();\n  @each $tokens in map.values($fallbacks) {\n    @each $token, $value in $tokens {\n      $fallbacks-flattened: map.set($fallbacks-flattened, $token, $value);\n    }\n  }\n  @if not map.has-key($fallbacks-flattened, $token) {\n    @error 'Token #{$token} does not exist. Configured tokens are:' +\n        #{map.keys($fallbacks-flattened)};\n  }\n\n  $sys-fallback: map.get($fallbacks-flattened, $token);\n  @if (sass-utils.is-css-var-name($sys-fallback)) {\n    $sys-fallback: _create-var($sys-fallback, $fallback);\n  }\n\n  @return _create-var(--mat-#{$token}, $sys-fallback);\n}\n\n// Outputs a map of token values as CSS variable definitions.\n@mixin values($tokens) {\n  @include sass-utils.current-selector-or-root() {\n    @each $key, $value in $tokens {\n      @if $value != null {\n        --mat-#{$key}: #{$value};\n      }\n    }\n  }\n}\n\n/// Emits new token values for the given token overrides.\n/// Verifies that the overrides passed in are valid tokens.\n/// New token values are emitted under the current selector or root.\n@mixin batch-create-token-values($overrides: (), $namespace-configs) {\n  @include sass-utils.current-selector-or-root() {\n    $prefixed-name-data: ();\n    $all-names: ();\n\n    @each $config in $namespace-configs {\n      $namespace: map.get($config, namespace);\n      $tokens: map.get(map.get($config, tokens), all);\n      $prefix: '';\n\n      @if (map.has-key($config, prefix)) {\n        $prefix: map.get($config, prefix);\n      }\n\n      @each $name, $value in $tokens {\n        $prefixed-name: $prefix + $name;\n        $all-names: list.append($all-names, $prefixed-name, $separator: comma);\n        $prefixed-name-data: map.set($prefixed-name-data, $prefixed-name, ($namespace, $name));\n      }\n    }\n\n    @each $name, $value in $overrides {\n      @if map.has-key($prefixed-name-data, $name) {\n        $data: map.get($prefixed-name-data, $name);\n        $namespace: list.nth($data, 1);\n        $name: list.nth($data, 2);\n        $prefixed-name: $namespace + '-' + $name;\n        @include values(($prefixed-name: $value));\n      } @else {\n        @error #{'Invalid token name `'}#{$name}#{'`. '}#{'Valid tokens are: '}#{$all-names};\n      }\n    }\n  }\n}\n","@use 'sass:string';\n@use 'sass:map';\n@use 'sass:meta';\n\n/// Whether our theming API is using --sys- variables for color tokens.\n$use-system-color-variables: false;\n\n/// Whether our theming API is using --sys- variables for typography tokens.\n$use-system-typography-variables: false;\n\n/// Include content under the current selector (&) or the document root if there is no current\n/// selector.\n/// @param {String} $root [html] The default root selector to use when there is no current selector.\n/// @output The given content under the current selector, or root selector if there is no current\n///     selector.\n/// @content Content to output under the current selector, or root selector if there is no current\n///     selector.\n@mixin current-selector-or-root($root: html) {\n  @if & {\n    @content;\n  }\n  @else {\n    #{$root} {\n      @content;\n    }\n  }\n}\n\n/// A version of the standard `map.merge` function that takes a variable number of arguments.\n/// Each argument is merged into the final result from left to right.\n/// @param {List} $maps The maps to combine with map.merge\n/// @return {Map} The combined result of successively calling map.merge with each parameter.\n@function merge-all($maps...) {\n  $result: ();\n  @each $map in $maps {\n    $result: map.merge($result, $map);\n  }\n  @return $result;\n}\n\n/// A version of the standard `map.deep-merge` function that takes a variable number of arguments.\n/// Each argument is deep-merged into the final result from left to right.\n/// @param {List} $maps The maps to combine with map.deep-merge\n/// @return {Map} The combined result of successively calling map.deep-merge with each parameter.\n@function deep-merge-all($maps...) {\n  $result: ();\n  @each $map in $maps {\n    $result: map.deep-merge($result, $map);\n  }\n  @return $result;\n}\n\n// Returns whether the $value is a CSS variable name based on whether it's a string prefixed\n// by \"--\".\n@function is-css-var-name($value) {\n  @return meta.type-of($value) == string and string.index($value, '--') == 1;\n}\n","@use \"@angular/material\" as mat;\n\n// Global mat-checkbox touch target size reduction to fix hitbox misalignment\n// in dense lists (e.g. timeline filters were triggering nearby checkboxes).\n.mat-mdc-checkbox .mdc-checkbox .mat-mdc-checkbox-touch-target {\n  width: 24px;\n  height: 24px;\n}\n\n// Search image preview dialog — rendered via CDK Overlay directly on body\n.image-dialog {\n  background: white;\n  border-radius: 8px;\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow: hidden;\n  cursor: default;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n\n  .dialog-content {\n    padding: 16px;\n    max-height: 90vh;\n    overflow: auto;\n\n    .full-image {\n      max-width: 100%;\n      max-height: 70vh;\n      object-fit: contain;\n      display: block;\n      margin: 0 auto;\n    }\n  }\n}\n\n// Fullscreen image overlay: must appear above any mat-dialog (CDK overlay z-index: 1000)\n.fullscreen-image-panel {\n  z-index: 1001 !important;\n\n  app-full-screen-image {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.mat-icon-toggle-button {\n  @include mat.icon-button-overrides((\n          icon-color: var(--mat-sys-on-surface)\n  ));\n  &.selected {\n    color: var(--mat-sys-primary);\n  }\n}\n.map-toolbar {\n  background-color: var(--mat-sys-inverse-surface);\n  display: flex;\n  .mat-icon-toggle-button {\n    @include mat.icon-button-overrides((\n            icon-color: var(--mat-sys-inverse-on-surface)\n    ));\n    &.selected {\n      color: var(--mat-sys-primary);\n      font-weight: 500;\n    }\n  }\n}\n\n.mat-mdc-mini-fab {\n  @include mat.fab-overrides((\n    small-disabled-state-foreground-color: var(--mat-sys-on-surface),\n    small-disabled-state-container-color: var(--mat-sys-secondary-container),\n  ));\n  &.selected {\n    @include mat.fab-overrides(\n      (\n        small-foreground-color: var(--mat-sys-primary),\n      )\n    );\n  }\n\n\n}\n// Main toolbar panel container\n.search-panel-container {\n  min-width: 320px;\n  max-width: 600px;\n  z-index: 11;\n}\n.search-form-field {\n  .mdc-text-field--filled {\n    border-bottom-right-radius: var(--mat-form-field-filled-container-shape, var(--mat-sys-corner-extra-small));\n    border-bottom-left-radius: var(--mat-form-field-filled-container-shape, var(--mat-sys-corner-extra-small));\n  }\n  // Autocomplete overide\n  .search-history-container {\n    padding: 0;\n    .search-history-option {\n      display: flex;\n      background-color: var(--mat-sys-surface);\n    }\n    .mat-mdc-option .mdc-list-item__primary-text {\n      display: flex;\n      flex-grow: 1;\n      align-items: center;\n      .search-text {\n        flex-grow: 1;\n      }\n    }\n  }\n  .search-button {\n    color: var(--mat-sys-primary);\n  }\n  @include mat.form-field-overrides(\n    (\n      filled-container-color: var(--mat-sys-surface),\n    )\n  );\n}\n.form-small {\n  @include mat.form-field-density(-4);\n  @include mat.form-field-overrides(\n    (\n      filled-label-text-size: 12px,\n      container-text-size: 14px,\n    )\n  );\n}\n.form-slim {\n  @extend .form-small;\n  .mat-mdc-form-field-subscript-wrapper {\n    display: none;\n  }\n}\n.form-ultra-slim {\n  @extend .form-slim;\n  @include mat.form-field-density(-6);\n  @include mat.form-field-overrides(\n    (\n      filled-label-text-size: 10px,\n      container-text-size: 12px,\n    )\n  );\n  @include mat.select-overrides(\n    (\n      trigger-text-size: 12px,\n    )\n  );\n}\n\n.panel-dialog {\n  --mat-dialog-container-min-width: 650px;\n  --mat-dialog-container-max-width: 650px;\n  --mat-dialog-container-small-max-width: 95vw;\n}\n.medium-panel-dialog {\n  @extend .panel-dialog;\n  --mat-dialog-container-min-height: 700px;\n  --mat-dialog-container-max-height: 700px;\n  mat-dialog-container {\n    min-height: 700px !important;\n  }\n}\n.gallery-dialog {\n  --mat-dialog-container-min-width: 80vw;\n  --mat-dialog-container-small-max-width: 95vw;\n\n  --mat-dialog-container-min-height: 75vh;\n  --mat-dialog-container-max-height: 75vh;\n}\n\n.dialog-header-container {\n  display: flex !important;\n  align-items: center;\n  gap: 16px;\n  /* Remove this to allow to create sub component */\n  &::before {\n    //display: none !important;\n  }\n  .header-content {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-top: 12px;\n    color: var(--mat-sys-on-surface);\n  }\n  button {\n    flex-shrink: 0; /* Evita que los botones se deformen si el título es largo */\n  }\n  .close-button {\n    align-self: start;\n  }\n}\n\n.search-form-field {\n  flex: 1;\n  --mat-form-field-state-layer-color: transparent;\n  --mat-form-field-filled-active-indicator-color: transparent;\n  --mat-form-field-filled-active-indicator-height: 0px;\n  --mat-form-field-filled-hover-active-indicator-coloractive-indicator-color: transparent;\n  --mat-form-field-filled-focus-active-indicator-color: transparent;\n\n}\n// sidebar filters container\n.mat-toolbar-filters {\n  display: flex;\n  flex-direction: row;\n  gap: 0.3em;\n\n  > div {\n    width: 50%;\n\n    mat-form-field {\n      width: 100%;\n    }\n  }\n}\n.toolbar-viewer {\n  @include mat.fab-overrides(\n    (\n      small-container-color: var(--mat-sys-inverse-surface),\n    )\n  );\n\n  // No capturar eventos - permitir zoom y clicks en el mapa\n  pointer-events: none;\n\n}\n\n// Geocoding search autocomplete styles\n\n.pac-container:after {\n  background-image: none !important;\n  height: 0 !important;\n}\n\n.pac-item {\n  width: inherit !important;\n  white-space: normal !important;\n  line-height: 1.5 !important;\n}\n\n.pac-item-query {\n  display: inline !important;\n}\n\n// Bordered header\n.panel-section-header {\n  border-bottom: 1px solid var(--mat-sys-outline-variant);\n  background: var(--mat-sys-surface-container-lowest);\n}\n","/**\n * Vexcel Design System — Layout & Component Tokens\n *\n * CSS custom properties used across the chat UI and other components.\n *\n * RULE: Only define a --vx-* token when it is either:\n *   (a) a unique value with no --mat-sys-* equivalent, OR\n *   (b) a semantic concept (success, warning, link) that\n *       Material does not model and is used in ≥2 places.\n *\n * Use --mat-sys-* tokens directly everywhere else.\n */\n\n:root {\n  /* ── Layout dimensions ──────────────────────────────── */\n  --vx-panel-w:            350px;\n  --vx-bubble-w:           420px;\n  --vx-bubble-h:           600px;\n  --vx-panel-header-h:     48px;\n  --vx-dialog-w:           650px;\n\n  /* ── Semantic status colors ─────────────────────────── */\n  /* No Material equivalent; used across type-chip, HITL cards, mock-panel */\n  --vx-success:            #22a55a;\n  --vx-error:              #d04825;\n  --vx-on-error:           #ffffff;\n  --vx-error-container:    #d048251a;\n  --vx-on-error-container: #5c1800;\n  --vx-warning:            #f59e0b;\n  --vx-on-warning:         #ffffff;\n  --vx-warning-container:  color-mix(in srgb, var(--vx-warning) 15%, #fff);\n  --vx-on-warning-container: #5b4500;\n  --vx-tracking-wide:      0.08em; /* eyebrow / step-kicker letter-spacing */\n  --vx-link:               #2964aa;\n}\n\n/* ── Utility: spinning icon (used by sync icon during loading) ── */\n.spin-icon {\n  animation: vx-spin 1s linear infinite;\n}\n\n@keyframes vx-spin {\n  to { transform: rotate(360deg); }\n}\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.8 (https://getbootstrap.com/)\n   * Copyright 2011-2025 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n\n  // 3. Better affordance and consistent appearance for search cancel button\n  &::-webkit-search-cancel-button {\n    cursor: pointer;\n    filter: grayscale(1);\n  }\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  flex-shrink: 0;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-left: auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","@use '@vision/viewer-components/styles/globals' as *;\n@use '@angular/material' as mat;\n\n:root {\n  @include mat.form-field-overrides((\n          hover-state-layer-opacity: 0,\n          filled-label-text-color: var(--mat-sys-secondary),\n          filled-label-text-size: 20px,\n          filled-hover-label-text-color: var(--mat-sys-secondary),\n          filled-focus-label-text-color: var(--mat-sys-secondary),\n          filled-error-label-text-color: var(--mat-sys-secondary),\n          filled-error-hover-label-text-color: var(--mat-sys-secondary),\n          filled-error-focus-label-text-color: var(--mat-sys-secondary),\n  ));\n  @include mat.select-overrides((\n          panel-background-color: var(--mat-sys-background),\n  ));\n  @include mat.checkbox-overrides((\n          label-text-color: var(--mat-sys-secondary),\n  ));\n  @include mat.menu-overrides((\n          container-color: var(--mat-sys-background),\n  ));\n  @include mat.menu-overrides((\n          divider-color: rgba(var(--mat-sys-inverse-surface), 0.7)\n  ));\n}\n\n  mat-button-toggle-group {\n    background-color: #e0e0e0 !important;\n  }\n\n  mat-button-toggle {\n    border: none !important;\n    height: 100% !important;\n\n    .mat-button-toggle-button {\n      border: none !important;\n    }\n\n    .mat-button-toggle-label-content {\n      line-height: 32px !important;\n      padding: 0 16px !important;\n      font-size: 13px !important;\n      font-weight: 500 !important;\n      color: var(--mat-sys-inverse-surface) !important;\n      display: flex !important;\n      align-items: center !important;\n      justify-content: center !important;\n    }\n\n    &.mat-button-toggle-checked {\n      background-color: var(--mat-sys-primary) !important;\n\n      .mat-button-toggle-label-content {\n        color: white !important;\n      }\n    }\n    .mat-pseudo-checkbox-minimal.mat-pseudo-checkbox-checked::after{\n      color: white;\n    }\n\n    mat-button-toggle-group.neutral {\n      background-color: var(--mat-sys-inverse-surface) !important;\n\n      mat-button-toggle.mat-button-toggle-checked {\n        background-color: transparent !important;\n\n        .mat-button-toggle-label-content {\n          color: var(--mat-sys-inverse-surface) !important;\n        }\n      }\n    }\n  }\n\n.mat-mdc-slider {\n  --mat-mdc-slider-hover-ripple-color: unset; // 'none' also works\n  --mat-mdc-slider-focus-ripple-color: unset;\n}\n\n.mat-mdc-option-active {\n  background-color: var(--mat-sys-background) !important;\n  color: var(--mat-sys-primary) !important;\n}\n\n.mat-error .error-title {\n  font-weight: bold;\n  white-space: normal;\n  word-wrap: break-word;\n}\n\n.mat-mdc-form-field-error-wrapper {\n  z-index: 99 !important;\n  padding: 0 !important;\n}\n\n.mdc-text-field {\n  padding: 0 !important;\n}\n\n.mat-error {\n  margin: 0.25rem 0 0 0;\n  border-color: red;\n  border-style: solid;\n  border-width: 1px;\n  min-width: 100%;\n  background-color: #FFE8E8;\n  color: red;\n  font-size: var(--mat-sys-label-small-size) !important;\n}\n\n.mat-error p {\n  margin: 0 0.25rem 0 1.5rem !important;\n}\n\n.mat-error .error-title {\n  font-weight: bold;\n  white-space: normal;\n  word-wrap: break-word;\n  margin-top: -12px !important;\n}\n\n.mat-error .mat-icon {\n  font-size: 15px !important;\n  padding: 0.25rem;\n  position: absolute;\n  height: 24px !important;\n  width: 24px !important;\n}","@use '@vision/viewer-components/styles/globals' as *;\n@use '@angular/material' as mat;\n\n.auth-wrapper {\n  flex-direction: row;\n  box-sizing: border-box;\n  display: flex;\n  place-content: center;\n  align-items: center;\n  height: 100%;\n  background-image: url('assets/img/auth_back.webp');\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  justify-content: center;\n  align-content: center;\n\n  .auth-form {\n    width: 100%;\n    padding: 8px;\n    @include mat.form-field-overrides((\n            filled-label-text-weight: var(--mat-sys-title-medium-weight),\n            filled-label-text-color: var(--mat-sys-secondary),\n    ));\n\n    .mat-mdc-form-field {\n      width: 100%;\n\n      .mat-mdc-text-field-wrapper {\n        padding: 0;\n      }\n\n    }\n  }\n\n  .auth-box {\n    position: relative;\n    top: 0;\n    opacity: 1;\n    float: left;\n    width: 100%;\n    background: #fff;\n    border-radius: 2px;\n    transform: scale(1);\n    -webkit-transform: scale(1);\n    -ms-transform: scale(1);\n    z-index: 5;\n    max-width: 330px;\n    padding: 0;\n  }\n\n  .auth-container {\n    margin-top: 0.5rem;\n    padding: 2rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    h6 {\n      margin-top: 1rem;\n    }\n\n  }\n\n  @media (max-width: 767.98px) {\n    .auth-container {\n      width: 300px !important;\n    }\n    .auth-box {\n      max-width: 300px !important;\n    }\n  }\n\n  .auth-icon {\n    position: absolute;\n    right: 2%;\n    bottom: 1%;\n    background-image: url('assets/img/vexcel_white_logo.png');\n    background-size: contain;\n    background-repeat: no-repeat;\n    width: 100px;\n    height: 130px;\n    color: white;\n  }\n\n  .auth-title {\n    font-size: 20px;\n    font-weight: 500;\n  }\n\n  .auth-container-actions {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin: 20px 0;\n  }\n\n  .auth-loading-container {\n    flex-direction: row;\n    box-sizing: border-box;\n    display: flex;\n    place-content: center;\n    align-items: center;\n    background-color: rgba(131, 131, 131, 0.21);\n    position: absolute;\n    min-width: 100%;\n    min-height: 100%;\n    z-index: 99;\n    justify-content: center;\n    align-content: center\n  }\n\n  .auth-forgot-password {\n    display: block;\n    text-align: right;\n    margin-bottom: 15px;\n  }\n\n  .auth-container-resume {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n  }\n\n  .auth-accept-button {\n    font-size: 16px !important;\n    padding: 1.5rem 1rem !important;\n  }\n\n  .auth-accept-button.mat-button-disabled {\n    background-color: rgba(0, 0, 0, 0.12) !important;\n    color: rgba(0, 0, 0, 0.26) !important;\n  }\n\n  .auth-error-response-container {\n    margin-top: 0.7em;\n    position: relative;\n  }\n\n\n}","/* -------------------------------------------------------------------------\n * Optional Viewer Components Styles\n * -------------------------------------------------------------------------\n * These styles are not mandatory to be loaded globally.\n * They are separated so they can be loaded lazily if needed,\n * avoiding unnecessary bloat in the main bundle.\n */\n@use \"styles/components\";       // Styles for additional components\n@use \"styles/core-map-styles\";    // Styles for the core map library\n@import \"styles/external\";         // Styles for external libraries (e.g., OL, ol-ext, etc.)\n\n\n\n\n","@use 'styles/globals' as *;\n\nconfirm-download-dialog {\n  .download-button {\n    background-color: var(--mat-sys-primary);\n    color: white;\n  }\n}\n.dialogActions {\n  .buttonDialog {\n    color: white;\n    background-color: var(--mat-sys-primary) !important;\n  }\n\n  .buttonDialog:disabled {\n    //background-color: $disabled-color !important;\n    color: $gray-800 !important;\n  }\n\n  .cancelButton:disabled {\n    //background-color: $disabled-color !important;\n    color: $gray-800 !important;\n  }\n}\n\n.urlStyle{\n  width: 70%\n}\n\n\n\n.disabled {\n  color: rgba(0, 0, 0, 0.38);\n}\n\n.upload-div {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  margin-bottom: 4%;\n}\n\n.upload-div mat-form-field {\n  // width: 80%;\n}\n\n/* TODO(mdc-migration): The following rule targets internal classes of radio that may no longer apply for the MDC version. */\nmat-radio-group {\n  // margin-top: 1%;\n}\n\n.divButtonFoot {\n  justify-content: flex-end;\n  width: 100%;\n  display: inline-flex;\n}\n\n.spacer {\n  flex: 1 1 auto;\n}\n\n.horizontal-container {\n  padding: 10px;\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n\n  mat-form-field, .slider-wrapper {\n    // width: 45%;\n  }\n}\n\n.layersContainer {\n  max-height: 200px;\n  max-width: 540px;\n  overflow-y: scroll;\n\n  > div {\n    border: 1px solid #C3C1C1;\n    margin-bottom: 15px;\n\n    .layer-info {\n      display: flex;\n      flex-wrap: wrap;\n      flex-direction: column;\n    }\n  }\n\n  .horizontal-container mat-checkbox {\n    // width: 100%;\n    /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */\n    /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */\n    .mat-checkbox-layout {\n      // width: 100%;\n      // margin-bottom: 0;\n      /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */\n      .mat-checkbox-label {\n        // width: 95%;\n      }\n    }\n\n  }\n}\n\n.type-radio-group {\n  width: 30%;\n  display: flex;\n\n  .spacer {\n    flex: 0.47 0.5 auto;\n\n    &.auth-option-spacer {\n      min-width: 27%;\n    }\n  }\n}\n\n.bottom-wrapper {\n  display: flex;\n\n  button {\n    width: 30%;\n    max-width: 165px;\n  }\n}\n\n.loading {\n  display: flex;\n  align-items: center;\n  width: 30%;\n\n  span {\n    color: rgba(0,0,0,0.7);\n  }\n}\n","@use 'styles/globals' as *;\n@use '@angular/material' as mat;\n\n.overlay-widget {\n  .layer-row {\n    font-size: 12px;\n    height: 24px;\n    box-shadow: unset;\n    padding: 0 !important;\n    display: contents !important;\n    background-color: rgba(76, 81, 85, 0.65);\n    color: white;\n  }\n\n  .layer-name {\n    color: white;\n  }\n\n\n}\n\n.layer-manager-sync {\n  position: absolute;\n  width: 350px;\n  top: 0;\n  right: 50px;\n  bottom: 50px;\n  left: 0;\n  overflow: inherit;\n}\n\napp-layer-manager-widget {\n  .child-layers {\n    padding-left: 1em !important;\n    overflow: unset !important;\n  }\n\n  .main-layer {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .layer-name {\n    color: white !important;\n  }\n\n  .icon-container.arrow-icon-spacing {\n    margin-left: -2px !important;\n    width: 14px !important;\n  }\n}\n\n\napp-layer-item {\n  width: 100% !important;\n}\n\n.layer-content {\n  flex-grow: 1;\n}\n\n.layer-name {\n  color: #797E82;\n  font-weight: normal !important;\n}\n\n.layer-name.disabled {\n  color: $gray-500 !important;\n}\n\n\n.layer-manager-container .overlay-container {\n  display: block;\n}\n\n.layer-selector {\n  width: 100%;\n  margin-bottom: 20px;\n  padding: 0;\n}\n.icon-container{\n  padding-top: 5px;\n  width: 20px !important;\n  display: flex;\n  align-items: center;\n  vertical-align: center;\n}\n\n.icon-container.arrow-icon-spacing {\n  margin-left: -10px;\n}\n\n.layer-row .mat-icon {\n  // font-size: 20px;\n  user-select: none;\n}\n.layer-row .mat-icon.icon-description {\n  // font-size: 14px;\n  // width: 14px;\n  // height: 14px;\n  // margin-left: 10px;\n}\n\n.left-mat-icon {\n  width: 20px !important;\n  cursor: pointer;\n}\n\n#security-icon {\n\n    @include mat.icon-density(-4);\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n}\n\n.material-icons.folder-icon {\n  color: $blue;\n}\n.layer-row .tools-container .mat-mdc-icon-button {\n  // width: 26px;\n  // height: 26px;\n  // line-height: 26px;\n}\n\n.layer-row .tools-container .location-button {\n  opacity: 0.7;\n}\n\n.layer-row .tools-container .location-button:disabled {\n  color: $gray-500;\n}\n.layer-row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin: 6px 0;\n  padding: 6px 2px;\n  border-radius: 4px;\n}\n\n\n.layer-row .tools-container .mat-mdc-icon-button {\n  // width: 26px;\n  // height: 26px;\n  // line-height: 26px;\n}\n\n.layer-row .tools-container .location-button:disabled {\n  color: $gray-500;\n}\n\n.layer-row .tools-container .mat-divider {\n  border-right: 2px $gray-500 solid !important;\n  // opacity: 0.35;\n  // margin: 4px 0;\n  // height: 18px;\n}\n\n.layer-name {\n  padding: 0 6px;\n  font-size: 13px;\n}\n\n.layer-menu .mat-mdc-menu-item{\n  // height: 32px !important;\n  // display: flex !important;\n  // align-items: center !important;\n}\n.layer-menu .mat-mdc-menu-content {\n  // padding: 0 !important;\n}\n/**\nDraggable layer panel\n */\n.layer-selector .cdk-drag-preview {\n  box-sizing: border-box;\n  // border-radius: 4px;\n  // box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n  //0 8px 10px 1px rgba(0, 0, 0, 0.14),\n  //0 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.layer-selector .cdk-drag-placeholder {\n  // opacity: 0;\n}\n\n.layer-selector .cdk-drag-animating {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.layer-selector .layer-row:last-child {\n  border: none;\n}\n\n.layer-selector .base-layer-group.cdk-drop-list-dragging .layer-row:not(.cdk-drag-placeholder) {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.child-layers {\n  padding-left: 3rem;\n  margin-left: 0.5rem !important;\n  width: 100%;\n}\n\n.child-features {\n  display: flex;\n}\n\n.feature-content{\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: 4px 2px;\n  margin-left: 15px;\n  line-height: 20px;\n}\n\n.feature-content span{\n  max-width: 190px;\n  display: inline-block;\n}\n\n.feature-icon {\n  padding: 5px;\n}\n\n.feature-button .mat-icon{\n  // transform: rotate(-45deg);\n}\n\n.left-mat-icon {\n  width: 20px !important;\n  height: 20px !important;\n  cursor: pointer;\n}\n\n.no-pointer {\n  cursor: default !important;\n}\n\n.mat-divider {\n  border-top-color: rgba(0, 0, 0, 0.15);\n}\n\n.primary-field {\n  font-size: 0.80rem;\n}\n\n.secondary-field {\n  font-size: 0.70rem;\n}\n\n.highlight {\n  font-weight: bold !important;\n  background: rgba(73, 150, 233, 0.2) 0 0 no-repeat padding-box;\n  border-radius: 4px;\n}\n\n.svg_left-icons {\n  width: 70%;\n  height: 70%;\n}\n\n.icon-field {\n  padding: 8px !important;\n  margin: 0 !important;\n}\n\n.zoom-to-feature mat-icon {\n  transform: scale(1) !important;\n}\n.switch-button{\n  font-size: 34px;\n  width: 34px;\n  height: 34px;\n  color: #9c9c9c;\n}\n.switch-button.on{\n  color: $blue;\n}\n","// The following variables are customization of boostrap and must appear before the bootstrap import\n// To view other customizable variables, look in node_modules > bootstrap > scss > _variables.scss\n\n$header-height: 64px;\n\n$grid-breakpoints: (\n  xxxs: 0,\n  xxs: 320px,\n  xs: 568px,\n  sm: 667px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1440px,\n  xxxl: 1600px\n);\n\n$container-max-widths: (\n  xxxs: 0,\n  xxs: 320px,\n  xs: 568px,\n  sm: 667px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1440px,\n  xxxl: 1600px\n);\n$white-33-opaq:   rgba(255,255,255,0.33);\n$white-80-opaq:   rgba(255,255,255,0.8);\n$white-90-opaq:   rgba(255,255,255,0.9);\n$blue:    #1877af;\n$red:     #cc8772;\n$yellow:  #FEAC00;\n$orange: #FD7E14;\n$light-yellow: #FFFDE7;\n$green:   #84bd00;\n$cyan:    #47afec;\n\n$gray-extra-light-solid: #f5f5f5;\n$gray-50: rgba(157, 161, 163, .05);\n$gray-100: rgba(157,161,163,.1);\n$gray-200: rgba(157,161,163,.15);\n$gray-300: rgba(0,0,0,.25);\n$gray-400: rgba(157,161,163,.8); // secondary\n$gray-500: rgb(157,161,163);\n$gray-600: #F1F1F2;\n$gray-700: rgba(157,161,163,.35);\n$gray-800: #53575a;\n$gray-900: #212529;\n$black:    #000;\n\n//Variables for the material design custom theme:\n$dark-primary-text: rgba(black, 0.87);\n$light-primary-text: white;\n$accent-button-text: #FF6060;\n\n//color palettes\n$light-blue-palette: (\n  50: $blue,\n  100: $blue,\n  200: #1c8aca,\n  300: $blue,\n  400: $blue,\n  500: $blue,\n  600: #125c87,\n  700: $blue,\n  800: $blue,\n  900: $blue,\n  A100: $blue,\n  A200: $blue,\n  A400: $blue,\n  A700: $blue,\n  contrast: (\n    50: $dark-primary-text,\n    100: $dark-primary-text,\n    200: $dark-primary-text,\n    300: $dark-primary-text,\n    400: $dark-primary-text,\n    500: $light-primary-text,\n    600: $light-primary-text,\n    700: $light-primary-text,\n    800: $light-primary-text,\n    900: $light-primary-text,\n    A100: $dark-primary-text,\n    A200: $dark-primary-text,\n    A400: $dark-primary-text,\n    A700: $light-primary-text,\n  )\n);\n\n$light-green-palette: (\n  50: #dff0d8,\n  100: $green,\n  200: #a1e600,\n  300: $green,\n  400: $green,\n  500: $green,\n  600: #6b9900,\n  700: $green,\n  800: $green,\n  900: $green,\n  A100: $green,\n  A200: $green,\n  A400: $green,\n  A700: $green,\n  contrast: (\n    50: $light-primary-text,\n    100: $light-primary-text,\n    200: $light-primary-text,\n    300: $light-primary-text,\n    400: $light-primary-text,\n    500: $light-primary-text,\n    600: $light-primary-text,\n    700: $light-primary-text,\n    800: $light-primary-text,\n    900: $light-primary-text,\n    A100: $light-primary-text,\n    A200: $light-primary-text,\n    A400: $light-primary-text,\n    A700: $light-primary-text,\n  )\n);\n\n$mat-light-red: (\n  50: $red,\n  100: $red,\n  200: #d69f8f, //Lighter\n  300: $red,\n  400: $red, //Default\n  500: $red,\n  600: #c26f56, //Darker\n  700: $red,\n  800: $red,\n  900: $red,\n  A100: $red,\n  A200: $red,\n  A400: $red,\n  A700: $red,\n  contrast: (\n    50: $light-primary-text,\n    100: $light-primary-text,\n    200: $light-primary-text,\n    300: $light-primary-text,\n    400: $light-primary-text,\n    500: $light-primary-text,\n    600: $light-primary-text,\n    700: $light-primary-text,\n    800: $light-primary-text,\n    900: $light-primary-text,\n    A100: $light-primary-text,\n    A200: $light-primary-text,\n    A400: $light-primary-text,\n    A700: $light-primary-text,\n  )\n);\n\n$mat-light-yellow: (\n  50: #FFFDE7,\n  100: #FFF9C4,\n  200: #FFF59D,\n  300: #FFF176,\n  400: #FFEE58,\n  500: #FFEB3B,\n  600: #FDD835,\n  700: #FBC02D,\n  800: #F9A825,\n  900: #F57F17,\n  A100: #FFFF8D,\n  A200: #FFFF00,\n  A400: #FFEA00,\n  A700: #FFD600,\n  contrast: (\n    50: $light-primary-text,\n    100: $light-primary-text,\n    200: $light-primary-text,\n    300: $light-primary-text,\n    400: $light-primary-text,\n    500: $light-primary-text,\n    600: $light-primary-text,\n    700: $light-primary-text,\n    800: $light-primary-text,\n    900: $light-primary-text,\n    A100: $light-primary-text,\n    A200: $light-primary-text,\n    A400: $light-primary-text,\n    A700: $light-primary-text,\n  )\n);\n\n$secondary:     $gray-400;\n$success:       $green;\n$info:          $cyan;\n$warning:       $yellow;\n$danger:        $red;\n$light:         $gray-100;\n$dark:          $gray-800;\n\n","@use 'styles/globals' as *;\n@use '@angular/material' as mat;\n.link-btn {\n  color: var(--mat-sys-primary);\n  cursor: pointer;\n  pointer-events: all;\n}\n\n.toolbar-toggle-container {\n  position: relative;\n}\n\n.toolbar-panel-container {\n  position: absolute;\n  padding: 15px;\n  left: 50px;\n  top: 0;\n  width: 350px;\n  height: 100%;\n  max-height: 100%;\n  background-color: var(--mat-sys-surface);\n  z-index: 5;\n  flex: 1;\n  overflow-x: auto;\n}\n\n.scale-line{\n  margin-top: 8px !important;\n}\n\n.scale-line-selector{\n  z-index: 4;\n}\n\n#unit-selector-panel{\n  position: absolute;\n  bottom: 7em;\n}\n\n.button-area {\n  display: flex !important;\n}\n\n.restore-button{\n  background-color: var(--mat-sys-on-primary) !important;\n  color: var(--mat-sys-primary)  !important;\n  padding: 0 8px !important;\n}\n\n.save-button{\n  background-color: var(--mat-sys-primary) !important;\n  color: var(--mat-sys-on-primary) !important;\n}\n\n.non-truncated-property-tooltip{\n  word-break: keep-all !important;\n  white-space: normal !important;\n  max-width: 215px !important;\n}\n\n.non-truncated-property-tooltip-disabled{\n  word-break: keep-all !important;\n  white-space: normal !important;\n  max-width: 240px !important;\n}\n\n.non-truncated-damage-tooltip{\n  word-break: keep-all !important;\n  white-space: normal !important;\n  max-width: 251px !important;\n}\n\n.non-truncated-damage-tooltip-disabled{\n  word-break: keep-all !important;\n  white-space: normal !important;\n  max-width: 267px !important;\n}\n\n.non-truncated-pdf-tooltip{\n  word-break: keep-all !important;\n  white-space: normal !important;\n  max-width: 230px !important;\n}\n\n.non-truncated-pdf-tooltip-disabled{\n  word-break: keep-all !important;\n  white-space: normal !important;\n  max-width: 280px !important;\n}\n","@use 'styles/globals' as *;\napp-infrared-selector {\n  .switch-button.on {\n    color: var(--mat-sys-primary) !important;\n  }\n\n  button.on {\n    color: var(--mat-sys-primary) !important;\n  }\n}\n\napp-collection-controller {\n  .path-orientation.selected {\n    fill: var(--mat-sys-primary);\n  }\n\n  .nadir-button.selected {\n    color: var(--mat-sys-primary);\n  }\n\n  .infrared-button.selected {\n    color: var(--mat-sys-primary);\n  }\n\n  .path-mode.selected {\n    fill: var(--mat-sys-primary);\n  }\n}\n\n.mode-badge {\n  width: 20px !important;\n  height: 20px !important;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: bold;\n  color: #fff;\n  line-height: 20px;\n  text-align: center;\n  background-color: #008DFF;\n}\n\n.mode-badge.gray {\n  background-color: #BFBFBF;\n}\n\n.mode-badge.second-mode-badge {\n  margin-left: 4px;\n}\n\n.collection-preview-card {\n  min-width: 600px;\n  position: relative !important;\n  pointer-events: auto;\n  padding: 0 35px !important;\n  .mat-mdc-card-content {\n    padding: 0 !important; // Por defecto suele traer padding lateral, quítalo si vas a usar el de la card\n    position: relative !important;\n    margin-top: 20px !important;\n    height: 80px;\n  }\n  &.mini .mat-mdc-card-content {\n    margin-top: 30px !important;\n  }\n\n}\n.mini-slider {\n  min-width: 105px !important;\n  .filters-panel {\n    left: 60px !important;\n    margin: 15px 0 !important;\n  }\n}\n\n\n\n.collection-preview-card .ngx-slider-limit{\n  color: black;\n  font-size: 14px;\n}\n\n.collection-preview-card .ngx-slider .ngx-slider-bar {\n  background: #E3E3E3;\n  height: 2px;\n}\n\n/* START Pointer stop timeline style */\n.collection-preview-card .ngx-slider .ngx-slider-pointer {\n  outline-width: 0 !important;\n  margin-left: -2px;\n  top: 22px;\n  background-color: transparent !important;\n  z-index: 3;\n  border-radius: 0;\n\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-bottom: 15px solid #f1f1f2;\n}\n\n.mini-slider .ngx-slider .ngx-slider-pointer {\n  left: 16px !important;\n}\n\n.collection-preview-card .ngx-slider .ngx-slider-pointer::after {\n  border-radius: 4px;\n  width: 6px !important;\n  height: 6px !important;\n  background-color: white !important;\n  top: 7px !important;\n  left: -3px !important;\n}\n/* END Pointer stop timeline style */\n\n/* START Stops timeline style */\n.collection-preview-card .ngx-slider .ngx-slider-tick {\n  font-family: Roboto-Light, Roboto,sans-serif;\n  font-size: 12px !important;\n  position: absolute;\n  font-weight: bold !important;\n  color: #fff !important;\n  margin: 0 0 0 -2px !important;\n  border-radius: 10px;\n}\n\n.mini-slider .ngx-slider .ngx-slider-tick.gray {\n  left: 16px !important;\n}\n\n.mini-slider .ngx-slider .ngx-slider-tick {\n  left: 16px !important;\n}\n\n.collection-preview-card .ngx-slider .ngx-slider-tick::after,\n{\n  position: absolute;\n  width: 20px !important;\n  height: 20px !important;\n  font-weight: bold !important;\n  color: #fff !important;\n  top: -5px !important;\n  left: -5px !important;\n  line-height: 20px;\n  border-radius: 10px;\n  background-color: #008DFF !important;\n}\n\n.collection-preview-card .ngx-slider .ngx-slider-tick.wide::after {\n  position: absolute;\n  width: 20px !important;\n  height: 20px !important;\n  font-weight: bold !important;\n  color: #fff !important;\n  top: -5px !important;\n  left: -5px !important;\n  line-height: 20px;\n  border-radius: 10px;\n  background-color: #8ECCFF !important;\n}\n\n.collection-preview-card .ngx-slider .ngx-slider-tick.gray::after {\n  position: absolute;\n  width: 30px !important;\n  height: 30px !important;\n  font-weight: bold !important;\n  top: -8px !important;\n  left: -8px !important;\n  line-height: 24px;\n  margin: 0 0 0 -2px !important;\n  background-color: #BFBFBF !important;\n  -webkit-mask: url(\"assets/images/white-storm-border.svg\") no-repeat no-repeat;\n  mask: url(\"assets/images/white-storm-border.svg\") no-repeat no-repeat;\n  -webkit-mask-size: 30px;\n}\n\n\n\n.collection-preview-card .ngx-slider .ngx-slider-tick.threeD::after {\n  content: '3D' !important;\n}\n\n.collection-preview-card .ngx-slider .ngx-slider-tick.twoD::after {\n  content: '2D' !important;\n}\n\n.collection-preview-card .ngx-slider-tick-value{\n  color: #e2e2e2;\n  font-size: 12px !important;\n  white-space: nowrap !important;\n  top: -22px !important;\n}\n\n.collection-preview-card .ngx-slider .ngx-slider-tick.gray .ngx-slider-tick-value{\n  top: -18px !important;\n}\n\n.collection-preview-card .ngx-slider-tick.collection-hide{\n  opacity: 0.35;\n}\n/* END Stops timeline style */\n\n/* START Legend timeline style */\n.collection-preview-card .ngx-slider-tick-legend{\n  top: 2px !important;\n  font-size: 10px;\n  color: #F4F5F7;\n  text-shadow: 0 3px 6px #000000;\n  margin-top: 10px;\n  white-space: nowrap !important;\n}\n\n.collection-preview-card .ngx-slider-span {\n  height: 0;\n}\n\n.collection-preview-card .ngx-slider .ngx-slider-tick-legend .legend-limits {\n  text-align: center !important;\n}\n\n.legend-limits {\n  position: absolute;\n  bottom: 37px;\n  margin: 0 0 -15px -18px !important;\n  width: 37px;\n  height: 30px;\n  overflow: hidden;\n  white-space: pre-wrap;\n}\n\n.legend-year {\n  position: absolute;\n  font-size: 12px;\n  top: -35px !important;\n  margin-left: -10px;\n}\n/* END Legend timeline style */\n\n/* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */\n.collection-selector .mat-checkbox-inner-container{\n  // width: 12px;\n  // height: 12px;\n}\n/* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */\n.collection-selector .mat-mdc-checkbox .mat-checkbox-ripple {\n  // left: calc(50% - 7px) !important;\n  // top: calc(50% - 7px) !important;\n  // height: 14px !important;\n  // width: 14px !important;\n}\n\n.right-padding {\n  padding-right: 50px !important;\n}\n\n.slider-padding {\n  display: flex !important;\n}\n\n.disabled{\n  pointer-events: none;\n}\n\n.float-right {\n  float: right;\n}\n\n.collection-hide {\n  opacity: 0.25;\n}\n\n.hide {\n  display: none !important;;\n}\n\n.center {\n  position: relative;\n}\n\n.block {\n  display: block;\n}\n\n\n.container-line {\n  width: 80px;\n  height: 1px;\n  background-color: black;\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n\n.circle {\n  display: inline-block;\n  vertical-align: middle;\n  width: 10px;\n  height: 10px;\n  background-color: white;\n  border: solid 1px black;\n  border-radius: 50%;\n  position: absolute;\n  top: -4px;\n  left: calc(50% - 5px);\n}\n\n\n.white {\n  background: white;\n}\n\n\n.white .circle {\n  background: white;\n  border-color: white;\n}\n\n.badge-display {\n  margin-top: -17px;\n  position: absolute;\n}\n\n.date-label {\n  text-align: center;\n  color: white;\n  padding-top: 23px;\n  position: relative;\n}\n\n.date-mini-slider {\n  text-align: center;\n  font-size: 10px;\n  text-shadow: 3px 3px #43464b;\n  position: relative;\n}\n\n.text-white {\n  color: white;\n}\n","@use 'styles/globals' as *;\n\n.sidebar-component {\n  box-sizing: content-box;\n  padding: 0 24px 16px;\n  display: block;\n  margin: 0;\n  border-radius: 4px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n  background-color: white;\n}\n\n.sidebar-component .header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-top: 10px;\n}\n\n.sidebar-component .container-title{\n  font-weight: bold;\n  padding-left: 10px;\n  display: block;\n  font-size: 14px;\n  margin-left: -20px;\n  color: black;\n}\n.sidebar-component .sub-title{\n  text-align: left;\n  color: black;\n  padding: 4px;\n  margin: 10px 0;\n}\n\n\n\n\n.sidebar-component .header-container {\n  flex: 1 1 auto;\n}\n\n.sidebar-component .container-title {\n  color: $green;\n  font-weight: bold;\n  padding-left: 10px;\n  display: block;\n  font-size: 12px;\n  padding-top: 4px;\n}\n\n.sidebar-component .sub-title {\n  color: $green;\n  font-weight: bold;\n  padding-left: 20px;\n  text-align: center;\n  font-size: 10px;\n}\n.sidebar-component .info-title {\n  color: $gray-500;\n  font-weight: bold;\n  padding-left: 10px;\n  text-align: center;\n  font-size: 12px;\n}\n\n.sidebar-component .top-divider {\n  border-top: 2px $gray-400;\n}\n\n.sidebar-component .container-subtitle {\n  padding-left: 10px;\n  color: $gray-500;\n  font-size: 10px;\n  display: block;\n}\n\n.sidebar-icon-indicator {\n  height: 28px;\n  width: 28px;\n  font-size: 28px;\n}\n\n.sidebar-radio-button {\n  padding: 0 6px 0 0;\n}\n\n","@use 'styles/globals' as *;\n\n\n/*  FullScreen mode */\n\n.fullscreen {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background-color: #262626;\n  color: white;\n\n  .top-info-panel {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    height: 7%;\n    position: absolute;\n    top: 0;\n    justify-content: space-between;\n    padding: 0 3%;\n    z-index: 16;\n    background-color: #262626;\n\n    .info-back-wrapper {\n      width: 19%;\n      display: flex;\n      min-width: 360px;\n      align-items: center;\n      padding-top: 1%;\n\n      mat-icon {\n        cursor: pointer;\n      }\n\n      .address {\n        text-align: left;\n        font-size: 16px;\n        padding-left: 1%;\n        width: 100%;\n      }\n    }\n\n    .view-on-map-button {\n      border: none;\n      font-size: 16px;\n      font-weight: bold;\n      background: transparent;\n      color: var(--mat-sys-primary);\n\n      &:focus { outline: none; }\n\n      mat-icon {\n        position: relative;\n        top: 7px;\n      }\n    }\n  }\n\n  .side-column {\n    width: 10%;\n    display: flex;\n    flex-direction: column;\n    min-height: 10%;\n    justify-content: center;\n\n    .arrow-label {\n      position: relative;\n      top: 20px;\n    }\n\n    &.align-right {\n      align-items: flex-end;\n      padding-right: 1%;\n    }\n\n    &.align-left {\n      align-items: flex-start;\n      padding-left: 1%;\n    }\n\n    mat-icon {\n      cursor: pointer;\n      position: absolute;\n    }\n  }\n\n  .fullscreen-image {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    overflow: hidden;\n\n    .img-wrapper {\n      width: 80%;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      margin: 0 auto;\n      overflow: hidden;\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n\n      .image {\n        position: relative;\n        display: flex;\n        min-width: 80%;\n        align-items: center;\n        justify-content: center;\n\n        .image-mask {\n          position: absolute;\n          background-color: #F9FAFB;\n          border: 1px solid #707070;\n          height: 100%;\n          width: 100%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          z-index: 15;\n\n          .loading-animation {\n            width: 80px;\n            height: 80px;\n\n            div {\n              transform-origin: 11px 40px;\n              margin-left: 35%;\n\n              &::after {\n                width: 4px;\n                height: 19px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .bottom-info-panel {\n    width: 100%;\n    height: 13%;\n    position: absolute;\n    bottom: 0%;\n    padding: 0 3%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 16;\n    background-color: #262626;\n\n    .image-info-wrapper {\n      display: flex;\n      height: 100%;\n      width: 26%;\n      justify-content: space-between;\n      align-items: center;\n      min-width: 370px;\n      word-wrap: break-word;\n\n      .image-gsd-type {\n        text-transform: capitalize;\n      }\n    }\n\n    .bottom-actions-panel {\n      display: flex;\n      justify-content: space-between;\n\n      .mat-button-toggle {\n        background: transparent;\n      }\n\n      .fullscreen-action {\n        &.active {\n          background-color: $white-33-opaq;\n        }\n      }\n\n      .fullscreen-control-panel {\n        background-color: $gray-800;\n      }\n\n      .count {\n        display: flex;\n        align-items: center;\n        width: 43px;\n        justify-content: center;\n      }\n    }\n  }\n\n  .disabled, .disabled mat-icon {\n    color: $gray-400;\n    cursor: default;\n  }\n}\n\n.toolTipButton {\n  position: relative;\n  display: inline-block;\n  border-bottom: 1px dotted black;\n}\n\n.toolTipButton .tooltiptext {\n  visibility: hidden;\n  font-weight: 500;\n  font-size: 10px;\n  background-color: #616161;\n  margin: 30px 14px 14px 14px;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 6px 8px;\n  position: absolute;\n  z-index: 1;\n}\n\n.toolTipButton:hover .tooltiptext {\n  visibility: visible;\n}\n\n.fullscreen-info-panel {\n  background: white;\n  color: #3C4043;\n\n  .info-details {\n    div {\n      &.value-list {\n        color: rgba(0, 0, 0, 0.54);\n      }\n    }\n  }\n}\n\n\n.toolbar-header-wrapper {\n  .toolbar-gallery-header {\n    .open-gallery-button {\n      color: var(--mat-sys-primary);\n    }\n\n    .collapse-button {\n      mat-icon {\n        background: #F7F9FC;\n        color: var(--mat-sys-primary);\n\n        &:hover {\n          color: #F7F9FC;\n          background: var(--mat-sys-primary);\n        }\n      }\n    }\n  }\n}\n\n.toolbar-gallery-info-panel {\n  .scroll-arrow {\n    background: whitesmoke;\n\n    &#left-arrow {\n      background: linear-gradient(270deg, transparent 0, rgba(245, 245, 245, 1) 30%);\n    }\n\n    &#right-arrow {\n      background: linear-gradient(90deg, transparent 0, rgba(245, 245, 245, 1) 30%);\n    }\n  }\n\n  .image-filters {\n    .filter {\n      background-color: white;\n      border: 1px solid #0000003F;\n      box-shadow: 0px 3px 6px #9DA1A359;\n\n      &.selected {\n        border-color: var(--mat-sys-primary);\n      }\n    }\n  }\n}\n\n.image-wrapper {\n  &.is-selected {\n    border-color: var(--mat-sys-primary) !important;\n  }\n}\n\n.collections-wrapper, .toolbar-gallery-container {\n  &::-webkit-scrollbar {\n    background-color: $gray-extra-light-solid;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #BEBEC4 0% 0% no-repeat padding-box;\n  }\n\n  .collection-cover {\n    .cover-year-label {\n      color: $light-primary-text;\n\n      &:after {\n        background: transparent linear-gradient(180deg, #F7F7FF0D 0%, #969696D3 33%, #5F5F62 100%) 0% 0% no-repeat padding-box;\n      }\n    }\n  }\n}\n\n\n/*  Image Gallery colors */\n\n\n\n.selected-image {\n  box-shadow: inset 0px 0px 1px 5px var(--mat-sys-primary);\n}\n\n /*Filter styles*/\n.filter-group {\n\n  //.mat-button-toggle {\n  //\n  //  background-color: white !important;\n  //  // border: 2px solid rgba(0, 0, 0, 0.25) !important;\n  //  // box-shadow: 0 3px 6px rgba(157, 161, 163, 0.35);\n  //  color: black !important;\n  //  // width: auto !important;\n  //  // line-height: 38px !important;\n  //  // height: 38px !important;\n  //}\n  ///*  TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */\n  //.mat-button-toggle-button {\n  //  outline: none !important;\n  //}\n  ///*  TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */\n  //.mat-button-toggle .mat-button-toggle-label-content {\n  //  // line-height: 36px !important;\n  //  // padding: 0 !important;\n  //  // margin: 0 12px;\n  //}\n  ///*  TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */\n  //.mat-button-toggle.locked {\n  //  // pointer-events: none;\n  //}\n\n}\n/*Placeholder*/\n @keyframes placeHolderShimmer {\n   0% {\n     background-position: -468px 0\n   }\n   100% {\n     background-position: 468px 0\n   }\n }\n","@use 'styles/globals' as *;\n\n.dialog-bottom-actions-spacing {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  height: 100%;\n}\n\n\n\n.upload-layer-container {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n\n  .info-row {\n    display: inline-flex;\n    justify-content: space-between;\n    text-align: center;\n  }\n}\n\nhr {\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid $gray-800;\n  margin: 1em 0;\n  padding: 0;\n  width: 99%;\n}\n\n.url-form {\n  padding-bottom: 30px;\n}\n\n.layer-name-label {\n  max-width: 300px !important;\n  white-space: nowrap;\n  overflow: hidden;\n  display: block;\n  text-overflow: ellipsis;\n}\n\n\n.buttonDialog {\n  width: 20%;\n  margin: 10px;\n  display: flex;\n  justify-content: center;\n}\n\n.cancelButton {\n  width: 20%;\n  margin: 10px;\n  display: flex;\n  justify-content: center;\n  background-color: white !important;\n  color: black !important;\n}\n\n\n.dialogActions {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n}\n\n.name-end-icon {\n  padding-left: 15px;\n}\n\n.row-field-name {\n  width: 60% !important;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.row-field {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.name {\n  display: flex;\n  align-items: center;\n}\n\n.edit-icon {\n  padding-left: 20px !important;\n  color: $gray-800;\n  padding-right: 20px !important;\n}\n\n.add-data-title {\n  padding-left: 10px;\n}\n\n\n\n\n\n.layer-name-dialog{\n  width: 100%;\n\n}\n\n.name-field-color {\n  color: $gray-800 !important;\n}\n\n.type-radio-group {\n  width: 30%;\n  display: flex;\n\n  .spacer {\n    flex: 0.47 0.5 auto;\n  }\n}\n\n.bottom-wrapper {\n  display: flex;\n\n  button {\n    width: 30%;\n    max-width: 165px;\n    color: var(--mat-sys-primary);\n  }\n}\n\n.upload-layer-content {\n  display: flex;\n  max-height: 40vh !important;\n  justify-content: space-between;\n  flex-direction: column;\n  overflow-y: scroll;\n}\n\n.spacer {\n  flex: 1 1 auto;\n}\n\n\n.auth-div {\n  padding-bottom: 20px;\n}\n\n\n.checkbox-padding {\n  padding-right: 20px !important;\n}\n\n.auth-field {\n  width: 100%;\n  display: inline-flex;\n  justify-content: flex-start;\n  align-items:center;\n}\n\n\n.horizontal-container {\n  padding: 10px;\n  width: 100%;\n  justify-content: space-between;\n  display: inline-flex;\n  align-items:center;\n\n  &.rename-form {\n    padding-top: 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n\n\n\n\n.url-div {\n  display: inline-block;\n}\n\n.loading {\n  padding-top: 30px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100% !important;\n  max-height: 150px !important;\n}\n\n.error {\n  color: red;\n}\n\n.loading-data-label {\n  padding-top: 50px;\n}\n\n\n.mat-mdc-option.mat-active {\n  background: white !important;\n}\n\n.mat-mdc-option.mat-mdc-selected {\n  background: white !important;\n}\n\n::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 7px;\n}\n::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0,0,0,.5);\n  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);\n}\n\n/* TODO(mdc-migration): The following rule targets internal classes of slider that may no longer apply for the MDC version.*/\n.mat-mdc-slider.mat-accent .mat-slider-thumb-label-text {\n  color: white !important;\n}\n\n\n.slider-wrapper {\n  .slider-label {\n    color: rgba(0, 0, 0, 0.42);\n    font-size: 11px;\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  }\n\n\n}\n\n.dropzone {\n  background-color: #F3F2F190;\n  border: 1px dashed var(--mat-sys-primary);\n\n  .dropzone-label {\n    color: $gray-500;\n    font-weight: 500;\n  }\n\n\n\n}\n//// Loader styles\n//.loading-animation {\n//  width: 50px;\n//  height: 50px;\n//\n//  div {\n//    transform-origin: 13px 44px;\n//    margin-left: 85%;\n//\n//\n//    &::after {\n//      width: 7px;\n//      height: 23px;\n//      border: 1px solid rgb(42, 42, 42);\n//      border-radius: 30%;\n//      background:  $gray-800;\n//    }\n//  }\n//}\n/*  Loader styles */\n.loading-animation {\n  width: 40px;\n  height: 40px;\n\n  div {\n    transform-origin: 11px 18px;\n    animation: lds-spinner 1.2s linear infinite;\n\n    &:after {\n      content: \" \";\n      display: block;\n      position: absolute;\n      top: 5px;\n      left: 10px;\n      width: 2px;\n      height: 8px;\n      background: black;\n    }\n\n    &:nth-child(1) {\n      transform: rotate(0deg);\n      animation-delay: -1.1s;\n    }\n\n    &:nth-child(2) {\n      transform: rotate(30deg);\n      animation-delay: -1s;\n    }\n\n    &:nth-child(3) {\n      transform: rotate(60deg);\n      animation-delay: -0.9s;\n    }\n\n    &:nth-child(4) {\n      transform: rotate(90deg);\n      animation-delay: -0.8s;\n    }\n\n    &:nth-child(5) {\n      transform: rotate(120deg);\n      animation-delay: -0.7s;\n    }\n\n    &:nth-child(6) {\n      transform: rotate(150deg);\n      animation-delay: -0.6s;\n    }\n\n    &:nth-child(7) {\n      transform: rotate(180deg);\n      animation-delay: -0.5s;\n    }\n\n    &:nth-child(8) {\n      transform: rotate(210deg);\n      animation-delay: -0.4s;\n    }\n\n    &:nth-child(9) {\n      transform: rotate(240deg);\n      animation-delay: -0.3s;\n    }\n\n    &:nth-child(10) {\n      transform: rotate(270deg);\n      animation-delay: -0.2s;\n    }\n\n    &:nth-child(11) {\n      transform: rotate(300deg);\n      animation-delay: -0.1s;\n    }\n\n    &:nth-child(12) {\n      transform: rotate(330deg);\n      animation-delay: 0s;\n    }\n\n  }\n}\n","@use 'styles/globals' as *;\n\n\nphoenix-property-info, phoenix-property-damage-info {\n  .copy-table {\n    color: var(--mat-sys-primary);\n\n    mat-icon {\n      color: var(--mat-sys-primary);\n    }\n  }\n\n\n}\n.ortho-status {\n  background-color:var(--mat-sys-primary);\n}\n\n.ortho-status-blue {\n  background-color: $ortho-status-preview-color !important;\n  color: $ortho-status-preview-text-color !important;\n  .white-icon {\n    color: $ortho-status-preview-text-color !important;\n  }\n}\n.colored-icon-preview {\n  color: $ortho-status-preview-text-color;\n}\n\napp-location-info {\n  .copy-clipboard-button mat-icon {\n    color: #8A8A8A;\n  }\n\n  .copy-clipboard-button button {\n    width: 25px;\n    height: 25px;\n    margin-top: 7px;\n  }\n}\n.location-info-container {\n  position: absolute;\n  bottom: 2px;\n  right: 18px;\n  z-index: 5;\n  pointer-events: none;\n}\n\n.location-info-container-phoenix{\n  margin-bottom: 0;\n  margin-right: 0;\n  margin-top: 2px;\n  opacity: 0.9;\n}\n","@use \"styles/globals\" as *;\n@use \"@angular/material\" as mat;\n\n.form-container {\n  display: flex;\n  flex-direction: column;\n}\n.form-container > * {\n  width: 100%;\n}\n.map-sidenav-container {\n  padding: 0 4px;\n  border-radius: 4px;\n  overflow: visible;\n}\n\n.viewer-container {\n  display: flex;\n  position: relative;\n  height: calc(100vh - #{$header-height});\n}\n\n.viewer-container .map-container {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n  width: auto;\n}\n\n.viewer-container .panel-container {\n  position: absolute;\n  z-index: 2;\n  display: flex;\n  max-height: 100%;\n  height: 100%;\n  transition: height 0.5s ease-in;\n}\n\n/* dual-view container*/\n.dual-container {\n  display: flex;\n}\n.dual-child-container {\n  flex: 1 0 50%;\n  max-width: 50%;\n}\n\n.dual-child-container + .dual-child-container {\n  border-left: solid var(--mat-sys-secondary) 3px;\n}\n\n.dual-child-container .viewer-container .panel-container {\n  transition: max-height 0.5s ease-in;\n  max-height: 50% !important;\n}\n\n.left-toolbar-container {\n  z-index: 10;\n  width: 50px;\n  min-height: 100%;\n  padding: 15px 0;\n  pointer-events: none; // No capturar eventos - permitir clicks en el mapa\n\n  // Los hijos (botones) sí deben capturar eventos\n  > * {\n    pointer-events: auto;\n  }\n}\n\n.left-toolbar-container-arrow {\n  z-index: 10;\n  height: 50px;\n  width: 20px;\n  background-color: #414344;\n  overflow: hidden;\n  bottom: auto !important;\n  top: 0 !important;\n  right: auto !important;\n  box-shadow: none;\n  border: 2px;\n  opacity: 80%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.arrow-icon {\n  color: white;\n  font-size: 20px;\n  opacity: 100% !important;\n  display: contents !important;\n}\n\n.right-toolbar-container {\n  z-index: 10;\n  position: absolute;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n  min-height: 100%;\n  padding-top: 0;\n}\n.top-toolbar-container {\n  position: absolute;\n  width: 100%;\n  display: flex;\n  pointer-events: none;\n  padding-top: 10px;\n  z-index: 20;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: flex-start;\n}\n\n.expand-dual-view-container {\n  position: absolute;\n  display: flex;\n  align-items: flex-start;\n  top: 0 !important;\n  z-index: 20;\n  justify-content: left;\n}\n\n.top-toolbar-container .measurement-tools {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.toolbar-container {\n  position: absolute;\n  bottom: 20px;\n  right: 35px;\n  z-index: 5;\n  pointer-events: none;\n}\n\n.toolbar-zoom-container {\n  position: absolute;\n  bottom: 70px;\n  right: 35px;\n  z-index: 5;\n}\n\n.toolbar-container-2 {\n  bottom: 150px;\n}\n\n.toolbar-container .toolbar-item {\n  height: 100%;\n}\n\n.search-manager-card {\n  margin-bottom: 5px;\n}\n\n.footer-tools-container {\n  position: absolute;\n  bottom: 0;\n  right: 35px;\n}\n.measurement-tools {\n  background-color: $white-90-opaq;\n  z-index: 2;\n}\n.measurement-container .measure-select-field select {\n  text-align: right;\n}\n.tooltip-for-measure {\n  position: relative;\n  text-shadow: 0 3px 2px #000000;\n  border-radius: 0;\n  color: white;\n  padding: 4px 8px;\n  white-space: nowrap;\n  font-family: Roboto, CenturyGothic, AppleGothic, sans-serif;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.map-legend-container {\n  position: absolute;\n  right: auto !important;\n  bottom: 30px;\n  z-index: 5;\n}\n\n.dual-view-bottom-left {\n  position: absolute;\n  right: auto !important;\n  bottom: 75px;\n  z-index: 5;\n}\n\n.historic-container {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  z-index: 5;\n}\n\n.toast-bottom-container {\n  display: flex;\n  justify-content: center;\n  z-index: 11 !important;\n}\n\n.toolbar-toast-container {\n  position: absolute;\n  bottom: 70px !important;\n  z-index: 11 !important;\n}\n\n.toolbar-info-controller {\n  z-index: 10;\n}\n\n.info-container {\n  position: absolute;\n  padding-left: 50px;\n  width: -webkit-fill-available;\n  z-index: 4;\n}\n\n.info-container-short {\n  margin-left: 350px;\n  width: -webkit-fill-available;\n}\n\n@media screen and (max-width: 1400px) {\n  .top-toolbar-container .measurement-tools {\n    position: initial;\n  }\n}\n\n@media screen and (max-width: 2800px) {\n  .top-toolbar-container .measurement-tools.dual-view-tools {\n    position: initial;\n  }\n}\n","@use 'styles/globals' as *;\n@use \"@angular/material\" as mat;\n\n// Base display container\n.search-display-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: calc(100vh - #{$header-height}) !important;\n  background-color: var(--mat-sys-surface);\n}\n\n\n// Toolbar styles\n.display-toolbar {\n  flex-shrink: 0;\n  background: var(--mat-sys-surface);\n  color: rgba(0, 0, 0, 0.87);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.toolbar-content {\n  display: flex;\n  align-items: center;\n}\n\n.toolbar-icon {\n  margin-right: 12px;\n}\n\n.toolbar-icon--primary {\n  color: #2196F3;\n}\n\n.toolbar-icon--success {\n  color: #4CAF50;\n}\n\n.toolbar-icon--warning {\n  color: #FF9800;\n}\n\n.toolbar-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.toolbar-title {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\n.toolbar-subtitle {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.6);\n  line-height: 1.2;\n}\n\n.toolbar-subtitle--inline {\n  margin-left: 16px;\n  font-size: 14px;\n}\n\n.toolbar-spacer {\n  flex: 1;\n}\n\n// Content area\n.display-content {\n  padding: 16px;\n}\n\n.display-content--centered {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.display-content--no-padding {\n  padding: 0;\n}\n\n// Landing/welcome sections\n.landing-section {\n  max-width: 900px;\n  width: 100%;\n  padding: 64px 32px;\n  text-align: center;\n}\n\n.landing-header {\n  margin-bottom: 48px;\n}\n\n.landing-icon {\n  font-size: 80px;\n  width: 80px;\n  height: 80px;\n  margin-bottom: 24px;\n}\n\n.landing-icon--primary {\n  color: #2196F3;\n}\n.landing-icon--success {\n  color: #4CAF50;\n}\n.landing-icon--error {\n  color: #f44336;\n}\n.landing-icon--warning {\n  color: #FF9800;\n}\n\n.landing-title {\n  margin: 0 0 16px 0;\n  font-size: 32px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n}\n\n.landing-description {\n  font-size: 18px;\n  color: rgba(0, 0, 0, 0.6);\n  line-height: 1.6;\n  margin: 0;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n// State containers (loading, empty, error)\n.state-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 32px;\n  text-align: center;\n}\n\n.state-container--compact {\n  padding: 32px 16px;\n}\n\n.state-icon {\n  font-size: 64px;\n  width: 64px;\n  height: 64px;\n  margin-bottom: 16px;\n  color: rgba(0, 0, 0, 0.38);\n}\n\n.state-icon--error {\n  color: #f44336;\n}\n\n.state-icon--primary {\n  color: #2196F3;\n}\n\n.state-title {\n  margin: 0 0 8px 0;\n  font-size: 24px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n}\n\n.state-title--medium {\n  font-size: 20px;\n}\n\n.state-description {\n  margin: 0 0 24px 0;\n  font-size: 16px;\n  color: rgba(0, 0, 0, 0.6);\n  max-width: 400px;\n  line-height: 1.5;\n}\n\n// Grid layout\n.results-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 16px;\n  width: 100%;\n}\n\n.results-grid--compact {\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 12px;\n}\n\n// Feature cards\n.feature-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 24px;\n  margin-bottom: 64px;\n}\n\n.feature-card {\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.feature-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);\n}\n\n.feature-card-content {\n  padding: 32px 24px;\n  text-align: center;\n}\n\n.feature-icon {\n  font-size: 48px;\n  width: 48px;\n  height: 48px;\n  margin-bottom: 16px;\n  color: var(--mat-sys-primary);\n}\n\n.feature-title {\n  margin: 0 0 12px 0;\n  font-size: 18px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\n\n.feature-description {\n  margin: 0;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.6);\n  line-height: 1.5;\n}\n\n// Chips sections\n.chips-section {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.chips-section-title {\n  margin: 0 0 24px 0;\n  font-size: 20px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n}\n\n.chips-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n}\n\n// Material Chip Styling (fix for Angular Material 16 MDC)\n.suggestion-chip {\n  cursor: pointer;\n  transition: background-color 0.2s ease, box-shadow 0.2s ease;\n  height: auto !important;\n  max-width: 100%;\n\n  .mdc-evolution-chip__text-label,\n  .mat-mdc-chip-action-label {\n    white-space: normal;\n    line-height: 1.4;\n  }\n\n  // Force background color for Angular Material 16 chips\n  &.mdc-evolution-chip {\n    --mat-chip-container-color: #e0e0e0;\n    --mat-chip-label-text-color: rgba(0, 0, 0, 0.87);\n    \n    &:hover {\n      --mat-chip-container-color: rgba(76, 175, 80, 0.12);\n      --mat-chip-elevated-container-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    }\n  }\n\n  // Fallback for legacy chips\n  &:not(.mdc-evolution-chip) {\n    background-color: #e0e0e0 !important;\n    \n    &:hover {\n      background-color: rgba(76, 175, 80, 0.12) !important;\n    }\n  }\n}\n\n.suggestion-chip--primary {\n  &.mdc-evolution-chip {\n    --mat-chip-container-color: #e3f2fd;\n\n    &:hover {\n      --mat-chip-container-color: rgba(33, 150, 243, 0.12);\n    }\n  }\n\n  &:not(.mdc-evolution-chip) {\n    background-color: #e3f2fd !important;\n    \n    &:hover {\n      background-color: rgba(33, 150, 243, 0.12) !important;\n    }\n  }\n}\n\n// Override Angular Material chip set styles\n/* TODO(mdc-migration): The following rule targets internal classes of chips that may no longer apply for the MDC version.*/\nmat-chip-set {\n  .mdc-evolution-chip-set__chips {\n    gap: 8px;\n  }\n}\n\n// Load more section\n.load-more-section {\n  display: flex;\n  justify-content: center;\n  margin-top: 24px;\n  padding: 16px;\n}\n\n.load-more-button {\n  min-width: 160px;\n}\n\n// Chat/input container\n.chat-input-container {\n  display: flex;\n  padding: 16px;\n  background: var(--mat-sys-surface);\n  border-top: 1px solid rgba(0, 0, 0, 0.12);\n  gap: 12px;\n  align-items: flex-end;\n  flex-shrink: 0;\n}\n\n.chat-input-field {\n  flex: 1;\n  margin: 0;\n\n  // Remove default borders and enhance appearance\n  .mat-mdc-form-field-subscript-wrapper {\n    // display: none; // Hide hint/error space to save vertical space\n  }\n\n  .mat-mdc-text-field-wrapper {\n    .mat-mdc-form-field-flex {\n      .mat-mdc-floating-label {\n        // top: 50%;\n        // transform: translateY(-50%);\n      }\n    }\n  }\n\n  // Ensure textarea takes full width\n  textarea {\n    resize: none;\n    min-height: 24px;\n    line-height: 1.5;\n  }\n}\n\n.send-button {\n  height: 56px;\n  min-width: 100px;\n}\n\n// Mobile responsiveness\n@media (max-width: 768px) {\n  .display-content {\n    padding: 12px;\n  }\n\n  .landing-section {\n    padding: 32px 16px;\n  }\n\n  .landing-header {\n    margin-bottom: 32px;\n  }\n\n  .landing-icon {\n    font-size: 64px;\n    width: 64px;\n    height: 64px;\n  }\n\n  .landing-title {\n    font-size: 28px;\n  }\n\n  .landing-description {\n    font-size: 16px;\n  }\n\n  .feature-cards-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n    margin-bottom: 48px;\n  }\n\n  .feature-card-content {\n    padding: 24px 16px;\n  }\n\n  .feature-icon {\n    font-size: 40px;\n    width: 40px;\n    height: 40px;\n  }\n\n  .results-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .chips-container {\n    flex-direction: column;\n    gap: 8px;\n    align-items: center;\n  }\n\n  .state-container {\n    padding: 32px 16px;\n  }\n\n  .state-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n  }\n\n  .state-title {\n    font-size: 20px;\n  }\n\n  .state-description {\n    font-size: 14px;\n  }\n\n  .toolbar-subtitle--inline {\n    display: none;\n  }\n\n  .chat-input-container {\n    padding: 12px;\n  }\n\n  .send-button {\n    min-width: 80px;\n  }\n}","/* -------------------------------------------------------------------------\n * Dialog Styles - Unified Search Dialog Components\n * -------------------------------------------------------------------------\n * Unified styles for SearchImageDialog and SearchGeofencingDialog components.\n * Uses Material Design Components (MDC) with responsive design.\n * Provides consistent layout, animations, and user experience.\n */\n\n.vision-dialog-container {\n  max-width: min(90vw, 1000px) !important;\n  max-height: 90vh;\n  width: 100%;\n  height: 100%;\n\n  @media (min-width: 768px) {\n    max-width: 900px;\n    max-height: 85vh;\n  }\n\n  @media (min-width: 1024px) {\n    max-width: min(60vw, 1000px);\n    max-height: 80vh;\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Dialog Structure - Common Layout\n * -------------------------------------------------------------------------\n */\n\n\n\n\n\n.vision-dialog-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 500px;\n\n  .dialog-header {\n    padding: 24px 24px 16px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    flex-shrink: 0;\n\n    h2 {\n      margin: 0 0 8px;\n      font-size: 24px;\n      font-weight: 500;\n      color: rgba(0, 0, 0, 0.87);\n    }\n\n    .dialog-description {\n      margin: 0;\n      font-size: 14px;\n      color: rgba(0, 0, 0, 0.6);\n      line-height: 1.5;\n    }\n  }\n\n  .dialog-body {\n    flex: 1 1 auto;\n    padding: 0 24px;\n    overflow-y: auto;\n    min-height: 0;\n\n    .search-dialog-tabs {\n      flex: 1;\n      min-height: 0;\n\n      .tab-content {\n        padding: 24px 0;\n        min-height: 300px;\n\n        .method-description {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          margin-bottom: 24px;\n          font-size: 14px;\n          color: #666;\n\n          mat-icon {\n            font-size: 18px;\n            width: 18px;\n            height: 18px;\n          }\n        }\n\n        .form-section {\n          margin-bottom: 16px;\n        }\n\n        .full-width {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  .dialog-footer {\n    flex-shrink: 0;\n    margin-top: 24px;\n    padding-top: 16px;\n    border-top: 1px solid #e0e0e0;\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n\n    button {\n      &.loading {\n        position: relative;\n        color: transparent !important;\n\n        .loading-icon {\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          animation: spin 1s linear infinite;\n        }\n\n        mat-spinner {\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n        }\n      }\n    }\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Tab Validation Status - Only show when there's content\n * -------------------------------------------------------------------------\n */\n\n.tab-validation-status {\n  margin-top: 16px;\n  padding: 12px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9em;\n\n  // Keep the status icon at its intrinsic size: as a flex item it would otherwise shrink and\n  // get clipped as soon as the message next to it wraps to more than one line.\n  mat-icon {\n    flex-shrink: 0;\n  }\n\n  &.valid {\n    background-color: rgba(76, 175, 80, 0.05);\n    color: rgba(27, 94, 32, 1);\n    border: 1px solid rgba(76, 175, 80, 0.2);\n\n    mat-icon {\n      color: rgba(56, 142, 60, 1);\n    }\n  }\n\n  &.invalid {\n    background-color: rgba(244, 67, 54, 0.05);\n    color: rgba(183, 28, 28, 1);\n    border: 1px solid rgba(244, 67, 54, 0.2);\n\n    mat-icon {\n      color: rgba(211, 47, 47, 1);\n    }\n  }\n\n  &.loading {\n    background-color: rgba(33, 150, 243, 0.05);\n    color: rgba(13, 71, 161, 1);\n    border: 1px solid rgba(33, 150, 243, 0.2);\n\n    mat-icon {\n      color: rgba(25, 118, 210, 1);\n      animation: spin 1s linear infinite;\n    }\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Preview Section - Fixed at bottom (40% height for image dialog)\n * -------------------------------------------------------------------------\n */\n\n.preview-section {\n  flex-shrink: 0;\n  height: 40%;\n  min-height: 200px;\n  margin-top: 16px;\n  border-top: 2px solid #e0e0e0;\n  padding: 16px 0 0 0;\n  background-color: #fafafa;\n\n  .preview-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 16px;\n    font-weight: 500;\n    color: #333;\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n      color: #1976d2;\n    }\n  }\n\n  .preview-content {\n    height: calc(100% - 50px);\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .image-preview {\n      max-width: 100%;\n      max-height: 100%;\n      object-fit: contain;\n      border-radius: 8px;\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    }\n\n    .preview-info {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 8px;\n      color: #666;\n\n      mat-icon {\n        font-size: 48px;\n        width: 48px;\n        height: 48px;\n        color: #ccc;\n      }\n\n      .preview-details {\n        text-align: center;\n        font-size: 14px;\n\n        .file-name {\n          font-weight: 500;\n          color: #333;\n        }\n\n        .file-size {\n          color: #666;\n          font-size: 12px;\n        }\n      }\n    }\n  }\n\n  .preview-placeholder {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n    color: #999;\n\n    mat-icon {\n      font-size: 64px;\n      width: 64px;\n      height: 64px;\n    }\n  }\n}\n\n\n/* -------------------------------------------------------------------------\n * Map/Geometry specific styling\n * -------------------------------------------------------------------------\n */\n\n.radius-section {\n  margin-top: 24px;\n  padding: 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  background-color: #f9f9f9;\n\n  mat-form-field {\n    // width: 250px;\n  }\n\n}\n\n.map-radius-info {\n  margin-top: 16px;\n  padding: 12px;\n  background-color: #e3f2fd;\n  border: 1px solid #2196f3;\n  border-radius: 4px;\n\n  .radius-display {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #1565c0;\n    font-weight: 500;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n\n/* -------------------------------------------------------------------------\n * Section Headers - Common styling for all sections\n * -------------------------------------------------------------------------\n */\n\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n  font-weight: 500;\n  color: #424242;\n\n  &.warning mat-icon {\n    color: #b28704;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n\n  mat-icon {\n    color: #1976d2;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Content Sections - Common padding and structure\n * -------------------------------------------------------------------------\n */\n\n.content-section {\n  padding: 16px 0;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid #e0e0e0;\n  }\n}\n\n.search-query-section {\n  @extend .content-section;\n}\n\n.export-config-section {\n  @extend .content-section;\n}\n\n.format-selection-section {\n  @extend .content-section;\n}\n\n.progress-section {\n  @extend .content-section;\n}\n\n/* -------------------------------------------------------------------------\n * Card layouts - Selection cards for various dialogs\n * -------------------------------------------------------------------------\n */\n\n.selection-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.format-cards {\n  @extend .selection-cards;\n  flex-direction: row !important;\n}\n\n.selection-card {\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  border: 2px solid transparent;\n  border-radius: 8px;\n\n  &:hover {\n    border-color: rgba(25, 118, 210, 0.3);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  &.selected {\n    border-color: #075eba;\n    background-color: rgba(25, 118, 210, 0.05);\n  }\n\n\n  .card-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 8px;\n\n    .card-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n      color: #1976d2;\n    }\n\n    .card-info {\n      flex: 1;\n\n      .card-title {\n        font-weight: 500;\n        color: #333;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n\n        .recommended-badge {\n          background-color: #4caf50;\n          color: white;\n          padding: 2px 8px;\n          border-radius: 12px;\n          font-size: 11px;\n          font-weight: 500;\n          text-transform: uppercase;\n        }\n      }\n\n      .card-extension {\n        font-size: 12px;\n        color: #666;\n        font-family: monospace;\n      }\n    }\n  }\n\n  .card-description {\n    font-size: 14px;\n    color: #666;\n    line-height: 1.4;\n  }\n}\n\n.format-card {\n  @extend .selection-card;\n\n  .format-header {\n    @extend .card-header;\n  }\n\n  .format-icon {\n    @extend .card-icon;\n  }\n\n  .format-info {\n    @extend .card-info;\n  }\n\n  .format-title {\n    @extend .card-title;\n  }\n\n  .format-extension {\n    @extend .card-extension;\n  }\n\n  .format-description {\n    @extend .card-description;\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Query Display - For export dialog\n * -------------------------------------------------------------------------\n */\n\n.search-query-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 16px;\n  background-color: #f9f9f9;\n\n  .query-info {\n    .query-type {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      margin-bottom: 8px;\n\n      mat-icon {\n        color: #1976d2;\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n\n      .query-title {\n        font-weight: 500;\n        color: #333;\n      }\n    }\n\n    .query-description {\n      font-size: 14px;\n      color: #666;\n      margin-bottom: 12px;\n    }\n\n    .query-preview {\n      .preview-image {\n        max-width: 200px;\n        max-height: 120px;\n        border-radius: 4px;\n        border: 1px solid #e0e0e0;\n        object-fit: cover;\n      }\n\n      .text-preview {\n        font-family: 'Courier New', monospace;\n        font-size: 12px;\n        background-color: #f5f5f5;\n        border: 1px solid #e0e0e0;\n        border-radius: 4px;\n        padding: 8px;\n        color: #555;\n        max-height: 80px;\n        overflow-y: auto;\n        word-break: break-all;\n        white-space: pre-wrap;\n      }\n    }\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Progress and Status - For export dialog\n * -------------------------------------------------------------------------\n */\n\n.progress-container {\n  margin-bottom: 16px;\n\n  .progress-text {\n    text-align: center;\n    margin-top: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #1976d2;\n  }\n}\n\n.status-message {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px;\n  border-radius: 4px;\n  margin-bottom: 16px;\n\n  &.success {\n    background-color: rgba(76, 175, 80, 0.1);\n    color: #2e7d32;\n    border: 1px solid rgba(76, 175, 80, 0.3);\n\n    mat-icon {\n      color: #4caf50;\n    }\n  }\n\n  &.error {\n    background-color: rgba(244, 67, 54, 0.1);\n    color: #c62828;\n    border: 1px solid rgba(244, 67, 54, 0.3);\n\n    mat-icon {\n      color: #f44336;\n    }\n  }\n\n  &:not(.success):not(.error) {\n    background-color: rgba(33, 150, 243, 0.1);\n    color: #1565c0;\n    border: 1px solid rgba(33, 150, 243, 0.3);\n\n    mat-icon {\n      color: #2196f3;\n    }\n  }\n}\n\n.error-actions {\n  text-align: center;\n}\n\n/* -------------------------------------------------------------------------\n * Animations\n * -------------------------------------------------------------------------\n */\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Tab Groups (Both Dialogs)\n * -------------------------------------------------------------------------\n */\n.search-dialog-tabs {\n  .mat-mdc-tab-group {\n    .mat-mdc-tab-header {\n      border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    }\n\n    .mat-mdc-tab-body-content {\n      // padding: 0;\n      // overflow: visible;\n    }\n  }\n}\n\n.tab-content {\n  padding: 24px 0;\n  min-height: 280px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.method-description {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: rgba(0, 0, 0, 0.7);\n  font-size: 14px;\n  margin-bottom: 8px;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n}\n\n/* -------------------------------------------------------------------------\n * File Upload Section with Drag & Drop (Both Dialogs)\n * -------------------------------------------------------------------------\n */\n.upload-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.file-input-hidden {\n  display: none;\n}\n\n.dropzone {\n  border: 2px dashed #ccc;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background-color: #fafafa;\n  position: relative;\n  height: 180px;\n  overflow: hidden;\n\n  &:hover {\n    border-color: #999;\n    background-color: #f5f5f5;\n  }\n\n  &.drag-over {\n    border-color: #1976d2;\n    background-color: rgba(25, 118, 210, 0.04);\n\n    .dropzone-content {\n      opacity: 0;\n    }\n  }\n\n  &.has-file {\n    border-color: #4caf50;\n    background-color: rgba(76, 175, 80, 0.04);\n    border-style: solid;\n    text-align: left !important;\n    height: 120px;\n  }\n\n  &.has-image {\n    text-align: left !important;\n    height: 120px;\n  }\n\n  &.dropzone-error {\n    border-color: #f44336;\n    background-color: rgba(244, 67, 54, 0.04);\n  }\n\n  .dropzone-content {\n    transition: opacity 0.3s ease;\n\n    .upload-icon {\n      font-size: 48px;\n      width: 48px;\n      height: 48px;\n      color: #999;\n      margin-bottom: 16px;\n    }\n\n    .primary-text {\n      font-size: 16px;\n      font-weight: 500;\n      color: rgba(0, 0, 0, 0.87);\n      margin: 0 0 8px;\n    }\n\n    .secondary-text {\n      font-size: 14px;\n      color: rgba(0, 0, 0, 0.6);\n      margin: 0 0 16px;\n\n      .link-text {\n        color: #1976d2;\n        text-decoration: underline;\n        cursor: pointer;\n      }\n    }\n\n    .file-restrictions {\n      small {\n        color: rgba(0, 0, 0, 0.5);\n        font-size: 12px;\n      }\n    }\n  }\n\n  .dropzone-drag-over {\n    .drag-icon {\n      font-size: 64px;\n      width: 64px;\n      height: 64px;\n      color: #1976d2;\n      margin-bottom: 16px;\n      animation: bounce 1s infinite;\n    }\n\n    p {\n      font-size: 18px;\n      font-weight: 500;\n      color: #1976d2;\n      margin: 0;\n    }\n  }\n\n  // Image-specific uploaded preview\n  .uploaded-image-preview {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    width: 100%;\n    text-align: left;\n    padding: 16px;\n\n    .image-preview {\n      width: 80px;\n      height: 80px;\n      border-radius: 4px;\n      object-fit: cover;\n      border: 1px solid rgba(0, 0, 0, 0.12);\n      flex-shrink: 0;\n    }\n\n    .image-preview-error {\n      width: 80px;\n      height: 80px;\n      font-size: 80px;\n      color: var(--mat-sys-error);\n      flex-shrink: 0;\n    }\n\n    .file-info {\n      flex: 1;\n      min-width: 0;\n      position: relative;\n\n      .file-name {\n        font-weight: 500;\n        color: rgba(0, 0, 0, 0.87);\n        margin-bottom: 4px;\n        word-break: break-all;\n      }\n\n      .file-details {\n        font-size: 14px;\n        color: rgba(0, 0, 0, 0.6);\n      }\n\n    }\n  }\n\n  // Geofencing-specific uploaded file info\n  .uploaded-file-info {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    width: 100%;\n    position: relative;\n\n    .file-icon {\n      flex-shrink: 0;\n\n      mat-icon {\n        font-size: 48px;\n        width: 48px;\n        height: 48px;\n        color: #666;\n      }\n    }\n\n    .file-details {\n      flex: 1;\n      min-width: 0;\n\n      .file-name {\n        font-weight: 500;\n        color: rgba(0, 0, 0, 0.87);\n        margin-bottom: 4px;\n        word-break: break-all;\n        font-size: 16px;\n      }\n\n      .file-size {\n        font-size: 14px;\n        color: rgba(0, 0, 0, 0.6);\n        margin-bottom: 8px;\n      }\n\n      .file-status {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-size: 14px;\n\n        &.processing {\n          color: #1976d2;\n        }\n\n        &.success {\n          color: #4caf50;\n        }\n\n        &.error {\n          color: #f44336;\n        }\n\n        mat-icon {\n          font-size: 16px;\n          width: 16px;\n          height: 16px;\n        }\n      }\n    }\n\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Form Sections (Both Dialogs)\n * -------------------------------------------------------------------------\n */\n.form-section {\n  .full-width {\n    width: 100%;\n  }\n\n  .mat-mdc-form-field {\n    // margin-bottom: 16px;\n  }\n}\n\n.validate-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  button {\n    align-self: flex-start;\n  }\n\n  .validation-result {\n    .validation-success {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      color: #4caf50;\n      font-size: 14px;\n      padding: 8px 12px;\n      background-color: rgba(76, 175, 80, 0.04);\n      border-radius: 4px;\n      border: 1px solid rgba(76, 175, 80, 0.2);\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n    }\n\n    .validation-error {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      color: #f44336;\n      font-size: 14px;\n      padding: 8px 12px;\n      background-color: rgba(244, 67, 54, 0.04);\n      border-radius: 4px;\n      border: 1px solid rgba(244, 67, 54, 0.2);\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Map Selection Tools (Both Dialogs)\n * -------------------------------------------------------------------------\n */\n.map-selection-section {\n  .selection-tools {\n    h4 {\n      margin: 0 0 16px;\n      color: rgba(0, 0, 0, 0.87);\n      font-weight: 500;\n    }\n\n    .tool-cards {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n      gap: 12px;\n      margin-bottom: 20px;\n\n      .tool-card {\n        cursor: pointer;\n        transition: all 0.3s ease;\n        border: 2px solid transparent;\n\n        &:hover {\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);\n          border-color: rgba(25, 118, 210, 0.2);\n        }\n\n        &.selected {\n          border-color: #1976d2;\n          box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);\n        }\n        /* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version.\n */\n        mat-card-content {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n          padding: 16px !important;\n\n\n\n          .tool-info {\n            flex: 1;\n\n            .tool-title {\n              font-weight: 500;\n              color: rgba(0, 0, 0, 0.87);\n              margin-bottom: 4px;\n            }\n\n            .tool-description {\n              font-size: 12px;\n              color: rgba(0, 0, 0, 0.6);\n              line-height: 1.3;\n            }\n          }\n        }\n\n        &.selected {\n\n\n          .tool-title {\n            color: #1976d2;\n          }\n        }\n      }\n    }\n\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Configuration Sections (Both Dialogs)\n * -------------------------------------------------------------------------\n */\n.config-section {\n  margin-top: 24px;\n  padding-top: 24px;\n\n  .config-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 20px;\n    font-weight: 500;\n    color: rgba(0, 0, 0, 0.7);\n    font-size: 16px;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .config-description {\n    color: rgba(0, 0, 0, 0.6);\n    font-size: 14px;\n    line-height: 1.5;\n    margin: 0 0 16px;\n  }\n\n  .config-form {\n    .mat-mdc-form-field {\n      // max-width: 300px;\n    }\n  }\n\n  .config-info {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #4caf50;\n    font-size: 14px;\n    padding: 12px;\n    background-color: rgba(76, 175, 80, 0.04);\n    border-radius: 4px;\n    border: 1px solid rgba(76, 175, 80, 0.2);\n\n    .success-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .details-section {\n    margin-top: 16px;\n\n    summary {\n      cursor: pointer;\n      font-size: 14px;\n      color: rgba(0, 0, 0, 0.7);\n      padding: 8px 0;\n      outline: none;\n\n      &:hover {\n        color: rgba(0, 0, 0, 0.87);\n      }\n    }\n\n    .details-content {\n      margin-top: 8px;\n\n      label {\n        font-size: 12px;\n        color: rgba(0, 0, 0, 0.6);\n        display: block;\n        margin-bottom: 4px;\n      }\n\n      pre {\n        background: #f5f5f5;\n        padding: 12px;\n        border-radius: 4px;\n        font-size: 11px;\n        line-height: 1.4;\n        overflow-x: auto;\n        margin: 0;\n        border: 1px solid #e0e0e0;\n      }\n    }\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Preview Sections\n * -------------------------------------------------------------------------\n */\n.preview-section {\n  margin-top: 24px;\n\n  .preview-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 16px 0;\n    font-weight: 500;\n    color: rgba(0, 0, 0, 0.7);\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .preview-container {\n    border-radius: 8px;\n    overflow: hidden;\n    border: 1px solid rgba(0, 0, 0, 0.12);\n    background-color: #fafafa;\n\n    .preview-image {\n      width: 100%;\n      max-height: 200px;\n      object-fit: contain;\n      display: block;\n    }\n\n    .preview-placeholder {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      padding: 48px;\n      color: rgba(0, 0, 0, 0.5);\n      font-style: italic;\n\n      mat-icon {\n        font-size: 48px;\n        width: 48px;\n        height: 48px;\n        margin-bottom: 16px;\n      }\n    }\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Error Display (Both Dialogs)\n * -------------------------------------------------------------------------\n */\n.error-message, .global-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #f44336;\n  font-size: 14px;\n  padding: 12px 16px;\n  background-color: rgba(244, 67, 54, 0.04);\n  border-radius: 4px;\n  border: 1px solid rgba(244, 67, 54, 0.2);\n  margin-top: 16px;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Animations\n * -------------------------------------------------------------------------\n */\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-10px);\n  }\n  60% {\n    transform: translateY(-5px);\n  }\n}\n\n@keyframes pulse-dot {\n  0% {\n    transform: scale(0);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Responsive Design\n * -------------------------------------------------------------------------\n */\n@media (max-width: 767px) {\n  .dialog-header {\n    padding: 16px 16px 12px;\n\n    h2 {\n      font-size: 20px;\n    }\n  }\n\n  .dialog-body {\n    padding: 0 16px;\n  }\n\n  .dialog-footer {\n    padding: 12px 16px 16px;\n    flex-direction: column;\n\n    .mat-mdc-button {\n      // width: 100%;\n    }\n  }\n\n  .tab-content {\n    padding: 16px 0;\n    min-height: 250px;\n  }\n\n  .dropzone {\n    padding: 20px 16px;\n    height: 160px;\n\n    .dropzone-content {\n      .upload-icon {\n        font-size: 36px;\n        width: 36px;\n        height: 36px;\n        margin-bottom: 12px;\n      }\n\n      .primary-text {\n        font-size: 14px;\n      }\n\n      .secondary-text {\n        font-size: 12px;\n      }\n    }\n\n    .uploaded-image-preview {\n      flex-direction: column;\n      text-align: center;\n      gap: 12px;\n\n      .image-preview {\n        width: 60px;\n        height: 60px;\n      }\n\n\n    }\n\n    .uploaded-file-info {\n      flex-direction: column;\n      text-align: center;\n      gap: 12px;\n\n      .file-icon mat-icon {\n        font-size: 36px;\n        width: 36px;\n        height: 36px;\n      }\n\n\n    }\n  }\n\n  .map-selection-section {\n    .selection-tools {\n      .tool-cards {\n        grid-template-columns: 1fr;\n      }\n\n    }\n  }\n\n  .config-section {\n    .config-form .mat-mdc-form-field {\n      // max-width: none;\n      // width: 100%;\n    }\n  }\n\n  .preview-section {\n    .preview-container {\n      .preview-placeholder {\n        padding: 32px 16px;\n\n        mat-icon {\n          font-size: 36px;\n          width: 36px;\n          height: 36px;\n        }\n      }\n    }\n  }\n}\n\n/* -------------------------------------------------------------------------\n * Focus and Accessibility\n * -------------------------------------------------------------------------\n */\n.dropzone:focus-visible,\n.tool-card:focus-visible {\n  outline: 2px solid #1976d2;\n  outline-offset: 2px;\n}\n\n.mat-mdc-button:focus-visible,\n.mat-mdc-icon-button:focus-visible {\n  outline: 2px solid #1976d2;\n  outline-offset: 2px;\n}\n\n\n","/**\n * Agent UI Component Styles\n *\n * BEM-style SCSS classes for all agent-ui components.\n * All classes are prefixed with \"achat-\" (agent-chat) to avoid collisions.\n * Components use ViewEncapsulation.None so these styles are globally scoped.\n *\n * Colors and spacing reference the CSS custom properties defined in\n * agent-ui/styles/globals.scss under the [data-agent-ui] scope.\n */\n\n// ---------------------------------------------------------------------------\n// Shared variables\n// ---------------------------------------------------------------------------\n\n$achat-btn-size: 36px; // h-9 / w-9\n$achat-btn-size-sm: 32px; // h-8 / w-8\n$achat-btn-size-xs: 24px; // h-6 / w-6\n$achat-border-radius-full: 9999px;\n$achat-border-radius-md: 6px;\n$achat-border-radius-lg: 8px;\n$achat-border-radius-input: 28px;\n$achat-transition: colors 0.2s ease;\n$achat-mono-font: ui-monospace, SFMono-Regular, 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace;\n$achat-max-content-width: 48rem; // max-w-3xl\n\n// ---------------------------------------------------------------------------\n// achat-view — top-level chat view container (ai-chat-view)\n// ---------------------------------------------------------------------------\n\n.achat-view {\n  position: relative;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n// ---------------------------------------------------------------------------\n// achat-scroll — scroll container area (ai-chat-view-scroll-view)\n// ---------------------------------------------------------------------------\n\n.achat-scroll-loading {\n  height: 100%;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.achat-scroll-wrapper {\n  height: 100%;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  position: relative;\n}\n\n.achat-scroll-viewport {\n  flex: 1;\n  min-height: 0;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.achat-scroll-content {\n  padding-left: 1rem;\n  padding-right: 1rem;\n\n  @media (min-width: 640px) {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}\n\n.achat-scroll-messages {\n  max-width: $achat-max-content-width;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0.5rem 0; /* Add vertical padding for better spacing */\n}\n\n.achat-scroll-to-bottom-wrap {\n  position: absolute;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  z-index: 30;\n}\n\n// ---------------------------------------------------------------------------\n// achat-scroll-to-bottom — floating scroll button (ai-chat-view-scroll-to-bottom-button)\n// ---------------------------------------------------------------------------\n\n.achat-scroll-to-bottom {\n  border-radius: $achat-border-radius-full;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  background-color: #ffffff;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  border: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: #f9fafb;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:focus-visible {\n    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.4), 0 0 0 4px rgba(255, 255, 255, 0.8);\n  }\n\n  lucide-angular {\n    width: 16px;\n    height: 16px;\n    color: #4b5563;\n  }\n\n  .dark & {\n    background-color: #111827;\n    border-color: #374151;\n\n    &:hover {\n      background-color: #1f2937;\n    }\n\n    lucide-angular {\n      color: #ffffff;\n    }\n  }\n}\n\n// ---------------------------------------------------------------------------\n// achat-feather — gradient fade at bottom of scroll area (ai-chat-view-feather)\n// ---------------------------------------------------------------------------\n\n.achat-feather {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 4rem;\n  pointer-events: none;\n  z-index: 10;\n  background: linear-gradient(to top, var(--achat-bg, transparent), transparent);\n}\n\n// ---------------------------------------------------------------------------\n// achat-bottom-panel — absolute positioned wrapper for HITL content + input\n// Groups all bottom-of-chat elements so they can be measured as one unit.\n// ---------------------------------------------------------------------------\n\n.achat-bottom-panel {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 20;\n}\n\n// ---------------------------------------------------------------------------\n// achat-run-error — error banner shown above input when a run fails\n// ---------------------------------------------------------------------------\n\n.achat-run-error {\n  border-top: 1px solid var(--mat-divider-color, rgba(0, 0, 0, 0.12));\n  background-color: var(--mat-sys-error-container, #fce8e6);\n\n  &__icon {\n    color: var(--mat-sys-error, #b3261e);\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    flex-shrink: 0;\n  }\n\n  &__text {\n    color: var(--mat-sys-on-error-container, #410e0b);\n  }\n}\n\n// ---------------------------------------------------------------------------\n// achat-input-container — input area, flows inside achat-bottom-panel\n// ---------------------------------------------------------------------------\n\n.achat-input-container {\n  position: relative;\n}\n\n.achat-input-container__inner {\n  max-width: $achat-max-content-width;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0 0.75rem 0.75rem;\n\n  @media (min-width: 640px) {\n    padding: 0 0.5rem 0.75rem;\n  }\n}\n\n// ---------------------------------------------------------------------------\n// achat-disclaimer — disclaimer text below input (ai-chat-view-disclaimer)\n// ---------------------------------------------------------------------------\n\n.achat-disclaimer {\n  text-align: center;\n  font-size: 0.75rem;\n  color: var(--muted-foreground);\n  padding: 0.75rem 1rem;\n  max-width: $achat-max-content-width;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n// ---------------------------------------------------------------------------\n// achat-input — chat input box (ai-chat-input)\n// ---------------------------------------------------------------------------\n\n.achat-input {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  gap: 4px;\n  padding: 6px;\n  cursor: text;\n  overflow: visible;\n  background-clip: padding-box;\n  background-color: #ffffff;\n  box-shadow: 0 4px 4px 0 #0000000a, 0 0 1px 0 #0000009e;\n  border-radius: $achat-border-radius-input;\n\n  .dark & {\n    background-color: #303030;\n  }\n}\n\n// ---------------------------------------------------------------------------\n// achat-toolbar — bottom row of input box (ai-chat-toolbar directive)\n// ---------------------------------------------------------------------------\n\n.achat-toolbar {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.achat-toolbar__group {\n  display: flex;\n  align-items: center;\n}\n\n.achat-toolbar__send-wrap {\n  margin-right: 10px;\n}\n\n// ---------------------------------------------------------------------------\n// achat-textarea — the message input textarea (ai-chat-textarea)\n// ---------------------------------------------------------------------------\n\n.achat-textarea {\n  flex: 1;\n  padding: 8px 6px;\n  outline: none;\n  resize: none;\n  background-color: transparent;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: 400;\n  line-height: 1.625;\n  font-size: 16px;\n  font-family: inherit;\n  min-height: 36px !important;\n  height: auto !important;\n  box-sizing: border-box;\n  border: none;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  &::placeholder {\n    color: rgba(0, 0, 0, 0.47);\n  }\n\n  .dark &::placeholder {\n    color: rgba(255, 255, 255, 0.8);\n  }\n\n  &:focus {\n    outline: none;\n    border: none;\n  }\n}\n\n// ---------------------------------------------------------------------------\n// achat-audio-recorder — audio visualizer canvas (ai-chat-audio-recorder)\n// ---------------------------------------------------------------------------\n\n.achat-audio-recorder {\n  display: block;\n  width: 100%;\n}\n\n.achat-audio-recorder__canvas {\n  height: 44px;\n  width: 100%;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n\n// ---------------------------------------------------------------------------\n// Shared button base\n// ---------------------------------------------------------------------------\n\n%achat-btn-base {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  white-space: nowrap;\n  border-radius: $achat-border-radius-md;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n  outline: none;\n  cursor: pointer;\n  border: none;\n\n  &:disabled {\n    pointer-events: none;\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &:focus-visible {\n    border: 1px solid var(--ring);\n    box-shadow: 0 0 0 3px rgba(var(--ring), 0.5);\n  }\n\n  svg,\n  lucide-angular {\n    pointer-events: none;\n    flex-shrink: 0;\n  }\n}\n\n// ---------------------------------------------------------------------------\n// achat-btn — primary/secondary action buttons (ai-chat-buttons)\n// ---------------------------------------------------------------------------\n\n.achat-btn {\n  @extend %achat-btn-base;\n\n  border-radius: $achat-border-radius-full;\n  height: $achat-btn-size;\n  width: $achat-btn-size;\n}\n\n.achat-btn--primary {\n  background-color: #000000;\n  color: #ffffff;\n\n  &:hover:not(:disabled) {\n    opacity: 0.7;\n  }\n\n  &:disabled {\n    background-color: rgba(0, 0, 0, 0.08);\n    color: rgb(13, 13, 13);\n    opacity: 1;\n  }\n\n  .dark & {\n    background-color: #ffffff;\n    color: #000000;\n\n    &:disabled {\n      background-color: #454545;\n      color: #ffffff;\n    }\n  }\n}\n\n.achat-btn--secondary {\n  background-color: transparent;\n  color: #444444;\n\n  &:hover:not(:disabled) {\n    background-color: #f8f8f8;\n    color: #333333;\n  }\n\n  &:disabled {\n    background-color: transparent;\n    color: #444444;\n  }\n\n  .dark & {\n    color: #ffffff;\n    border-color: #404040;\n\n    &:hover:not(:disabled) {\n      background-color: #404040;\n      color: #ffffff;\n    }\n\n    &:disabled {\n      background-color: transparent;\n      color: #cccccc;\n    }\n  }\n}\n\n.achat-btn--mr {\n  margin-right: 0.5rem;\n}\n\n.achat-btn--ml {\n  margin-left: 0.5rem;\n}\n\n.achat-btn--mr-custom {\n  margin-right: 10px;\n}\n\n// ---------------------------------------------------------------------------\n// achat-msg-btn — icon toolbar buttons (message toolbars, branch nav)\n// ---------------------------------------------------------------------------\n\n.achat-msg-btn {\n  @extend %achat-btn-base;\n\n  padding: 0;\n  color: rgb(93, 93, 93);\n  background-color: transparent;\n  height: $achat-btn-size-sm;\n  width: $achat-btn-size-sm;\n  border-radius: $achat-border-radius-md;\n\n  &:hover:not(:disabled) {\n    background-color: #e8e8e8;\n    color: rgb(93, 93, 93);\n  }\n\n  .dark & {\n    color: rgb(243, 243, 243);\n\n    &:hover:not(:disabled) {\n      background-color: #303030;\n      color: rgb(243, 243, 243);\n    }\n  }\n}\n\n.achat-msg-btn--sm {\n  height: $achat-btn-size-xs;\n  width: $achat-btn-size-xs;\n}\n\n// ---------------------------------------------------------------------------\n// achat-tools-btn — tools menu trigger button (ai-chat-tools-menu)\n// ---------------------------------------------------------------------------\n\n.achat-tools-btn {\n  @extend %achat-btn-base;\n\n  border-radius: $achat-border-radius-full;\n  height: $achat-btn-size;\n  padding: 0 0.75rem;\n  gap: 0.5rem;\n  background-color: transparent;\n  color: #444444;\n  font-weight: 400;\n\n  &:hover:not(:disabled) {\n    background-color: #f8f8f8;\n    color: #333333;\n  }\n\n  &:disabled {\n    background-color: transparent;\n    color: #444444;\n    cursor: not-allowed;\n  }\n\n  .dark & {\n    color: #ffffff;\n    border-color: #404040;\n\n    &:hover:not(:disabled) {\n      background-color: #404040;\n      color: #ffffff;\n    }\n\n    &:disabled {\n      background-color: transparent;\n      color: #cccccc;\n    }\n  }\n}\n\n.achat-tools-btn__label {\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n\n// ---------------------------------------------------------------------------\n// achat-menu — dropdown menu panel (ai-chat-tools-menu)\n// ---------------------------------------------------------------------------\n\n.achat-menu {\n  min-width: 200px;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: $achat-border-radius-lg;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  padding: 0.25rem;\n\n  .dark & {\n    background-color: #1f1f1f;\n    border-color: #374151;\n  }\n}\n\n.achat-menu__separator {\n  height: 1px;\n  background-color: #e5e7eb;\n  margin: 0.25rem 0;\n\n  .dark & {\n    background-color: #374151;\n  }\n}\n\n.achat-menu__item {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  text-align: left;\n  background-color: transparent;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: inherit;\n\n  &:hover {\n    background-color: #f3f4f6;\n  }\n\n  .dark &:hover {\n    background-color: #1f2937;\n  }\n}\n\n.achat-menu__item-chevron {\n  margin-left: auto;\n}\n\n// ---------------------------------------------------------------------------\n// achat-message-view — messages list container (ai-chat-message-view)\n// ---------------------------------------------------------------------------\n\n.achat-message-view {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n// ---------------------------------------------------------------------------\n// achat-cursor — blinking loading cursor (ai-chat-message-view-cursor)\n// ---------------------------------------------------------------------------\n\n.achat-cursor {\n  width: 11px;\n  height: 11px;\n  border-radius: $achat-border-radius-full;\n  background-color: var(--foreground);\n  animation: pulse-cursor 0.9s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n  margin-left: 0.25rem;\n}\n\n// ---------------------------------------------------------------------------\n// achat-assistant-msg — assistant message wrapper (ai-chat-assistant-message)\n// ---------------------------------------------------------------------------\n\n.achat-assistant-msg {\n  max-width: 100%;\n  overflow-wrap: break-word;\n  word-break: break-word;\n\n  // Prose styles for markdown content\n  -webkit-font-smoothing: antialiased;\n\n  // Dark prose invert\n  .dark & {\n    color: var(--foreground);\n  }\n}\n\n.achat-msg__actions {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n// ---------------------------------------------------------------------------\n// achat-reasoning-step — intermediate reasoning step display\n// ---------------------------------------------------------------------------\n\n.achat-reasoning-step {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  padding: 0.25rem 0.5rem;\n  color: var(--muted-foreground);\n}\n\n.achat-reasoning-spinner {\n  display: inline-block;\n  width: 0.75rem;\n  height: 0.75rem;\n  margin-top: 0.125rem;\n  flex-shrink: 0;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: achat-reasoning-spin 0.75s linear infinite;\n}\n\n@keyframes achat-reasoning-spin {\n  to { transform: rotate(360deg); }\n}\n\n.achat-reasoning-label {\n  font-size: 0.75rem;\n  font-style: italic;\n  line-height: 1.25rem;\n}\n\n.achat-reasoning-desc {\n  opacity: 0.7;\n}\n\n.achat-reasoning-step--done {\n  opacity: 0.55;\n\n  .achat-reasoning-label {\n    font-style: normal;\n  }\n}\n\n.achat-reasoning-check {\n  display: inline-block;\n  width: 0.75rem;\n  height: 0.75rem;\n  margin-top: 0.125rem;\n  flex-shrink: 0;\n  font-size: 0.7rem;\n  line-height: 0.75rem;\n  color: var(--success, #16a34a);\n}\n\n// ---------------------------------------------------------------------------\n// achat-assistant-toolbar — toolbar row below assistant message\n// ---------------------------------------------------------------------------\n\n.achat-assistant-toolbar {\n  width: 100%;\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n  margin-left: -5px;\n}\n\n// ---------------------------------------------------------------------------\n// achat-user-msg — user message outer wrapper (ai-chat-user-message)\n// ---------------------------------------------------------------------------\n\n.achat-user-msg {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  padding-top: 2.5rem;\n\n  // Reveal toolbar on hover (group pattern)\n  &:hover .achat-user-toolbar {\n    visibility: visible;\n  }\n}\n\n// ---------------------------------------------------------------------------\n// achat-user-msg__content — message bubble (ai-chat-user-message-renderer)\n// ---------------------------------------------------------------------------\n\n.achat-user-msg__content {\n  background-color: var(--muted);\n  position: relative;\n  max-width: 80%;\n  border-radius: 18px;\n  padding: 6px 1rem;\n  display: inline-block;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n  word-break: break-word;\n\n  &[data-multiline='true'] {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n}\n\n// ---------------------------------------------------------------------------\n// achat-user-toolbar — toolbar row below user message\n// ---------------------------------------------------------------------------\n\n.achat-user-toolbar {\n  width: 100%;\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 4px;\n  visibility: hidden;\n}\n\n// ---------------------------------------------------------------------------\n// achat-branch-nav — branch navigation (ai-chat-user-message-branch-navigation)\n// ---------------------------------------------------------------------------\n\n.achat-branch-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.achat-branch-nav__label {\n  font-size: 0.875rem;\n  color: var(--muted-foreground);\n  font-weight: 500;\n  padding-left: 0;\n  padding-right: 0;\n}\n","// Shared structural classes for ai-components chat cards.\n// These classes are used across EndpointCard, ToolDataCard, EmbeddingsCard and HITL cards.\n// Keep visual rules here (border, background, border-radius) — layout goes in Bootstrap utilities.\n\n// Base card — large rounded corners + overflow clip applied directly on mat-card.\n.ai-card {\n  border-radius: var(--mat-sys-corner-large) !important;\n  overflow: hidden;\n}\n\n// Card footer — action bar row at the bottom of all result/tool cards.\n.ai-card__footer {\n  border-top: 1px solid var(--mat-sys-outline-variant);\n  background: var(--mat-sys-surface-container-low);\n  min-height: 44px;\n}\n\n// Card header — bottom divider on CardHeaderComponent wrapper.\n.ai-card__header {\n  border-bottom: 1px solid var(--mat-sys-outline-variant);\n}\n\n// Small icon inside card header — use .mat-icon-sm global utility instead.\n\n// API credit cost / approval warning box.\n.ai-card__cost-box {\n  background: color-mix(in srgb, var(--vx-warning) 8%, transparent);\n  border: 1px solid color-mix(in srgb, var(--vx-warning) 40%, transparent);\n  border-radius: var(--mat-sys-corner-medium);\n}\n\n// Missing-params error inline row.\n.ai-card__missing-params {\n  background: var(--mat-sys-error-container);\n  color: var(--mat-sys-on-error-container);\n  border-radius: var(--mat-sys-corner-medium);\n}\n\n// Warning icon color (API cost box). Uses --vx-warning which has no M3 equivalent.\n.ai-card__warning-icon {\n  color: var(--vx-warning);\n}\n\n// Warning text color. Uses --vx-warning which has no M3 equivalent.\n.ai-card__warning-text {\n  color: var(--vx-warning);\n}\n\n// Pill badge used in notification cards (HITL + bg-job panel) and the task-list card.\n// Defined globally because badges appear in projected content where component-scoped\n// styles don't reach.\n.notification-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border-radius: var(--mat-sys-corner-full);\n  padding: 2px 10px;\n\n  mat-icon {\n    font-size: 13px;\n    width: 13px;\n    height: 13px;\n  }\n\n  &--success {\n    background: color-mix(in srgb, var(--vx-success) 12%, transparent);\n    color: var(--vx-success);\n    border: 1px solid color-mix(in srgb, var(--vx-success) 30%, transparent);\n  }\n\n  &--error {\n    background: var(--mat-sys-error-container);\n    color: var(--mat-sys-error);\n    border: 1px solid color-mix(in srgb, var(--mat-sys-error) 30%, transparent);\n  }\n\n  &--pending {\n    background: color-mix(in srgb, var(--mat-sys-secondary) 10%, transparent);\n    color: var(--mat-sys-on-surface-variant);\n    border: 1px solid var(--mat-sys-outline-variant);\n  }\n\n  &--running {\n    background: color-mix(in srgb, var(--mat-sys-secondary) 10%, transparent);\n    color: var(--mat-sys-on-surface-variant);\n    border: 1px solid var(--mat-sys-outline-variant);\n  }\n\n  &--warning {\n    background: color-mix(in srgb, var(--vx-warning) 12%, transparent);\n    color: var(--vx-warning);\n    border: 1px solid color-mix(in srgb, var(--vx-warning) 40%, transparent);\n  }\n}\n","@import \"styles/components/popup\";\n@import 'styles/components/layers';\n@import \"styles/components/tools\";\n@import \"styles/components/collection-timeline\";\n@import 'styles/components/sidebar';\n@import 'styles/components/gallery';\n@import 'styles/components/user-data';\n@import 'styles/components/properties';\n@import 'styles/components/map-container';\n@import \"styles/components/compound-display\";\n@import \"styles/components/dialog\";\n@import \"styles/components/agent-ui\";\n@import \"styles/components/ai-chat-cards\";\n\n\n// Toolbar info panel overlay styling\n.toolbar-header-overlay {\n  position: absolute;\n  top: 64px;\n  left: 0;\n  right: 0;\n  z-index: 999;\n}\n.custom-tooltip {\n  max-width: 350px !important;\n}\n\n.status-tooltip {\n  max-width: 400px !important;\n}\n","@use 'styles/globals' as *;\n@use '@angular/material' as mat;\n/* status control styles */\ncanvas {\n  opacity: 1 !important;\n  background: transparent !important;\n}\n\n.ol-map {\n  height: calc(100vh - #{$header-height}) !important;\n  overflow: hidden;\n  width: 100%;\n}\n\n\n.discrete-view {\n  background: linear-gradient(180deg, #5c635d, rgba(92, 99, 93, 0.8)) !important;\n  background-size: 400% 400%;\n  animation: gradient 6s ease infinite !important;\n}\n\n@keyframes gradient {\n  0%{background-position:50% 0}\n  50%{background-position:50% 100%}\n  100%{background-position:50% 0}\n}\n\n.map {\n  overflow: hidden;\n  height: 800px;\n}\n\n\n/*  swipe control */\n.ol-swipe.ol-control {\n  background-color: white;\n  border-radius: 0 !important;\n  padding: 0 !important;\n  cursor: ew-resize;\n\n  &::after {\n    top: -5000px !important;\n    bottom: -5000px !important;\n    position: absolute;\n    left: 28%;\n    width: 14px;\n    background: transparent !important;\n  }\n\n  & button {\n    width: 24px;\n    height: 24px;\n    transform: rotate(90deg);\n    background: white url(\"assets/images/swipe.png\") no-repeat fixed center/cover !important;\n    border-radius: 0 !important;\n    cursor: ew-resize;\n\n    &::before {\n      background: transparent;\n    }\n\n    &::after {\n      background: transparent;\n\n    }\n  }\n}\n\n.ol-swipe:hover.ol-control {\n  background-color: var(--mat-sys-primary);\n\n  &::before {\n    background: var(--mat-sys-primary) !important;\n  }\n\n  & button {\n    background: url(\"assets/images/swipe-white.png\") no-repeat fixed center/cover !important;\n  }\n}\n\n.ol-control.ol-status {\n  font-family: 'Lucida Grande', Verdana, Geneva, Lucida, Arial, Helvetica, sans-serif;\n  font-size: 16px;\n}\n\n\n.ol-attribution.ol-uncollapsible {\n  position: relative;\n  background-color: unset;\n  max-width: unset;\n  padding: 0 !important;\n}\n\n.ol-attribution ul, .ol-attribution a {\n  font-size: 13px !important;\n  color: white !important;\n  margin-top: 2px;\n  text-shadow: unset !important;\n  padding: unset !important;\n}\n\n.ol-scale-line {\n  position: initial;\n  background-color: var(--mat-sys-inverse-surface);\n  z-index: 1 !important;\n}\n\n.ol-scale-line-inner {\n  border: 1px solid white !important;\n  border-top: none !important;\n  border-color: rgba(255, 255, 255, 0.75) !important;\n  color: rgba(255, 255, 255, 0.75) !important;\n}\n\n/* end status control styles */\n\n/* mode switching animation styles */\n.ol-viewport.down-2d {\n  perspective: 400px;\n  animation: lay-down 2s normal 1;\n}\n\n.ol-viewport.layed-down {\n  transform: perspective(300px) rotateX(16deg) scale(0.7,0.7);\n}\n\n/*dont used*/\n\n.ol-popup.default.hasclosebox.ol-popup-bottom.ol-popup-left.visible {\n  left: -9999em;\n\n  > div {\n    left: 9999em !important;\n    position: relative;\n  }\n}\n\n.ol-popup.default.hasclosebox.ol-popup-bottom.ol-popup-right.visible {\n  left: -9999em;\n\n  > div {\n    left: 9999em !important;\n    position: relative;\n  }\n}\n\n.ol-popup.default.hasclosebox.ol-popup-top.ol-popup-left.visible {\n  left: -9999em;\n\n  > div {\n    left: 9999em !important;\n    position: relative;\n  }\n}\n\nol-popup.default.hasclosebox.ol-popup-top.ol-popup-right.visible {\n  left: -9999em;\n\n  > div {\n    left: 9999em !important;\n    position: relative;\n  }\n}\n\n.ol-popup-content #open-gallery-button {\n  color: var(--mat-sys-primary);\n}\n\n.ol-popup-content #open-gallery-button.disabled {\n  color: #0000008A;\n}\n\n.ol-viewport.up-3d {\n  perspective: 400px;\n  animation: zoom-in 1s normal 1;\n}\n\n.ol-viewport.down-3d {\n  perspective: 400px;\n  animation: zoom-out 2s normal 1;\n}\n\n.ol-viewport.layed-down-3d {\n  transform: perspective(500px) rotateX(40deg) scale(1,1);\n}\n\n.ol-viewport.up-2d {\n  perspective: 400px;\n  animation: lay-down-3d 1s normal 1;\n}\n\n.ol-viewport.additional {\n  perspective: 400px;\n  animation: lay-down 1s reverse 1;\n}\n\n.grid-container {\n  z-index: 0;\n  width: 100%;\n  height: 100%;\n  perspective: 400px;\n  display: flex;\n  overflow: hidden;\n  position: sticky;\n  bottom: 0;\n}\n\n.background-grid {\n  width: 100%;\n  height: 100%;\n  transform: rotateX(40deg);\n  background: linear-gradient(0deg, transparent 24%,#4D5154 25%,#4D5154 26%, transparent 27%, transparent 74%,#4D5154 75%,#4D5154 76%, transparent 77%, transparent), linear-gradient(90deg, transparent 24%,#4D5154 25%,#4D5154 26%, transparent 27%, transparent 74%,#4D5154 75%,#4D5154 76%, transparent 77%, transparent);\n  background-color: #707070;\n  border: 2px solid #4D5154;\n  background-size: 7rem 7rem;\n}\n/* end mode switching animation styles */\n\n/* layerSwitcher control styles */\n.ol-layerswitcher .panel li.ol-layer-hidden {\n  opacity: 0.6;\n  display: none !important;\n}\n.ol-control.ol-layerswitcher {\n  right: 20px;\n  left: auto;\n  max-height: 70% !important;\n  background: white !important;\n  .panel-container{\n    position: static;\n  }\n}\n\n.ol-layerswitcher > button {\n  float: none;\n}\n\n.tooltip {\n  color: white;\n  font-family: \"Century Gothic\", CenturyGothic, AppleGothic, sans-serif;\n}\n\n\n\n/* end layerSwitcher control styles */\n\n\n/* Context menu styles */\n.ol-ctx-menu-container {\n  position: absolute;\n  padding: 0;\n  background: #fff;\n  color: #222;\n  font-size: 15px;\n  border-radius: 5px;\n  box-shadow: rgba(0, 0, 0, 0.2) 3px 3px 5px;\n  box-sizing: border-box;\n  z-index: 1;\n}\n\n.ol-ctx-menu-container li {\n  position: relative;\n  padding: 5px;\n  line-height: 30px;\n  text-indent: 30px;\n}\n\n/* infobox */\n.ol-popup .closeBox {\n  color: #8A8A8A;\n  font-weight: 200;\n  font-size: 16px !important;\n  background-color: white;\n}\n\n.ol-popup-content #open-gallery-button {\n  border: none;\n  background-color: transparent;\n  font-weight: bolder;\n  padding: 0;\n  position: relative;\n}\n\n.ol-popup-content #open-gallery-button #gallery-tooltip {\n  visibility: hidden;\n  width: 180px;\n  background-color: #5555557a;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 6px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 100%;\n  left: 3%;\n  font-size: 11px;\n}\n\n.ol-popup-content #open-gallery-button.disabled:hover #gallery-tooltip{\n  visibility: visible;\n}\n\n.ol-popup-content #open-gallery-button:focus {\n  outline: none;\n}\n\n.ol-popup-content #open-gallery-button.disabled {\n  cursor: default;\n}\n\n.ol-popup .closeBox:hover {\n  background-color: white;\n  color: #666666;\n}\n\n.ol-popup .closeBox:after {\n  top: 30%;\n}\n\n.ol-popup .ol-popup-content {\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 1.5vh 0 1.5vh 1.5vw;\n}\n\n.ol-popup-content .address {\n  font-size: 14px;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  user-select: text;\n  font-weight: bold;\n}\n\n.ol-popup-content .location,\n.ol-popup-content .capture-date {\n  color: #0000008A;\n  font-size: 12px;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  user-select: text;\n}\n\n.ol-popup-content .capture-date span {\n  font-weight: 500;\n}\n\n.ol-popup-content .infobox-control {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.ol-popup-content .infobox-control span:first-child {\n  margin-right: 5px;\n}\n\n.ol-popup-content .infobox-control #pin-btn {\n  background-image: url(\"assets/images/pin_btn.svg\");\n  height: 18px;\n  width: 11px;\n}\n\n.ol-popup-content .infobox-control #visibility-btn {\n  background-image: url(\"assets/images/ic_visibility_off.svg\");\n  background-repeat: no-repeat;\n  height: 12px;\n  width: 14px;\n  top: 3px;\n  position: relative;\n}\n\n.ol-popup-content .infobox-control #visibility-btn:hover::after {\n  content: '';\n  height: 1px;\n  width: 1px;\n  box-shadow: 6px 8px 10px 4px rgba(0, 0, 0, 0.3);\n}\n\n.ol-popup.default {\n  width: auto;\n  border: none;\n  border-radius: 2px;\n  transform: none;\n}\n.ol-popup.default.feature {\n  width: auto;\n  border: none;\n  border-radius: 2px;\n  transform: none;\n  overflow: auto;\n  user-select: text !important;\n}\n.ol-popup.default > div {\n  border: none;\n  border-radius: 2px;\n}\n\n.ol-popup.default.ol-popup-bottom {\n  margin-bottom: 28px;\n}\n\n.ol-popup-top.ol-popup-left.default,\n.ol-popup-top.ol-popup-right.default,\n.ol-popup-right.default,\n.ol-popup-left.default {\n  margin-top: 15px;\n  transform: none;\n}\n\n.ol-popup-right.default {\n  margin: 5px 0 25px 0 !important;\n}\n\n.ol-popup-left.default {\n  margin: 5px 0 25px 0 !important;\n}\n\n.ol-popup-top.ol-popup-left.default,\n.ol-popup-left.default > div {\n  transform: translateX(-50%);\n  margin-bottom: 30px;\n}\n\n.ol-popup-left.default > div,\n.ol-popup-right.default > div {\n  border: 1px grey solid;\n}\n\n.ol-popup-top.ol-popup-right.default,\n.ol-popup-right.default > div {\n  transform: translateX(50%);\n  margin-bottom: 30px;\n}\n\n.ol-popup-left .anchor {\n  left: 50%;\n}\n\n.ol-popup-right .anchor {\n  right: 50%;\n}\n\n.ol-popup.default .anchor {\n  margin: 0;\n  margin-bottom: -12px;\n}\n\n.ol-popup.default .anchor:before {\n  border-color: transparent;\n}\n\n.ol-popup-top .anchor {\n  top: -12px;\n}\n\n.overlay-tooltip {\n  background-color: rgba(0,0,0,0.4);\n  margin: -10px 6px\n}\n\n.overlay-tooltip .ol-popup-content {\n  padding: 5px !important;\n  color: white !important;\n}\n\n.lds-ellipsis {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n\n#loading-message-container{\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  align-items: center;\n\n}\n#loading-message-container span{\n  color: white;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.lds-ellipsis div {\n  position: absolute;\n  top: 33px;\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background: #fff;\n  animation-timing-function: cubic-bezier(0, 1, 1, 0);\n}\n.lds-ellipsis div:nth-child(1) {\n  left: 8px;\n  animation: lds-ellipsis1 0.6s infinite;\n}\n.lds-ellipsis div:nth-child(2) {\n  left: 8px;\n  animation: lds-ellipsis2 0.6s infinite;\n}\n.lds-ellipsis div:nth-child(3) {\n  left: 32px;\n  animation: lds-ellipsis2 0.6s infinite;\n}\n.lds-ellipsis div:nth-child(4) {\n  left: 56px;\n  animation: lds-ellipsis3 0.6s infinite;\n}\n@keyframes lds-ellipsis1 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes lds-ellipsis3 {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0);\n  }\n}\n@keyframes lds-ellipsis2 {\n  0% {\n    transform: translate(0, 0);\n  }\n  100% {\n    transform: translate(24px, 0);\n  }\n}\n/* End context menu styles */\n\n/* animation keyframes */\n@keyframes lay-down {\n  0% {\n    transform: perspective(500px) rotateX(0deg) scale(0.7,0.7);\n  }\n  100% {\n    transform: perspective(300px) rotateX(16deg) scale(0.7,0.7);\n  }\n}\n\n@keyframes zoom-in {\n  0% {\n    transform: perspective(300px) rotateX(0deg) scale(0.7,0.7);\n  }\n  100% {\n    transform: perspective(500px) rotateX(0deg) scale(1,1);\n  }\n}\n\n@keyframes lay-down-3d {\n  0% {\n    transform: perspective(500px) rotateX(40deg) scale(1,1);\n  }\n  100% {\n    transform: none;\n  }\n}\n\n@keyframes zoom-out {\n  0% {\n    transform: perspective(500px) rotateX(40deg) scale(1.5,1.5);\n  }\n  100% {\n    transform: perspective(500px) rotateX(40deg) scale(1,1);\n  }\n}\n\n\n@keyframes zoom-out-in {\n  0% {\n    transform: perspective(500px) rotateX(40deg) scale(1.5,1.5);\n  }\n  33.33%, 50% {\n    transform: perspective(500px) rotateX(40deg) scale(1,1);\n  }\n  100% {\n    transform: perspective(500px) rotateX(40deg) scale(1.5,1.5);\n  }\n}\n\n\n/* End animation keyframes */\n","@use \"@vision/viewer-components/styles/viewer-styles\";\n@use '@angular/material' as mat;\n\n.mat-toolbar-header {\n  @include mat.icon-button-overrides((\n          hover-state-layer-opacity: 0.25\n  ));\n\n  .mat-mdc-icon-button:hover {\n    mat-icon {\n      //color: var(--mat-sys-primary-container) !important;\n      opacity: 0.45;\n    }\n  }\n\n}\n\napp-search-bar {\n    @include mat.icon-button-overrides((\n            hover-state-layer-opacity: 0\n    ));\n\n  .mat-mdc-icon-button:hover {\n    mat-icon {\n      opacity: 0.65 !important;\n    }\n  }\n\n}","@use '@vision/viewer-components/styles/globals' as *;\n\n@use '@angular/material' as mat;\n@use \"./theme-brand-colors\" as brand-theme;\n\n/* Brand Theme - Light Mode (Default) */\n.theme-brand {\n  @include mat.theme((\n          color: (\n                  primary: brand-theme.$primary-palette,\n                  tertiary: brand-theme.$tertiary-palette,\n          ),\n  ));\n\n\n  @include mat.theme-overrides((\n          primary: #56A7B7,\n          on-primary: #ffffff,\n          primary-container: #56A7B7,\n          on-primary-container: #ffffff,\n          on-secondary-container: #dee2e6,\n          primary-fixed-dim: #3B737E, // header and other colors higher than primary\n          inverse-surface: #414344,\n          inverse-on-surface: #ffffff,\n          error: red,\n          corner-medium: 8px,\n          corner-full: 8px,\n          corner-extra-large: 8px,\n  ));\n}\n.dark-mode.theme-brand {\n  @include mat.theme-overrides((\n          primary: #83d2e3,\n          on-primary: #00363e,\n          primary-container: #004e5a,\n          on-primary-container: #a2eeff,\n          on-secondary-container: #57818a,\n          primary-fixed-dim: #83d2e3,\n          inverse-surface: #e5e2e1,\n          inverse-on-surface: #313030,\n          error: red,\n          corner-medium: 8px,\n          corner-full: 8px,\n          corner-extra-large: 8px,\n  ))\n}\n\n.auth-box:has(.register-container) {\n  max-width: 500px !important;\n  min-width: 500px !important;\n}\n\n:root {\n  --required-color: red\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
